/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.app = (function() {

    /**
     * Namespace app.
     * @exports app
     * @namespace
     */
    var app = {};

    app.ForceOffline = (function() {

        /**
         * Properties of a ForceOffline.
         * @memberof app
         * @interface IForceOffline
         */

        /**
         * Constructs a new ForceOffline.
         * @memberof app
         * @classdesc Represents a ForceOffline.
         * @implements IForceOffline
         * @constructor
         * @param {app.IForceOffline=} [properties] Properties to set
         */
        function ForceOffline(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ForceOffline instance using the specified properties.
         * @function create
         * @memberof app.ForceOffline
         * @static
         * @param {app.IForceOffline=} [properties] Properties to set
         * @returns {app.ForceOffline} ForceOffline instance
         */
        ForceOffline.create = function create(properties) {
            return new ForceOffline(properties);
        };

        /**
         * Encodes the specified ForceOffline message. Does not implicitly {@link app.ForceOffline.verify|verify} messages.
         * @function encode
         * @memberof app.ForceOffline
         * @static
         * @param {app.IForceOffline} message ForceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ForceOffline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ForceOffline message, length delimited. Does not implicitly {@link app.ForceOffline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.ForceOffline
         * @static
         * @param {app.IForceOffline} message ForceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ForceOffline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ForceOffline message from the specified reader or buffer.
         * @function decode
         * @memberof app.ForceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.ForceOffline} ForceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ForceOffline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ForceOffline();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ForceOffline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.ForceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.ForceOffline} ForceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ForceOffline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ForceOffline message.
         * @function verify
         * @memberof app.ForceOffline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ForceOffline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ForceOffline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.ForceOffline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.ForceOffline} ForceOffline
         */
        ForceOffline.fromObject = function fromObject(object) {
            if (object instanceof $root.app.ForceOffline)
                return object;
            return new $root.app.ForceOffline();
        };

        /**
         * Creates a plain object from a ForceOffline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.ForceOffline
         * @static
         * @param {app.ForceOffline} message ForceOffline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ForceOffline.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ForceOffline to JSON.
         * @function toJSON
         * @memberof app.ForceOffline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ForceOffline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ForceOffline.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof app.ForceOffline
             * @interface IRequest
             * @property {string|null} [token] Request token
             * @property {string|null} [deviceId] Request deviceId
             * @property {string|null} [offlineDeviceId] Request offlineDeviceId
             */

            /**
             * Constructs a new Request.
             * @memberof app.ForceOffline
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {app.ForceOffline.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request token.
             * @member {string} token
             * @memberof app.ForceOffline.Request
             * @instance
             */
            Request.prototype.token = "";

            /**
             * Request deviceId.
             * @member {string} deviceId
             * @memberof app.ForceOffline.Request
             * @instance
             */
            Request.prototype.deviceId = "";

            /**
             * Request offlineDeviceId.
             * @member {string} offlineDeviceId
             * @memberof app.ForceOffline.Request
             * @instance
             */
            Request.prototype.offlineDeviceId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof app.ForceOffline.Request
             * @static
             * @param {app.ForceOffline.IRequest=} [properties] Properties to set
             * @returns {app.ForceOffline.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link app.ForceOffline.Request.verify|verify} messages.
             * @function encode
             * @memberof app.ForceOffline.Request
             * @static
             * @param {app.ForceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.deviceId);
                if (message.offlineDeviceId != null && Object.hasOwnProperty.call(message, "offlineDeviceId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.offlineDeviceId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link app.ForceOffline.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.ForceOffline.Request
             * @static
             * @param {app.ForceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof app.ForceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.ForceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ForceOffline.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.token = reader.string();
                        break;
                    case 2:
                        message.deviceId = reader.string();
                        break;
                    case 4:
                        message.offlineDeviceId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.ForceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.ForceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof app.ForceOffline.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.offlineDeviceId != null && message.hasOwnProperty("offlineDeviceId"))
                    if (!$util.isString(message.offlineDeviceId))
                        return "offlineDeviceId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.ForceOffline.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.ForceOffline.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.app.ForceOffline.Request)
                    return object;
                var message = new $root.app.ForceOffline.Request();
                if (object.token != null)
                    message.token = String(object.token);
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.offlineDeviceId != null)
                    message.offlineDeviceId = String(object.offlineDeviceId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.ForceOffline.Request
             * @static
             * @param {app.ForceOffline.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.token = "";
                    object.deviceId = "";
                    object.offlineDeviceId = "";
                }
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.offlineDeviceId != null && message.hasOwnProperty("offlineDeviceId"))
                    object.offlineDeviceId = message.offlineDeviceId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof app.ForceOffline.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        ForceOffline.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof app.ForceOffline
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof app.ForceOffline
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {app.ForceOffline.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof app.ForceOffline.Response
             * @static
             * @param {app.ForceOffline.IResponse=} [properties] Properties to set
             * @returns {app.ForceOffline.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link app.ForceOffline.Response.verify|verify} messages.
             * @function encode
             * @memberof app.ForceOffline.Response
             * @static
             * @param {app.ForceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link app.ForceOffline.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.ForceOffline.Response
             * @static
             * @param {app.ForceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof app.ForceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.ForceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.ForceOffline.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.ForceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.ForceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof app.ForceOffline.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.ForceOffline.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.ForceOffline.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.app.ForceOffline.Response)
                    return object;
                return new $root.app.ForceOffline.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.ForceOffline.Response
             * @static
             * @param {app.ForceOffline.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof app.ForceOffline.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return ForceOffline;
    })();

    app.OnForceOffline = (function() {

        /**
         * Properties of an OnForceOffline.
         * @memberof app
         * @interface IOnForceOffline
         */

        /**
         * Constructs a new OnForceOffline.
         * @memberof app
         * @classdesc Represents an OnForceOffline.
         * @implements IOnForceOffline
         * @constructor
         * @param {app.IOnForceOffline=} [properties] Properties to set
         */
        function OnForceOffline(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new OnForceOffline instance using the specified properties.
         * @function create
         * @memberof app.OnForceOffline
         * @static
         * @param {app.IOnForceOffline=} [properties] Properties to set
         * @returns {app.OnForceOffline} OnForceOffline instance
         */
        OnForceOffline.create = function create(properties) {
            return new OnForceOffline(properties);
        };

        /**
         * Encodes the specified OnForceOffline message. Does not implicitly {@link app.OnForceOffline.verify|verify} messages.
         * @function encode
         * @memberof app.OnForceOffline
         * @static
         * @param {app.IOnForceOffline} message OnForceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnForceOffline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified OnForceOffline message, length delimited. Does not implicitly {@link app.OnForceOffline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof app.OnForceOffline
         * @static
         * @param {app.IOnForceOffline} message OnForceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnForceOffline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OnForceOffline message from the specified reader or buffer.
         * @function decode
         * @memberof app.OnForceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {app.OnForceOffline} OnForceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnForceOffline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OnForceOffline();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OnForceOffline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof app.OnForceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {app.OnForceOffline} OnForceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnForceOffline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OnForceOffline message.
         * @function verify
         * @memberof app.OnForceOffline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OnForceOffline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an OnForceOffline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof app.OnForceOffline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {app.OnForceOffline} OnForceOffline
         */
        OnForceOffline.fromObject = function fromObject(object) {
            if (object instanceof $root.app.OnForceOffline)
                return object;
            return new $root.app.OnForceOffline();
        };

        /**
         * Creates a plain object from an OnForceOffline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof app.OnForceOffline
         * @static
         * @param {app.OnForceOffline} message OnForceOffline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OnForceOffline.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this OnForceOffline to JSON.
         * @function toJSON
         * @memberof app.OnForceOffline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OnForceOffline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        OnForceOffline.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof app.OnForceOffline
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof app.OnForceOffline
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {app.OnForceOffline.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {app.OnForceOffline.IRequest=} [properties] Properties to set
             * @returns {app.OnForceOffline.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link app.OnForceOffline.Request.verify|verify} messages.
             * @function encode
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {app.OnForceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link app.OnForceOffline.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {app.OnForceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.OnForceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OnForceOffline.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.OnForceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.OnForceOffline.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.app.OnForceOffline.Request)
                    return object;
                return new $root.app.OnForceOffline.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.OnForceOffline.Request
             * @static
             * @param {app.OnForceOffline.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof app.OnForceOffline.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        OnForceOffline.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof app.OnForceOffline
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof app.OnForceOffline
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {app.OnForceOffline.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {app.OnForceOffline.IResponse=} [properties] Properties to set
             * @returns {app.OnForceOffline.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link app.OnForceOffline.Response.verify|verify} messages.
             * @function encode
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {app.OnForceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link app.OnForceOffline.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {app.OnForceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {app.OnForceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.app.OnForceOffline.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {app.OnForceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {app.OnForceOffline.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.app.OnForceOffline.Response)
                    return object;
                return new $root.app.OnForceOffline.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof app.OnForceOffline.Response
             * @static
             * @param {app.OnForceOffline.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof app.OnForceOffline.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return OnForceOffline;
    })();

    return app;
})();

$root.base = (function() {

    /**
     * Namespace base.
     * @exports base
     * @namespace
     */
    var base = {};

    base.RequestType = (function() {

        /**
         * Properties of a RequestType.
         * @memberof base
         * @interface IRequestType
         * @property {string|null} [data] RequestType data
         * @property {string|null} [token] RequestType token
         * @property {string|null} [deviceId] RequestType deviceId
         * @property {user.IUserAgent|null} [userAgent] RequestType userAgent
         * @property {string|null} [appId] RequestType appId
         */

        /**
         * Constructs a new RequestType.
         * @memberof base
         * @classdesc Represents a RequestType.
         * @implements IRequestType
         * @constructor
         * @param {base.IRequestType=} [properties] Properties to set
         */
        function RequestType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestType data.
         * @member {string} data
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.data = "";

        /**
         * RequestType token.
         * @member {string} token
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.token = "";

        /**
         * RequestType deviceId.
         * @member {string} deviceId
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.deviceId = "";

        /**
         * RequestType userAgent.
         * @member {user.IUserAgent|null|undefined} userAgent
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.userAgent = null;

        /**
         * RequestType appId.
         * @member {string} appId
         * @memberof base.RequestType
         * @instance
         */
        RequestType.prototype.appId = "";

        /**
         * Creates a new RequestType instance using the specified properties.
         * @function create
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType=} [properties] Properties to set
         * @returns {base.RequestType} RequestType instance
         */
        RequestType.create = function create(properties) {
            return new RequestType(properties);
        };

        /**
         * Encodes the specified RequestType message. Does not implicitly {@link base.RequestType.verify|verify} messages.
         * @function encode
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType} message RequestType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
            if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.deviceId);
            if (message.userAgent != null && Object.hasOwnProperty.call(message, "userAgent"))
                $root.user.UserAgent.encode(message.userAgent, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.appId != null && Object.hasOwnProperty.call(message, "appId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.appId);
            return writer;
        };

        /**
         * Encodes the specified RequestType message, length delimited. Does not implicitly {@link base.RequestType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.RequestType
         * @static
         * @param {base.IRequestType} message RequestType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RequestType message from the specified reader or buffer.
         * @function decode
         * @memberof base.RequestType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.RequestType} RequestType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.RequestType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.token = reader.string();
                    break;
                case 3:
                    message.deviceId = reader.string();
                    break;
                case 4:
                    message.userAgent = $root.user.UserAgent.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.appId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RequestType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.RequestType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.RequestType} RequestType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestType message.
         * @function verify
         * @memberof base.RequestType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.token != null && message.hasOwnProperty("token"))
                if (!$util.isString(message.token))
                    return "token: string expected";
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (!$util.isString(message.deviceId))
                    return "deviceId: string expected";
            if (message.userAgent != null && message.hasOwnProperty("userAgent")) {
                var error = $root.user.UserAgent.verify(message.userAgent);
                if (error)
                    return "userAgent." + error;
            }
            if (message.appId != null && message.hasOwnProperty("appId"))
                if (!$util.isString(message.appId))
                    return "appId: string expected";
            return null;
        };

        /**
         * Creates a RequestType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.RequestType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.RequestType} RequestType
         */
        RequestType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.RequestType)
                return object;
            var message = new $root.base.RequestType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.token != null)
                message.token = String(object.token);
            if (object.deviceId != null)
                message.deviceId = String(object.deviceId);
            if (object.userAgent != null) {
                if (typeof object.userAgent !== "object")
                    throw TypeError(".base.RequestType.userAgent: object expected");
                message.userAgent = $root.user.UserAgent.fromObject(object.userAgent);
            }
            if (object.appId != null)
                message.appId = String(object.appId);
            return message;
        };

        /**
         * Creates a plain object from a RequestType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.RequestType
         * @static
         * @param {base.RequestType} message RequestType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.token = "";
                object.deviceId = "";
                object.userAgent = null;
                object.appId = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.token != null && message.hasOwnProperty("token"))
                object.token = message.token;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = message.deviceId;
            if (message.userAgent != null && message.hasOwnProperty("userAgent"))
                object.userAgent = $root.user.UserAgent.toObject(message.userAgent, options);
            if (message.appId != null && message.hasOwnProperty("appId"))
                object.appId = message.appId;
            return object;
        };

        /**
         * Converts this RequestType to JSON.
         * @function toJSON
         * @memberof base.RequestType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestType;
    })();

    base.ResponseType = (function() {

        /**
         * Properties of a ResponseType.
         * @memberof base
         * @interface IResponseType
         * @property {number|Long|null} [code] ResponseType code
         * @property {string|null} [msg] ResponseType msg
         * @property {string|null} [cnMsg] ResponseType cnMsg
         * @property {string|null} [error] ResponseType error
         * @property {string|null} [requestId] ResponseType requestId
         * @property {number|Long|null} [requestTime] ResponseType requestTime
         * @property {string|null} [author] ResponseType author
         * @property {string|null} [platform] ResponseType platform
         * @property {string|null} [data] ResponseType data
         */

        /**
         * Constructs a new ResponseType.
         * @memberof base
         * @classdesc Represents a ResponseType.
         * @implements IResponseType
         * @constructor
         * @param {base.IResponseType=} [properties] Properties to set
         */
        function ResponseType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseType code.
         * @member {number|Long} code
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ResponseType msg.
         * @member {string} msg
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.msg = "";

        /**
         * ResponseType cnMsg.
         * @member {string} cnMsg
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.cnMsg = "";

        /**
         * ResponseType error.
         * @member {string} error
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.error = "";

        /**
         * ResponseType requestId.
         * @member {string} requestId
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.requestId = "";

        /**
         * ResponseType requestTime.
         * @member {number|Long} requestTime
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.requestTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ResponseType author.
         * @member {string} author
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.author = "";

        /**
         * ResponseType platform.
         * @member {string} platform
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.platform = "";

        /**
         * ResponseType data.
         * @member {string} data
         * @memberof base.ResponseType
         * @instance
         */
        ResponseType.prototype.data = "";

        /**
         * Creates a new ResponseType instance using the specified properties.
         * @function create
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType=} [properties] Properties to set
         * @returns {base.ResponseType} ResponseType instance
         */
        ResponseType.create = function create(properties) {
            return new ResponseType(properties);
        };

        /**
         * Encodes the specified ResponseType message. Does not implicitly {@link base.ResponseType.verify|verify} messages.
         * @function encode
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType} message ResponseType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.code);
            if (message.msg != null && Object.hasOwnProperty.call(message, "msg"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.msg);
            if (message.cnMsg != null && Object.hasOwnProperty.call(message, "cnMsg"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.cnMsg);
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.error);
            if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.requestId);
            if (message.requestTime != null && Object.hasOwnProperty.call(message, "requestTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.requestTime);
            if (message.author != null && Object.hasOwnProperty.call(message, "author"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.author);
            if (message.platform != null && Object.hasOwnProperty.call(message, "platform"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.platform);
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.data);
            return writer;
        };

        /**
         * Encodes the specified ResponseType message, length delimited. Does not implicitly {@link base.ResponseType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.ResponseType
         * @static
         * @param {base.IResponseType} message ResponseType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResponseType message from the specified reader or buffer.
         * @function decode
         * @memberof base.ResponseType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.ResponseType} ResponseType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.ResponseType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.code = reader.int64();
                    break;
                case 2:
                    message.msg = reader.string();
                    break;
                case 3:
                    message.cnMsg = reader.string();
                    break;
                case 4:
                    message.error = reader.string();
                    break;
                case 5:
                    message.requestId = reader.string();
                    break;
                case 6:
                    message.requestTime = reader.int64();
                    break;
                case 7:
                    message.author = reader.string();
                    break;
                case 8:
                    message.platform = reader.string();
                    break;
                case 9:
                    message.data = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResponseType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.ResponseType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.ResponseType} ResponseType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseType message.
         * @function verify
         * @memberof base.ResponseType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                    return "code: integer|Long expected";
            if (message.msg != null && message.hasOwnProperty("msg"))
                if (!$util.isString(message.msg))
                    return "msg: string expected";
            if (message.cnMsg != null && message.hasOwnProperty("cnMsg"))
                if (!$util.isString(message.cnMsg))
                    return "cnMsg: string expected";
            if (message.error != null && message.hasOwnProperty("error"))
                if (!$util.isString(message.error))
                    return "error: string expected";
            if (message.requestId != null && message.hasOwnProperty("requestId"))
                if (!$util.isString(message.requestId))
                    return "requestId: string expected";
            if (message.requestTime != null && message.hasOwnProperty("requestTime"))
                if (!$util.isInteger(message.requestTime) && !(message.requestTime && $util.isInteger(message.requestTime.low) && $util.isInteger(message.requestTime.high)))
                    return "requestTime: integer|Long expected";
            if (message.author != null && message.hasOwnProperty("author"))
                if (!$util.isString(message.author))
                    return "author: string expected";
            if (message.platform != null && message.hasOwnProperty("platform"))
                if (!$util.isString(message.platform))
                    return "platform: string expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            return null;
        };

        /**
         * Creates a ResponseType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.ResponseType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.ResponseType} ResponseType
         */
        ResponseType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.ResponseType)
                return object;
            var message = new $root.base.ResponseType();
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = false;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber();
            if (object.msg != null)
                message.msg = String(object.msg);
            if (object.cnMsg != null)
                message.cnMsg = String(object.cnMsg);
            if (object.error != null)
                message.error = String(object.error);
            if (object.requestId != null)
                message.requestId = String(object.requestId);
            if (object.requestTime != null)
                if ($util.Long)
                    (message.requestTime = $util.Long.fromValue(object.requestTime)).unsigned = false;
                else if (typeof object.requestTime === "string")
                    message.requestTime = parseInt(object.requestTime, 10);
                else if (typeof object.requestTime === "number")
                    message.requestTime = object.requestTime;
                else if (typeof object.requestTime === "object")
                    message.requestTime = new $util.LongBits(object.requestTime.low >>> 0, object.requestTime.high >>> 0).toNumber();
            if (object.author != null)
                message.author = String(object.author);
            if (object.platform != null)
                message.platform = String(object.platform);
            if (object.data != null)
                message.data = String(object.data);
            return message;
        };

        /**
         * Creates a plain object from a ResponseType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.ResponseType
         * @static
         * @param {base.ResponseType} message ResponseType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
                object.msg = "";
                object.cnMsg = "";
                object.error = "";
                object.requestId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.requestTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.requestTime = options.longs === String ? "0" : 0;
                object.author = "";
                object.platform = "";
                object.data = "";
            }
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber() : message.code;
            if (message.msg != null && message.hasOwnProperty("msg"))
                object.msg = message.msg;
            if (message.cnMsg != null && message.hasOwnProperty("cnMsg"))
                object.cnMsg = message.cnMsg;
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            if (message.requestId != null && message.hasOwnProperty("requestId"))
                object.requestId = message.requestId;
            if (message.requestTime != null && message.hasOwnProperty("requestTime"))
                if (typeof message.requestTime === "number")
                    object.requestTime = options.longs === String ? String(message.requestTime) : message.requestTime;
                else
                    object.requestTime = options.longs === String ? $util.Long.prototype.toString.call(message.requestTime) : options.longs === Number ? new $util.LongBits(message.requestTime.low >>> 0, message.requestTime.high >>> 0).toNumber() : message.requestTime;
            if (message.author != null && message.hasOwnProperty("author"))
                object.author = message.author;
            if (message.platform != null && message.hasOwnProperty("platform"))
                object.platform = message.platform;
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            return object;
        };

        /**
         * Converts this ResponseType to JSON.
         * @function toJSON
         * @memberof base.ResponseType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseType;
    })();

    base.ResponseEncryptDataType = (function() {

        /**
         * Properties of a ResponseEncryptDataType.
         * @memberof base
         * @interface IResponseEncryptDataType
         * @property {string|null} [data] ResponseEncryptDataType data
         * @property {string|null} [key] ResponseEncryptDataType key
         */

        /**
         * Constructs a new ResponseEncryptDataType.
         * @memberof base
         * @classdesc Represents a ResponseEncryptDataType.
         * @implements IResponseEncryptDataType
         * @constructor
         * @param {base.IResponseEncryptDataType=} [properties] Properties to set
         */
        function ResponseEncryptDataType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseEncryptDataType data.
         * @member {string} data
         * @memberof base.ResponseEncryptDataType
         * @instance
         */
        ResponseEncryptDataType.prototype.data = "";

        /**
         * ResponseEncryptDataType key.
         * @member {string} key
         * @memberof base.ResponseEncryptDataType
         * @instance
         */
        ResponseEncryptDataType.prototype.key = "";

        /**
         * Creates a new ResponseEncryptDataType instance using the specified properties.
         * @function create
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType=} [properties] Properties to set
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType instance
         */
        ResponseEncryptDataType.create = function create(properties) {
            return new ResponseEncryptDataType(properties);
        };

        /**
         * Encodes the specified ResponseEncryptDataType message. Does not implicitly {@link base.ResponseEncryptDataType.verify|verify} messages.
         * @function encode
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType} message ResponseEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseEncryptDataType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
            return writer;
        };

        /**
         * Encodes the specified ResponseEncryptDataType message, length delimited. Does not implicitly {@link base.ResponseEncryptDataType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.IResponseEncryptDataType} message ResponseEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseEncryptDataType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResponseEncryptDataType message from the specified reader or buffer.
         * @function decode
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseEncryptDataType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.ResponseEncryptDataType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResponseEncryptDataType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseEncryptDataType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResponseEncryptDataType message.
         * @function verify
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResponseEncryptDataType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            return null;
        };

        /**
         * Creates a ResponseEncryptDataType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.ResponseEncryptDataType} ResponseEncryptDataType
         */
        ResponseEncryptDataType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.ResponseEncryptDataType)
                return object;
            var message = new $root.base.ResponseEncryptDataType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.key != null)
                message.key = String(object.key);
            return message;
        };

        /**
         * Creates a plain object from a ResponseEncryptDataType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.ResponseEncryptDataType
         * @static
         * @param {base.ResponseEncryptDataType} message ResponseEncryptDataType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseEncryptDataType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.key = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            return object;
        };

        /**
         * Converts this ResponseEncryptDataType to JSON.
         * @function toJSON
         * @memberof base.ResponseEncryptDataType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseEncryptDataType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseEncryptDataType;
    })();

    base.RequestEncryptDataType = (function() {

        /**
         * Properties of a RequestEncryptDataType.
         * @memberof base
         * @interface IRequestEncryptDataType
         * @property {string|null} [data] RequestEncryptDataType data
         * @property {string|null} [key] RequestEncryptDataType key
         * @property {string|null} [tempAesKey] RequestEncryptDataType tempAesKey
         */

        /**
         * Constructs a new RequestEncryptDataType.
         * @memberof base
         * @classdesc Represents a RequestEncryptDataType.
         * @implements IRequestEncryptDataType
         * @constructor
         * @param {base.IRequestEncryptDataType=} [properties] Properties to set
         */
        function RequestEncryptDataType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestEncryptDataType data.
         * @member {string} data
         * @memberof base.RequestEncryptDataType
         * @instance
         */
        RequestEncryptDataType.prototype.data = "";

        /**
         * RequestEncryptDataType key.
         * @member {string} key
         * @memberof base.RequestEncryptDataType
         * @instance
         */
        RequestEncryptDataType.prototype.key = "";

        /**
         * RequestEncryptDataType tempAesKey.
         * @member {string} tempAesKey
         * @memberof base.RequestEncryptDataType
         * @instance
         */
        RequestEncryptDataType.prototype.tempAesKey = "";

        /**
         * Creates a new RequestEncryptDataType instance using the specified properties.
         * @function create
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType=} [properties] Properties to set
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType instance
         */
        RequestEncryptDataType.create = function create(properties) {
            return new RequestEncryptDataType(properties);
        };

        /**
         * Encodes the specified RequestEncryptDataType message. Does not implicitly {@link base.RequestEncryptDataType.verify|verify} messages.
         * @function encode
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType} message RequestEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestEncryptDataType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
            if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.key);
            if (message.tempAesKey != null && Object.hasOwnProperty.call(message, "tempAesKey"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.tempAesKey);
            return writer;
        };

        /**
         * Encodes the specified RequestEncryptDataType message, length delimited. Does not implicitly {@link base.RequestEncryptDataType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.IRequestEncryptDataType} message RequestEncryptDataType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestEncryptDataType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RequestEncryptDataType message from the specified reader or buffer.
         * @function decode
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestEncryptDataType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.base.RequestEncryptDataType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.key = reader.string();
                    break;
                case 3:
                    message.tempAesKey = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RequestEncryptDataType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestEncryptDataType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RequestEncryptDataType message.
         * @function verify
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RequestEncryptDataType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.data != null && message.hasOwnProperty("data"))
                if (!$util.isString(message.data))
                    return "data: string expected";
            if (message.key != null && message.hasOwnProperty("key"))
                if (!$util.isString(message.key))
                    return "key: string expected";
            if (message.tempAesKey != null && message.hasOwnProperty("tempAesKey"))
                if (!$util.isString(message.tempAesKey))
                    return "tempAesKey: string expected";
            return null;
        };

        /**
         * Creates a RequestEncryptDataType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {base.RequestEncryptDataType} RequestEncryptDataType
         */
        RequestEncryptDataType.fromObject = function fromObject(object) {
            if (object instanceof $root.base.RequestEncryptDataType)
                return object;
            var message = new $root.base.RequestEncryptDataType();
            if (object.data != null)
                message.data = String(object.data);
            if (object.key != null)
                message.key = String(object.key);
            if (object.tempAesKey != null)
                message.tempAesKey = String(object.tempAesKey);
            return message;
        };

        /**
         * Creates a plain object from a RequestEncryptDataType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof base.RequestEncryptDataType
         * @static
         * @param {base.RequestEncryptDataType} message RequestEncryptDataType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestEncryptDataType.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.data = "";
                object.key = "";
                object.tempAesKey = "";
            }
            if (message.data != null && message.hasOwnProperty("data"))
                object.data = message.data;
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = message.key;
            if (message.tempAesKey != null && message.hasOwnProperty("tempAesKey"))
                object.tempAesKey = message.tempAesKey;
            return object;
        };

        /**
         * Converts this RequestEncryptDataType to JSON.
         * @function toJSON
         * @memberof base.RequestEncryptDataType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestEncryptDataType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestEncryptDataType;
    })();

    return base;
})();

$root.user = (function() {

    /**
     * Namespace user.
     * @exports user
     * @namespace
     */
    var user = {};

    user.StrangerUserInfo = (function() {

        /**
         * Properties of a StrangerUserInfo.
         * @memberof user
         * @interface IStrangerUserInfo
         * @property {number|Long|null} [uid] StrangerUserInfo uid
         * @property {number|Long|null} [email] StrangerUserInfo email
         * @property {string|null} [avatar] StrangerUserInfo avatar
         * @property {string|null} [nickname] StrangerUserInfo nickname
         * @property {string|null} [username] StrangerUserInfo username
         * @property {string|null} [bio] StrangerUserInfo bio
         * @property {boolean|null} [isAdded] StrangerUserInfo isAdded
         */

        /**
         * Constructs a new StrangerUserInfo.
         * @memberof user
         * @classdesc Represents a StrangerUserInfo.
         * @implements IStrangerUserInfo
         * @constructor
         * @param {user.IStrangerUserInfo=} [properties] Properties to set
         */
        function StrangerUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StrangerUserInfo uid.
         * @member {number|Long} uid
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * StrangerUserInfo email.
         * @member {number|Long} email
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.email = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * StrangerUserInfo avatar.
         * @member {string} avatar
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.avatar = "";

        /**
         * StrangerUserInfo nickname.
         * @member {string} nickname
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.nickname = "";

        /**
         * StrangerUserInfo username.
         * @member {string} username
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.username = "";

        /**
         * StrangerUserInfo bio.
         * @member {string} bio
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.bio = "";

        /**
         * StrangerUserInfo isAdded.
         * @member {boolean} isAdded
         * @memberof user.StrangerUserInfo
         * @instance
         */
        StrangerUserInfo.prototype.isAdded = false;

        /**
         * Creates a new StrangerUserInfo instance using the specified properties.
         * @function create
         * @memberof user.StrangerUserInfo
         * @static
         * @param {user.IStrangerUserInfo=} [properties] Properties to set
         * @returns {user.StrangerUserInfo} StrangerUserInfo instance
         */
        StrangerUserInfo.create = function create(properties) {
            return new StrangerUserInfo(properties);
        };

        /**
         * Encodes the specified StrangerUserInfo message. Does not implicitly {@link user.StrangerUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.StrangerUserInfo
         * @static
         * @param {user.IStrangerUserInfo} message StrangerUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StrangerUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.email);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.username);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.bio);
            if (message.isAdded != null && Object.hasOwnProperty.call(message, "isAdded"))
                writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isAdded);
            return writer;
        };

        /**
         * Encodes the specified StrangerUserInfo message, length delimited. Does not implicitly {@link user.StrangerUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.StrangerUserInfo
         * @static
         * @param {user.IStrangerUserInfo} message StrangerUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StrangerUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StrangerUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.StrangerUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.StrangerUserInfo} StrangerUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StrangerUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.StrangerUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.email = reader.int64();
                    break;
                case 3:
                    message.avatar = reader.string();
                    break;
                case 4:
                    message.nickname = reader.string();
                    break;
                case 5:
                    message.username = reader.string();
                    break;
                case 6:
                    message.bio = reader.string();
                    break;
                case 7:
                    message.isAdded = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StrangerUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.StrangerUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.StrangerUserInfo} StrangerUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StrangerUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StrangerUserInfo message.
         * @function verify
         * @memberof user.StrangerUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StrangerUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isInteger(message.email) && !(message.email && $util.isInteger(message.email.low) && $util.isInteger(message.email.high)))
                    return "email: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            if (message.isAdded != null && message.hasOwnProperty("isAdded"))
                if (typeof message.isAdded !== "boolean")
                    return "isAdded: boolean expected";
            return null;
        };

        /**
         * Creates a StrangerUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.StrangerUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.StrangerUserInfo} StrangerUserInfo
         */
        StrangerUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.StrangerUserInfo)
                return object;
            var message = new $root.user.StrangerUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.email != null)
                if ($util.Long)
                    (message.email = $util.Long.fromValue(object.email)).unsigned = false;
                else if (typeof object.email === "string")
                    message.email = parseInt(object.email, 10);
                else if (typeof object.email === "number")
                    message.email = object.email;
                else if (typeof object.email === "object")
                    message.email = new $util.LongBits(object.email.low >>> 0, object.email.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            if (object.bio != null)
                message.bio = String(object.bio);
            if (object.isAdded != null)
                message.isAdded = Boolean(object.isAdded);
            return message;
        };

        /**
         * Creates a plain object from a StrangerUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.StrangerUserInfo
         * @static
         * @param {user.StrangerUserInfo} message StrangerUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StrangerUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.email = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.email = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
                object.bio = "";
                object.isAdded = false;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.email != null && message.hasOwnProperty("email"))
                if (typeof message.email === "number")
                    object.email = options.longs === String ? String(message.email) : message.email;
                else
                    object.email = options.longs === String ? $util.Long.prototype.toString.call(message.email) : options.longs === Number ? new $util.LongBits(message.email.low >>> 0, message.email.high >>> 0).toNumber() : message.email;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            if (message.isAdded != null && message.hasOwnProperty("isAdded"))
                object.isAdded = message.isAdded;
            return object;
        };

        /**
         * Converts this StrangerUserInfo to JSON.
         * @function toJSON
         * @memberof user.StrangerUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StrangerUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StrangerUserInfo;
    })();

    user.FriendLogUserInfo = (function() {

        /**
         * Properties of a FriendLogUserInfo.
         * @memberof user
         * @interface IFriendLogUserInfo
         * @property {number|Long|null} [uid] FriendLogUserInfo uid
         * @property {string|null} [avatar] FriendLogUserInfo avatar
         * @property {string|null} [nickname] FriendLogUserInfo nickname
         * @property {string|null} [username] FriendLogUserInfo username
         */

        /**
         * Constructs a new FriendLogUserInfo.
         * @memberof user
         * @classdesc Represents a FriendLogUserInfo.
         * @implements IFriendLogUserInfo
         * @constructor
         * @param {user.IFriendLogUserInfo=} [properties] Properties to set
         */
        function FriendLogUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FriendLogUserInfo uid.
         * @member {number|Long} uid
         * @memberof user.FriendLogUserInfo
         * @instance
         */
        FriendLogUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendLogUserInfo avatar.
         * @member {string} avatar
         * @memberof user.FriendLogUserInfo
         * @instance
         */
        FriendLogUserInfo.prototype.avatar = "";

        /**
         * FriendLogUserInfo nickname.
         * @member {string} nickname
         * @memberof user.FriendLogUserInfo
         * @instance
         */
        FriendLogUserInfo.prototype.nickname = "";

        /**
         * FriendLogUserInfo username.
         * @member {string} username
         * @memberof user.FriendLogUserInfo
         * @instance
         */
        FriendLogUserInfo.prototype.username = "";

        /**
         * Creates a new FriendLogUserInfo instance using the specified properties.
         * @function create
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {user.IFriendLogUserInfo=} [properties] Properties to set
         * @returns {user.FriendLogUserInfo} FriendLogUserInfo instance
         */
        FriendLogUserInfo.create = function create(properties) {
            return new FriendLogUserInfo(properties);
        };

        /**
         * Encodes the specified FriendLogUserInfo message. Does not implicitly {@link user.FriendLogUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {user.IFriendLogUserInfo} message FriendLogUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendLogUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.username);
            return writer;
        };

        /**
         * Encodes the specified FriendLogUserInfo message, length delimited. Does not implicitly {@link user.FriendLogUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {user.IFriendLogUserInfo} message FriendLogUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendLogUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FriendLogUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.FriendLogUserInfo} FriendLogUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendLogUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.FriendLogUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.avatar = reader.string();
                    break;
                case 3:
                    message.nickname = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FriendLogUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.FriendLogUserInfo} FriendLogUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendLogUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FriendLogUserInfo message.
         * @function verify
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FriendLogUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            return null;
        };

        /**
         * Creates a FriendLogUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.FriendLogUserInfo} FriendLogUserInfo
         */
        FriendLogUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.FriendLogUserInfo)
                return object;
            var message = new $root.user.FriendLogUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            return message;
        };

        /**
         * Creates a plain object from a FriendLogUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.FriendLogUserInfo
         * @static
         * @param {user.FriendLogUserInfo} message FriendLogUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FriendLogUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            return object;
        };

        /**
         * Converts this FriendLogUserInfo to JSON.
         * @function toJSON
         * @memberof user.FriendLogUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FriendLogUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FriendLogUserInfo;
    })();

    user.FriendUserInfo = (function() {

        /**
         * Properties of a FriendUserInfo.
         * @memberof user
         * @interface IFriendUserInfo
         * @property {number|Long|null} [uid] FriendUserInfo uid
         * @property {string|null} [avatar] FriendUserInfo avatar
         * @property {string|null} [nickname] FriendUserInfo nickname
         * @property {string|null} [username] FriendUserInfo username
         * @property {string|null} [letter] FriendUserInfo letter
         * @property {string|null} [email] FriendUserInfo email
         * @property {string|null} [bio] FriendUserInfo bio
         */

        /**
         * Constructs a new FriendUserInfo.
         * @memberof user
         * @classdesc Represents a FriendUserInfo.
         * @implements IFriendUserInfo
         * @constructor
         * @param {user.IFriendUserInfo=} [properties] Properties to set
         */
        function FriendUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FriendUserInfo uid.
         * @member {number|Long} uid
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendUserInfo avatar.
         * @member {string} avatar
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.avatar = "";

        /**
         * FriendUserInfo nickname.
         * @member {string} nickname
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.nickname = "";

        /**
         * FriendUserInfo username.
         * @member {string} username
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.username = "";

        /**
         * FriendUserInfo letter.
         * @member {string} letter
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.letter = "";

        /**
         * FriendUserInfo email.
         * @member {string} email
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.email = "";

        /**
         * FriendUserInfo bio.
         * @member {string} bio
         * @memberof user.FriendUserInfo
         * @instance
         */
        FriendUserInfo.prototype.bio = "";

        /**
         * Creates a new FriendUserInfo instance using the specified properties.
         * @function create
         * @memberof user.FriendUserInfo
         * @static
         * @param {user.IFriendUserInfo=} [properties] Properties to set
         * @returns {user.FriendUserInfo} FriendUserInfo instance
         */
        FriendUserInfo.create = function create(properties) {
            return new FriendUserInfo(properties);
        };

        /**
         * Encodes the specified FriendUserInfo message. Does not implicitly {@link user.FriendUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.FriendUserInfo
         * @static
         * @param {user.IFriendUserInfo} message FriendUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.username);
            if (message.letter != null && Object.hasOwnProperty.call(message, "letter"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.letter);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.email);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.bio);
            return writer;
        };

        /**
         * Encodes the specified FriendUserInfo message, length delimited. Does not implicitly {@link user.FriendUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.FriendUserInfo
         * @static
         * @param {user.IFriendUserInfo} message FriendUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FriendUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.FriendUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.FriendUserInfo} FriendUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.FriendUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.avatar = reader.string();
                    break;
                case 3:
                    message.nickname = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                case 5:
                    message.letter = reader.string();
                    break;
                case 6:
                    message.email = reader.string();
                    break;
                case 7:
                    message.bio = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FriendUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.FriendUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.FriendUserInfo} FriendUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FriendUserInfo message.
         * @function verify
         * @memberof user.FriendUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FriendUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.letter != null && message.hasOwnProperty("letter"))
                if (!$util.isString(message.letter))
                    return "letter: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            return null;
        };

        /**
         * Creates a FriendUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.FriendUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.FriendUserInfo} FriendUserInfo
         */
        FriendUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.FriendUserInfo)
                return object;
            var message = new $root.user.FriendUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            if (object.letter != null)
                message.letter = String(object.letter);
            if (object.email != null)
                message.email = String(object.email);
            if (object.bio != null)
                message.bio = String(object.bio);
            return message;
        };

        /**
         * Creates a plain object from a FriendUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.FriendUserInfo
         * @static
         * @param {user.FriendUserInfo} message FriendUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FriendUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
                object.letter = "";
                object.email = "";
                object.bio = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.letter != null && message.hasOwnProperty("letter"))
                object.letter = message.letter;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            return object;
        };

        /**
         * Converts this FriendUserInfo to JSON.
         * @function toJSON
         * @memberof user.FriendUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FriendUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FriendUserInfo;
    })();

    user.RoomUserInfo = (function() {

        /**
         * Properties of a RoomUserInfo.
         * @memberof user
         * @interface IRoomUserInfo
         * @property {number|Long|null} [uid] RoomUserInfo uid
         * @property {string|null} [avatar] RoomUserInfo avatar
         * @property {string|null} [nickname] RoomUserInfo nickname
         * @property {string|null} [username] RoomUserInfo username
         * @property {string|null} [letter] RoomUserInfo letter
         * @property {string|null} [email] RoomUserInfo email
         * @property {string|null} [bio] RoomUserInfo bio
         */

        /**
         * Constructs a new RoomUserInfo.
         * @memberof user
         * @classdesc Represents a RoomUserInfo.
         * @implements IRoomUserInfo
         * @constructor
         * @param {user.IRoomUserInfo=} [properties] Properties to set
         */
        function RoomUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoomUserInfo uid.
         * @member {number|Long} uid
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * RoomUserInfo avatar.
         * @member {string} avatar
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.avatar = "";

        /**
         * RoomUserInfo nickname.
         * @member {string} nickname
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.nickname = "";

        /**
         * RoomUserInfo username.
         * @member {string} username
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.username = "";

        /**
         * RoomUserInfo letter.
         * @member {string} letter
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.letter = "";

        /**
         * RoomUserInfo email.
         * @member {string} email
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.email = "";

        /**
         * RoomUserInfo bio.
         * @member {string} bio
         * @memberof user.RoomUserInfo
         * @instance
         */
        RoomUserInfo.prototype.bio = "";

        /**
         * Creates a new RoomUserInfo instance using the specified properties.
         * @function create
         * @memberof user.RoomUserInfo
         * @static
         * @param {user.IRoomUserInfo=} [properties] Properties to set
         * @returns {user.RoomUserInfo} RoomUserInfo instance
         */
        RoomUserInfo.create = function create(properties) {
            return new RoomUserInfo(properties);
        };

        /**
         * Encodes the specified RoomUserInfo message. Does not implicitly {@link user.RoomUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.RoomUserInfo
         * @static
         * @param {user.IRoomUserInfo} message RoomUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.uid);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.nickname);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.username);
            if (message.letter != null && Object.hasOwnProperty.call(message, "letter"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.letter);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.email);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.bio);
            return writer;
        };

        /**
         * Encodes the specified RoomUserInfo message, length delimited. Does not implicitly {@link user.RoomUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.RoomUserInfo
         * @static
         * @param {user.IRoomUserInfo} message RoomUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.RoomUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.RoomUserInfo} RoomUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.RoomUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.int64();
                    break;
                case 2:
                    message.avatar = reader.string();
                    break;
                case 3:
                    message.nickname = reader.string();
                    break;
                case 4:
                    message.username = reader.string();
                    break;
                case 5:
                    message.letter = reader.string();
                    break;
                case 6:
                    message.email = reader.string();
                    break;
                case 7:
                    message.bio = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoomUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.RoomUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.RoomUserInfo} RoomUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomUserInfo message.
         * @function verify
         * @memberof user.RoomUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isInteger(message.uid) && !(message.uid && $util.isInteger(message.uid.low) && $util.isInteger(message.uid.high)))
                    return "uid: integer|Long expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.letter != null && message.hasOwnProperty("letter"))
                if (!$util.isString(message.letter))
                    return "letter: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            return null;
        };

        /**
         * Creates a RoomUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.RoomUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.RoomUserInfo} RoomUserInfo
         */
        RoomUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.RoomUserInfo)
                return object;
            var message = new $root.user.RoomUserInfo();
            if (object.uid != null)
                if ($util.Long)
                    (message.uid = $util.Long.fromValue(object.uid)).unsigned = false;
                else if (typeof object.uid === "string")
                    message.uid = parseInt(object.uid, 10);
                else if (typeof object.uid === "number")
                    message.uid = object.uid;
                else if (typeof object.uid === "object")
                    message.uid = new $util.LongBits(object.uid.low >>> 0, object.uid.high >>> 0).toNumber();
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.username != null)
                message.username = String(object.username);
            if (object.letter != null)
                message.letter = String(object.letter);
            if (object.email != null)
                message.email = String(object.email);
            if (object.bio != null)
                message.bio = String(object.bio);
            return message;
        };

        /**
         * Creates a plain object from a RoomUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.RoomUserInfo
         * @static
         * @param {user.RoomUserInfo} message RoomUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.uid = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.uid = options.longs === String ? "0" : 0;
                object.avatar = "";
                object.nickname = "";
                object.username = "";
                object.letter = "";
                object.email = "";
                object.bio = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (typeof message.uid === "number")
                    object.uid = options.longs === String ? String(message.uid) : message.uid;
                else
                    object.uid = options.longs === String ? $util.Long.prototype.toString.call(message.uid) : options.longs === Number ? new $util.LongBits(message.uid.low >>> 0, message.uid.high >>> 0).toNumber() : message.uid;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.letter != null && message.hasOwnProperty("letter"))
                object.letter = message.letter;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            return object;
        };

        /**
         * Converts this RoomUserInfo to JSON.
         * @function toJSON
         * @memberof user.RoomUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomUserInfo;
    })();

    user.SimpleSSOUserInfo = (function() {

        /**
         * Properties of a SimpleSSOUserInfo.
         * @memberof user
         * @interface ISimpleSSOUserInfo
         * @property {string|null} [uid] SimpleSSOUserInfo uid
         * @property {string|null} [username] SimpleSSOUserInfo username
         * @property {string|null} [nickname] SimpleSSOUserInfo nickname
         * @property {string|null} [avatar] SimpleSSOUserInfo avatar
         * @property {string|null} [bio] SimpleSSOUserInfo bio
         * @property {string|null} [letter] SimpleSSOUserInfo letter
         * @property {number|Long|null} [lastSeenTime] SimpleSSOUserInfo lastSeenTime
         */

        /**
         * Constructs a new SimpleSSOUserInfo.
         * @memberof user
         * @classdesc Represents a SimpleSSOUserInfo.
         * @implements ISimpleSSOUserInfo
         * @constructor
         * @param {user.ISimpleSSOUserInfo=} [properties] Properties to set
         */
        function SimpleSSOUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SimpleSSOUserInfo uid.
         * @member {string} uid
         * @memberof user.SimpleSSOUserInfo
         * @instance
         */
        SimpleSSOUserInfo.prototype.uid = "";

        /**
         * SimpleSSOUserInfo username.
         * @member {string} username
         * @memberof user.SimpleSSOUserInfo
         * @instance
         */
        SimpleSSOUserInfo.prototype.username = "";

        /**
         * SimpleSSOUserInfo nickname.
         * @member {string} nickname
         * @memberof user.SimpleSSOUserInfo
         * @instance
         */
        SimpleSSOUserInfo.prototype.nickname = "";

        /**
         * SimpleSSOUserInfo avatar.
         * @member {string} avatar
         * @memberof user.SimpleSSOUserInfo
         * @instance
         */
        SimpleSSOUserInfo.prototype.avatar = "";

        /**
         * SimpleSSOUserInfo bio.
         * @member {string} bio
         * @memberof user.SimpleSSOUserInfo
         * @instance
         */
        SimpleSSOUserInfo.prototype.bio = "";

        /**
         * SimpleSSOUserInfo letter.
         * @member {string} letter
         * @memberof user.SimpleSSOUserInfo
         * @instance
         */
        SimpleSSOUserInfo.prototype.letter = "";

        /**
         * SimpleSSOUserInfo lastSeenTime.
         * @member {number|Long} lastSeenTime
         * @memberof user.SimpleSSOUserInfo
         * @instance
         */
        SimpleSSOUserInfo.prototype.lastSeenTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new SimpleSSOUserInfo instance using the specified properties.
         * @function create
         * @memberof user.SimpleSSOUserInfo
         * @static
         * @param {user.ISimpleSSOUserInfo=} [properties] Properties to set
         * @returns {user.SimpleSSOUserInfo} SimpleSSOUserInfo instance
         */
        SimpleSSOUserInfo.create = function create(properties) {
            return new SimpleSSOUserInfo(properties);
        };

        /**
         * Encodes the specified SimpleSSOUserInfo message. Does not implicitly {@link user.SimpleSSOUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.SimpleSSOUserInfo
         * @static
         * @param {user.ISimpleSSOUserInfo} message SimpleSSOUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SimpleSSOUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nickname);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.bio);
            if (message.letter != null && Object.hasOwnProperty.call(message, "letter"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.letter);
            if (message.lastSeenTime != null && Object.hasOwnProperty.call(message, "lastSeenTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastSeenTime);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.username);
            return writer;
        };

        /**
         * Encodes the specified SimpleSSOUserInfo message, length delimited. Does not implicitly {@link user.SimpleSSOUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.SimpleSSOUserInfo
         * @static
         * @param {user.ISimpleSSOUserInfo} message SimpleSSOUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SimpleSSOUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SimpleSSOUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.SimpleSSOUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.SimpleSSOUserInfo} SimpleSSOUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SimpleSSOUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SimpleSSOUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 7:
                    message.username = reader.string();
                    break;
                case 2:
                    message.nickname = reader.string();
                    break;
                case 3:
                    message.avatar = reader.string();
                    break;
                case 4:
                    message.bio = reader.string();
                    break;
                case 5:
                    message.letter = reader.string();
                    break;
                case 6:
                    message.lastSeenTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SimpleSSOUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.SimpleSSOUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.SimpleSSOUserInfo} SimpleSSOUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SimpleSSOUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SimpleSSOUserInfo message.
         * @function verify
         * @memberof user.SimpleSSOUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SimpleSSOUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            if (message.letter != null && message.hasOwnProperty("letter"))
                if (!$util.isString(message.letter))
                    return "letter: string expected";
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (!$util.isInteger(message.lastSeenTime) && !(message.lastSeenTime && $util.isInteger(message.lastSeenTime.low) && $util.isInteger(message.lastSeenTime.high)))
                    return "lastSeenTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a SimpleSSOUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.SimpleSSOUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.SimpleSSOUserInfo} SimpleSSOUserInfo
         */
        SimpleSSOUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.SimpleSSOUserInfo)
                return object;
            var message = new $root.user.SimpleSSOUserInfo();
            if (object.uid != null)
                message.uid = String(object.uid);
            if (object.username != null)
                message.username = String(object.username);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.bio != null)
                message.bio = String(object.bio);
            if (object.letter != null)
                message.letter = String(object.letter);
            if (object.lastSeenTime != null)
                if ($util.Long)
                    (message.lastSeenTime = $util.Long.fromValue(object.lastSeenTime)).unsigned = false;
                else if (typeof object.lastSeenTime === "string")
                    message.lastSeenTime = parseInt(object.lastSeenTime, 10);
                else if (typeof object.lastSeenTime === "number")
                    message.lastSeenTime = object.lastSeenTime;
                else if (typeof object.lastSeenTime === "object")
                    message.lastSeenTime = new $util.LongBits(object.lastSeenTime.low >>> 0, object.lastSeenTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a SimpleSSOUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.SimpleSSOUserInfo
         * @static
         * @param {user.SimpleSSOUserInfo} message SimpleSSOUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SimpleSSOUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = "";
                object.nickname = "";
                object.avatar = "";
                object.bio = "";
                object.letter = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastSeenTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastSeenTime = options.longs === String ? "0" : 0;
                object.username = "";
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            if (message.letter != null && message.hasOwnProperty("letter"))
                object.letter = message.letter;
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (typeof message.lastSeenTime === "number")
                    object.lastSeenTime = options.longs === String ? String(message.lastSeenTime) : message.lastSeenTime;
                else
                    object.lastSeenTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastSeenTime) : options.longs === Number ? new $util.LongBits(message.lastSeenTime.low >>> 0, message.lastSeenTime.high >>> 0).toNumber() : message.lastSeenTime;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            return object;
        };

        /**
         * Converts this SimpleSSOUserInfo to JSON.
         * @function toJSON
         * @memberof user.SimpleSSOUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SimpleSSOUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SimpleSSOUserInfo;
    })();

    user.SSOUserInfo = (function() {

        /**
         * Properties of a SSOUserInfo.
         * @memberof user
         * @interface ISSOUserInfo
         * @property {string|null} [uid] SSOUserInfo uid
         * @property {string|null} [username] SSOUserInfo username
         * @property {string|null} [email] SSOUserInfo email
         * @property {string|null} [phone] SSOUserInfo phone
         * @property {string|null} [nickname] SSOUserInfo nickname
         * @property {string|null} [avatar] SSOUserInfo avatar
         * @property {string|null} [bio] SSOUserInfo bio
         * @property {Array.<string>|null} [city] SSOUserInfo city
         * @property {number|Long|null} [gender] SSOUserInfo gender
         * @property {string|null} [birthday] SSOUserInfo birthday
         * @property {number|Long|null} [status] SSOUserInfo status
         * @property {user.SSOUserInfo.IAdditionalInformation|null} [additionalInformation] SSOUserInfo additionalInformation
         * @property {user.SSOUserInfo.IAppData|null} [appData] SSOUserInfo appData
         * @property {number|Long|null} [creationTime] SSOUserInfo creationTime
         * @property {number|Long|null} [lastUpdateTime] SSOUserInfo lastUpdateTime
         * @property {number|Long|null} [lastSeenTime] SSOUserInfo lastSeenTime
         */

        /**
         * Constructs a new SSOUserInfo.
         * @memberof user
         * @classdesc Represents a SSOUserInfo.
         * @implements ISSOUserInfo
         * @constructor
         * @param {user.ISSOUserInfo=} [properties] Properties to set
         */
        function SSOUserInfo(properties) {
            this.city = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SSOUserInfo uid.
         * @member {string} uid
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.uid = "";

        /**
         * SSOUserInfo username.
         * @member {string} username
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.username = "";

        /**
         * SSOUserInfo email.
         * @member {string} email
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.email = "";

        /**
         * SSOUserInfo phone.
         * @member {string} phone
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.phone = "";

        /**
         * SSOUserInfo nickname.
         * @member {string} nickname
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.nickname = "";

        /**
         * SSOUserInfo avatar.
         * @member {string} avatar
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.avatar = "";

        /**
         * SSOUserInfo bio.
         * @member {string} bio
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.bio = "";

        /**
         * SSOUserInfo city.
         * @member {Array.<string>} city
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.city = $util.emptyArray;

        /**
         * SSOUserInfo gender.
         * @member {number|Long} gender
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.gender = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo birthday.
         * @member {string} birthday
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.birthday = "";

        /**
         * SSOUserInfo status.
         * @member {number|Long} status
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo additionalInformation.
         * @member {user.SSOUserInfo.IAdditionalInformation|null|undefined} additionalInformation
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.additionalInformation = null;

        /**
         * SSOUserInfo appData.
         * @member {user.SSOUserInfo.IAppData|null|undefined} appData
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.appData = null;

        /**
         * SSOUserInfo creationTime.
         * @member {number|Long} creationTime
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo lastUpdateTime.
         * @member {number|Long} lastUpdateTime
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * SSOUserInfo lastSeenTime.
         * @member {number|Long} lastSeenTime
         * @memberof user.SSOUserInfo
         * @instance
         */
        SSOUserInfo.prototype.lastSeenTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new SSOUserInfo instance using the specified properties.
         * @function create
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo=} [properties] Properties to set
         * @returns {user.SSOUserInfo} SSOUserInfo instance
         */
        SSOUserInfo.create = function create(properties) {
            return new SSOUserInfo(properties);
        };

        /**
         * Encodes the specified SSOUserInfo message. Does not implicitly {@link user.SSOUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo} message SSOUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SSOUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
            if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.phone);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.nickname);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.avatar);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.bio);
            if (message.city != null && message.city.length)
                for (var i = 0; i < message.city.length; ++i)
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.city[i]);
            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.gender);
            if (message.birthday != null && Object.hasOwnProperty.call(message, "birthday"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.birthday);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.status);
            if (message.additionalInformation != null && Object.hasOwnProperty.call(message, "additionalInformation"))
                $root.user.SSOUserInfo.AdditionalInformation.encode(message.additionalInformation, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.appData != null && Object.hasOwnProperty.call(message, "appData"))
                $root.user.SSOUserInfo.AppData.encode(message.appData, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.creationTime != null && Object.hasOwnProperty.call(message, "creationTime"))
                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.creationTime);
            if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.lastUpdateTime);
            if (message.lastSeenTime != null && Object.hasOwnProperty.call(message, "lastSeenTime"))
                writer.uint32(/* id 16, wireType 0 =*/128).int64(message.lastSeenTime);
            return writer;
        };

        /**
         * Encodes the specified SSOUserInfo message, length delimited. Does not implicitly {@link user.SSOUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.ISSOUserInfo} message SSOUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SSOUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SSOUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.SSOUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.SSOUserInfo} SSOUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SSOUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SSOUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.username = reader.string();
                    break;
                case 3:
                    message.email = reader.string();
                    break;
                case 4:
                    message.phone = reader.string();
                    break;
                case 5:
                    message.nickname = reader.string();
                    break;
                case 6:
                    message.avatar = reader.string();
                    break;
                case 7:
                    message.bio = reader.string();
                    break;
                case 8:
                    if (!(message.city && message.city.length))
                        message.city = [];
                    message.city.push(reader.string());
                    break;
                case 9:
                    message.gender = reader.int64();
                    break;
                case 10:
                    message.birthday = reader.string();
                    break;
                case 11:
                    message.status = reader.int64();
                    break;
                case 12:
                    message.additionalInformation = $root.user.SSOUserInfo.AdditionalInformation.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.appData = $root.user.SSOUserInfo.AppData.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.creationTime = reader.int64();
                    break;
                case 15:
                    message.lastUpdateTime = reader.int64();
                    break;
                case 16:
                    message.lastSeenTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SSOUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.SSOUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.SSOUserInfo} SSOUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SSOUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SSOUserInfo message.
         * @function verify
         * @memberof user.SSOUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SSOUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.email != null && message.hasOwnProperty("email"))
                if (!$util.isString(message.email))
                    return "email: string expected";
            if (message.phone != null && message.hasOwnProperty("phone"))
                if (!$util.isString(message.phone))
                    return "phone: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            if (message.city != null && message.hasOwnProperty("city")) {
                if (!Array.isArray(message.city))
                    return "city: array expected";
                for (var i = 0; i < message.city.length; ++i)
                    if (!$util.isString(message.city[i]))
                        return "city: string[] expected";
            }
            if (message.gender != null && message.hasOwnProperty("gender"))
                if (!$util.isInteger(message.gender) && !(message.gender && $util.isInteger(message.gender.low) && $util.isInteger(message.gender.high)))
                    return "gender: integer|Long expected";
            if (message.birthday != null && message.hasOwnProperty("birthday"))
                if (!$util.isString(message.birthday))
                    return "birthday: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.additionalInformation != null && message.hasOwnProperty("additionalInformation")) {
                var error = $root.user.SSOUserInfo.AdditionalInformation.verify(message.additionalInformation);
                if (error)
                    return "additionalInformation." + error;
            }
            if (message.appData != null && message.hasOwnProperty("appData")) {
                var error = $root.user.SSOUserInfo.AppData.verify(message.appData);
                if (error)
                    return "appData." + error;
            }
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (!$util.isInteger(message.creationTime) && !(message.creationTime && $util.isInteger(message.creationTime.low) && $util.isInteger(message.creationTime.high)))
                    return "creationTime: integer|Long expected";
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                    return "lastUpdateTime: integer|Long expected";
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (!$util.isInteger(message.lastSeenTime) && !(message.lastSeenTime && $util.isInteger(message.lastSeenTime.low) && $util.isInteger(message.lastSeenTime.high)))
                    return "lastSeenTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a SSOUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.SSOUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.SSOUserInfo} SSOUserInfo
         */
        SSOUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.SSOUserInfo)
                return object;
            var message = new $root.user.SSOUserInfo();
            if (object.uid != null)
                message.uid = String(object.uid);
            if (object.username != null)
                message.username = String(object.username);
            if (object.email != null)
                message.email = String(object.email);
            if (object.phone != null)
                message.phone = String(object.phone);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.bio != null)
                message.bio = String(object.bio);
            if (object.city) {
                if (!Array.isArray(object.city))
                    throw TypeError(".user.SSOUserInfo.city: array expected");
                message.city = [];
                for (var i = 0; i < object.city.length; ++i)
                    message.city[i] = String(object.city[i]);
            }
            if (object.gender != null)
                if ($util.Long)
                    (message.gender = $util.Long.fromValue(object.gender)).unsigned = false;
                else if (typeof object.gender === "string")
                    message.gender = parseInt(object.gender, 10);
                else if (typeof object.gender === "number")
                    message.gender = object.gender;
                else if (typeof object.gender === "object")
                    message.gender = new $util.LongBits(object.gender.low >>> 0, object.gender.high >>> 0).toNumber();
            if (object.birthday != null)
                message.birthday = String(object.birthday);
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.additionalInformation != null) {
                if (typeof object.additionalInformation !== "object")
                    throw TypeError(".user.SSOUserInfo.additionalInformation: object expected");
                message.additionalInformation = $root.user.SSOUserInfo.AdditionalInformation.fromObject(object.additionalInformation);
            }
            if (object.appData != null) {
                if (typeof object.appData !== "object")
                    throw TypeError(".user.SSOUserInfo.appData: object expected");
                message.appData = $root.user.SSOUserInfo.AppData.fromObject(object.appData);
            }
            if (object.creationTime != null)
                if ($util.Long)
                    (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = false;
                else if (typeof object.creationTime === "string")
                    message.creationTime = parseInt(object.creationTime, 10);
                else if (typeof object.creationTime === "number")
                    message.creationTime = object.creationTime;
                else if (typeof object.creationTime === "object")
                    message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber();
            if (object.lastUpdateTime != null)
                if ($util.Long)
                    (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                else if (typeof object.lastUpdateTime === "string")
                    message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                else if (typeof object.lastUpdateTime === "number")
                    message.lastUpdateTime = object.lastUpdateTime;
                else if (typeof object.lastUpdateTime === "object")
                    message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
            if (object.lastSeenTime != null)
                if ($util.Long)
                    (message.lastSeenTime = $util.Long.fromValue(object.lastSeenTime)).unsigned = false;
                else if (typeof object.lastSeenTime === "string")
                    message.lastSeenTime = parseInt(object.lastSeenTime, 10);
                else if (typeof object.lastSeenTime === "number")
                    message.lastSeenTime = object.lastSeenTime;
                else if (typeof object.lastSeenTime === "object")
                    message.lastSeenTime = new $util.LongBits(object.lastSeenTime.low >>> 0, object.lastSeenTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a SSOUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.SSOUserInfo
         * @static
         * @param {user.SSOUserInfo} message SSOUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SSOUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.city = [];
            if (options.defaults) {
                object.uid = "";
                object.username = "";
                object.email = "";
                object.phone = "";
                object.nickname = "";
                object.avatar = "";
                object.bio = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.gender = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.gender = options.longs === String ? "0" : 0;
                object.birthday = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                object.additionalInformation = null;
                object.appData = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.creationTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdateTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastSeenTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastSeenTime = options.longs === String ? "0" : 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.email != null && message.hasOwnProperty("email"))
                object.email = message.email;
            if (message.phone != null && message.hasOwnProperty("phone"))
                object.phone = message.phone;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            if (message.city && message.city.length) {
                object.city = [];
                for (var j = 0; j < message.city.length; ++j)
                    object.city[j] = message.city[j];
            }
            if (message.gender != null && message.hasOwnProperty("gender"))
                if (typeof message.gender === "number")
                    object.gender = options.longs === String ? String(message.gender) : message.gender;
                else
                    object.gender = options.longs === String ? $util.Long.prototype.toString.call(message.gender) : options.longs === Number ? new $util.LongBits(message.gender.low >>> 0, message.gender.high >>> 0).toNumber() : message.gender;
            if (message.birthday != null && message.hasOwnProperty("birthday"))
                object.birthday = message.birthday;
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.additionalInformation != null && message.hasOwnProperty("additionalInformation"))
                object.additionalInformation = $root.user.SSOUserInfo.AdditionalInformation.toObject(message.additionalInformation, options);
            if (message.appData != null && message.hasOwnProperty("appData"))
                object.appData = $root.user.SSOUserInfo.AppData.toObject(message.appData, options);
            if (message.creationTime != null && message.hasOwnProperty("creationTime"))
                if (typeof message.creationTime === "number")
                    object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
                else
                    object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber() : message.creationTime;
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (typeof message.lastUpdateTime === "number")
                    object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                else
                    object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (typeof message.lastSeenTime === "number")
                    object.lastSeenTime = options.longs === String ? String(message.lastSeenTime) : message.lastSeenTime;
                else
                    object.lastSeenTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastSeenTime) : options.longs === Number ? new $util.LongBits(message.lastSeenTime.low >>> 0, message.lastSeenTime.high >>> 0).toNumber() : message.lastSeenTime;
            return object;
        };

        /**
         * Converts this SSOUserInfo to JSON.
         * @function toJSON
         * @memberof user.SSOUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SSOUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SSOUserInfo.AdditionalInformation = (function() {

            /**
             * Properties of an AdditionalInformation.
             * @memberof user.SSOUserInfo
             * @interface IAdditionalInformation
             */

            /**
             * Constructs a new AdditionalInformation.
             * @memberof user.SSOUserInfo
             * @classdesc Represents an AdditionalInformation.
             * @implements IAdditionalInformation
             * @constructor
             * @param {user.SSOUserInfo.IAdditionalInformation=} [properties] Properties to set
             */
            function AdditionalInformation(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AdditionalInformation instance using the specified properties.
             * @function create
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {user.SSOUserInfo.IAdditionalInformation=} [properties] Properties to set
             * @returns {user.SSOUserInfo.AdditionalInformation} AdditionalInformation instance
             */
            AdditionalInformation.create = function create(properties) {
                return new AdditionalInformation(properties);
            };

            /**
             * Encodes the specified AdditionalInformation message. Does not implicitly {@link user.SSOUserInfo.AdditionalInformation.verify|verify} messages.
             * @function encode
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {user.SSOUserInfo.IAdditionalInformation} message AdditionalInformation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AdditionalInformation.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AdditionalInformation message, length delimited. Does not implicitly {@link user.SSOUserInfo.AdditionalInformation.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {user.SSOUserInfo.IAdditionalInformation} message AdditionalInformation message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AdditionalInformation.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AdditionalInformation message from the specified reader or buffer.
             * @function decode
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.SSOUserInfo.AdditionalInformation} AdditionalInformation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AdditionalInformation.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SSOUserInfo.AdditionalInformation();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AdditionalInformation message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.SSOUserInfo.AdditionalInformation} AdditionalInformation
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AdditionalInformation.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AdditionalInformation message.
             * @function verify
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AdditionalInformation.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AdditionalInformation message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.SSOUserInfo.AdditionalInformation} AdditionalInformation
             */
            AdditionalInformation.fromObject = function fromObject(object) {
                if (object instanceof $root.user.SSOUserInfo.AdditionalInformation)
                    return object;
                return new $root.user.SSOUserInfo.AdditionalInformation();
            };

            /**
             * Creates a plain object from an AdditionalInformation message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @static
             * @param {user.SSOUserInfo.AdditionalInformation} message AdditionalInformation
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AdditionalInformation.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AdditionalInformation to JSON.
             * @function toJSON
             * @memberof user.SSOUserInfo.AdditionalInformation
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AdditionalInformation.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AdditionalInformation;
        })();

        SSOUserInfo.AppData = (function() {

            /**
             * Properties of an AppData.
             * @memberof user.SSOUserInfo
             * @interface IAppData
             */

            /**
             * Constructs a new AppData.
             * @memberof user.SSOUserInfo
             * @classdesc Represents an AppData.
             * @implements IAppData
             * @constructor
             * @param {user.SSOUserInfo.IAppData=} [properties] Properties to set
             */
            function AppData(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new AppData instance using the specified properties.
             * @function create
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {user.SSOUserInfo.IAppData=} [properties] Properties to set
             * @returns {user.SSOUserInfo.AppData} AppData instance
             */
            AppData.create = function create(properties) {
                return new AppData(properties);
            };

            /**
             * Encodes the specified AppData message. Does not implicitly {@link user.SSOUserInfo.AppData.verify|verify} messages.
             * @function encode
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {user.SSOUserInfo.IAppData} message AppData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified AppData message, length delimited. Does not implicitly {@link user.SSOUserInfo.AppData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {user.SSOUserInfo.IAppData} message AppData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            AppData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an AppData message from the specified reader or buffer.
             * @function decode
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.SSOUserInfo.AppData} AppData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppData.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SSOUserInfo.AppData();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an AppData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.SSOUserInfo.AppData} AppData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            AppData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an AppData message.
             * @function verify
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            AppData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates an AppData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.SSOUserInfo.AppData} AppData
             */
            AppData.fromObject = function fromObject(object) {
                if (object instanceof $root.user.SSOUserInfo.AppData)
                    return object;
                return new $root.user.SSOUserInfo.AppData();
            };

            /**
             * Creates a plain object from an AppData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.SSOUserInfo.AppData
             * @static
             * @param {user.SSOUserInfo.AppData} message AppData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            AppData.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this AppData to JSON.
             * @function toJSON
             * @memberof user.SSOUserInfo.AppData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            AppData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return AppData;
        })();

        return SSOUserInfo;
    })();

    user.UpdateLoginUserProfile = (function() {

        /**
         * Properties of an UpdateLoginUserProfile.
         * @memberof user
         * @interface IUpdateLoginUserProfile
         */

        /**
         * Constructs a new UpdateLoginUserProfile.
         * @memberof user
         * @classdesc Represents an UpdateLoginUserProfile.
         * @implements IUpdateLoginUserProfile
         * @constructor
         * @param {user.IUpdateLoginUserProfile=} [properties] Properties to set
         */
        function UpdateLoginUserProfile(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateLoginUserProfile instance using the specified properties.
         * @function create
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {user.IUpdateLoginUserProfile=} [properties] Properties to set
         * @returns {user.UpdateLoginUserProfile} UpdateLoginUserProfile instance
         */
        UpdateLoginUserProfile.create = function create(properties) {
            return new UpdateLoginUserProfile(properties);
        };

        /**
         * Encodes the specified UpdateLoginUserProfile message. Does not implicitly {@link user.UpdateLoginUserProfile.verify|verify} messages.
         * @function encode
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {user.IUpdateLoginUserProfile} message UpdateLoginUserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateLoginUserProfile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UpdateLoginUserProfile message, length delimited. Does not implicitly {@link user.UpdateLoginUserProfile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {user.IUpdateLoginUserProfile} message UpdateLoginUserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateLoginUserProfile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateLoginUserProfile message from the specified reader or buffer.
         * @function decode
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.UpdateLoginUserProfile} UpdateLoginUserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateLoginUserProfile.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateLoginUserProfile();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateLoginUserProfile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.UpdateLoginUserProfile} UpdateLoginUserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateLoginUserProfile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateLoginUserProfile message.
         * @function verify
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateLoginUserProfile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UpdateLoginUserProfile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.UpdateLoginUserProfile} UpdateLoginUserProfile
         */
        UpdateLoginUserProfile.fromObject = function fromObject(object) {
            if (object instanceof $root.user.UpdateLoginUserProfile)
                return object;
            return new $root.user.UpdateLoginUserProfile();
        };

        /**
         * Creates a plain object from an UpdateLoginUserProfile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.UpdateLoginUserProfile
         * @static
         * @param {user.UpdateLoginUserProfile} message UpdateLoginUserProfile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateLoginUserProfile.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateLoginUserProfile to JSON.
         * @function toJSON
         * @memberof user.UpdateLoginUserProfile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateLoginUserProfile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UpdateLoginUserProfile.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.UpdateLoginUserProfile
             * @interface IRequest
             * @property {string|null} [userToken] Request userToken
             * @property {string|null} [avatar] Request avatar
             * @property {string|null} [username] Request username
             * @property {string|null} [nickname] Request nickname
             * @property {string|null} [bio] Request bio
             */

            /**
             * Constructs a new Request.
             * @memberof user.UpdateLoginUserProfile
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.UpdateLoginUserProfile.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request userToken.
             * @member {string} userToken
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.userToken = "";

            /**
             * Request avatar.
             * @member {string} avatar
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.avatar = "";

            /**
             * Request username.
             * @member {string} username
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.username = "";

            /**
             * Request nickname.
             * @member {string} nickname
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.nickname = "";

            /**
             * Request bio.
             * @member {string} bio
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             */
            Request.prototype.bio = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {user.UpdateLoginUserProfile.IRequest=} [properties] Properties to set
             * @returns {user.UpdateLoginUserProfile.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.UpdateLoginUserProfile.Request.verify|verify} messages.
             * @function encode
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {user.UpdateLoginUserProfile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userToken != null && Object.hasOwnProperty.call(message, "userToken"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userToken);
                if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
                if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.username);
                if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
                if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.bio);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.UpdateLoginUserProfile.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {user.UpdateLoginUserProfile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UpdateLoginUserProfile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateLoginUserProfile.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.userToken = reader.string();
                        break;
                    case 2:
                        message.avatar = reader.string();
                        break;
                    case 3:
                        message.username = reader.string();
                        break;
                    case 4:
                        message.nickname = reader.string();
                        break;
                    case 5:
                        message.bio = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UpdateLoginUserProfile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userToken != null && message.hasOwnProperty("userToken"))
                    if (!$util.isString(message.userToken))
                        return "userToken: string expected";
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    if (!$util.isString(message.avatar))
                        return "avatar: string expected";
                if (message.username != null && message.hasOwnProperty("username"))
                    if (!$util.isString(message.username))
                        return "username: string expected";
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    if (!$util.isString(message.nickname))
                        return "nickname: string expected";
                if (message.bio != null && message.hasOwnProperty("bio"))
                    if (!$util.isString(message.bio))
                        return "bio: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UpdateLoginUserProfile.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UpdateLoginUserProfile.Request)
                    return object;
                var message = new $root.user.UpdateLoginUserProfile.Request();
                if (object.userToken != null)
                    message.userToken = String(object.userToken);
                if (object.avatar != null)
                    message.avatar = String(object.avatar);
                if (object.username != null)
                    message.username = String(object.username);
                if (object.nickname != null)
                    message.nickname = String(object.nickname);
                if (object.bio != null)
                    message.bio = String(object.bio);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UpdateLoginUserProfile.Request
             * @static
             * @param {user.UpdateLoginUserProfile.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userToken = "";
                    object.avatar = "";
                    object.username = "";
                    object.nickname = "";
                    object.bio = "";
                }
                if (message.userToken != null && message.hasOwnProperty("userToken"))
                    object.userToken = message.userToken;
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    object.avatar = message.avatar;
                if (message.username != null && message.hasOwnProperty("username"))
                    object.username = message.username;
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    object.nickname = message.nickname;
                if (message.bio != null && message.hasOwnProperty("bio"))
                    object.bio = message.bio;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.UpdateLoginUserProfile.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        UpdateLoginUserProfile.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.UpdateLoginUserProfile
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [token] Response token
             * @property {user.ISSOUserInfo|null} [userInfo] Response userInfo
             */

            /**
             * Constructs a new Response.
             * @memberof user.UpdateLoginUserProfile
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.UpdateLoginUserProfile.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof user.UpdateLoginUserProfile.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof user.UpdateLoginUserProfile.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response userInfo.
             * @member {user.ISSOUserInfo|null|undefined} userInfo
             * @memberof user.UpdateLoginUserProfile.Response
             * @instance
             */
            Response.prototype.userInfo = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {user.UpdateLoginUserProfile.IResponse=} [properties] Properties to set
             * @returns {user.UpdateLoginUserProfile.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.UpdateLoginUserProfile.Response.verify|verify} messages.
             * @function encode
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {user.UpdateLoginUserProfile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.SSOUserInfo.encode(message.userInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.UpdateLoginUserProfile.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {user.UpdateLoginUserProfile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UpdateLoginUserProfile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateLoginUserProfile.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.token = reader.string();
                        break;
                    case 3:
                        message.userInfo = $root.user.SSOUserInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UpdateLoginUserProfile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.SSOUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UpdateLoginUserProfile.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UpdateLoginUserProfile.Response)
                    return object;
                var message = new $root.user.UpdateLoginUserProfile.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".user.UpdateLoginUserProfile.Response.userInfo: object expected");
                    message.userInfo = $root.user.SSOUserInfo.fromObject(object.userInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UpdateLoginUserProfile.Response
             * @static
             * @param {user.UpdateLoginUserProfile.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.token = "";
                    object.userInfo = null;
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.SSOUserInfo.toObject(message.userInfo, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.UpdateLoginUserProfile.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return UpdateLoginUserProfile;
    })();

    user.UpdateAnonymousUserProfile = (function() {

        /**
         * Properties of an UpdateAnonymousUserProfile.
         * @memberof user
         * @interface IUpdateAnonymousUserProfile
         */

        /**
         * Constructs a new UpdateAnonymousUserProfile.
         * @memberof user
         * @classdesc Represents an UpdateAnonymousUserProfile.
         * @implements IUpdateAnonymousUserProfile
         * @constructor
         * @param {user.IUpdateAnonymousUserProfile=} [properties] Properties to set
         */
        function UpdateAnonymousUserProfile(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateAnonymousUserProfile instance using the specified properties.
         * @function create
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {user.IUpdateAnonymousUserProfile=} [properties] Properties to set
         * @returns {user.UpdateAnonymousUserProfile} UpdateAnonymousUserProfile instance
         */
        UpdateAnonymousUserProfile.create = function create(properties) {
            return new UpdateAnonymousUserProfile(properties);
        };

        /**
         * Encodes the specified UpdateAnonymousUserProfile message. Does not implicitly {@link user.UpdateAnonymousUserProfile.verify|verify} messages.
         * @function encode
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {user.IUpdateAnonymousUserProfile} message UpdateAnonymousUserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAnonymousUserProfile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UpdateAnonymousUserProfile message, length delimited. Does not implicitly {@link user.UpdateAnonymousUserProfile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {user.IUpdateAnonymousUserProfile} message UpdateAnonymousUserProfile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateAnonymousUserProfile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateAnonymousUserProfile message from the specified reader or buffer.
         * @function decode
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.UpdateAnonymousUserProfile} UpdateAnonymousUserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAnonymousUserProfile.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateAnonymousUserProfile();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateAnonymousUserProfile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.UpdateAnonymousUserProfile} UpdateAnonymousUserProfile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateAnonymousUserProfile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateAnonymousUserProfile message.
         * @function verify
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateAnonymousUserProfile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UpdateAnonymousUserProfile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.UpdateAnonymousUserProfile} UpdateAnonymousUserProfile
         */
        UpdateAnonymousUserProfile.fromObject = function fromObject(object) {
            if (object instanceof $root.user.UpdateAnonymousUserProfile)
                return object;
            return new $root.user.UpdateAnonymousUserProfile();
        };

        /**
         * Creates a plain object from an UpdateAnonymousUserProfile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.UpdateAnonymousUserProfile
         * @static
         * @param {user.UpdateAnonymousUserProfile} message UpdateAnonymousUserProfile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateAnonymousUserProfile.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateAnonymousUserProfile to JSON.
         * @function toJSON
         * @memberof user.UpdateAnonymousUserProfile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateAnonymousUserProfile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UpdateAnonymousUserProfile.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.UpdateAnonymousUserProfile
             * @interface IRequest
             * @property {string|null} [userToken] Request userToken
             * @property {string|null} [avatar] Request avatar
             * @property {string|null} [username] Request username
             * @property {string|null} [nickname] Request nickname
             * @property {string|null} [bio] Request bio
             */

            /**
             * Constructs a new Request.
             * @memberof user.UpdateAnonymousUserProfile
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.UpdateAnonymousUserProfile.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request userToken.
             * @member {string} userToken
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.userToken = "";

            /**
             * Request avatar.
             * @member {string} avatar
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.avatar = "";

            /**
             * Request username.
             * @member {string} username
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.username = "";

            /**
             * Request nickname.
             * @member {string} nickname
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.nickname = "";

            /**
             * Request bio.
             * @member {string} bio
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             */
            Request.prototype.bio = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {user.UpdateAnonymousUserProfile.IRequest=} [properties] Properties to set
             * @returns {user.UpdateAnonymousUserProfile.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.UpdateAnonymousUserProfile.Request.verify|verify} messages.
             * @function encode
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {user.UpdateAnonymousUserProfile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userToken != null && Object.hasOwnProperty.call(message, "userToken"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userToken);
                if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
                if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.username);
                if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.nickname);
                if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.bio);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.UpdateAnonymousUserProfile.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {user.UpdateAnonymousUserProfile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UpdateAnonymousUserProfile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateAnonymousUserProfile.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.userToken = reader.string();
                        break;
                    case 2:
                        message.avatar = reader.string();
                        break;
                    case 3:
                        message.username = reader.string();
                        break;
                    case 4:
                        message.nickname = reader.string();
                        break;
                    case 5:
                        message.bio = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UpdateAnonymousUserProfile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userToken != null && message.hasOwnProperty("userToken"))
                    if (!$util.isString(message.userToken))
                        return "userToken: string expected";
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    if (!$util.isString(message.avatar))
                        return "avatar: string expected";
                if (message.username != null && message.hasOwnProperty("username"))
                    if (!$util.isString(message.username))
                        return "username: string expected";
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    if (!$util.isString(message.nickname))
                        return "nickname: string expected";
                if (message.bio != null && message.hasOwnProperty("bio"))
                    if (!$util.isString(message.bio))
                        return "bio: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UpdateAnonymousUserProfile.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UpdateAnonymousUserProfile.Request)
                    return object;
                var message = new $root.user.UpdateAnonymousUserProfile.Request();
                if (object.userToken != null)
                    message.userToken = String(object.userToken);
                if (object.avatar != null)
                    message.avatar = String(object.avatar);
                if (object.username != null)
                    message.username = String(object.username);
                if (object.nickname != null)
                    message.nickname = String(object.nickname);
                if (object.bio != null)
                    message.bio = String(object.bio);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @static
             * @param {user.UpdateAnonymousUserProfile.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userToken = "";
                    object.avatar = "";
                    object.username = "";
                    object.nickname = "";
                    object.bio = "";
                }
                if (message.userToken != null && message.hasOwnProperty("userToken"))
                    object.userToken = message.userToken;
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    object.avatar = message.avatar;
                if (message.username != null && message.hasOwnProperty("username"))
                    object.username = message.username;
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    object.nickname = message.nickname;
                if (message.bio != null && message.hasOwnProperty("bio"))
                    object.bio = message.bio;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.UpdateAnonymousUserProfile.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        UpdateAnonymousUserProfile.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.UpdateAnonymousUserProfile
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [token] Response token
             * @property {user.ISSOUserInfo|null} [userInfo] Response userInfo
             */

            /**
             * Constructs a new Response.
             * @memberof user.UpdateAnonymousUserProfile
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.UpdateAnonymousUserProfile.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response userInfo.
             * @member {user.ISSOUserInfo|null|undefined} userInfo
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @instance
             */
            Response.prototype.userInfo = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {user.UpdateAnonymousUserProfile.IResponse=} [properties] Properties to set
             * @returns {user.UpdateAnonymousUserProfile.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.UpdateAnonymousUserProfile.Response.verify|verify} messages.
             * @function encode
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {user.UpdateAnonymousUserProfile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.SSOUserInfo.encode(message.userInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.UpdateAnonymousUserProfile.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {user.UpdateAnonymousUserProfile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UpdateAnonymousUserProfile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UpdateAnonymousUserProfile.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.token = reader.string();
                        break;
                    case 3:
                        message.userInfo = $root.user.SSOUserInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UpdateAnonymousUserProfile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.SSOUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UpdateAnonymousUserProfile.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UpdateAnonymousUserProfile.Response)
                    return object;
                var message = new $root.user.UpdateAnonymousUserProfile.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".user.UpdateAnonymousUserProfile.Response.userInfo: object expected");
                    message.userInfo = $root.user.SSOUserInfo.fromObject(object.userInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @static
             * @param {user.UpdateAnonymousUserProfile.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.token = "";
                    object.userInfo = null;
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.SSOUserInfo.toObject(message.userInfo, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.UpdateAnonymousUserProfile.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return UpdateAnonymousUserProfile;
    })();

    user.GetAnonymousUserTokenByCloneUserData = (function() {

        /**
         * Properties of a GetAnonymousUserTokenByCloneUserData.
         * @memberof user
         * @interface IGetAnonymousUserTokenByCloneUserData
         */

        /**
         * Constructs a new GetAnonymousUserTokenByCloneUserData.
         * @memberof user
         * @classdesc Represents a GetAnonymousUserTokenByCloneUserData.
         * @implements IGetAnonymousUserTokenByCloneUserData
         * @constructor
         * @param {user.IGetAnonymousUserTokenByCloneUserData=} [properties] Properties to set
         */
        function GetAnonymousUserTokenByCloneUserData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetAnonymousUserTokenByCloneUserData instance using the specified properties.
         * @function create
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {user.IGetAnonymousUserTokenByCloneUserData=} [properties] Properties to set
         * @returns {user.GetAnonymousUserTokenByCloneUserData} GetAnonymousUserTokenByCloneUserData instance
         */
        GetAnonymousUserTokenByCloneUserData.create = function create(properties) {
            return new GetAnonymousUserTokenByCloneUserData(properties);
        };

        /**
         * Encodes the specified GetAnonymousUserTokenByCloneUserData message. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.verify|verify} messages.
         * @function encode
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {user.IGetAnonymousUserTokenByCloneUserData} message GetAnonymousUserTokenByCloneUserData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAnonymousUserTokenByCloneUserData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetAnonymousUserTokenByCloneUserData message, length delimited. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {user.IGetAnonymousUserTokenByCloneUserData} message GetAnonymousUserTokenByCloneUserData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAnonymousUserTokenByCloneUserData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAnonymousUserTokenByCloneUserData message from the specified reader or buffer.
         * @function decode
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.GetAnonymousUserTokenByCloneUserData} GetAnonymousUserTokenByCloneUserData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAnonymousUserTokenByCloneUserData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GetAnonymousUserTokenByCloneUserData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAnonymousUserTokenByCloneUserData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.GetAnonymousUserTokenByCloneUserData} GetAnonymousUserTokenByCloneUserData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAnonymousUserTokenByCloneUserData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAnonymousUserTokenByCloneUserData message.
         * @function verify
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAnonymousUserTokenByCloneUserData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetAnonymousUserTokenByCloneUserData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.GetAnonymousUserTokenByCloneUserData} GetAnonymousUserTokenByCloneUserData
         */
        GetAnonymousUserTokenByCloneUserData.fromObject = function fromObject(object) {
            if (object instanceof $root.user.GetAnonymousUserTokenByCloneUserData)
                return object;
            return new $root.user.GetAnonymousUserTokenByCloneUserData();
        };

        /**
         * Creates a plain object from a GetAnonymousUserTokenByCloneUserData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @static
         * @param {user.GetAnonymousUserTokenByCloneUserData} message GetAnonymousUserTokenByCloneUserData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAnonymousUserTokenByCloneUserData.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetAnonymousUserTokenByCloneUserData to JSON.
         * @function toJSON
         * @memberof user.GetAnonymousUserTokenByCloneUserData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAnonymousUserTokenByCloneUserData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetAnonymousUserTokenByCloneUserData.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.GetAnonymousUserTokenByCloneUserData
             * @interface IRequest
             * @property {string|null} [cloneUserToken] Request cloneUserToken
             * @property {string|null} [cloneUserDeviceId] Request cloneUserDeviceId
             */

            /**
             * Constructs a new Request.
             * @memberof user.GetAnonymousUserTokenByCloneUserData
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.GetAnonymousUserTokenByCloneUserData.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request cloneUserToken.
             * @member {string} cloneUserToken
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @instance
             */
            Request.prototype.cloneUserToken = "";

            /**
             * Request cloneUserDeviceId.
             * @member {string} cloneUserDeviceId
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @instance
             */
            Request.prototype.cloneUserDeviceId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IRequest=} [properties] Properties to set
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.Request.verify|verify} messages.
             * @function encode
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.cloneUserToken != null && Object.hasOwnProperty.call(message, "cloneUserToken"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.cloneUserToken);
                if (message.cloneUserDeviceId != null && Object.hasOwnProperty.call(message, "cloneUserDeviceId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.cloneUserDeviceId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GetAnonymousUserTokenByCloneUserData.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.cloneUserToken = reader.string();
                        break;
                    case 2:
                        message.cloneUserDeviceId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.cloneUserToken != null && message.hasOwnProperty("cloneUserToken"))
                    if (!$util.isString(message.cloneUserToken))
                        return "cloneUserToken: string expected";
                if (message.cloneUserDeviceId != null && message.hasOwnProperty("cloneUserDeviceId"))
                    if (!$util.isString(message.cloneUserDeviceId))
                        return "cloneUserDeviceId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.GetAnonymousUserTokenByCloneUserData.Request)
                    return object;
                var message = new $root.user.GetAnonymousUserTokenByCloneUserData.Request();
                if (object.cloneUserToken != null)
                    message.cloneUserToken = String(object.cloneUserToken);
                if (object.cloneUserDeviceId != null)
                    message.cloneUserDeviceId = String(object.cloneUserDeviceId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.cloneUserToken = "";
                    object.cloneUserDeviceId = "";
                }
                if (message.cloneUserToken != null && message.hasOwnProperty("cloneUserToken"))
                    object.cloneUserToken = message.cloneUserToken;
                if (message.cloneUserDeviceId != null && message.hasOwnProperty("cloneUserDeviceId"))
                    object.cloneUserDeviceId = message.cloneUserDeviceId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetAnonymousUserTokenByCloneUserData.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.GetAnonymousUserTokenByCloneUserData
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [token] Response token
             * @property {user.ISSOUserInfo|null} [userInfo] Response userInfo
             */

            /**
             * Constructs a new Response.
             * @memberof user.GetAnonymousUserTokenByCloneUserData
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.GetAnonymousUserTokenByCloneUserData.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response userInfo.
             * @member {user.ISSOUserInfo|null|undefined} userInfo
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @instance
             */
            Response.prototype.userInfo = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IResponse=} [properties] Properties to set
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.Response.verify|verify} messages.
             * @function encode
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.SSOUserInfo.encode(message.userInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.GetAnonymousUserTokenByCloneUserData.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.GetAnonymousUserTokenByCloneUserData.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.token = reader.string();
                        break;
                    case 3:
                        message.userInfo = $root.user.SSOUserInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.SSOUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.GetAnonymousUserTokenByCloneUserData.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.GetAnonymousUserTokenByCloneUserData.Response)
                    return object;
                var message = new $root.user.GetAnonymousUserTokenByCloneUserData.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".user.GetAnonymousUserTokenByCloneUserData.Response.userInfo: object expected");
                    message.userInfo = $root.user.SSOUserInfo.fromObject(object.userInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @static
             * @param {user.GetAnonymousUserTokenByCloneUserData.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.token = "";
                    object.userInfo = null;
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.SSOUserInfo.toObject(message.userInfo, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.GetAnonymousUserTokenByCloneUserData.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetAnonymousUserTokenByCloneUserData;
    })();

    user.UserAgent = (function() {

        /**
         * Properties of a UserAgent.
         * @memberof user
         * @interface IUserAgent
         * @property {user.UserAgent.IBrowser|null} [browser] UserAgent browser
         * @property {user.UserAgent.IDevice|null} [device] UserAgent device
         * @property {user.UserAgent.IOS|null} [os] UserAgent os
         * @property {string|null} [deviceName] UserAgent deviceName
         */

        /**
         * Constructs a new UserAgent.
         * @memberof user
         * @classdesc Represents a UserAgent.
         * @implements IUserAgent
         * @constructor
         * @param {user.IUserAgent=} [properties] Properties to set
         */
        function UserAgent(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserAgent browser.
         * @member {user.UserAgent.IBrowser|null|undefined} browser
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.browser = null;

        /**
         * UserAgent device.
         * @member {user.UserAgent.IDevice|null|undefined} device
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.device = null;

        /**
         * UserAgent os.
         * @member {user.UserAgent.IOS|null|undefined} os
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.os = null;

        /**
         * UserAgent deviceName.
         * @member {string} deviceName
         * @memberof user.UserAgent
         * @instance
         */
        UserAgent.prototype.deviceName = "";

        /**
         * Creates a new UserAgent instance using the specified properties.
         * @function create
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent=} [properties] Properties to set
         * @returns {user.UserAgent} UserAgent instance
         */
        UserAgent.create = function create(properties) {
            return new UserAgent(properties);
        };

        /**
         * Encodes the specified UserAgent message. Does not implicitly {@link user.UserAgent.verify|verify} messages.
         * @function encode
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent} message UserAgent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserAgent.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.browser != null && Object.hasOwnProperty.call(message, "browser"))
                $root.user.UserAgent.Browser.encode(message.browser, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.device != null && Object.hasOwnProperty.call(message, "device"))
                $root.user.UserAgent.Device.encode(message.device, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.os != null && Object.hasOwnProperty.call(message, "os"))
                $root.user.UserAgent.OS.encode(message.os, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.deviceName != null && Object.hasOwnProperty.call(message, "deviceName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.deviceName);
            return writer;
        };

        /**
         * Encodes the specified UserAgent message, length delimited. Does not implicitly {@link user.UserAgent.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.UserAgent
         * @static
         * @param {user.IUserAgent} message UserAgent message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserAgent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserAgent message from the specified reader or buffer.
         * @function decode
         * @memberof user.UserAgent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.UserAgent} UserAgent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserAgent.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.browser = $root.user.UserAgent.Browser.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.device = $root.user.UserAgent.Device.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.os = $root.user.UserAgent.OS.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.deviceName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserAgent message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.UserAgent
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.UserAgent} UserAgent
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserAgent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserAgent message.
         * @function verify
         * @memberof user.UserAgent
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserAgent.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.browser != null && message.hasOwnProperty("browser")) {
                var error = $root.user.UserAgent.Browser.verify(message.browser);
                if (error)
                    return "browser." + error;
            }
            if (message.device != null && message.hasOwnProperty("device")) {
                var error = $root.user.UserAgent.Device.verify(message.device);
                if (error)
                    return "device." + error;
            }
            if (message.os != null && message.hasOwnProperty("os")) {
                var error = $root.user.UserAgent.OS.verify(message.os);
                if (error)
                    return "os." + error;
            }
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                if (!$util.isString(message.deviceName))
                    return "deviceName: string expected";
            return null;
        };

        /**
         * Creates a UserAgent message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.UserAgent
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.UserAgent} UserAgent
         */
        UserAgent.fromObject = function fromObject(object) {
            if (object instanceof $root.user.UserAgent)
                return object;
            var message = new $root.user.UserAgent();
            if (object.browser != null) {
                if (typeof object.browser !== "object")
                    throw TypeError(".user.UserAgent.browser: object expected");
                message.browser = $root.user.UserAgent.Browser.fromObject(object.browser);
            }
            if (object.device != null) {
                if (typeof object.device !== "object")
                    throw TypeError(".user.UserAgent.device: object expected");
                message.device = $root.user.UserAgent.Device.fromObject(object.device);
            }
            if (object.os != null) {
                if (typeof object.os !== "object")
                    throw TypeError(".user.UserAgent.os: object expected");
                message.os = $root.user.UserAgent.OS.fromObject(object.os);
            }
            if (object.deviceName != null)
                message.deviceName = String(object.deviceName);
            return message;
        };

        /**
         * Creates a plain object from a UserAgent message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.UserAgent
         * @static
         * @param {user.UserAgent} message UserAgent
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserAgent.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.browser = null;
                object.device = null;
                object.os = null;
                object.deviceName = "";
            }
            if (message.browser != null && message.hasOwnProperty("browser"))
                object.browser = $root.user.UserAgent.Browser.toObject(message.browser, options);
            if (message.device != null && message.hasOwnProperty("device"))
                object.device = $root.user.UserAgent.Device.toObject(message.device, options);
            if (message.os != null && message.hasOwnProperty("os"))
                object.os = $root.user.UserAgent.OS.toObject(message.os, options);
            if (message.deviceName != null && message.hasOwnProperty("deviceName"))
                object.deviceName = message.deviceName;
            return object;
        };

        /**
         * Converts this UserAgent to JSON.
         * @function toJSON
         * @memberof user.UserAgent
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserAgent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UserAgent.Browser = (function() {

            /**
             * Properties of a Browser.
             * @memberof user.UserAgent
             * @interface IBrowser
             * @property {string|null} [name] Browser name
             * @property {string|null} [major] Browser major
             * @property {string|null} [version] Browser version
             */

            /**
             * Constructs a new Browser.
             * @memberof user.UserAgent
             * @classdesc Represents a Browser.
             * @implements IBrowser
             * @constructor
             * @param {user.UserAgent.IBrowser=} [properties] Properties to set
             */
            function Browser(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Browser name.
             * @member {string} name
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.name = "";

            /**
             * Browser major.
             * @member {string} major
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.major = "";

            /**
             * Browser version.
             * @member {string} version
             * @memberof user.UserAgent.Browser
             * @instance
             */
            Browser.prototype.version = "";

            /**
             * Creates a new Browser instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser=} [properties] Properties to set
             * @returns {user.UserAgent.Browser} Browser instance
             */
            Browser.create = function create(properties) {
                return new Browser(properties);
            };

            /**
             * Encodes the specified Browser message. Does not implicitly {@link user.UserAgent.Browser.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser} message Browser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Browser.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.major != null && Object.hasOwnProperty.call(message, "major"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.major);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.version);
                return writer;
            };

            /**
             * Encodes the specified Browser message, length delimited. Does not implicitly {@link user.UserAgent.Browser.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.IBrowser} message Browser message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Browser.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Browser message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.Browser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.Browser} Browser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Browser.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.Browser();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.major = reader.string();
                        break;
                    case 3:
                        message.version = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Browser message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.Browser
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.Browser} Browser
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Browser.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Browser message.
             * @function verify
             * @memberof user.UserAgent.Browser
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Browser.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.major != null && message.hasOwnProperty("major"))
                    if (!$util.isString(message.major))
                        return "major: string expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                return null;
            };

            /**
             * Creates a Browser message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.Browser
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.Browser} Browser
             */
            Browser.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.Browser)
                    return object;
                var message = new $root.user.UserAgent.Browser();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.major != null)
                    message.major = String(object.major);
                if (object.version != null)
                    message.version = String(object.version);
                return message;
            };

            /**
             * Creates a plain object from a Browser message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.Browser
             * @static
             * @param {user.UserAgent.Browser} message Browser
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Browser.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.major = "";
                    object.version = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.major != null && message.hasOwnProperty("major"))
                    object.major = message.major;
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                return object;
            };

            /**
             * Converts this Browser to JSON.
             * @function toJSON
             * @memberof user.UserAgent.Browser
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Browser.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Browser;
        })();

        UserAgent.Device = (function() {

            /**
             * Properties of a Device.
             * @memberof user.UserAgent
             * @interface IDevice
             * @property {string|null} [model] Device model
             * @property {string|null} [type] Device type
             * @property {string|null} [vendor] Device vendor
             */

            /**
             * Constructs a new Device.
             * @memberof user.UserAgent
             * @classdesc Represents a Device.
             * @implements IDevice
             * @constructor
             * @param {user.UserAgent.IDevice=} [properties] Properties to set
             */
            function Device(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Device model.
             * @member {string} model
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.model = "";

            /**
             * Device type.
             * @member {string} type
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.type = "";

            /**
             * Device vendor.
             * @member {string} vendor
             * @memberof user.UserAgent.Device
             * @instance
             */
            Device.prototype.vendor = "";

            /**
             * Creates a new Device instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice=} [properties] Properties to set
             * @returns {user.UserAgent.Device} Device instance
             */
            Device.create = function create(properties) {
                return new Device(properties);
            };

            /**
             * Encodes the specified Device message. Does not implicitly {@link user.UserAgent.Device.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice} message Device message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Device.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.model);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.vendor != null && Object.hasOwnProperty.call(message, "vendor"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.vendor);
                return writer;
            };

            /**
             * Encodes the specified Device message, length delimited. Does not implicitly {@link user.UserAgent.Device.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.IDevice} message Device message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Device.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Device message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.Device
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.Device} Device
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Device.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.Device();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.model = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        message.vendor = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Device message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.Device
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.Device} Device
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Device.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Device message.
             * @function verify
             * @memberof user.UserAgent.Device
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Device.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.model != null && message.hasOwnProperty("model"))
                    if (!$util.isString(message.model))
                        return "model: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.vendor != null && message.hasOwnProperty("vendor"))
                    if (!$util.isString(message.vendor))
                        return "vendor: string expected";
                return null;
            };

            /**
             * Creates a Device message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.Device
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.Device} Device
             */
            Device.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.Device)
                    return object;
                var message = new $root.user.UserAgent.Device();
                if (object.model != null)
                    message.model = String(object.model);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.vendor != null)
                    message.vendor = String(object.vendor);
                return message;
            };

            /**
             * Creates a plain object from a Device message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.Device
             * @static
             * @param {user.UserAgent.Device} message Device
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Device.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.model = "";
                    object.type = "";
                    object.vendor = "";
                }
                if (message.model != null && message.hasOwnProperty("model"))
                    object.model = message.model;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.vendor != null && message.hasOwnProperty("vendor"))
                    object.vendor = message.vendor;
                return object;
            };

            /**
             * Converts this Device to JSON.
             * @function toJSON
             * @memberof user.UserAgent.Device
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Device.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Device;
        })();

        UserAgent.OS = (function() {

            /**
             * Properties of a OS.
             * @memberof user.UserAgent
             * @interface IOS
             * @property {string|null} [name] OS name
             * @property {string|null} [version] OS version
             */

            /**
             * Constructs a new OS.
             * @memberof user.UserAgent
             * @classdesc Represents a OS.
             * @implements IOS
             * @constructor
             * @param {user.UserAgent.IOS=} [properties] Properties to set
             */
            function OS(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OS name.
             * @member {string} name
             * @memberof user.UserAgent.OS
             * @instance
             */
            OS.prototype.name = "";

            /**
             * OS version.
             * @member {string} version
             * @memberof user.UserAgent.OS
             * @instance
             */
            OS.prototype.version = "";

            /**
             * Creates a new OS instance using the specified properties.
             * @function create
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS=} [properties] Properties to set
             * @returns {user.UserAgent.OS} OS instance
             */
            OS.create = function create(properties) {
                return new OS(properties);
            };

            /**
             * Encodes the specified OS message. Does not implicitly {@link user.UserAgent.OS.verify|verify} messages.
             * @function encode
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS} message OS message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OS.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
                return writer;
            };

            /**
             * Encodes the specified OS message, length delimited. Does not implicitly {@link user.UserAgent.OS.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.IOS} message OS message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OS.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a OS message from the specified reader or buffer.
             * @function decode
             * @memberof user.UserAgent.OS
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.UserAgent.OS} OS
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OS.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.UserAgent.OS();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.version = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a OS message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.UserAgent.OS
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.UserAgent.OS} OS
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OS.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a OS message.
             * @function verify
             * @memberof user.UserAgent.OS
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OS.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.version != null && message.hasOwnProperty("version"))
                    if (!$util.isString(message.version))
                        return "version: string expected";
                return null;
            };

            /**
             * Creates a OS message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.UserAgent.OS
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.UserAgent.OS} OS
             */
            OS.fromObject = function fromObject(object) {
                if (object instanceof $root.user.UserAgent.OS)
                    return object;
                var message = new $root.user.UserAgent.OS();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.version != null)
                    message.version = String(object.version);
                return message;
            };

            /**
             * Creates a plain object from a OS message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.UserAgent.OS
             * @static
             * @param {user.UserAgent.OS} message OS
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OS.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.version = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.version != null && message.hasOwnProperty("version"))
                    object.version = message.version;
                return object;
            };

            /**
             * Converts this OS to JSON.
             * @function toJSON
             * @memberof user.UserAgent.OS
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OS.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OS;
        })();

        return UserAgent;
    })();

    user.OnlineDeviceList = (function() {

        /**
         * Properties of an OnlineDeviceList.
         * @memberof user
         * @interface IOnlineDeviceList
         * @property {user.ISSOUserInfo|null} [userInfo] OnlineDeviceList userInfo
         * @property {number|Long|null} [loginTime] OnlineDeviceList loginTime
         * @property {user.IUserAgent|null} [userAgent] OnlineDeviceList userAgent
         * @property {string|null} [location] OnlineDeviceList location
         * @property {string|null} [deviceId] OnlineDeviceList deviceId
         */

        /**
         * Constructs a new OnlineDeviceList.
         * @memberof user
         * @classdesc Represents an OnlineDeviceList.
         * @implements IOnlineDeviceList
         * @constructor
         * @param {user.IOnlineDeviceList=} [properties] Properties to set
         */
        function OnlineDeviceList(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OnlineDeviceList userInfo.
         * @member {user.ISSOUserInfo|null|undefined} userInfo
         * @memberof user.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.userInfo = null;

        /**
         * OnlineDeviceList loginTime.
         * @member {number|Long} loginTime
         * @memberof user.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.loginTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * OnlineDeviceList userAgent.
         * @member {user.IUserAgent|null|undefined} userAgent
         * @memberof user.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.userAgent = null;

        /**
         * OnlineDeviceList location.
         * @member {string} location
         * @memberof user.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.location = "";

        /**
         * OnlineDeviceList deviceId.
         * @member {string} deviceId
         * @memberof user.OnlineDeviceList
         * @instance
         */
        OnlineDeviceList.prototype.deviceId = "";

        /**
         * Creates a new OnlineDeviceList instance using the specified properties.
         * @function create
         * @memberof user.OnlineDeviceList
         * @static
         * @param {user.IOnlineDeviceList=} [properties] Properties to set
         * @returns {user.OnlineDeviceList} OnlineDeviceList instance
         */
        OnlineDeviceList.create = function create(properties) {
            return new OnlineDeviceList(properties);
        };

        /**
         * Encodes the specified OnlineDeviceList message. Does not implicitly {@link user.OnlineDeviceList.verify|verify} messages.
         * @function encode
         * @memberof user.OnlineDeviceList
         * @static
         * @param {user.IOnlineDeviceList} message OnlineDeviceList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlineDeviceList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                $root.user.SSOUserInfo.encode(message.userInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.loginTime != null && Object.hasOwnProperty.call(message, "loginTime"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.loginTime);
            if (message.userAgent != null && Object.hasOwnProperty.call(message, "userAgent"))
                $root.user.UserAgent.encode(message.userAgent, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.location);
            if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.deviceId);
            return writer;
        };

        /**
         * Encodes the specified OnlineDeviceList message, length delimited. Does not implicitly {@link user.OnlineDeviceList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.OnlineDeviceList
         * @static
         * @param {user.IOnlineDeviceList} message OnlineDeviceList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OnlineDeviceList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OnlineDeviceList message from the specified reader or buffer.
         * @function decode
         * @memberof user.OnlineDeviceList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.OnlineDeviceList} OnlineDeviceList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlineDeviceList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.OnlineDeviceList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.userInfo = $root.user.SSOUserInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.loginTime = reader.int64();
                    break;
                case 3:
                    message.userAgent = $root.user.UserAgent.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.location = reader.string();
                    break;
                case 5:
                    message.deviceId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OnlineDeviceList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.OnlineDeviceList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.OnlineDeviceList} OnlineDeviceList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OnlineDeviceList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OnlineDeviceList message.
         * @function verify
         * @memberof user.OnlineDeviceList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OnlineDeviceList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                var error = $root.user.SSOUserInfo.verify(message.userInfo);
                if (error)
                    return "userInfo." + error;
            }
            if (message.loginTime != null && message.hasOwnProperty("loginTime"))
                if (!$util.isInteger(message.loginTime) && !(message.loginTime && $util.isInteger(message.loginTime.low) && $util.isInteger(message.loginTime.high)))
                    return "loginTime: integer|Long expected";
            if (message.userAgent != null && message.hasOwnProperty("userAgent")) {
                var error = $root.user.UserAgent.verify(message.userAgent);
                if (error)
                    return "userAgent." + error;
            }
            if (message.location != null && message.hasOwnProperty("location"))
                if (!$util.isString(message.location))
                    return "location: string expected";
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (!$util.isString(message.deviceId))
                    return "deviceId: string expected";
            return null;
        };

        /**
         * Creates an OnlineDeviceList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.OnlineDeviceList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.OnlineDeviceList} OnlineDeviceList
         */
        OnlineDeviceList.fromObject = function fromObject(object) {
            if (object instanceof $root.user.OnlineDeviceList)
                return object;
            var message = new $root.user.OnlineDeviceList();
            if (object.userInfo != null) {
                if (typeof object.userInfo !== "object")
                    throw TypeError(".user.OnlineDeviceList.userInfo: object expected");
                message.userInfo = $root.user.SSOUserInfo.fromObject(object.userInfo);
            }
            if (object.loginTime != null)
                if ($util.Long)
                    (message.loginTime = $util.Long.fromValue(object.loginTime)).unsigned = false;
                else if (typeof object.loginTime === "string")
                    message.loginTime = parseInt(object.loginTime, 10);
                else if (typeof object.loginTime === "number")
                    message.loginTime = object.loginTime;
                else if (typeof object.loginTime === "object")
                    message.loginTime = new $util.LongBits(object.loginTime.low >>> 0, object.loginTime.high >>> 0).toNumber();
            if (object.userAgent != null) {
                if (typeof object.userAgent !== "object")
                    throw TypeError(".user.OnlineDeviceList.userAgent: object expected");
                message.userAgent = $root.user.UserAgent.fromObject(object.userAgent);
            }
            if (object.location != null)
                message.location = String(object.location);
            if (object.deviceId != null)
                message.deviceId = String(object.deviceId);
            return message;
        };

        /**
         * Creates a plain object from an OnlineDeviceList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.OnlineDeviceList
         * @static
         * @param {user.OnlineDeviceList} message OnlineDeviceList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OnlineDeviceList.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.userInfo = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.loginTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.loginTime = options.longs === String ? "0" : 0;
                object.userAgent = null;
                object.location = "";
                object.deviceId = "";
            }
            if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                object.userInfo = $root.user.SSOUserInfo.toObject(message.userInfo, options);
            if (message.loginTime != null && message.hasOwnProperty("loginTime"))
                if (typeof message.loginTime === "number")
                    object.loginTime = options.longs === String ? String(message.loginTime) : message.loginTime;
                else
                    object.loginTime = options.longs === String ? $util.Long.prototype.toString.call(message.loginTime) : options.longs === Number ? new $util.LongBits(message.loginTime.low >>> 0, message.loginTime.high >>> 0).toNumber() : message.loginTime;
            if (message.userAgent != null && message.hasOwnProperty("userAgent"))
                object.userAgent = $root.user.UserAgent.toObject(message.userAgent, options);
            if (message.location != null && message.hasOwnProperty("location"))
                object.location = message.location;
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = message.deviceId;
            return object;
        };

        /**
         * Converts this OnlineDeviceList to JSON.
         * @function toJSON
         * @memberof user.OnlineDeviceList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OnlineDeviceList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OnlineDeviceList;
    })();

    user.OtherDeviceOnline = (function() {

        /**
         * Properties of an OtherDeviceOnline.
         * @memberof user
         * @interface IOtherDeviceOnline
         */

        /**
         * Constructs a new OtherDeviceOnline.
         * @memberof user
         * @classdesc Represents an OtherDeviceOnline.
         * @implements IOtherDeviceOnline
         * @constructor
         * @param {user.IOtherDeviceOnline=} [properties] Properties to set
         */
        function OtherDeviceOnline(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new OtherDeviceOnline instance using the specified properties.
         * @function create
         * @memberof user.OtherDeviceOnline
         * @static
         * @param {user.IOtherDeviceOnline=} [properties] Properties to set
         * @returns {user.OtherDeviceOnline} OtherDeviceOnline instance
         */
        OtherDeviceOnline.create = function create(properties) {
            return new OtherDeviceOnline(properties);
        };

        /**
         * Encodes the specified OtherDeviceOnline message. Does not implicitly {@link user.OtherDeviceOnline.verify|verify} messages.
         * @function encode
         * @memberof user.OtherDeviceOnline
         * @static
         * @param {user.IOtherDeviceOnline} message OtherDeviceOnline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtherDeviceOnline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified OtherDeviceOnline message, length delimited. Does not implicitly {@link user.OtherDeviceOnline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.OtherDeviceOnline
         * @static
         * @param {user.IOtherDeviceOnline} message OtherDeviceOnline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtherDeviceOnline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OtherDeviceOnline message from the specified reader or buffer.
         * @function decode
         * @memberof user.OtherDeviceOnline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.OtherDeviceOnline} OtherDeviceOnline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtherDeviceOnline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.OtherDeviceOnline();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OtherDeviceOnline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.OtherDeviceOnline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.OtherDeviceOnline} OtherDeviceOnline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtherDeviceOnline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OtherDeviceOnline message.
         * @function verify
         * @memberof user.OtherDeviceOnline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OtherDeviceOnline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an OtherDeviceOnline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.OtherDeviceOnline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.OtherDeviceOnline} OtherDeviceOnline
         */
        OtherDeviceOnline.fromObject = function fromObject(object) {
            if (object instanceof $root.user.OtherDeviceOnline)
                return object;
            return new $root.user.OtherDeviceOnline();
        };

        /**
         * Creates a plain object from an OtherDeviceOnline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.OtherDeviceOnline
         * @static
         * @param {user.OtherDeviceOnline} message OtherDeviceOnline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OtherDeviceOnline.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this OtherDeviceOnline to JSON.
         * @function toJSON
         * @memberof user.OtherDeviceOnline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OtherDeviceOnline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        OtherDeviceOnline.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.OtherDeviceOnline
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof user.OtherDeviceOnline
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.OtherDeviceOnline.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.OtherDeviceOnline.Request
             * @static
             * @param {user.OtherDeviceOnline.IRequest=} [properties] Properties to set
             * @returns {user.OtherDeviceOnline.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.OtherDeviceOnline.Request.verify|verify} messages.
             * @function encode
             * @memberof user.OtherDeviceOnline.Request
             * @static
             * @param {user.OtherDeviceOnline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.OtherDeviceOnline.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.OtherDeviceOnline.Request
             * @static
             * @param {user.OtherDeviceOnline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.OtherDeviceOnline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.OtherDeviceOnline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.OtherDeviceOnline.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.OtherDeviceOnline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.OtherDeviceOnline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.OtherDeviceOnline.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.OtherDeviceOnline.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.OtherDeviceOnline.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.OtherDeviceOnline.Request)
                    return object;
                return new $root.user.OtherDeviceOnline.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.OtherDeviceOnline.Request
             * @static
             * @param {user.OtherDeviceOnline.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.OtherDeviceOnline.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        OtherDeviceOnline.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.OtherDeviceOnline
             * @interface IResponse
             * @property {user.IOnlineDeviceList|null} [currentDevice] Response currentDevice
             * @property {Array.<user.IOnlineDeviceList>|null} [onlineDeviceList] Response onlineDeviceList
             */

            /**
             * Constructs a new Response.
             * @memberof user.OtherDeviceOnline
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.OtherDeviceOnline.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.onlineDeviceList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response currentDevice.
             * @member {user.IOnlineDeviceList|null|undefined} currentDevice
             * @memberof user.OtherDeviceOnline.Response
             * @instance
             */
            Response.prototype.currentDevice = null;

            /**
             * Response onlineDeviceList.
             * @member {Array.<user.IOnlineDeviceList>} onlineDeviceList
             * @memberof user.OtherDeviceOnline.Response
             * @instance
             */
            Response.prototype.onlineDeviceList = $util.emptyArray;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.OtherDeviceOnline.Response
             * @static
             * @param {user.OtherDeviceOnline.IResponse=} [properties] Properties to set
             * @returns {user.OtherDeviceOnline.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.OtherDeviceOnline.Response.verify|verify} messages.
             * @function encode
             * @memberof user.OtherDeviceOnline.Response
             * @static
             * @param {user.OtherDeviceOnline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.currentDevice != null && Object.hasOwnProperty.call(message, "currentDevice"))
                    $root.user.OnlineDeviceList.encode(message.currentDevice, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.onlineDeviceList != null && message.onlineDeviceList.length)
                    for (var i = 0; i < message.onlineDeviceList.length; ++i)
                        $root.user.OnlineDeviceList.encode(message.onlineDeviceList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.OtherDeviceOnline.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.OtherDeviceOnline.Response
             * @static
             * @param {user.OtherDeviceOnline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.OtherDeviceOnline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.OtherDeviceOnline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.OtherDeviceOnline.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.currentDevice = $root.user.OnlineDeviceList.decode(reader, reader.uint32());
                        break;
                    case 2:
                        if (!(message.onlineDeviceList && message.onlineDeviceList.length))
                            message.onlineDeviceList = [];
                        message.onlineDeviceList.push($root.user.OnlineDeviceList.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.OtherDeviceOnline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.OtherDeviceOnline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.OtherDeviceOnline.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.currentDevice != null && message.hasOwnProperty("currentDevice")) {
                    var error = $root.user.OnlineDeviceList.verify(message.currentDevice);
                    if (error)
                        return "currentDevice." + error;
                }
                if (message.onlineDeviceList != null && message.hasOwnProperty("onlineDeviceList")) {
                    if (!Array.isArray(message.onlineDeviceList))
                        return "onlineDeviceList: array expected";
                    for (var i = 0; i < message.onlineDeviceList.length; ++i) {
                        var error = $root.user.OnlineDeviceList.verify(message.onlineDeviceList[i]);
                        if (error)
                            return "onlineDeviceList." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.OtherDeviceOnline.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.OtherDeviceOnline.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.OtherDeviceOnline.Response)
                    return object;
                var message = new $root.user.OtherDeviceOnline.Response();
                if (object.currentDevice != null) {
                    if (typeof object.currentDevice !== "object")
                        throw TypeError(".user.OtherDeviceOnline.Response.currentDevice: object expected");
                    message.currentDevice = $root.user.OnlineDeviceList.fromObject(object.currentDevice);
                }
                if (object.onlineDeviceList) {
                    if (!Array.isArray(object.onlineDeviceList))
                        throw TypeError(".user.OtherDeviceOnline.Response.onlineDeviceList: array expected");
                    message.onlineDeviceList = [];
                    for (var i = 0; i < object.onlineDeviceList.length; ++i) {
                        if (typeof object.onlineDeviceList[i] !== "object")
                            throw TypeError(".user.OtherDeviceOnline.Response.onlineDeviceList: object expected");
                        message.onlineDeviceList[i] = $root.user.OnlineDeviceList.fromObject(object.onlineDeviceList[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.OtherDeviceOnline.Response
             * @static
             * @param {user.OtherDeviceOnline.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.onlineDeviceList = [];
                if (options.defaults)
                    object.currentDevice = null;
                if (message.currentDevice != null && message.hasOwnProperty("currentDevice"))
                    object.currentDevice = $root.user.OnlineDeviceList.toObject(message.currentDevice, options);
                if (message.onlineDeviceList && message.onlineDeviceList.length) {
                    object.onlineDeviceList = [];
                    for (var j = 0; j < message.onlineDeviceList.length; ++j)
                        object.onlineDeviceList[j] = $root.user.OnlineDeviceList.toObject(message.onlineDeviceList[j], options);
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.OtherDeviceOnline.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return OtherDeviceOnline;
    })();

    user.OtherDeviceOffline = (function() {

        /**
         * Properties of an OtherDeviceOffline.
         * @memberof user
         * @interface IOtherDeviceOffline
         */

        /**
         * Constructs a new OtherDeviceOffline.
         * @memberof user
         * @classdesc Represents an OtherDeviceOffline.
         * @implements IOtherDeviceOffline
         * @constructor
         * @param {user.IOtherDeviceOffline=} [properties] Properties to set
         */
        function OtherDeviceOffline(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new OtherDeviceOffline instance using the specified properties.
         * @function create
         * @memberof user.OtherDeviceOffline
         * @static
         * @param {user.IOtherDeviceOffline=} [properties] Properties to set
         * @returns {user.OtherDeviceOffline} OtherDeviceOffline instance
         */
        OtherDeviceOffline.create = function create(properties) {
            return new OtherDeviceOffline(properties);
        };

        /**
         * Encodes the specified OtherDeviceOffline message. Does not implicitly {@link user.OtherDeviceOffline.verify|verify} messages.
         * @function encode
         * @memberof user.OtherDeviceOffline
         * @static
         * @param {user.IOtherDeviceOffline} message OtherDeviceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtherDeviceOffline.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified OtherDeviceOffline message, length delimited. Does not implicitly {@link user.OtherDeviceOffline.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.OtherDeviceOffline
         * @static
         * @param {user.IOtherDeviceOffline} message OtherDeviceOffline message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OtherDeviceOffline.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OtherDeviceOffline message from the specified reader or buffer.
         * @function decode
         * @memberof user.OtherDeviceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.OtherDeviceOffline} OtherDeviceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtherDeviceOffline.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.OtherDeviceOffline();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OtherDeviceOffline message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.OtherDeviceOffline
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.OtherDeviceOffline} OtherDeviceOffline
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OtherDeviceOffline.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OtherDeviceOffline message.
         * @function verify
         * @memberof user.OtherDeviceOffline
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OtherDeviceOffline.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an OtherDeviceOffline message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.OtherDeviceOffline
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.OtherDeviceOffline} OtherDeviceOffline
         */
        OtherDeviceOffline.fromObject = function fromObject(object) {
            if (object instanceof $root.user.OtherDeviceOffline)
                return object;
            return new $root.user.OtherDeviceOffline();
        };

        /**
         * Creates a plain object from an OtherDeviceOffline message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.OtherDeviceOffline
         * @static
         * @param {user.OtherDeviceOffline} message OtherDeviceOffline
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OtherDeviceOffline.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this OtherDeviceOffline to JSON.
         * @function toJSON
         * @memberof user.OtherDeviceOffline
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OtherDeviceOffline.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        OtherDeviceOffline.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.OtherDeviceOffline
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof user.OtherDeviceOffline
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.OtherDeviceOffline.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.OtherDeviceOffline.Request
             * @static
             * @param {user.OtherDeviceOffline.IRequest=} [properties] Properties to set
             * @returns {user.OtherDeviceOffline.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.OtherDeviceOffline.Request.verify|verify} messages.
             * @function encode
             * @memberof user.OtherDeviceOffline.Request
             * @static
             * @param {user.OtherDeviceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.OtherDeviceOffline.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.OtherDeviceOffline.Request
             * @static
             * @param {user.OtherDeviceOffline.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.OtherDeviceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.OtherDeviceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.OtherDeviceOffline.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.OtherDeviceOffline.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.OtherDeviceOffline.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.OtherDeviceOffline.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.OtherDeviceOffline.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.OtherDeviceOffline.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.OtherDeviceOffline.Request)
                    return object;
                return new $root.user.OtherDeviceOffline.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.OtherDeviceOffline.Request
             * @static
             * @param {user.OtherDeviceOffline.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.OtherDeviceOffline.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        OtherDeviceOffline.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.OtherDeviceOffline
             * @interface IResponse
             * @property {user.IOnlineDeviceList|null} [currentDevice] Response currentDevice
             * @property {Array.<user.IOnlineDeviceList>|null} [onlineDeviceList] Response onlineDeviceList
             */

            /**
             * Constructs a new Response.
             * @memberof user.OtherDeviceOffline
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.OtherDeviceOffline.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.onlineDeviceList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response currentDevice.
             * @member {user.IOnlineDeviceList|null|undefined} currentDevice
             * @memberof user.OtherDeviceOffline.Response
             * @instance
             */
            Response.prototype.currentDevice = null;

            /**
             * Response onlineDeviceList.
             * @member {Array.<user.IOnlineDeviceList>} onlineDeviceList
             * @memberof user.OtherDeviceOffline.Response
             * @instance
             */
            Response.prototype.onlineDeviceList = $util.emptyArray;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.OtherDeviceOffline.Response
             * @static
             * @param {user.OtherDeviceOffline.IResponse=} [properties] Properties to set
             * @returns {user.OtherDeviceOffline.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.OtherDeviceOffline.Response.verify|verify} messages.
             * @function encode
             * @memberof user.OtherDeviceOffline.Response
             * @static
             * @param {user.OtherDeviceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.currentDevice != null && Object.hasOwnProperty.call(message, "currentDevice"))
                    $root.user.OnlineDeviceList.encode(message.currentDevice, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.onlineDeviceList != null && message.onlineDeviceList.length)
                    for (var i = 0; i < message.onlineDeviceList.length; ++i)
                        $root.user.OnlineDeviceList.encode(message.onlineDeviceList[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.OtherDeviceOffline.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.OtherDeviceOffline.Response
             * @static
             * @param {user.OtherDeviceOffline.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.OtherDeviceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.OtherDeviceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.OtherDeviceOffline.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.currentDevice = $root.user.OnlineDeviceList.decode(reader, reader.uint32());
                        break;
                    case 2:
                        if (!(message.onlineDeviceList && message.onlineDeviceList.length))
                            message.onlineDeviceList = [];
                        message.onlineDeviceList.push($root.user.OnlineDeviceList.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.OtherDeviceOffline.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.OtherDeviceOffline.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.OtherDeviceOffline.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.currentDevice != null && message.hasOwnProperty("currentDevice")) {
                    var error = $root.user.OnlineDeviceList.verify(message.currentDevice);
                    if (error)
                        return "currentDevice." + error;
                }
                if (message.onlineDeviceList != null && message.hasOwnProperty("onlineDeviceList")) {
                    if (!Array.isArray(message.onlineDeviceList))
                        return "onlineDeviceList: array expected";
                    for (var i = 0; i < message.onlineDeviceList.length; ++i) {
                        var error = $root.user.OnlineDeviceList.verify(message.onlineDeviceList[i]);
                        if (error)
                            return "onlineDeviceList." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.OtherDeviceOffline.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.OtherDeviceOffline.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.OtherDeviceOffline.Response)
                    return object;
                var message = new $root.user.OtherDeviceOffline.Response();
                if (object.currentDevice != null) {
                    if (typeof object.currentDevice !== "object")
                        throw TypeError(".user.OtherDeviceOffline.Response.currentDevice: object expected");
                    message.currentDevice = $root.user.OnlineDeviceList.fromObject(object.currentDevice);
                }
                if (object.onlineDeviceList) {
                    if (!Array.isArray(object.onlineDeviceList))
                        throw TypeError(".user.OtherDeviceOffline.Response.onlineDeviceList: array expected");
                    message.onlineDeviceList = [];
                    for (var i = 0; i < object.onlineDeviceList.length; ++i) {
                        if (typeof object.onlineDeviceList[i] !== "object")
                            throw TypeError(".user.OtherDeviceOffline.Response.onlineDeviceList: object expected");
                        message.onlineDeviceList[i] = $root.user.OnlineDeviceList.fromObject(object.onlineDeviceList[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.OtherDeviceOffline.Response
             * @static
             * @param {user.OtherDeviceOffline.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.onlineDeviceList = [];
                if (options.defaults)
                    object.currentDevice = null;
                if (message.currentDevice != null && message.hasOwnProperty("currentDevice"))
                    object.currentDevice = $root.user.OnlineDeviceList.toObject(message.currentDevice, options);
                if (message.onlineDeviceList && message.onlineDeviceList.length) {
                    object.onlineDeviceList = [];
                    for (var j = 0; j < message.onlineDeviceList.length; ++j)
                        object.onlineDeviceList[j] = $root.user.OnlineDeviceList.toObject(message.onlineDeviceList[j], options);
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.OtherDeviceOffline.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return OtherDeviceOffline;
    })();

    user.SendMessagesToOtherDevices = (function() {

        /**
         * Properties of a SendMessagesToOtherDevices.
         * @memberof user
         * @interface ISendMessagesToOtherDevices
         */

        /**
         * Constructs a new SendMessagesToOtherDevices.
         * @memberof user
         * @classdesc Represents a SendMessagesToOtherDevices.
         * @implements ISendMessagesToOtherDevices
         * @constructor
         * @param {user.ISendMessagesToOtherDevices=} [properties] Properties to set
         */
        function SendMessagesToOtherDevices(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SendMessagesToOtherDevices instance using the specified properties.
         * @function create
         * @memberof user.SendMessagesToOtherDevices
         * @static
         * @param {user.ISendMessagesToOtherDevices=} [properties] Properties to set
         * @returns {user.SendMessagesToOtherDevices} SendMessagesToOtherDevices instance
         */
        SendMessagesToOtherDevices.create = function create(properties) {
            return new SendMessagesToOtherDevices(properties);
        };

        /**
         * Encodes the specified SendMessagesToOtherDevices message. Does not implicitly {@link user.SendMessagesToOtherDevices.verify|verify} messages.
         * @function encode
         * @memberof user.SendMessagesToOtherDevices
         * @static
         * @param {user.ISendMessagesToOtherDevices} message SendMessagesToOtherDevices message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessagesToOtherDevices.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SendMessagesToOtherDevices message, length delimited. Does not implicitly {@link user.SendMessagesToOtherDevices.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.SendMessagesToOtherDevices
         * @static
         * @param {user.ISendMessagesToOtherDevices} message SendMessagesToOtherDevices message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessagesToOtherDevices.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendMessagesToOtherDevices message from the specified reader or buffer.
         * @function decode
         * @memberof user.SendMessagesToOtherDevices
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.SendMessagesToOtherDevices} SendMessagesToOtherDevices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessagesToOtherDevices.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SendMessagesToOtherDevices();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendMessagesToOtherDevices message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.SendMessagesToOtherDevices
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.SendMessagesToOtherDevices} SendMessagesToOtherDevices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessagesToOtherDevices.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendMessagesToOtherDevices message.
         * @function verify
         * @memberof user.SendMessagesToOtherDevices
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendMessagesToOtherDevices.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SendMessagesToOtherDevices message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.SendMessagesToOtherDevices
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.SendMessagesToOtherDevices} SendMessagesToOtherDevices
         */
        SendMessagesToOtherDevices.fromObject = function fromObject(object) {
            if (object instanceof $root.user.SendMessagesToOtherDevices)
                return object;
            return new $root.user.SendMessagesToOtherDevices();
        };

        /**
         * Creates a plain object from a SendMessagesToOtherDevices message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.SendMessagesToOtherDevices
         * @static
         * @param {user.SendMessagesToOtherDevices} message SendMessagesToOtherDevices
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendMessagesToOtherDevices.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SendMessagesToOtherDevices to JSON.
         * @function toJSON
         * @memberof user.SendMessagesToOtherDevices
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendMessagesToOtherDevices.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SendMessagesToOtherDevices.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.SendMessagesToOtherDevices
             * @interface IRequest
             * @property {string|null} [deviceId] Request deviceId
             * @property {string|null} [apiName] Request apiName
             * @property {string|null} [data] Request data
             */

            /**
             * Constructs a new Request.
             * @memberof user.SendMessagesToOtherDevices
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.SendMessagesToOtherDevices.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request deviceId.
             * @member {string} deviceId
             * @memberof user.SendMessagesToOtherDevices.Request
             * @instance
             */
            Request.prototype.deviceId = "";

            /**
             * Request apiName.
             * @member {string} apiName
             * @memberof user.SendMessagesToOtherDevices.Request
             * @instance
             */
            Request.prototype.apiName = "";

            /**
             * Request data.
             * @member {string} data
             * @memberof user.SendMessagesToOtherDevices.Request
             * @instance
             */
            Request.prototype.data = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.SendMessagesToOtherDevices.Request
             * @static
             * @param {user.SendMessagesToOtherDevices.IRequest=} [properties] Properties to set
             * @returns {user.SendMessagesToOtherDevices.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.SendMessagesToOtherDevices.Request.verify|verify} messages.
             * @function encode
             * @memberof user.SendMessagesToOtherDevices.Request
             * @static
             * @param {user.SendMessagesToOtherDevices.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.apiName != null && Object.hasOwnProperty.call(message, "apiName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.apiName);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.data);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.SendMessagesToOtherDevices.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.SendMessagesToOtherDevices.Request
             * @static
             * @param {user.SendMessagesToOtherDevices.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.SendMessagesToOtherDevices.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.SendMessagesToOtherDevices.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SendMessagesToOtherDevices.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.apiName = reader.string();
                        break;
                    case 3:
                        message.data = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.SendMessagesToOtherDevices.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.SendMessagesToOtherDevices.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.SendMessagesToOtherDevices.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.apiName != null && message.hasOwnProperty("apiName"))
                    if (!$util.isString(message.apiName))
                        return "apiName: string expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!$util.isString(message.data))
                        return "data: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.SendMessagesToOtherDevices.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.SendMessagesToOtherDevices.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.SendMessagesToOtherDevices.Request)
                    return object;
                var message = new $root.user.SendMessagesToOtherDevices.Request();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.apiName != null)
                    message.apiName = String(object.apiName);
                if (object.data != null)
                    message.data = String(object.data);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.SendMessagesToOtherDevices.Request
             * @static
             * @param {user.SendMessagesToOtherDevices.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.apiName = "";
                    object.data = "";
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.apiName != null && message.hasOwnProperty("apiName"))
                    object.apiName = message.apiName;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = message.data;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.SendMessagesToOtherDevices.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        SendMessagesToOtherDevices.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.SendMessagesToOtherDevices
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof user.SendMessagesToOtherDevices
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.SendMessagesToOtherDevices.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.SendMessagesToOtherDevices.Response
             * @static
             * @param {user.SendMessagesToOtherDevices.IResponse=} [properties] Properties to set
             * @returns {user.SendMessagesToOtherDevices.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.SendMessagesToOtherDevices.Response.verify|verify} messages.
             * @function encode
             * @memberof user.SendMessagesToOtherDevices.Response
             * @static
             * @param {user.SendMessagesToOtherDevices.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.SendMessagesToOtherDevices.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.SendMessagesToOtherDevices.Response
             * @static
             * @param {user.SendMessagesToOtherDevices.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.SendMessagesToOtherDevices.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.SendMessagesToOtherDevices.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.SendMessagesToOtherDevices.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.SendMessagesToOtherDevices.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.SendMessagesToOtherDevices.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.SendMessagesToOtherDevices.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.SendMessagesToOtherDevices.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.SendMessagesToOtherDevices.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.SendMessagesToOtherDevices.Response)
                    return object;
                return new $root.user.SendMessagesToOtherDevices.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.SendMessagesToOtherDevices.Response
             * @static
             * @param {user.SendMessagesToOtherDevices.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.SendMessagesToOtherDevices.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return SendMessagesToOtherDevices;
    })();

    user.ReceiveMessagesFromOtherDevices = (function() {

        /**
         * Properties of a ReceiveMessagesFromOtherDevices.
         * @memberof user
         * @interface IReceiveMessagesFromOtherDevices
         */

        /**
         * Constructs a new ReceiveMessagesFromOtherDevices.
         * @memberof user
         * @classdesc Represents a ReceiveMessagesFromOtherDevices.
         * @implements IReceiveMessagesFromOtherDevices
         * @constructor
         * @param {user.IReceiveMessagesFromOtherDevices=} [properties] Properties to set
         */
        function ReceiveMessagesFromOtherDevices(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ReceiveMessagesFromOtherDevices instance using the specified properties.
         * @function create
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @static
         * @param {user.IReceiveMessagesFromOtherDevices=} [properties] Properties to set
         * @returns {user.ReceiveMessagesFromOtherDevices} ReceiveMessagesFromOtherDevices instance
         */
        ReceiveMessagesFromOtherDevices.create = function create(properties) {
            return new ReceiveMessagesFromOtherDevices(properties);
        };

        /**
         * Encodes the specified ReceiveMessagesFromOtherDevices message. Does not implicitly {@link user.ReceiveMessagesFromOtherDevices.verify|verify} messages.
         * @function encode
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @static
         * @param {user.IReceiveMessagesFromOtherDevices} message ReceiveMessagesFromOtherDevices message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReceiveMessagesFromOtherDevices.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ReceiveMessagesFromOtherDevices message, length delimited. Does not implicitly {@link user.ReceiveMessagesFromOtherDevices.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @static
         * @param {user.IReceiveMessagesFromOtherDevices} message ReceiveMessagesFromOtherDevices message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReceiveMessagesFromOtherDevices.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReceiveMessagesFromOtherDevices message from the specified reader or buffer.
         * @function decode
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.ReceiveMessagesFromOtherDevices} ReceiveMessagesFromOtherDevices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReceiveMessagesFromOtherDevices.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.ReceiveMessagesFromOtherDevices();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReceiveMessagesFromOtherDevices message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.ReceiveMessagesFromOtherDevices} ReceiveMessagesFromOtherDevices
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReceiveMessagesFromOtherDevices.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReceiveMessagesFromOtherDevices message.
         * @function verify
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReceiveMessagesFromOtherDevices.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ReceiveMessagesFromOtherDevices message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.ReceiveMessagesFromOtherDevices} ReceiveMessagesFromOtherDevices
         */
        ReceiveMessagesFromOtherDevices.fromObject = function fromObject(object) {
            if (object instanceof $root.user.ReceiveMessagesFromOtherDevices)
                return object;
            return new $root.user.ReceiveMessagesFromOtherDevices();
        };

        /**
         * Creates a plain object from a ReceiveMessagesFromOtherDevices message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @static
         * @param {user.ReceiveMessagesFromOtherDevices} message ReceiveMessagesFromOtherDevices
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReceiveMessagesFromOtherDevices.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ReceiveMessagesFromOtherDevices to JSON.
         * @function toJSON
         * @memberof user.ReceiveMessagesFromOtherDevices
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReceiveMessagesFromOtherDevices.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ReceiveMessagesFromOtherDevices.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.ReceiveMessagesFromOtherDevices
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof user.ReceiveMessagesFromOtherDevices
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.ReceiveMessagesFromOtherDevices.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {user.ReceiveMessagesFromOtherDevices.IRequest=} [properties] Properties to set
             * @returns {user.ReceiveMessagesFromOtherDevices.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.ReceiveMessagesFromOtherDevices.Request.verify|verify} messages.
             * @function encode
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {user.ReceiveMessagesFromOtherDevices.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.ReceiveMessagesFromOtherDevices.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {user.ReceiveMessagesFromOtherDevices.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.ReceiveMessagesFromOtherDevices.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.ReceiveMessagesFromOtherDevices.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.ReceiveMessagesFromOtherDevices.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.ReceiveMessagesFromOtherDevices.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.ReceiveMessagesFromOtherDevices.Request)
                    return object;
                return new $root.user.ReceiveMessagesFromOtherDevices.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @static
             * @param {user.ReceiveMessagesFromOtherDevices.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.ReceiveMessagesFromOtherDevices.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        ReceiveMessagesFromOtherDevices.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.ReceiveMessagesFromOtherDevices
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [apiName] Response apiName
             * @property {string|null} [data] Response data
             */

            /**
             * Constructs a new Response.
             * @memberof user.ReceiveMessagesFromOtherDevices
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.ReceiveMessagesFromOtherDevices.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response apiName.
             * @member {string} apiName
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @instance
             */
            Response.prototype.apiName = "";

            /**
             * Response data.
             * @member {string} data
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @instance
             */
            Response.prototype.data = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {user.ReceiveMessagesFromOtherDevices.IResponse=} [properties] Properties to set
             * @returns {user.ReceiveMessagesFromOtherDevices.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.ReceiveMessagesFromOtherDevices.Response.verify|verify} messages.
             * @function encode
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {user.ReceiveMessagesFromOtherDevices.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.apiName != null && Object.hasOwnProperty.call(message, "apiName"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.apiName);
                if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.data);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.ReceiveMessagesFromOtherDevices.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {user.ReceiveMessagesFromOtherDevices.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.ReceiveMessagesFromOtherDevices.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.ReceiveMessagesFromOtherDevices.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.apiName = reader.string();
                        break;
                    case 3:
                        message.data = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.ReceiveMessagesFromOtherDevices.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.apiName != null && message.hasOwnProperty("apiName"))
                    if (!$util.isString(message.apiName))
                        return "apiName: string expected";
                if (message.data != null && message.hasOwnProperty("data"))
                    if (!$util.isString(message.data))
                        return "data: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.ReceiveMessagesFromOtherDevices.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.ReceiveMessagesFromOtherDevices.Response)
                    return object;
                var message = new $root.user.ReceiveMessagesFromOtherDevices.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.apiName != null)
                    message.apiName = String(object.apiName);
                if (object.data != null)
                    message.data = String(object.data);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @static
             * @param {user.ReceiveMessagesFromOtherDevices.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.apiName = "";
                    object.data = "";
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.apiName != null && message.hasOwnProperty("apiName"))
                    object.apiName = message.apiName;
                if (message.data != null && message.hasOwnProperty("data"))
                    object.data = message.data;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.ReceiveMessagesFromOtherDevices.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return ReceiveMessagesFromOtherDevices;
    })();

    user.CreateAccount = (function() {

        /**
         * Properties of a CreateAccount.
         * @memberof user
         * @interface ICreateAccount
         */

        /**
         * Constructs a new CreateAccount.
         * @memberof user
         * @classdesc Represents a CreateAccount.
         * @implements ICreateAccount
         * @constructor
         * @param {user.ICreateAccount=} [properties] Properties to set
         */
        function CreateAccount(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new CreateAccount instance using the specified properties.
         * @function create
         * @memberof user.CreateAccount
         * @static
         * @param {user.ICreateAccount=} [properties] Properties to set
         * @returns {user.CreateAccount} CreateAccount instance
         */
        CreateAccount.create = function create(properties) {
            return new CreateAccount(properties);
        };

        /**
         * Encodes the specified CreateAccount message. Does not implicitly {@link user.CreateAccount.verify|verify} messages.
         * @function encode
         * @memberof user.CreateAccount
         * @static
         * @param {user.ICreateAccount} message CreateAccount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateAccount.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified CreateAccount message, length delimited. Does not implicitly {@link user.CreateAccount.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.CreateAccount
         * @static
         * @param {user.ICreateAccount} message CreateAccount message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateAccount message from the specified reader or buffer.
         * @function decode
         * @memberof user.CreateAccount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.CreateAccount} CreateAccount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateAccount.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.CreateAccount();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateAccount message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.CreateAccount
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.CreateAccount} CreateAccount
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateAccount message.
         * @function verify
         * @memberof user.CreateAccount
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateAccount.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a CreateAccount message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.CreateAccount
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.CreateAccount} CreateAccount
         */
        CreateAccount.fromObject = function fromObject(object) {
            if (object instanceof $root.user.CreateAccount)
                return object;
            return new $root.user.CreateAccount();
        };

        /**
         * Creates a plain object from a CreateAccount message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.CreateAccount
         * @static
         * @param {user.CreateAccount} message CreateAccount
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateAccount.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this CreateAccount to JSON.
         * @function toJSON
         * @memberof user.CreateAccount
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        CreateAccount.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof user.CreateAccount
             * @interface IRequest
             * @property {string|null} [appId] Request appId
             * @property {string|null} [appKey] Request appKey
             * @property {string|null} [uid] Request uid
             * @property {string|null} [password] Request password
             * @property {string|null} [nickname] Request nickname
             * @property {string|null} [avatar] Request avatar
             */

            /**
             * Constructs a new Request.
             * @memberof user.CreateAccount
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {user.CreateAccount.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request appId.
             * @member {string} appId
             * @memberof user.CreateAccount.Request
             * @instance
             */
            Request.prototype.appId = "";

            /**
             * Request appKey.
             * @member {string} appKey
             * @memberof user.CreateAccount.Request
             * @instance
             */
            Request.prototype.appKey = "";

            /**
             * Request uid.
             * @member {string} uid
             * @memberof user.CreateAccount.Request
             * @instance
             */
            Request.prototype.uid = "";

            /**
             * Request password.
             * @member {string} password
             * @memberof user.CreateAccount.Request
             * @instance
             */
            Request.prototype.password = "";

            /**
             * Request nickname.
             * @member {string} nickname
             * @memberof user.CreateAccount.Request
             * @instance
             */
            Request.prototype.nickname = "";

            /**
             * Request avatar.
             * @member {string} avatar
             * @memberof user.CreateAccount.Request
             * @instance
             */
            Request.prototype.avatar = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof user.CreateAccount.Request
             * @static
             * @param {user.CreateAccount.IRequest=} [properties] Properties to set
             * @returns {user.CreateAccount.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link user.CreateAccount.Request.verify|verify} messages.
             * @function encode
             * @memberof user.CreateAccount.Request
             * @static
             * @param {user.CreateAccount.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.appId != null && Object.hasOwnProperty.call(message, "appId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.appId);
                if (message.appKey != null && Object.hasOwnProperty.call(message, "appKey"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.appKey);
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.uid);
                if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.password);
                if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.nickname);
                if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.avatar);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link user.CreateAccount.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.CreateAccount.Request
             * @static
             * @param {user.CreateAccount.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof user.CreateAccount.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.CreateAccount.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.CreateAccount.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.appId = reader.string();
                        break;
                    case 2:
                        message.appKey = reader.string();
                        break;
                    case 3:
                        message.uid = reader.string();
                        break;
                    case 4:
                        message.password = reader.string();
                        break;
                    case 5:
                        message.nickname = reader.string();
                        break;
                    case 6:
                        message.avatar = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.CreateAccount.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.CreateAccount.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof user.CreateAccount.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.appId != null && message.hasOwnProperty("appId"))
                    if (!$util.isString(message.appId))
                        return "appId: string expected";
                if (message.appKey != null && message.hasOwnProperty("appKey"))
                    if (!$util.isString(message.appKey))
                        return "appKey: string expected";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                if (message.password != null && message.hasOwnProperty("password"))
                    if (!$util.isString(message.password))
                        return "password: string expected";
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    if (!$util.isString(message.nickname))
                        return "nickname: string expected";
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    if (!$util.isString(message.avatar))
                        return "avatar: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.CreateAccount.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.CreateAccount.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.user.CreateAccount.Request)
                    return object;
                var message = new $root.user.CreateAccount.Request();
                if (object.appId != null)
                    message.appId = String(object.appId);
                if (object.appKey != null)
                    message.appKey = String(object.appKey);
                if (object.uid != null)
                    message.uid = String(object.uid);
                if (object.password != null)
                    message.password = String(object.password);
                if (object.nickname != null)
                    message.nickname = String(object.nickname);
                if (object.avatar != null)
                    message.avatar = String(object.avatar);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.CreateAccount.Request
             * @static
             * @param {user.CreateAccount.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.appId = "";
                    object.appKey = "";
                    object.uid = "";
                    object.password = "";
                    object.nickname = "";
                    object.avatar = "";
                }
                if (message.appId != null && message.hasOwnProperty("appId"))
                    object.appId = message.appId;
                if (message.appKey != null && message.hasOwnProperty("appKey"))
                    object.appKey = message.appKey;
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                if (message.password != null && message.hasOwnProperty("password"))
                    object.password = message.password;
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    object.nickname = message.nickname;
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    object.avatar = message.avatar;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof user.CreateAccount.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        CreateAccount.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof user.CreateAccount
             * @interface IResponse
             * @property {string|null} [deviceId] Response deviceId
             * @property {string|null} [token] Response token
             * @property {user.IMWCUserInfo|null} [userInfo] Response userInfo
             */

            /**
             * Constructs a new Response.
             * @memberof user.CreateAccount
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {user.CreateAccount.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response deviceId.
             * @member {string} deviceId
             * @memberof user.CreateAccount.Response
             * @instance
             */
            Response.prototype.deviceId = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof user.CreateAccount.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response userInfo.
             * @member {user.IMWCUserInfo|null|undefined} userInfo
             * @memberof user.CreateAccount.Response
             * @instance
             */
            Response.prototype.userInfo = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof user.CreateAccount.Response
             * @static
             * @param {user.CreateAccount.IResponse=} [properties] Properties to set
             * @returns {user.CreateAccount.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link user.CreateAccount.Response.verify|verify} messages.
             * @function encode
             * @memberof user.CreateAccount.Response
             * @static
             * @param {user.CreateAccount.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.deviceId);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.token);
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.MWCUserInfo.encode(message.userInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link user.CreateAccount.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof user.CreateAccount.Response
             * @static
             * @param {user.CreateAccount.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof user.CreateAccount.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {user.CreateAccount.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.CreateAccount.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deviceId = reader.string();
                        break;
                    case 2:
                        message.token = reader.string();
                        break;
                    case 3:
                        message.userInfo = $root.user.MWCUserInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof user.CreateAccount.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {user.CreateAccount.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof user.CreateAccount.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    if (!$util.isString(message.deviceId))
                        return "deviceId: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.MWCUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof user.CreateAccount.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {user.CreateAccount.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.user.CreateAccount.Response)
                    return object;
                var message = new $root.user.CreateAccount.Response();
                if (object.deviceId != null)
                    message.deviceId = String(object.deviceId);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".user.CreateAccount.Response.userInfo: object expected");
                    message.userInfo = $root.user.MWCUserInfo.fromObject(object.userInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof user.CreateAccount.Response
             * @static
             * @param {user.CreateAccount.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.deviceId = "";
                    object.token = "";
                    object.userInfo = null;
                }
                if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                    object.deviceId = message.deviceId;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.MWCUserInfo.toObject(message.userInfo, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof user.CreateAccount.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return CreateAccount;
    })();

    user.MWCToken = (function() {

        /**
         * Properties of a MWCToken.
         * @memberof user
         * @interface IMWCToken
         * @property {string|null} [appId] MWCToken appId
         * @property {string|null} [appKey] MWCToken appKey
         * @property {user.IMWCUserInfo|null} [userInfo] MWCToken userInfo
         * @property {user.IUserAgent|null} [userAgent] MWCToken userAgent
         * @property {string|null} [deviceId] MWCToken deviceId
         * @property {string|null} [loginTime] MWCToken loginTime
         */

        /**
         * Constructs a new MWCToken.
         * @memberof user
         * @classdesc Represents a MWCToken.
         * @implements IMWCToken
         * @constructor
         * @param {user.IMWCToken=} [properties] Properties to set
         */
        function MWCToken(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MWCToken appId.
         * @member {string} appId
         * @memberof user.MWCToken
         * @instance
         */
        MWCToken.prototype.appId = "";

        /**
         * MWCToken appKey.
         * @member {string} appKey
         * @memberof user.MWCToken
         * @instance
         */
        MWCToken.prototype.appKey = "";

        /**
         * MWCToken userInfo.
         * @member {user.IMWCUserInfo|null|undefined} userInfo
         * @memberof user.MWCToken
         * @instance
         */
        MWCToken.prototype.userInfo = null;

        /**
         * MWCToken userAgent.
         * @member {user.IUserAgent|null|undefined} userAgent
         * @memberof user.MWCToken
         * @instance
         */
        MWCToken.prototype.userAgent = null;

        /**
         * MWCToken deviceId.
         * @member {string} deviceId
         * @memberof user.MWCToken
         * @instance
         */
        MWCToken.prototype.deviceId = "";

        /**
         * MWCToken loginTime.
         * @member {string} loginTime
         * @memberof user.MWCToken
         * @instance
         */
        MWCToken.prototype.loginTime = "";

        /**
         * Creates a new MWCToken instance using the specified properties.
         * @function create
         * @memberof user.MWCToken
         * @static
         * @param {user.IMWCToken=} [properties] Properties to set
         * @returns {user.MWCToken} MWCToken instance
         */
        MWCToken.create = function create(properties) {
            return new MWCToken(properties);
        };

        /**
         * Encodes the specified MWCToken message. Does not implicitly {@link user.MWCToken.verify|verify} messages.
         * @function encode
         * @memberof user.MWCToken
         * @static
         * @param {user.IMWCToken} message MWCToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MWCToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.appId != null && Object.hasOwnProperty.call(message, "appId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.appId);
            if (message.appKey != null && Object.hasOwnProperty.call(message, "appKey"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.appKey);
            if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                $root.user.MWCUserInfo.encode(message.userInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.userAgent != null && Object.hasOwnProperty.call(message, "userAgent"))
                $root.user.UserAgent.encode(message.userAgent, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.deviceId != null && Object.hasOwnProperty.call(message, "deviceId"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.deviceId);
            if (message.loginTime != null && Object.hasOwnProperty.call(message, "loginTime"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.loginTime);
            return writer;
        };

        /**
         * Encodes the specified MWCToken message, length delimited. Does not implicitly {@link user.MWCToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.MWCToken
         * @static
         * @param {user.IMWCToken} message MWCToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MWCToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MWCToken message from the specified reader or buffer.
         * @function decode
         * @memberof user.MWCToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.MWCToken} MWCToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MWCToken.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.MWCToken();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.appId = reader.string();
                    break;
                case 2:
                    message.appKey = reader.string();
                    break;
                case 3:
                    message.userInfo = $root.user.MWCUserInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.userAgent = $root.user.UserAgent.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.deviceId = reader.string();
                    break;
                case 6:
                    message.loginTime = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MWCToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.MWCToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.MWCToken} MWCToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MWCToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MWCToken message.
         * @function verify
         * @memberof user.MWCToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MWCToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.appId != null && message.hasOwnProperty("appId"))
                if (!$util.isString(message.appId))
                    return "appId: string expected";
            if (message.appKey != null && message.hasOwnProperty("appKey"))
                if (!$util.isString(message.appKey))
                    return "appKey: string expected";
            if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                var error = $root.user.MWCUserInfo.verify(message.userInfo);
                if (error)
                    return "userInfo." + error;
            }
            if (message.userAgent != null && message.hasOwnProperty("userAgent")) {
                var error = $root.user.UserAgent.verify(message.userAgent);
                if (error)
                    return "userAgent." + error;
            }
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                if (!$util.isString(message.deviceId))
                    return "deviceId: string expected";
            if (message.loginTime != null && message.hasOwnProperty("loginTime"))
                if (!$util.isString(message.loginTime))
                    return "loginTime: string expected";
            return null;
        };

        /**
         * Creates a MWCToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.MWCToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.MWCToken} MWCToken
         */
        MWCToken.fromObject = function fromObject(object) {
            if (object instanceof $root.user.MWCToken)
                return object;
            var message = new $root.user.MWCToken();
            if (object.appId != null)
                message.appId = String(object.appId);
            if (object.appKey != null)
                message.appKey = String(object.appKey);
            if (object.userInfo != null) {
                if (typeof object.userInfo !== "object")
                    throw TypeError(".user.MWCToken.userInfo: object expected");
                message.userInfo = $root.user.MWCUserInfo.fromObject(object.userInfo);
            }
            if (object.userAgent != null) {
                if (typeof object.userAgent !== "object")
                    throw TypeError(".user.MWCToken.userAgent: object expected");
                message.userAgent = $root.user.UserAgent.fromObject(object.userAgent);
            }
            if (object.deviceId != null)
                message.deviceId = String(object.deviceId);
            if (object.loginTime != null)
                message.loginTime = String(object.loginTime);
            return message;
        };

        /**
         * Creates a plain object from a MWCToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.MWCToken
         * @static
         * @param {user.MWCToken} message MWCToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MWCToken.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.appId = "";
                object.appKey = "";
                object.userInfo = null;
                object.userAgent = null;
                object.deviceId = "";
                object.loginTime = "";
            }
            if (message.appId != null && message.hasOwnProperty("appId"))
                object.appId = message.appId;
            if (message.appKey != null && message.hasOwnProperty("appKey"))
                object.appKey = message.appKey;
            if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                object.userInfo = $root.user.MWCUserInfo.toObject(message.userInfo, options);
            if (message.userAgent != null && message.hasOwnProperty("userAgent"))
                object.userAgent = $root.user.UserAgent.toObject(message.userAgent, options);
            if (message.deviceId != null && message.hasOwnProperty("deviceId"))
                object.deviceId = message.deviceId;
            if (message.loginTime != null && message.hasOwnProperty("loginTime"))
                object.loginTime = message.loginTime;
            return object;
        };

        /**
         * Converts this MWCToken to JSON.
         * @function toJSON
         * @memberof user.MWCToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MWCToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MWCToken;
    })();

    user.MWCUserInfo = (function() {

        /**
         * Properties of a MWCUserInfo.
         * @memberof user
         * @interface IMWCUserInfo
         * @property {string|null} [uid] MWCUserInfo uid
         * @property {string|null} [nickname] MWCUserInfo nickname
         * @property {string|null} [avatar] MWCUserInfo avatar
         * @property {string|null} [bio] MWCUserInfo bio
         * @property {number|Long|null} [status] MWCUserInfo status
         * @property {number|Long|null} [createTime] MWCUserInfo createTime
         */

        /**
         * Constructs a new MWCUserInfo.
         * @memberof user
         * @classdesc Represents a MWCUserInfo.
         * @implements IMWCUserInfo
         * @constructor
         * @param {user.IMWCUserInfo=} [properties] Properties to set
         */
        function MWCUserInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MWCUserInfo uid.
         * @member {string} uid
         * @memberof user.MWCUserInfo
         * @instance
         */
        MWCUserInfo.prototype.uid = "";

        /**
         * MWCUserInfo nickname.
         * @member {string} nickname
         * @memberof user.MWCUserInfo
         * @instance
         */
        MWCUserInfo.prototype.nickname = "";

        /**
         * MWCUserInfo avatar.
         * @member {string} avatar
         * @memberof user.MWCUserInfo
         * @instance
         */
        MWCUserInfo.prototype.avatar = "";

        /**
         * MWCUserInfo bio.
         * @member {string} bio
         * @memberof user.MWCUserInfo
         * @instance
         */
        MWCUserInfo.prototype.bio = "";

        /**
         * MWCUserInfo status.
         * @member {number|Long} status
         * @memberof user.MWCUserInfo
         * @instance
         */
        MWCUserInfo.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MWCUserInfo createTime.
         * @member {number|Long} createTime
         * @memberof user.MWCUserInfo
         * @instance
         */
        MWCUserInfo.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new MWCUserInfo instance using the specified properties.
         * @function create
         * @memberof user.MWCUserInfo
         * @static
         * @param {user.IMWCUserInfo=} [properties] Properties to set
         * @returns {user.MWCUserInfo} MWCUserInfo instance
         */
        MWCUserInfo.create = function create(properties) {
            return new MWCUserInfo(properties);
        };

        /**
         * Encodes the specified MWCUserInfo message. Does not implicitly {@link user.MWCUserInfo.verify|verify} messages.
         * @function encode
         * @memberof user.MWCUserInfo
         * @static
         * @param {user.IMWCUserInfo} message MWCUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MWCUserInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nickname);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
            if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.bio);
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.status);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTime);
            return writer;
        };

        /**
         * Encodes the specified MWCUserInfo message, length delimited. Does not implicitly {@link user.MWCUserInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof user.MWCUserInfo
         * @static
         * @param {user.IMWCUserInfo} message MWCUserInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MWCUserInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MWCUserInfo message from the specified reader or buffer.
         * @function decode
         * @memberof user.MWCUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {user.MWCUserInfo} MWCUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MWCUserInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.user.MWCUserInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.nickname = reader.string();
                    break;
                case 3:
                    message.avatar = reader.string();
                    break;
                case 4:
                    message.bio = reader.string();
                    break;
                case 5:
                    message.status = reader.int64();
                    break;
                case 6:
                    message.createTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MWCUserInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof user.MWCUserInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {user.MWCUserInfo} MWCUserInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MWCUserInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MWCUserInfo message.
         * @function verify
         * @memberof user.MWCUserInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MWCUserInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.bio != null && message.hasOwnProperty("bio"))
                if (!$util.isString(message.bio))
                    return "bio: string expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a MWCUserInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof user.MWCUserInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {user.MWCUserInfo} MWCUserInfo
         */
        MWCUserInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.user.MWCUserInfo)
                return object;
            var message = new $root.user.MWCUserInfo();
            if (object.uid != null)
                message.uid = String(object.uid);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.bio != null)
                message.bio = String(object.bio);
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a MWCUserInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof user.MWCUserInfo
         * @static
         * @param {user.MWCUserInfo} message MWCUserInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MWCUserInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = "";
                object.nickname = "";
                object.avatar = "";
                object.bio = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.bio != null && message.hasOwnProperty("bio"))
                object.bio = message.bio;
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            return object;
        };

        /**
         * Converts this MWCUserInfo to JSON.
         * @function toJSON
         * @memberof user.MWCUserInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MWCUserInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MWCUserInfo;
    })();

    return user;
})();

$root.contact = (function() {

    /**
     * Namespace contact.
     * @exports contact
     * @namespace
     */
    var contact = {};

    contact.Contact = (function() {

        /**
         * Properties of a Contact.
         * @memberof contact
         * @interface IContact
         * @property {string|null} [id] Contact id
         * @property {Array.<contact.Contact.IUser>|null} [users] Contact users
         * @property {contact.Contact.IPermissions|null} [permissions] Contact permissions
         * @property {number|Long|null} [status] Contact status
         * @property {number|Long|null} [createTime] Contact createTime
         * @property {number|Long|null} [lastSeenTime] Contact lastSeenTime
         * @property {string|null} [lastMessage] Contact lastMessage
         * @property {number|Long|null} [lastMessageTime] Contact lastMessageTime
         */

        /**
         * Constructs a new Contact.
         * @memberof contact
         * @classdesc Represents a Contact.
         * @implements IContact
         * @constructor
         * @param {contact.IContact=} [properties] Properties to set
         */
        function Contact(properties) {
            this.users = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Contact id.
         * @member {string} id
         * @memberof contact.Contact
         * @instance
         */
        Contact.prototype.id = "";

        /**
         * Contact users.
         * @member {Array.<contact.Contact.IUser>} users
         * @memberof contact.Contact
         * @instance
         */
        Contact.prototype.users = $util.emptyArray;

        /**
         * Contact permissions.
         * @member {contact.Contact.IPermissions|null|undefined} permissions
         * @memberof contact.Contact
         * @instance
         */
        Contact.prototype.permissions = null;

        /**
         * Contact status.
         * @member {number|Long} status
         * @memberof contact.Contact
         * @instance
         */
        Contact.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Contact createTime.
         * @member {number|Long} createTime
         * @memberof contact.Contact
         * @instance
         */
        Contact.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Contact lastSeenTime.
         * @member {number|Long} lastSeenTime
         * @memberof contact.Contact
         * @instance
         */
        Contact.prototype.lastSeenTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Contact lastMessage.
         * @member {string} lastMessage
         * @memberof contact.Contact
         * @instance
         */
        Contact.prototype.lastMessage = "";

        /**
         * Contact lastMessageTime.
         * @member {number|Long} lastMessageTime
         * @memberof contact.Contact
         * @instance
         */
        Contact.prototype.lastMessageTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new Contact instance using the specified properties.
         * @function create
         * @memberof contact.Contact
         * @static
         * @param {contact.IContact=} [properties] Properties to set
         * @returns {contact.Contact} Contact instance
         */
        Contact.create = function create(properties) {
            return new Contact(properties);
        };

        /**
         * Encodes the specified Contact message. Does not implicitly {@link contact.Contact.verify|verify} messages.
         * @function encode
         * @memberof contact.Contact
         * @static
         * @param {contact.IContact} message Contact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Contact.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.users != null && message.users.length)
                for (var i = 0; i < message.users.length; ++i)
                    $root.contact.Contact.User.encode(message.users[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.permissions != null && Object.hasOwnProperty.call(message, "permissions"))
                $root.contact.Contact.Permissions.encode(message.permissions, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.status);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTime);
            if (message.lastSeenTime != null && Object.hasOwnProperty.call(message, "lastSeenTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastSeenTime);
            if (message.lastMessage != null && Object.hasOwnProperty.call(message, "lastMessage"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.lastMessage);
            if (message.lastMessageTime != null && Object.hasOwnProperty.call(message, "lastMessageTime"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastMessageTime);
            return writer;
        };

        /**
         * Encodes the specified Contact message, length delimited. Does not implicitly {@link contact.Contact.verify|verify} messages.
         * @function encodeDelimited
         * @memberof contact.Contact
         * @static
         * @param {contact.IContact} message Contact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Contact.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Contact message from the specified reader or buffer.
         * @function decode
         * @memberof contact.Contact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {contact.Contact} Contact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Contact.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.Contact();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.contact.Contact.User.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.permissions = $root.contact.Contact.Permissions.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.status = reader.int64();
                    break;
                case 5:
                    message.createTime = reader.int64();
                    break;
                case 6:
                    message.lastSeenTime = reader.int64();
                    break;
                case 7:
                    message.lastMessage = reader.string();
                    break;
                case 8:
                    message.lastMessageTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Contact message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof contact.Contact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {contact.Contact} Contact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Contact.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Contact message.
         * @function verify
         * @memberof contact.Contact
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Contact.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.users != null && message.hasOwnProperty("users")) {
                if (!Array.isArray(message.users))
                    return "users: array expected";
                for (var i = 0; i < message.users.length; ++i) {
                    var error = $root.contact.Contact.User.verify(message.users[i]);
                    if (error)
                        return "users." + error;
                }
            }
            if (message.permissions != null && message.hasOwnProperty("permissions")) {
                var error = $root.contact.Contact.Permissions.verify(message.permissions);
                if (error)
                    return "permissions." + error;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (!$util.isInteger(message.lastSeenTime) && !(message.lastSeenTime && $util.isInteger(message.lastSeenTime.low) && $util.isInteger(message.lastSeenTime.high)))
                    return "lastSeenTime: integer|Long expected";
            if (message.lastMessage != null && message.hasOwnProperty("lastMessage"))
                if (!$util.isString(message.lastMessage))
                    return "lastMessage: string expected";
            if (message.lastMessageTime != null && message.hasOwnProperty("lastMessageTime"))
                if (!$util.isInteger(message.lastMessageTime) && !(message.lastMessageTime && $util.isInteger(message.lastMessageTime.low) && $util.isInteger(message.lastMessageTime.high)))
                    return "lastMessageTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a Contact message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof contact.Contact
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {contact.Contact} Contact
         */
        Contact.fromObject = function fromObject(object) {
            if (object instanceof $root.contact.Contact)
                return object;
            var message = new $root.contact.Contact();
            if (object.id != null)
                message.id = String(object.id);
            if (object.users) {
                if (!Array.isArray(object.users))
                    throw TypeError(".contact.Contact.users: array expected");
                message.users = [];
                for (var i = 0; i < object.users.length; ++i) {
                    if (typeof object.users[i] !== "object")
                        throw TypeError(".contact.Contact.users: object expected");
                    message.users[i] = $root.contact.Contact.User.fromObject(object.users[i]);
                }
            }
            if (object.permissions != null) {
                if (typeof object.permissions !== "object")
                    throw TypeError(".contact.Contact.permissions: object expected");
                message.permissions = $root.contact.Contact.Permissions.fromObject(object.permissions);
            }
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.lastSeenTime != null)
                if ($util.Long)
                    (message.lastSeenTime = $util.Long.fromValue(object.lastSeenTime)).unsigned = false;
                else if (typeof object.lastSeenTime === "string")
                    message.lastSeenTime = parseInt(object.lastSeenTime, 10);
                else if (typeof object.lastSeenTime === "number")
                    message.lastSeenTime = object.lastSeenTime;
                else if (typeof object.lastSeenTime === "object")
                    message.lastSeenTime = new $util.LongBits(object.lastSeenTime.low >>> 0, object.lastSeenTime.high >>> 0).toNumber();
            if (object.lastMessage != null)
                message.lastMessage = String(object.lastMessage);
            if (object.lastMessageTime != null)
                if ($util.Long)
                    (message.lastMessageTime = $util.Long.fromValue(object.lastMessageTime)).unsigned = false;
                else if (typeof object.lastMessageTime === "string")
                    message.lastMessageTime = parseInt(object.lastMessageTime, 10);
                else if (typeof object.lastMessageTime === "number")
                    message.lastMessageTime = object.lastMessageTime;
                else if (typeof object.lastMessageTime === "object")
                    message.lastMessageTime = new $util.LongBits(object.lastMessageTime.low >>> 0, object.lastMessageTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a Contact message. Also converts values to other types if specified.
         * @function toObject
         * @memberof contact.Contact
         * @static
         * @param {contact.Contact} message Contact
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Contact.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.users = [];
            if (options.defaults) {
                object.id = "";
                object.permissions = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastSeenTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastSeenTime = options.longs === String ? "0" : 0;
                object.lastMessage = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastMessageTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastMessageTime = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.users && message.users.length) {
                object.users = [];
                for (var j = 0; j < message.users.length; ++j)
                    object.users[j] = $root.contact.Contact.User.toObject(message.users[j], options);
            }
            if (message.permissions != null && message.hasOwnProperty("permissions"))
                object.permissions = $root.contact.Contact.Permissions.toObject(message.permissions, options);
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (typeof message.lastSeenTime === "number")
                    object.lastSeenTime = options.longs === String ? String(message.lastSeenTime) : message.lastSeenTime;
                else
                    object.lastSeenTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastSeenTime) : options.longs === Number ? new $util.LongBits(message.lastSeenTime.low >>> 0, message.lastSeenTime.high >>> 0).toNumber() : message.lastSeenTime;
            if (message.lastMessage != null && message.hasOwnProperty("lastMessage"))
                object.lastMessage = message.lastMessage;
            if (message.lastMessageTime != null && message.hasOwnProperty("lastMessageTime"))
                if (typeof message.lastMessageTime === "number")
                    object.lastMessageTime = options.longs === String ? String(message.lastMessageTime) : message.lastMessageTime;
                else
                    object.lastMessageTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastMessageTime) : options.longs === Number ? new $util.LongBits(message.lastMessageTime.low >>> 0, message.lastMessageTime.high >>> 0).toNumber() : message.lastMessageTime;
            return object;
        };

        /**
         * Converts this Contact to JSON.
         * @function toJSON
         * @memberof contact.Contact
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Contact.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Contact.User = (function() {

            /**
             * Properties of a User.
             * @memberof contact.Contact
             * @interface IUser
             * @property {string|null} [uid] User uid
             * @property {string|null} [nickname] User nickname
             * @property {boolean|null} [receiveMessage] User receiveMessage
             * @property {user.ISimpleSSOUserInfo|null} [userInfo] User userInfo
             */

            /**
             * Constructs a new User.
             * @memberof contact.Contact
             * @classdesc Represents a User.
             * @implements IUser
             * @constructor
             * @param {contact.Contact.IUser=} [properties] Properties to set
             */
            function User(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * User uid.
             * @member {string} uid
             * @memberof contact.Contact.User
             * @instance
             */
            User.prototype.uid = "";

            /**
             * User nickname.
             * @member {string} nickname
             * @memberof contact.Contact.User
             * @instance
             */
            User.prototype.nickname = "";

            /**
             * User receiveMessage.
             * @member {boolean} receiveMessage
             * @memberof contact.Contact.User
             * @instance
             */
            User.prototype.receiveMessage = false;

            /**
             * User userInfo.
             * @member {user.ISimpleSSOUserInfo|null|undefined} userInfo
             * @memberof contact.Contact.User
             * @instance
             */
            User.prototype.userInfo = null;

            /**
             * Creates a new User instance using the specified properties.
             * @function create
             * @memberof contact.Contact.User
             * @static
             * @param {contact.Contact.IUser=} [properties] Properties to set
             * @returns {contact.Contact.User} User instance
             */
            User.create = function create(properties) {
                return new User(properties);
            };

            /**
             * Encodes the specified User message. Does not implicitly {@link contact.Contact.User.verify|verify} messages.
             * @function encode
             * @memberof contact.Contact.User
             * @static
             * @param {contact.Contact.IUser} message User message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            User.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
                if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.nickname);
                if (message.receiveMessage != null && Object.hasOwnProperty.call(message, "receiveMessage"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.receiveMessage);
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.SimpleSSOUserInfo.encode(message.userInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified User message, length delimited. Does not implicitly {@link contact.Contact.User.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.Contact.User
             * @static
             * @param {contact.Contact.IUser} message User message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            User.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a User message from the specified reader or buffer.
             * @function decode
             * @memberof contact.Contact.User
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.Contact.User} User
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            User.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.Contact.User();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.uid = reader.string();
                        break;
                    case 2:
                        message.nickname = reader.string();
                        break;
                    case 3:
                        message.receiveMessage = reader.bool();
                        break;
                    case 4:
                        message.userInfo = $root.user.SimpleSSOUserInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a User message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.Contact.User
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.Contact.User} User
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            User.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a User message.
             * @function verify
             * @memberof contact.Contact.User
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            User.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    if (!$util.isString(message.nickname))
                        return "nickname: string expected";
                if (message.receiveMessage != null && message.hasOwnProperty("receiveMessage"))
                    if (typeof message.receiveMessage !== "boolean")
                        return "receiveMessage: boolean expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.SimpleSSOUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                return null;
            };

            /**
             * Creates a User message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.Contact.User
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.Contact.User} User
             */
            User.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.Contact.User)
                    return object;
                var message = new $root.contact.Contact.User();
                if (object.uid != null)
                    message.uid = String(object.uid);
                if (object.nickname != null)
                    message.nickname = String(object.nickname);
                if (object.receiveMessage != null)
                    message.receiveMessage = Boolean(object.receiveMessage);
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".contact.Contact.User.userInfo: object expected");
                    message.userInfo = $root.user.SimpleSSOUserInfo.fromObject(object.userInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a User message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.Contact.User
             * @static
             * @param {contact.Contact.User} message User
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            User.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.uid = "";
                    object.nickname = "";
                    object.receiveMessage = false;
                    object.userInfo = null;
                }
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                if (message.nickname != null && message.hasOwnProperty("nickname"))
                    object.nickname = message.nickname;
                if (message.receiveMessage != null && message.hasOwnProperty("receiveMessage"))
                    object.receiveMessage = message.receiveMessage;
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.SimpleSSOUserInfo.toObject(message.userInfo, options);
                return object;
            };

            /**
             * Converts this User to JSON.
             * @function toJSON
             * @memberof contact.Contact.User
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            User.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return User;
        })();

        Contact.Permissions = (function() {

            /**
             * Properties of a Permissions.
             * @memberof contact.Contact
             * @interface IPermissions
             * @property {boolean|null} [e2ee] Permissions e2ee
             */

            /**
             * Constructs a new Permissions.
             * @memberof contact.Contact
             * @classdesc Represents a Permissions.
             * @implements IPermissions
             * @constructor
             * @param {contact.Contact.IPermissions=} [properties] Properties to set
             */
            function Permissions(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Permissions e2ee.
             * @member {boolean} e2ee
             * @memberof contact.Contact.Permissions
             * @instance
             */
            Permissions.prototype.e2ee = false;

            /**
             * Creates a new Permissions instance using the specified properties.
             * @function create
             * @memberof contact.Contact.Permissions
             * @static
             * @param {contact.Contact.IPermissions=} [properties] Properties to set
             * @returns {contact.Contact.Permissions} Permissions instance
             */
            Permissions.create = function create(properties) {
                return new Permissions(properties);
            };

            /**
             * Encodes the specified Permissions message. Does not implicitly {@link contact.Contact.Permissions.verify|verify} messages.
             * @function encode
             * @memberof contact.Contact.Permissions
             * @static
             * @param {contact.Contact.IPermissions} message Permissions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Permissions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.e2ee != null && Object.hasOwnProperty.call(message, "e2ee"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.e2ee);
                return writer;
            };

            /**
             * Encodes the specified Permissions message, length delimited. Does not implicitly {@link contact.Contact.Permissions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.Contact.Permissions
             * @static
             * @param {contact.Contact.IPermissions} message Permissions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Permissions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Permissions message from the specified reader or buffer.
             * @function decode
             * @memberof contact.Contact.Permissions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.Contact.Permissions} Permissions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Permissions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.Contact.Permissions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.e2ee = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Permissions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.Contact.Permissions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.Contact.Permissions} Permissions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Permissions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Permissions message.
             * @function verify
             * @memberof contact.Contact.Permissions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Permissions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.e2ee != null && message.hasOwnProperty("e2ee"))
                    if (typeof message.e2ee !== "boolean")
                        return "e2ee: boolean expected";
                return null;
            };

            /**
             * Creates a Permissions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.Contact.Permissions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.Contact.Permissions} Permissions
             */
            Permissions.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.Contact.Permissions)
                    return object;
                var message = new $root.contact.Contact.Permissions();
                if (object.e2ee != null)
                    message.e2ee = Boolean(object.e2ee);
                return message;
            };

            /**
             * Creates a plain object from a Permissions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.Contact.Permissions
             * @static
             * @param {contact.Contact.Permissions} message Permissions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Permissions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.e2ee = false;
                if (message.e2ee != null && message.hasOwnProperty("e2ee"))
                    object.e2ee = message.e2ee;
                return object;
            };

            /**
             * Converts this Permissions to JSON.
             * @function toJSON
             * @memberof contact.Contact.Permissions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Permissions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Permissions;
        })();

        return Contact;
    })();

    contact.GetContactList = (function() {

        /**
         * Properties of a GetContactList.
         * @memberof contact
         * @interface IGetContactList
         */

        /**
         * Constructs a new GetContactList.
         * @memberof contact
         * @classdesc Represents a GetContactList.
         * @implements IGetContactList
         * @constructor
         * @param {contact.IGetContactList=} [properties] Properties to set
         */
        function GetContactList(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetContactList instance using the specified properties.
         * @function create
         * @memberof contact.GetContactList
         * @static
         * @param {contact.IGetContactList=} [properties] Properties to set
         * @returns {contact.GetContactList} GetContactList instance
         */
        GetContactList.create = function create(properties) {
            return new GetContactList(properties);
        };

        /**
         * Encodes the specified GetContactList message. Does not implicitly {@link contact.GetContactList.verify|verify} messages.
         * @function encode
         * @memberof contact.GetContactList
         * @static
         * @param {contact.IGetContactList} message GetContactList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContactList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetContactList message, length delimited. Does not implicitly {@link contact.GetContactList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof contact.GetContactList
         * @static
         * @param {contact.IGetContactList} message GetContactList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetContactList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetContactList message from the specified reader or buffer.
         * @function decode
         * @memberof contact.GetContactList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {contact.GetContactList} GetContactList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContactList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.GetContactList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetContactList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof contact.GetContactList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {contact.GetContactList} GetContactList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetContactList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetContactList message.
         * @function verify
         * @memberof contact.GetContactList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetContactList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetContactList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof contact.GetContactList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {contact.GetContactList} GetContactList
         */
        GetContactList.fromObject = function fromObject(object) {
            if (object instanceof $root.contact.GetContactList)
                return object;
            return new $root.contact.GetContactList();
        };

        /**
         * Creates a plain object from a GetContactList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof contact.GetContactList
         * @static
         * @param {contact.GetContactList} message GetContactList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetContactList.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetContactList to JSON.
         * @function toJSON
         * @memberof contact.GetContactList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetContactList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetContactList.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof contact.GetContactList
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof contact.GetContactList
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {contact.GetContactList.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof contact.GetContactList.Request
             * @static
             * @param {contact.GetContactList.IRequest=} [properties] Properties to set
             * @returns {contact.GetContactList.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link contact.GetContactList.Request.verify|verify} messages.
             * @function encode
             * @memberof contact.GetContactList.Request
             * @static
             * @param {contact.GetContactList.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link contact.GetContactList.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.GetContactList.Request
             * @static
             * @param {contact.GetContactList.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof contact.GetContactList.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.GetContactList.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.GetContactList.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.GetContactList.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.GetContactList.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof contact.GetContactList.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.GetContactList.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.GetContactList.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.GetContactList.Request)
                    return object;
                return new $root.contact.GetContactList.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.GetContactList.Request
             * @static
             * @param {contact.GetContactList.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof contact.GetContactList.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetContactList.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof contact.GetContactList
             * @interface IResponse
             * @property {Array.<contact.IContact>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof contact.GetContactList
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {contact.GetContactList.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<contact.IContact>} list
             * @memberof contact.GetContactList.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof contact.GetContactList.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof contact.GetContactList.Response
             * @static
             * @param {contact.GetContactList.IResponse=} [properties] Properties to set
             * @returns {contact.GetContactList.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link contact.GetContactList.Response.verify|verify} messages.
             * @function encode
             * @memberof contact.GetContactList.Response
             * @static
             * @param {contact.GetContactList.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.contact.Contact.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link contact.GetContactList.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.GetContactList.Response
             * @static
             * @param {contact.GetContactList.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof contact.GetContactList.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.GetContactList.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.GetContactList.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.contact.Contact.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.GetContactList.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.GetContactList.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof contact.GetContactList.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.contact.Contact.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.GetContactList.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.GetContactList.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.GetContactList.Response)
                    return object;
                var message = new $root.contact.GetContactList.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".contact.GetContactList.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".contact.GetContactList.Response.list: object expected");
                        message.list[i] = $root.contact.Contact.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.GetContactList.Response
             * @static
             * @param {contact.GetContactList.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.contact.Contact.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof contact.GetContactList.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetContactList;
    })();

    contact.SearchContact = (function() {

        /**
         * Properties of a SearchContact.
         * @memberof contact
         * @interface ISearchContact
         */

        /**
         * Constructs a new SearchContact.
         * @memberof contact
         * @classdesc Represents a SearchContact.
         * @implements ISearchContact
         * @constructor
         * @param {contact.ISearchContact=} [properties] Properties to set
         */
        function SearchContact(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SearchContact instance using the specified properties.
         * @function create
         * @memberof contact.SearchContact
         * @static
         * @param {contact.ISearchContact=} [properties] Properties to set
         * @returns {contact.SearchContact} SearchContact instance
         */
        SearchContact.create = function create(properties) {
            return new SearchContact(properties);
        };

        /**
         * Encodes the specified SearchContact message. Does not implicitly {@link contact.SearchContact.verify|verify} messages.
         * @function encode
         * @memberof contact.SearchContact
         * @static
         * @param {contact.ISearchContact} message SearchContact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchContact.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SearchContact message, length delimited. Does not implicitly {@link contact.SearchContact.verify|verify} messages.
         * @function encodeDelimited
         * @memberof contact.SearchContact
         * @static
         * @param {contact.ISearchContact} message SearchContact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchContact.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchContact message from the specified reader or buffer.
         * @function decode
         * @memberof contact.SearchContact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {contact.SearchContact} SearchContact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchContact.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.SearchContact();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchContact message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof contact.SearchContact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {contact.SearchContact} SearchContact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchContact.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchContact message.
         * @function verify
         * @memberof contact.SearchContact
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchContact.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SearchContact message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof contact.SearchContact
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {contact.SearchContact} SearchContact
         */
        SearchContact.fromObject = function fromObject(object) {
            if (object instanceof $root.contact.SearchContact)
                return object;
            return new $root.contact.SearchContact();
        };

        /**
         * Creates a plain object from a SearchContact message. Also converts values to other types if specified.
         * @function toObject
         * @memberof contact.SearchContact
         * @static
         * @param {contact.SearchContact} message SearchContact
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchContact.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SearchContact to JSON.
         * @function toJSON
         * @memberof contact.SearchContact
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchContact.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SearchContact.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof contact.SearchContact
             * @interface IRequest
             * @property {string|null} [userId] Request userId
             */

            /**
             * Constructs a new Request.
             * @memberof contact.SearchContact
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {contact.SearchContact.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request userId.
             * @member {string} userId
             * @memberof contact.SearchContact.Request
             * @instance
             */
            Request.prototype.userId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof contact.SearchContact.Request
             * @static
             * @param {contact.SearchContact.IRequest=} [properties] Properties to set
             * @returns {contact.SearchContact.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link contact.SearchContact.Request.verify|verify} messages.
             * @function encode
             * @memberof contact.SearchContact.Request
             * @static
             * @param {contact.SearchContact.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link contact.SearchContact.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.SearchContact.Request
             * @static
             * @param {contact.SearchContact.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof contact.SearchContact.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.SearchContact.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.SearchContact.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.userId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.SearchContact.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.SearchContact.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof contact.SearchContact.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.SearchContact.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.SearchContact.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.SearchContact.Request)
                    return object;
                var message = new $root.contact.SearchContact.Request();
                if (object.userId != null)
                    message.userId = String(object.userId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.SearchContact.Request
             * @static
             * @param {contact.SearchContact.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.userId = "";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof contact.SearchContact.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        SearchContact.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof contact.SearchContact
             * @interface IResponse
             * @property {user.ISimpleSSOUserInfo|null} [userInfo] Response userInfo
             * @property {boolean|null} [isFriend] Response isFriend
             * @property {string|null} [roomId] Response roomId
             */

            /**
             * Constructs a new Response.
             * @memberof contact.SearchContact
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {contact.SearchContact.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response userInfo.
             * @member {user.ISimpleSSOUserInfo|null|undefined} userInfo
             * @memberof contact.SearchContact.Response
             * @instance
             */
            Response.prototype.userInfo = null;

            /**
             * Response isFriend.
             * @member {boolean} isFriend
             * @memberof contact.SearchContact.Response
             * @instance
             */
            Response.prototype.isFriend = false;

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof contact.SearchContact.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof contact.SearchContact.Response
             * @static
             * @param {contact.SearchContact.IResponse=} [properties] Properties to set
             * @returns {contact.SearchContact.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link contact.SearchContact.Response.verify|verify} messages.
             * @function encode
             * @memberof contact.SearchContact.Response
             * @static
             * @param {contact.SearchContact.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                    $root.user.SimpleSSOUserInfo.encode(message.userInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.isFriend != null && Object.hasOwnProperty.call(message, "isFriend"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isFriend);
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.roomId);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link contact.SearchContact.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.SearchContact.Response
             * @static
             * @param {contact.SearchContact.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof contact.SearchContact.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.SearchContact.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.SearchContact.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.userInfo = $root.user.SimpleSSOUserInfo.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.isFriend = reader.bool();
                        break;
                    case 3:
                        message.roomId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.SearchContact.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.SearchContact.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof contact.SearchContact.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                    var error = $root.user.SimpleSSOUserInfo.verify(message.userInfo);
                    if (error)
                        return "userInfo." + error;
                }
                if (message.isFriend != null && message.hasOwnProperty("isFriend"))
                    if (typeof message.isFriend !== "boolean")
                        return "isFriend: boolean expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.SearchContact.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.SearchContact.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.SearchContact.Response)
                    return object;
                var message = new $root.contact.SearchContact.Response();
                if (object.userInfo != null) {
                    if (typeof object.userInfo !== "object")
                        throw TypeError(".contact.SearchContact.Response.userInfo: object expected");
                    message.userInfo = $root.user.SimpleSSOUserInfo.fromObject(object.userInfo);
                }
                if (object.isFriend != null)
                    message.isFriend = Boolean(object.isFriend);
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.SearchContact.Response
             * @static
             * @param {contact.SearchContact.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userInfo = null;
                    object.isFriend = false;
                    object.roomId = "";
                }
                if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                    object.userInfo = $root.user.SimpleSSOUserInfo.toObject(message.userInfo, options);
                if (message.isFriend != null && message.hasOwnProperty("isFriend"))
                    object.isFriend = message.isFriend;
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof contact.SearchContact.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return SearchContact;
    })();

    contact.SearchUserInfoList = (function() {

        /**
         * Properties of a SearchUserInfoList.
         * @memberof contact
         * @interface ISearchUserInfoList
         */

        /**
         * Constructs a new SearchUserInfoList.
         * @memberof contact
         * @classdesc Represents a SearchUserInfoList.
         * @implements ISearchUserInfoList
         * @constructor
         * @param {contact.ISearchUserInfoList=} [properties] Properties to set
         */
        function SearchUserInfoList(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SearchUserInfoList instance using the specified properties.
         * @function create
         * @memberof contact.SearchUserInfoList
         * @static
         * @param {contact.ISearchUserInfoList=} [properties] Properties to set
         * @returns {contact.SearchUserInfoList} SearchUserInfoList instance
         */
        SearchUserInfoList.create = function create(properties) {
            return new SearchUserInfoList(properties);
        };

        /**
         * Encodes the specified SearchUserInfoList message. Does not implicitly {@link contact.SearchUserInfoList.verify|verify} messages.
         * @function encode
         * @memberof contact.SearchUserInfoList
         * @static
         * @param {contact.ISearchUserInfoList} message SearchUserInfoList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchUserInfoList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SearchUserInfoList message, length delimited. Does not implicitly {@link contact.SearchUserInfoList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof contact.SearchUserInfoList
         * @static
         * @param {contact.ISearchUserInfoList} message SearchUserInfoList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SearchUserInfoList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SearchUserInfoList message from the specified reader or buffer.
         * @function decode
         * @memberof contact.SearchUserInfoList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {contact.SearchUserInfoList} SearchUserInfoList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchUserInfoList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.SearchUserInfoList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SearchUserInfoList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof contact.SearchUserInfoList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {contact.SearchUserInfoList} SearchUserInfoList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SearchUserInfoList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SearchUserInfoList message.
         * @function verify
         * @memberof contact.SearchUserInfoList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SearchUserInfoList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SearchUserInfoList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof contact.SearchUserInfoList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {contact.SearchUserInfoList} SearchUserInfoList
         */
        SearchUserInfoList.fromObject = function fromObject(object) {
            if (object instanceof $root.contact.SearchUserInfoList)
                return object;
            return new $root.contact.SearchUserInfoList();
        };

        /**
         * Creates a plain object from a SearchUserInfoList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof contact.SearchUserInfoList
         * @static
         * @param {contact.SearchUserInfoList} message SearchUserInfoList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SearchUserInfoList.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SearchUserInfoList to JSON.
         * @function toJSON
         * @memberof contact.SearchUserInfoList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SearchUserInfoList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SearchUserInfoList.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof contact.SearchUserInfoList
             * @interface IRequest
             * @property {Array.<string>|null} [uid] Request uid
             */

            /**
             * Constructs a new Request.
             * @memberof contact.SearchUserInfoList
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {contact.SearchUserInfoList.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.uid = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request uid.
             * @member {Array.<string>} uid
             * @memberof contact.SearchUserInfoList.Request
             * @instance
             */
            Request.prototype.uid = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof contact.SearchUserInfoList.Request
             * @static
             * @param {contact.SearchUserInfoList.IRequest=} [properties] Properties to set
             * @returns {contact.SearchUserInfoList.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link contact.SearchUserInfoList.Request.verify|verify} messages.
             * @function encode
             * @memberof contact.SearchUserInfoList.Request
             * @static
             * @param {contact.SearchUserInfoList.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uid != null && message.uid.length)
                    for (var i = 0; i < message.uid.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid[i]);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link contact.SearchUserInfoList.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.SearchUserInfoList.Request
             * @static
             * @param {contact.SearchUserInfoList.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof contact.SearchUserInfoList.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.SearchUserInfoList.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.SearchUserInfoList.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.uid && message.uid.length))
                            message.uid = [];
                        message.uid.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.SearchUserInfoList.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.SearchUserInfoList.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof contact.SearchUserInfoList.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uid != null && message.hasOwnProperty("uid")) {
                    if (!Array.isArray(message.uid))
                        return "uid: array expected";
                    for (var i = 0; i < message.uid.length; ++i)
                        if (!$util.isString(message.uid[i]))
                            return "uid: string[] expected";
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.SearchUserInfoList.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.SearchUserInfoList.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.SearchUserInfoList.Request)
                    return object;
                var message = new $root.contact.SearchUserInfoList.Request();
                if (object.uid) {
                    if (!Array.isArray(object.uid))
                        throw TypeError(".contact.SearchUserInfoList.Request.uid: array expected");
                    message.uid = [];
                    for (var i = 0; i < object.uid.length; ++i)
                        message.uid[i] = String(object.uid[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.SearchUserInfoList.Request
             * @static
             * @param {contact.SearchUserInfoList.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uid = [];
                if (message.uid && message.uid.length) {
                    object.uid = [];
                    for (var j = 0; j < message.uid.length; ++j)
                        object.uid[j] = message.uid[j];
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof contact.SearchUserInfoList.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        SearchUserInfoList.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof contact.SearchUserInfoList
             * @interface IResponse
             * @property {Array.<user.ISimpleSSOUserInfo>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof contact.SearchUserInfoList
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {contact.SearchUserInfoList.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<user.ISimpleSSOUserInfo>} list
             * @memberof contact.SearchUserInfoList.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof contact.SearchUserInfoList.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof contact.SearchUserInfoList.Response
             * @static
             * @param {contact.SearchUserInfoList.IResponse=} [properties] Properties to set
             * @returns {contact.SearchUserInfoList.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link contact.SearchUserInfoList.Response.verify|verify} messages.
             * @function encode
             * @memberof contact.SearchUserInfoList.Response
             * @static
             * @param {contact.SearchUserInfoList.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.user.SimpleSSOUserInfo.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link contact.SearchUserInfoList.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.SearchUserInfoList.Response
             * @static
             * @param {contact.SearchUserInfoList.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof contact.SearchUserInfoList.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.SearchUserInfoList.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.SearchUserInfoList.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.user.SimpleSSOUserInfo.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.SearchUserInfoList.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.SearchUserInfoList.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof contact.SearchUserInfoList.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.user.SimpleSSOUserInfo.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.SearchUserInfoList.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.SearchUserInfoList.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.SearchUserInfoList.Response)
                    return object;
                var message = new $root.contact.SearchUserInfoList.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".contact.SearchUserInfoList.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".contact.SearchUserInfoList.Response.list: object expected");
                        message.list[i] = $root.user.SimpleSSOUserInfo.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.SearchUserInfoList.Response
             * @static
             * @param {contact.SearchUserInfoList.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.user.SimpleSSOUserInfo.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof contact.SearchUserInfoList.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return SearchUserInfoList;
    })();

    contact.AddContact = (function() {

        /**
         * Properties of an AddContact.
         * @memberof contact
         * @interface IAddContact
         */

        /**
         * Constructs a new AddContact.
         * @memberof contact
         * @classdesc Represents an AddContact.
         * @implements IAddContact
         * @constructor
         * @param {contact.IAddContact=} [properties] Properties to set
         */
        function AddContact(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new AddContact instance using the specified properties.
         * @function create
         * @memberof contact.AddContact
         * @static
         * @param {contact.IAddContact=} [properties] Properties to set
         * @returns {contact.AddContact} AddContact instance
         */
        AddContact.create = function create(properties) {
            return new AddContact(properties);
        };

        /**
         * Encodes the specified AddContact message. Does not implicitly {@link contact.AddContact.verify|verify} messages.
         * @function encode
         * @memberof contact.AddContact
         * @static
         * @param {contact.IAddContact} message AddContact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddContact.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified AddContact message, length delimited. Does not implicitly {@link contact.AddContact.verify|verify} messages.
         * @function encodeDelimited
         * @memberof contact.AddContact
         * @static
         * @param {contact.IAddContact} message AddContact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AddContact.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AddContact message from the specified reader or buffer.
         * @function decode
         * @memberof contact.AddContact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {contact.AddContact} AddContact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddContact.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.AddContact();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AddContact message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof contact.AddContact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {contact.AddContact} AddContact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AddContact.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AddContact message.
         * @function verify
         * @memberof contact.AddContact
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AddContact.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an AddContact message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof contact.AddContact
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {contact.AddContact} AddContact
         */
        AddContact.fromObject = function fromObject(object) {
            if (object instanceof $root.contact.AddContact)
                return object;
            return new $root.contact.AddContact();
        };

        /**
         * Creates a plain object from an AddContact message. Also converts values to other types if specified.
         * @function toObject
         * @memberof contact.AddContact
         * @static
         * @param {contact.AddContact} message AddContact
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AddContact.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this AddContact to JSON.
         * @function toJSON
         * @memberof contact.AddContact
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AddContact.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        AddContact.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof contact.AddContact
             * @interface IRequest
             * @property {string|null} [userId] Request userId
             * @property {string|null} [remark] Request remark
             */

            /**
             * Constructs a new Request.
             * @memberof contact.AddContact
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {contact.AddContact.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request userId.
             * @member {string} userId
             * @memberof contact.AddContact.Request
             * @instance
             */
            Request.prototype.userId = "";

            /**
             * Request remark.
             * @member {string} remark
             * @memberof contact.AddContact.Request
             * @instance
             */
            Request.prototype.remark = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof contact.AddContact.Request
             * @static
             * @param {contact.AddContact.IRequest=} [properties] Properties to set
             * @returns {contact.AddContact.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link contact.AddContact.Request.verify|verify} messages.
             * @function encode
             * @memberof contact.AddContact.Request
             * @static
             * @param {contact.AddContact.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                if (message.remark != null && Object.hasOwnProperty.call(message, "remark"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.remark);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link contact.AddContact.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.AddContact.Request
             * @static
             * @param {contact.AddContact.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof contact.AddContact.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.AddContact.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.AddContact.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.userId = reader.string();
                        break;
                    case 2:
                        message.remark = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.AddContact.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.AddContact.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof contact.AddContact.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userId != null && message.hasOwnProperty("userId"))
                    if (!$util.isString(message.userId))
                        return "userId: string expected";
                if (message.remark != null && message.hasOwnProperty("remark"))
                    if (!$util.isString(message.remark))
                        return "remark: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.AddContact.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.AddContact.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.AddContact.Request)
                    return object;
                var message = new $root.contact.AddContact.Request();
                if (object.userId != null)
                    message.userId = String(object.userId);
                if (object.remark != null)
                    message.remark = String(object.remark);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.AddContact.Request
             * @static
             * @param {contact.AddContact.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userId = "";
                    object.remark = "";
                }
                if (message.userId != null && message.hasOwnProperty("userId"))
                    object.userId = message.userId;
                if (message.remark != null && message.hasOwnProperty("remark"))
                    object.remark = message.remark;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof contact.AddContact.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        AddContact.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof contact.AddContact
             * @interface IResponse
             * @property {string|null} [type] Response type
             * @property {string|null} [roomId] Response roomId
             * @property {string|null} [uid] Response uid
             */

            /**
             * Constructs a new Response.
             * @memberof contact.AddContact
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {contact.AddContact.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response type.
             * @member {string} type
             * @memberof contact.AddContact.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof contact.AddContact.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response uid.
             * @member {string} uid
             * @memberof contact.AddContact.Response
             * @instance
             */
            Response.prototype.uid = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof contact.AddContact.Response
             * @static
             * @param {contact.AddContact.IResponse=} [properties] Properties to set
             * @returns {contact.AddContact.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link contact.AddContact.Response.verify|verify} messages.
             * @function encode
             * @memberof contact.AddContact.Response
             * @static
             * @param {contact.AddContact.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.roomId);
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.uid);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link contact.AddContact.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.AddContact.Response
             * @static
             * @param {contact.AddContact.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof contact.AddContact.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.AddContact.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.AddContact.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.string();
                        break;
                    case 2:
                        message.roomId = reader.string();
                        break;
                    case 3:
                        message.uid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.AddContact.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.AddContact.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof contact.AddContact.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.AddContact.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.AddContact.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.AddContact.Response)
                    return object;
                var message = new $root.contact.AddContact.Response();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.uid != null)
                    message.uid = String(object.uid);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.AddContact.Response
             * @static
             * @param {contact.AddContact.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = "";
                    object.roomId = "";
                    object.uid = "";
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof contact.AddContact.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return AddContact;
    })();

    contact.DeleteContact = (function() {

        /**
         * Properties of a DeleteContact.
         * @memberof contact
         * @interface IDeleteContact
         */

        /**
         * Constructs a new DeleteContact.
         * @memberof contact
         * @classdesc Represents a DeleteContact.
         * @implements IDeleteContact
         * @constructor
         * @param {contact.IDeleteContact=} [properties] Properties to set
         */
        function DeleteContact(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DeleteContact instance using the specified properties.
         * @function create
         * @memberof contact.DeleteContact
         * @static
         * @param {contact.IDeleteContact=} [properties] Properties to set
         * @returns {contact.DeleteContact} DeleteContact instance
         */
        DeleteContact.create = function create(properties) {
            return new DeleteContact(properties);
        };

        /**
         * Encodes the specified DeleteContact message. Does not implicitly {@link contact.DeleteContact.verify|verify} messages.
         * @function encode
         * @memberof contact.DeleteContact
         * @static
         * @param {contact.IDeleteContact} message DeleteContact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteContact.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified DeleteContact message, length delimited. Does not implicitly {@link contact.DeleteContact.verify|verify} messages.
         * @function encodeDelimited
         * @memberof contact.DeleteContact
         * @static
         * @param {contact.IDeleteContact} message DeleteContact message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteContact.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteContact message from the specified reader or buffer.
         * @function decode
         * @memberof contact.DeleteContact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {contact.DeleteContact} DeleteContact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteContact.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.DeleteContact();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteContact message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof contact.DeleteContact
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {contact.DeleteContact} DeleteContact
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteContact.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteContact message.
         * @function verify
         * @memberof contact.DeleteContact
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteContact.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a DeleteContact message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof contact.DeleteContact
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {contact.DeleteContact} DeleteContact
         */
        DeleteContact.fromObject = function fromObject(object) {
            if (object instanceof $root.contact.DeleteContact)
                return object;
            return new $root.contact.DeleteContact();
        };

        /**
         * Creates a plain object from a DeleteContact message. Also converts values to other types if specified.
         * @function toObject
         * @memberof contact.DeleteContact
         * @static
         * @param {contact.DeleteContact} message DeleteContact
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteContact.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DeleteContact to JSON.
         * @function toJSON
         * @memberof contact.DeleteContact
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteContact.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        DeleteContact.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof contact.DeleteContact
             * @interface IRequest
             * @property {string|null} [uid] Request uid
             */

            /**
             * Constructs a new Request.
             * @memberof contact.DeleteContact
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {contact.DeleteContact.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request uid.
             * @member {string} uid
             * @memberof contact.DeleteContact.Request
             * @instance
             */
            Request.prototype.uid = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof contact.DeleteContact.Request
             * @static
             * @param {contact.DeleteContact.IRequest=} [properties] Properties to set
             * @returns {contact.DeleteContact.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link contact.DeleteContact.Request.verify|verify} messages.
             * @function encode
             * @memberof contact.DeleteContact.Request
             * @static
             * @param {contact.DeleteContact.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link contact.DeleteContact.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.DeleteContact.Request
             * @static
             * @param {contact.DeleteContact.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof contact.DeleteContact.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.DeleteContact.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.DeleteContact.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.uid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.DeleteContact.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.DeleteContact.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof contact.DeleteContact.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.DeleteContact.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.DeleteContact.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.DeleteContact.Request)
                    return object;
                var message = new $root.contact.DeleteContact.Request();
                if (object.uid != null)
                    message.uid = String(object.uid);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.DeleteContact.Request
             * @static
             * @param {contact.DeleteContact.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.uid = "";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof contact.DeleteContact.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        DeleteContact.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof contact.DeleteContact
             * @interface IResponse
             * @property {string|null} [roomId] Response roomId
             */

            /**
             * Constructs a new Response.
             * @memberof contact.DeleteContact
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {contact.DeleteContact.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof contact.DeleteContact.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof contact.DeleteContact.Response
             * @static
             * @param {contact.DeleteContact.IResponse=} [properties] Properties to set
             * @returns {contact.DeleteContact.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link contact.DeleteContact.Response.verify|verify} messages.
             * @function encode
             * @memberof contact.DeleteContact.Response
             * @static
             * @param {contact.DeleteContact.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link contact.DeleteContact.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.DeleteContact.Response
             * @static
             * @param {contact.DeleteContact.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof contact.DeleteContact.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.DeleteContact.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.DeleteContact.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.DeleteContact.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.DeleteContact.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof contact.DeleteContact.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.DeleteContact.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.DeleteContact.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.DeleteContact.Response)
                    return object;
                var message = new $root.contact.DeleteContact.Response();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.DeleteContact.Response
             * @static
             * @param {contact.DeleteContact.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.roomId = "";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof contact.DeleteContact.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return DeleteContact;
    })();

    contact.UpdateContactStatus = (function() {

        /**
         * Properties of an UpdateContactStatus.
         * @memberof contact
         * @interface IUpdateContactStatus
         */

        /**
         * Constructs a new UpdateContactStatus.
         * @memberof contact
         * @classdesc Represents an UpdateContactStatus.
         * @implements IUpdateContactStatus
         * @constructor
         * @param {contact.IUpdateContactStatus=} [properties] Properties to set
         */
        function UpdateContactStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateContactStatus instance using the specified properties.
         * @function create
         * @memberof contact.UpdateContactStatus
         * @static
         * @param {contact.IUpdateContactStatus=} [properties] Properties to set
         * @returns {contact.UpdateContactStatus} UpdateContactStatus instance
         */
        UpdateContactStatus.create = function create(properties) {
            return new UpdateContactStatus(properties);
        };

        /**
         * Encodes the specified UpdateContactStatus message. Does not implicitly {@link contact.UpdateContactStatus.verify|verify} messages.
         * @function encode
         * @memberof contact.UpdateContactStatus
         * @static
         * @param {contact.IUpdateContactStatus} message UpdateContactStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContactStatus.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UpdateContactStatus message, length delimited. Does not implicitly {@link contact.UpdateContactStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof contact.UpdateContactStatus
         * @static
         * @param {contact.IUpdateContactStatus} message UpdateContactStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateContactStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateContactStatus message from the specified reader or buffer.
         * @function decode
         * @memberof contact.UpdateContactStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {contact.UpdateContactStatus} UpdateContactStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContactStatus.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.UpdateContactStatus();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateContactStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof contact.UpdateContactStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {contact.UpdateContactStatus} UpdateContactStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateContactStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateContactStatus message.
         * @function verify
         * @memberof contact.UpdateContactStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateContactStatus.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UpdateContactStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof contact.UpdateContactStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {contact.UpdateContactStatus} UpdateContactStatus
         */
        UpdateContactStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.contact.UpdateContactStatus)
                return object;
            return new $root.contact.UpdateContactStatus();
        };

        /**
         * Creates a plain object from an UpdateContactStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof contact.UpdateContactStatus
         * @static
         * @param {contact.UpdateContactStatus} message UpdateContactStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateContactStatus.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateContactStatus to JSON.
         * @function toJSON
         * @memberof contact.UpdateContactStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateContactStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UpdateContactStatus.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof contact.UpdateContactStatus
             * @interface IResponse
             * @property {string|null} [type] Response type
             * @property {string|null} [roomId] Response roomId
             * @property {string|null} [uid] Response uid
             */

            /**
             * Constructs a new Response.
             * @memberof contact.UpdateContactStatus
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {contact.UpdateContactStatus.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response type.
             * @member {string} type
             * @memberof contact.UpdateContactStatus.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof contact.UpdateContactStatus.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response uid.
             * @member {string} uid
             * @memberof contact.UpdateContactStatus.Response
             * @instance
             */
            Response.prototype.uid = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof contact.UpdateContactStatus.Response
             * @static
             * @param {contact.UpdateContactStatus.IResponse=} [properties] Properties to set
             * @returns {contact.UpdateContactStatus.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link contact.UpdateContactStatus.Response.verify|verify} messages.
             * @function encode
             * @memberof contact.UpdateContactStatus.Response
             * @static
             * @param {contact.UpdateContactStatus.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.roomId);
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.uid);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link contact.UpdateContactStatus.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof contact.UpdateContactStatus.Response
             * @static
             * @param {contact.UpdateContactStatus.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof contact.UpdateContactStatus.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {contact.UpdateContactStatus.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.contact.UpdateContactStatus.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.string();
                        break;
                    case 2:
                        message.roomId = reader.string();
                        break;
                    case 3:
                        message.uid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof contact.UpdateContactStatus.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {contact.UpdateContactStatus.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof contact.UpdateContactStatus.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof contact.UpdateContactStatus.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {contact.UpdateContactStatus.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.contact.UpdateContactStatus.Response)
                    return object;
                var message = new $root.contact.UpdateContactStatus.Response();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.uid != null)
                    message.uid = String(object.uid);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof contact.UpdateContactStatus.Response
             * @static
             * @param {contact.UpdateContactStatus.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.type = "";
                    object.roomId = "";
                    object.uid = "";
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof contact.UpdateContactStatus.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return UpdateContactStatus;
    })();

    return contact;
})();

$root.encryption = (function() {

    /**
     * Namespace encryption.
     * @exports encryption
     * @namespace
     */
    var encryption = {};

    encryption.ExchangeKey = (function() {

        /**
         * Properties of an ExchangeKey.
         * @memberof encryption
         * @interface IExchangeKey
         */

        /**
         * Constructs a new ExchangeKey.
         * @memberof encryption
         * @classdesc Represents an ExchangeKey.
         * @implements IExchangeKey
         * @constructor
         * @param {encryption.IExchangeKey=} [properties] Properties to set
         */
        function ExchangeKey(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ExchangeKey instance using the specified properties.
         * @function create
         * @memberof encryption.ExchangeKey
         * @static
         * @param {encryption.IExchangeKey=} [properties] Properties to set
         * @returns {encryption.ExchangeKey} ExchangeKey instance
         */
        ExchangeKey.create = function create(properties) {
            return new ExchangeKey(properties);
        };

        /**
         * Encodes the specified ExchangeKey message. Does not implicitly {@link encryption.ExchangeKey.verify|verify} messages.
         * @function encode
         * @memberof encryption.ExchangeKey
         * @static
         * @param {encryption.IExchangeKey} message ExchangeKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExchangeKey.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ExchangeKey message, length delimited. Does not implicitly {@link encryption.ExchangeKey.verify|verify} messages.
         * @function encodeDelimited
         * @memberof encryption.ExchangeKey
         * @static
         * @param {encryption.IExchangeKey} message ExchangeKey message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExchangeKey.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExchangeKey message from the specified reader or buffer.
         * @function decode
         * @memberof encryption.ExchangeKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {encryption.ExchangeKey} ExchangeKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExchangeKey.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.ExchangeKey();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExchangeKey message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof encryption.ExchangeKey
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {encryption.ExchangeKey} ExchangeKey
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExchangeKey.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExchangeKey message.
         * @function verify
         * @memberof encryption.ExchangeKey
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExchangeKey.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an ExchangeKey message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof encryption.ExchangeKey
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {encryption.ExchangeKey} ExchangeKey
         */
        ExchangeKey.fromObject = function fromObject(object) {
            if (object instanceof $root.encryption.ExchangeKey)
                return object;
            return new $root.encryption.ExchangeKey();
        };

        /**
         * Creates a plain object from an ExchangeKey message. Also converts values to other types if specified.
         * @function toObject
         * @memberof encryption.ExchangeKey
         * @static
         * @param {encryption.ExchangeKey} message ExchangeKey
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExchangeKey.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ExchangeKey to JSON.
         * @function toJSON
         * @memberof encryption.ExchangeKey
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExchangeKey.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ExchangeKey.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof encryption.ExchangeKey
             * @interface IRequest
             * @property {string|null} [tempAESKey] Request tempAESKey
             * @property {string|null} [RSASign] Request RSASign
             * @property {string|null} [RSAPublicKey] Request RSAPublicKey
             * @property {string|null} [DHPublicKey] Request DHPublicKey
             */

            /**
             * Constructs a new Request.
             * @memberof encryption.ExchangeKey
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {encryption.ExchangeKey.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request tempAESKey.
             * @member {string} tempAESKey
             * @memberof encryption.ExchangeKey.Request
             * @instance
             */
            Request.prototype.tempAESKey = "";

            /**
             * Request RSASign.
             * @member {string} RSASign
             * @memberof encryption.ExchangeKey.Request
             * @instance
             */
            Request.prototype.RSASign = "";

            /**
             * Request RSAPublicKey.
             * @member {string} RSAPublicKey
             * @memberof encryption.ExchangeKey.Request
             * @instance
             */
            Request.prototype.RSAPublicKey = "";

            /**
             * Request DHPublicKey.
             * @member {string} DHPublicKey
             * @memberof encryption.ExchangeKey.Request
             * @instance
             */
            Request.prototype.DHPublicKey = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof encryption.ExchangeKey.Request
             * @static
             * @param {encryption.ExchangeKey.IRequest=} [properties] Properties to set
             * @returns {encryption.ExchangeKey.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link encryption.ExchangeKey.Request.verify|verify} messages.
             * @function encode
             * @memberof encryption.ExchangeKey.Request
             * @static
             * @param {encryption.ExchangeKey.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.tempAESKey != null && Object.hasOwnProperty.call(message, "tempAESKey"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.tempAESKey);
                if (message.RSASign != null && Object.hasOwnProperty.call(message, "RSASign"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.RSASign);
                if (message.RSAPublicKey != null && Object.hasOwnProperty.call(message, "RSAPublicKey"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.RSAPublicKey);
                if (message.DHPublicKey != null && Object.hasOwnProperty.call(message, "DHPublicKey"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.DHPublicKey);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link encryption.ExchangeKey.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof encryption.ExchangeKey.Request
             * @static
             * @param {encryption.ExchangeKey.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof encryption.ExchangeKey.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {encryption.ExchangeKey.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.ExchangeKey.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.tempAESKey = reader.string();
                        break;
                    case 2:
                        message.RSASign = reader.string();
                        break;
                    case 3:
                        message.RSAPublicKey = reader.string();
                        break;
                    case 4:
                        message.DHPublicKey = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof encryption.ExchangeKey.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {encryption.ExchangeKey.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof encryption.ExchangeKey.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.tempAESKey != null && message.hasOwnProperty("tempAESKey"))
                    if (!$util.isString(message.tempAESKey))
                        return "tempAESKey: string expected";
                if (message.RSASign != null && message.hasOwnProperty("RSASign"))
                    if (!$util.isString(message.RSASign))
                        return "RSASign: string expected";
                if (message.RSAPublicKey != null && message.hasOwnProperty("RSAPublicKey"))
                    if (!$util.isString(message.RSAPublicKey))
                        return "RSAPublicKey: string expected";
                if (message.DHPublicKey != null && message.hasOwnProperty("DHPublicKey"))
                    if (!$util.isString(message.DHPublicKey))
                        return "DHPublicKey: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof encryption.ExchangeKey.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {encryption.ExchangeKey.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.encryption.ExchangeKey.Request)
                    return object;
                var message = new $root.encryption.ExchangeKey.Request();
                if (object.tempAESKey != null)
                    message.tempAESKey = String(object.tempAESKey);
                if (object.RSASign != null)
                    message.RSASign = String(object.RSASign);
                if (object.RSAPublicKey != null)
                    message.RSAPublicKey = String(object.RSAPublicKey);
                if (object.DHPublicKey != null)
                    message.DHPublicKey = String(object.DHPublicKey);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof encryption.ExchangeKey.Request
             * @static
             * @param {encryption.ExchangeKey.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.tempAESKey = "";
                    object.RSASign = "";
                    object.RSAPublicKey = "";
                    object.DHPublicKey = "";
                }
                if (message.tempAESKey != null && message.hasOwnProperty("tempAESKey"))
                    object.tempAESKey = message.tempAESKey;
                if (message.RSASign != null && message.hasOwnProperty("RSASign"))
                    object.RSASign = message.RSASign;
                if (message.RSAPublicKey != null && message.hasOwnProperty("RSAPublicKey"))
                    object.RSAPublicKey = message.RSAPublicKey;
                if (message.DHPublicKey != null && message.hasOwnProperty("DHPublicKey"))
                    object.DHPublicKey = message.DHPublicKey;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof encryption.ExchangeKey.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        ExchangeKey.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof encryption.ExchangeKey
             * @interface IResponse
             * @property {string|null} [userAESKey] Response userAESKey
             * @property {string|null} [RSASign] Response RSASign
             * @property {string|null} [DHPublicKey] Response DHPublicKey
             * @property {number|Long|null} [deadline] Response deadline
             */

            /**
             * Constructs a new Response.
             * @memberof encryption.ExchangeKey
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {encryption.ExchangeKey.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response userAESKey.
             * @member {string} userAESKey
             * @memberof encryption.ExchangeKey.Response
             * @instance
             */
            Response.prototype.userAESKey = "";

            /**
             * Response RSASign.
             * @member {string} RSASign
             * @memberof encryption.ExchangeKey.Response
             * @instance
             */
            Response.prototype.RSASign = "";

            /**
             * Response DHPublicKey.
             * @member {string} DHPublicKey
             * @memberof encryption.ExchangeKey.Response
             * @instance
             */
            Response.prototype.DHPublicKey = "";

            /**
             * Response deadline.
             * @member {number|Long} deadline
             * @memberof encryption.ExchangeKey.Response
             * @instance
             */
            Response.prototype.deadline = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof encryption.ExchangeKey.Response
             * @static
             * @param {encryption.ExchangeKey.IResponse=} [properties] Properties to set
             * @returns {encryption.ExchangeKey.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link encryption.ExchangeKey.Response.verify|verify} messages.
             * @function encode
             * @memberof encryption.ExchangeKey.Response
             * @static
             * @param {encryption.ExchangeKey.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.userAESKey != null && Object.hasOwnProperty.call(message, "userAESKey"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.userAESKey);
                if (message.RSASign != null && Object.hasOwnProperty.call(message, "RSASign"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.RSASign);
                if (message.DHPublicKey != null && Object.hasOwnProperty.call(message, "DHPublicKey"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.DHPublicKey);
                if (message.deadline != null && Object.hasOwnProperty.call(message, "deadline"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.deadline);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link encryption.ExchangeKey.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof encryption.ExchangeKey.Response
             * @static
             * @param {encryption.ExchangeKey.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof encryption.ExchangeKey.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {encryption.ExchangeKey.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.ExchangeKey.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.userAESKey = reader.string();
                        break;
                    case 2:
                        message.RSASign = reader.string();
                        break;
                    case 3:
                        message.DHPublicKey = reader.string();
                        break;
                    case 4:
                        message.deadline = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof encryption.ExchangeKey.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {encryption.ExchangeKey.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof encryption.ExchangeKey.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.userAESKey != null && message.hasOwnProperty("userAESKey"))
                    if (!$util.isString(message.userAESKey))
                        return "userAESKey: string expected";
                if (message.RSASign != null && message.hasOwnProperty("RSASign"))
                    if (!$util.isString(message.RSASign))
                        return "RSASign: string expected";
                if (message.DHPublicKey != null && message.hasOwnProperty("DHPublicKey"))
                    if (!$util.isString(message.DHPublicKey))
                        return "DHPublicKey: string expected";
                if (message.deadline != null && message.hasOwnProperty("deadline"))
                    if (!$util.isInteger(message.deadline) && !(message.deadline && $util.isInteger(message.deadline.low) && $util.isInteger(message.deadline.high)))
                        return "deadline: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof encryption.ExchangeKey.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {encryption.ExchangeKey.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.encryption.ExchangeKey.Response)
                    return object;
                var message = new $root.encryption.ExchangeKey.Response();
                if (object.userAESKey != null)
                    message.userAESKey = String(object.userAESKey);
                if (object.RSASign != null)
                    message.RSASign = String(object.RSASign);
                if (object.DHPublicKey != null)
                    message.DHPublicKey = String(object.DHPublicKey);
                if (object.deadline != null)
                    if ($util.Long)
                        (message.deadline = $util.Long.fromValue(object.deadline)).unsigned = false;
                    else if (typeof object.deadline === "string")
                        message.deadline = parseInt(object.deadline, 10);
                    else if (typeof object.deadline === "number")
                        message.deadline = object.deadline;
                    else if (typeof object.deadline === "object")
                        message.deadline = new $util.LongBits(object.deadline.low >>> 0, object.deadline.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof encryption.ExchangeKey.Response
             * @static
             * @param {encryption.ExchangeKey.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.userAESKey = "";
                    object.RSASign = "";
                    object.DHPublicKey = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.deadline = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.deadline = options.longs === String ? "0" : 0;
                }
                if (message.userAESKey != null && message.hasOwnProperty("userAESKey"))
                    object.userAESKey = message.userAESKey;
                if (message.RSASign != null && message.hasOwnProperty("RSASign"))
                    object.RSASign = message.RSASign;
                if (message.DHPublicKey != null && message.hasOwnProperty("DHPublicKey"))
                    object.DHPublicKey = message.DHPublicKey;
                if (message.deadline != null && message.hasOwnProperty("deadline"))
                    if (typeof message.deadline === "number")
                        object.deadline = options.longs === String ? String(message.deadline) : message.deadline;
                    else
                        object.deadline = options.longs === String ? $util.Long.prototype.toString.call(message.deadline) : options.longs === Number ? new $util.LongBits(message.deadline.low >>> 0, message.deadline.high >>> 0).toNumber() : message.deadline;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof encryption.ExchangeKey.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return ExchangeKey;
    })();

    encryption.GetRsaPublicKeyType = (function() {

        /**
         * Properties of a GetRsaPublicKeyType.
         * @memberof encryption
         * @interface IGetRsaPublicKeyType
         */

        /**
         * Constructs a new GetRsaPublicKeyType.
         * @memberof encryption
         * @classdesc Represents a GetRsaPublicKeyType.
         * @implements IGetRsaPublicKeyType
         * @constructor
         * @param {encryption.IGetRsaPublicKeyType=} [properties] Properties to set
         */
        function GetRsaPublicKeyType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetRsaPublicKeyType instance using the specified properties.
         * @function create
         * @memberof encryption.GetRsaPublicKeyType
         * @static
         * @param {encryption.IGetRsaPublicKeyType=} [properties] Properties to set
         * @returns {encryption.GetRsaPublicKeyType} GetRsaPublicKeyType instance
         */
        GetRsaPublicKeyType.create = function create(properties) {
            return new GetRsaPublicKeyType(properties);
        };

        /**
         * Encodes the specified GetRsaPublicKeyType message. Does not implicitly {@link encryption.GetRsaPublicKeyType.verify|verify} messages.
         * @function encode
         * @memberof encryption.GetRsaPublicKeyType
         * @static
         * @param {encryption.IGetRsaPublicKeyType} message GetRsaPublicKeyType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRsaPublicKeyType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetRsaPublicKeyType message, length delimited. Does not implicitly {@link encryption.GetRsaPublicKeyType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof encryption.GetRsaPublicKeyType
         * @static
         * @param {encryption.IGetRsaPublicKeyType} message GetRsaPublicKeyType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRsaPublicKeyType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRsaPublicKeyType message from the specified reader or buffer.
         * @function decode
         * @memberof encryption.GetRsaPublicKeyType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {encryption.GetRsaPublicKeyType} GetRsaPublicKeyType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRsaPublicKeyType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.GetRsaPublicKeyType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRsaPublicKeyType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof encryption.GetRsaPublicKeyType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {encryption.GetRsaPublicKeyType} GetRsaPublicKeyType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRsaPublicKeyType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRsaPublicKeyType message.
         * @function verify
         * @memberof encryption.GetRsaPublicKeyType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRsaPublicKeyType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetRsaPublicKeyType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof encryption.GetRsaPublicKeyType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {encryption.GetRsaPublicKeyType} GetRsaPublicKeyType
         */
        GetRsaPublicKeyType.fromObject = function fromObject(object) {
            if (object instanceof $root.encryption.GetRsaPublicKeyType)
                return object;
            return new $root.encryption.GetRsaPublicKeyType();
        };

        /**
         * Creates a plain object from a GetRsaPublicKeyType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof encryption.GetRsaPublicKeyType
         * @static
         * @param {encryption.GetRsaPublicKeyType} message GetRsaPublicKeyType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRsaPublicKeyType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetRsaPublicKeyType to JSON.
         * @function toJSON
         * @memberof encryption.GetRsaPublicKeyType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRsaPublicKeyType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetRsaPublicKeyType.Resquest = (function() {

            /**
             * Properties of a Resquest.
             * @memberof encryption.GetRsaPublicKeyType
             * @interface IResquest
             * @property {string|null} [publicKey] Resquest publicKey
             * @property {string|null} [sign] Resquest sign
             */

            /**
             * Constructs a new Resquest.
             * @memberof encryption.GetRsaPublicKeyType
             * @classdesc Represents a Resquest.
             * @implements IResquest
             * @constructor
             * @param {encryption.GetRsaPublicKeyType.IResquest=} [properties] Properties to set
             */
            function Resquest(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Resquest publicKey.
             * @member {string} publicKey
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @instance
             */
            Resquest.prototype.publicKey = "";

            /**
             * Resquest sign.
             * @member {string} sign
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @instance
             */
            Resquest.prototype.sign = "";

            /**
             * Creates a new Resquest instance using the specified properties.
             * @function create
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @static
             * @param {encryption.GetRsaPublicKeyType.IResquest=} [properties] Properties to set
             * @returns {encryption.GetRsaPublicKeyType.Resquest} Resquest instance
             */
            Resquest.create = function create(properties) {
                return new Resquest(properties);
            };

            /**
             * Encodes the specified Resquest message. Does not implicitly {@link encryption.GetRsaPublicKeyType.Resquest.verify|verify} messages.
             * @function encode
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @static
             * @param {encryption.GetRsaPublicKeyType.IResquest} message Resquest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Resquest.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.publicKey != null && Object.hasOwnProperty.call(message, "publicKey"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.publicKey);
                if (message.sign != null && Object.hasOwnProperty.call(message, "sign"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.sign);
                return writer;
            };

            /**
             * Encodes the specified Resquest message, length delimited. Does not implicitly {@link encryption.GetRsaPublicKeyType.Resquest.verify|verify} messages.
             * @function encodeDelimited
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @static
             * @param {encryption.GetRsaPublicKeyType.IResquest} message Resquest message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Resquest.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Resquest message from the specified reader or buffer.
             * @function decode
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {encryption.GetRsaPublicKeyType.Resquest} Resquest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Resquest.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.GetRsaPublicKeyType.Resquest();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.publicKey = reader.string();
                        break;
                    case 2:
                        message.sign = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Resquest message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {encryption.GetRsaPublicKeyType.Resquest} Resquest
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Resquest.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Resquest message.
             * @function verify
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Resquest.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.publicKey != null && message.hasOwnProperty("publicKey"))
                    if (!$util.isString(message.publicKey))
                        return "publicKey: string expected";
                if (message.sign != null && message.hasOwnProperty("sign"))
                    if (!$util.isString(message.sign))
                        return "sign: string expected";
                return null;
            };

            /**
             * Creates a Resquest message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {encryption.GetRsaPublicKeyType.Resquest} Resquest
             */
            Resquest.fromObject = function fromObject(object) {
                if (object instanceof $root.encryption.GetRsaPublicKeyType.Resquest)
                    return object;
                var message = new $root.encryption.GetRsaPublicKeyType.Resquest();
                if (object.publicKey != null)
                    message.publicKey = String(object.publicKey);
                if (object.sign != null)
                    message.sign = String(object.sign);
                return message;
            };

            /**
             * Creates a plain object from a Resquest message. Also converts values to other types if specified.
             * @function toObject
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @static
             * @param {encryption.GetRsaPublicKeyType.Resquest} message Resquest
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Resquest.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.publicKey = "";
                    object.sign = "";
                }
                if (message.publicKey != null && message.hasOwnProperty("publicKey"))
                    object.publicKey = message.publicKey;
                if (message.sign != null && message.hasOwnProperty("sign"))
                    object.sign = message.sign;
                return object;
            };

            /**
             * Converts this Resquest to JSON.
             * @function toJSON
             * @memberof encryption.GetRsaPublicKeyType.Resquest
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Resquest.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Resquest;
        })();

        GetRsaPublicKeyType.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof encryption.GetRsaPublicKeyType
             * @interface IResponse
             * @property {string|null} [publicKey] Response publicKey
             * @property {string|null} [sign] Response sign
             */

            /**
             * Constructs a new Response.
             * @memberof encryption.GetRsaPublicKeyType
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {encryption.GetRsaPublicKeyType.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response publicKey.
             * @member {string} publicKey
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @instance
             */
            Response.prototype.publicKey = "";

            /**
             * Response sign.
             * @member {string} sign
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @instance
             */
            Response.prototype.sign = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @static
             * @param {encryption.GetRsaPublicKeyType.IResponse=} [properties] Properties to set
             * @returns {encryption.GetRsaPublicKeyType.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link encryption.GetRsaPublicKeyType.Response.verify|verify} messages.
             * @function encode
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @static
             * @param {encryption.GetRsaPublicKeyType.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.publicKey != null && Object.hasOwnProperty.call(message, "publicKey"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.publicKey);
                if (message.sign != null && Object.hasOwnProperty.call(message, "sign"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.sign);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link encryption.GetRsaPublicKeyType.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @static
             * @param {encryption.GetRsaPublicKeyType.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {encryption.GetRsaPublicKeyType.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.GetRsaPublicKeyType.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.publicKey = reader.string();
                        break;
                    case 2:
                        message.sign = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {encryption.GetRsaPublicKeyType.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.publicKey != null && message.hasOwnProperty("publicKey"))
                    if (!$util.isString(message.publicKey))
                        return "publicKey: string expected";
                if (message.sign != null && message.hasOwnProperty("sign"))
                    if (!$util.isString(message.sign))
                        return "sign: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {encryption.GetRsaPublicKeyType.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.encryption.GetRsaPublicKeyType.Response)
                    return object;
                var message = new $root.encryption.GetRsaPublicKeyType.Response();
                if (object.publicKey != null)
                    message.publicKey = String(object.publicKey);
                if (object.sign != null)
                    message.sign = String(object.sign);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @static
             * @param {encryption.GetRsaPublicKeyType.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.publicKey = "";
                    object.sign = "";
                }
                if (message.publicKey != null && message.hasOwnProperty("publicKey"))
                    object.publicKey = message.publicKey;
                if (message.sign != null && message.hasOwnProperty("sign"))
                    object.sign = message.sign;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof encryption.GetRsaPublicKeyType.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetRsaPublicKeyType;
    })();

    encryption.PostClientRsaPublicKeAndGenerateDhKeyType = (function() {

        /**
         * Properties of a PostClientRsaPublicKeAndGenerateDhKeyType.
         * @memberof encryption
         * @interface IPostClientRsaPublicKeAndGenerateDhKeyType
         */

        /**
         * Constructs a new PostClientRsaPublicKeAndGenerateDhKeyType.
         * @memberof encryption
         * @classdesc Represents a PostClientRsaPublicKeAndGenerateDhKeyType.
         * @implements IPostClientRsaPublicKeAndGenerateDhKeyType
         * @constructor
         * @param {encryption.IPostClientRsaPublicKeAndGenerateDhKeyType=} [properties] Properties to set
         */
        function PostClientRsaPublicKeAndGenerateDhKeyType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new PostClientRsaPublicKeAndGenerateDhKeyType instance using the specified properties.
         * @function create
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @static
         * @param {encryption.IPostClientRsaPublicKeAndGenerateDhKeyType=} [properties] Properties to set
         * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType} PostClientRsaPublicKeAndGenerateDhKeyType instance
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.create = function create(properties) {
            return new PostClientRsaPublicKeAndGenerateDhKeyType(properties);
        };

        /**
         * Encodes the specified PostClientRsaPublicKeAndGenerateDhKeyType message. Does not implicitly {@link encryption.PostClientRsaPublicKeAndGenerateDhKeyType.verify|verify} messages.
         * @function encode
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @static
         * @param {encryption.IPostClientRsaPublicKeAndGenerateDhKeyType} message PostClientRsaPublicKeAndGenerateDhKeyType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified PostClientRsaPublicKeAndGenerateDhKeyType message, length delimited. Does not implicitly {@link encryption.PostClientRsaPublicKeAndGenerateDhKeyType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @static
         * @param {encryption.IPostClientRsaPublicKeAndGenerateDhKeyType} message PostClientRsaPublicKeAndGenerateDhKeyType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PostClientRsaPublicKeAndGenerateDhKeyType message from the specified reader or buffer.
         * @function decode
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType} PostClientRsaPublicKeAndGenerateDhKeyType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PostClientRsaPublicKeAndGenerateDhKeyType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType} PostClientRsaPublicKeAndGenerateDhKeyType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PostClientRsaPublicKeAndGenerateDhKeyType message.
         * @function verify
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a PostClientRsaPublicKeAndGenerateDhKeyType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType} PostClientRsaPublicKeAndGenerateDhKeyType
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.fromObject = function fromObject(object) {
            if (object instanceof $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType)
                return object;
            return new $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType();
        };

        /**
         * Creates a plain object from a PostClientRsaPublicKeAndGenerateDhKeyType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @static
         * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType} message PostClientRsaPublicKeAndGenerateDhKeyType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this PostClientRsaPublicKeAndGenerateDhKeyType to JSON.
         * @function toJSON
         * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PostClientRsaPublicKeAndGenerateDhKeyType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        PostClientRsaPublicKeAndGenerateDhKeyType.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
             * @interface IResponse
             * @property {string|null} [randomKey] Response randomKey
             * @property {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.IDhKeyType|null} [dhKey] Response dhKey
             */

            /**
             * Constructs a new Response.
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response randomKey.
             * @member {string} randomKey
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @instance
             */
            Response.prototype.randomKey = "";

            /**
             * Response dhKey.
             * @member {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.IDhKeyType|null|undefined} dhKey
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @instance
             */
            Response.prototype.dhKey = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @static
             * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.IResponse=} [properties] Properties to set
             * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.verify|verify} messages.
             * @function encode
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @static
             * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.randomKey != null && Object.hasOwnProperty.call(message, "randomKey"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.randomKey);
                if (message.dhKey != null && Object.hasOwnProperty.call(message, "dhKey"))
                    $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType.encode(message.dhKey, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @static
             * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.randomKey = reader.string();
                        break;
                    case 2:
                        message.dhKey = $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.randomKey != null && message.hasOwnProperty("randomKey"))
                    if (!$util.isString(message.randomKey))
                        return "randomKey: string expected";
                if (message.dhKey != null && message.hasOwnProperty("dhKey")) {
                    var error = $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType.verify(message.dhKey);
                    if (error)
                        return "dhKey." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response)
                    return object;
                var message = new $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response();
                if (object.randomKey != null)
                    message.randomKey = String(object.randomKey);
                if (object.dhKey != null) {
                    if (typeof object.dhKey !== "object")
                        throw TypeError(".encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.dhKey: object expected");
                    message.dhKey = $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType.fromObject(object.dhKey);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @static
             * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.randomKey = "";
                    object.dhKey = null;
                }
                if (message.randomKey != null && message.hasOwnProperty("randomKey"))
                    object.randomKey = message.randomKey;
                if (message.dhKey != null && message.hasOwnProperty("dhKey"))
                    object.dhKey = $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType.toObject(message.dhKey, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Response.DhKeyType = (function() {

                /**
                 * Properties of a DhKeyType.
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
                 * @interface IDhKeyType
                 * @property {string|null} [prime] DhKeyType prime
                 * @property {string|null} [base] DhKeyType base
                 * @property {string|null} [sharePublicKey] DhKeyType sharePublicKey
                 */

                /**
                 * Constructs a new DhKeyType.
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response
                 * @classdesc Represents a DhKeyType.
                 * @implements IDhKeyType
                 * @constructor
                 * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.IDhKeyType=} [properties] Properties to set
                 */
                function DhKeyType(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DhKeyType prime.
                 * @member {string} prime
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @instance
                 */
                DhKeyType.prototype.prime = "";

                /**
                 * DhKeyType base.
                 * @member {string} base
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @instance
                 */
                DhKeyType.prototype.base = "";

                /**
                 * DhKeyType sharePublicKey.
                 * @member {string} sharePublicKey
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @instance
                 */
                DhKeyType.prototype.sharePublicKey = "";

                /**
                 * Creates a new DhKeyType instance using the specified properties.
                 * @function create
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @static
                 * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.IDhKeyType=} [properties] Properties to set
                 * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType} DhKeyType instance
                 */
                DhKeyType.create = function create(properties) {
                    return new DhKeyType(properties);
                };

                /**
                 * Encodes the specified DhKeyType message. Does not implicitly {@link encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType.verify|verify} messages.
                 * @function encode
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @static
                 * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.IDhKeyType} message DhKeyType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DhKeyType.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.prime != null && Object.hasOwnProperty.call(message, "prime"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.prime);
                    if (message.base != null && Object.hasOwnProperty.call(message, "base"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.base);
                    if (message.sharePublicKey != null && Object.hasOwnProperty.call(message, "sharePublicKey"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.sharePublicKey);
                    return writer;
                };

                /**
                 * Encodes the specified DhKeyType message, length delimited. Does not implicitly {@link encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @static
                 * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.IDhKeyType} message DhKeyType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DhKeyType.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DhKeyType message from the specified reader or buffer.
                 * @function decode
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType} DhKeyType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DhKeyType.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.prime = reader.string();
                            break;
                        case 2:
                            message.base = reader.string();
                            break;
                        case 3:
                            message.sharePublicKey = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DhKeyType message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType} DhKeyType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DhKeyType.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DhKeyType message.
                 * @function verify
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DhKeyType.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.prime != null && message.hasOwnProperty("prime"))
                        if (!$util.isString(message.prime))
                            return "prime: string expected";
                    if (message.base != null && message.hasOwnProperty("base"))
                        if (!$util.isString(message.base))
                            return "base: string expected";
                    if (message.sharePublicKey != null && message.hasOwnProperty("sharePublicKey"))
                        if (!$util.isString(message.sharePublicKey))
                            return "sharePublicKey: string expected";
                    return null;
                };

                /**
                 * Creates a DhKeyType message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType} DhKeyType
                 */
                DhKeyType.fromObject = function fromObject(object) {
                    if (object instanceof $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType)
                        return object;
                    var message = new $root.encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType();
                    if (object.prime != null)
                        message.prime = String(object.prime);
                    if (object.base != null)
                        message.base = String(object.base);
                    if (object.sharePublicKey != null)
                        message.sharePublicKey = String(object.sharePublicKey);
                    return message;
                };

                /**
                 * Creates a plain object from a DhKeyType message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @static
                 * @param {encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType} message DhKeyType
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DhKeyType.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.prime = "";
                        object.base = "";
                        object.sharePublicKey = "";
                    }
                    if (message.prime != null && message.hasOwnProperty("prime"))
                        object.prime = message.prime;
                    if (message.base != null && message.hasOwnProperty("base"))
                        object.base = message.base;
                    if (message.sharePublicKey != null && message.hasOwnProperty("sharePublicKey"))
                        object.sharePublicKey = message.sharePublicKey;
                    return object;
                };

                /**
                 * Converts this DhKeyType to JSON.
                 * @function toJSON
                 * @memberof encryption.PostClientRsaPublicKeAndGenerateDhKeyType.Response.DhKeyType
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DhKeyType.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DhKeyType;
            })();

            return Response;
        })();

        return PostClientRsaPublicKeAndGenerateDhKeyType;
    })();

    encryption.GetAesKeyType = (function() {

        /**
         * Properties of a GetAesKeyType.
         * @memberof encryption
         * @interface IGetAesKeyType
         */

        /**
         * Constructs a new GetAesKeyType.
         * @memberof encryption
         * @classdesc Represents a GetAesKeyType.
         * @implements IGetAesKeyType
         * @constructor
         * @param {encryption.IGetAesKeyType=} [properties] Properties to set
         */
        function GetAesKeyType(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetAesKeyType instance using the specified properties.
         * @function create
         * @memberof encryption.GetAesKeyType
         * @static
         * @param {encryption.IGetAesKeyType=} [properties] Properties to set
         * @returns {encryption.GetAesKeyType} GetAesKeyType instance
         */
        GetAesKeyType.create = function create(properties) {
            return new GetAesKeyType(properties);
        };

        /**
         * Encodes the specified GetAesKeyType message. Does not implicitly {@link encryption.GetAesKeyType.verify|verify} messages.
         * @function encode
         * @memberof encryption.GetAesKeyType
         * @static
         * @param {encryption.IGetAesKeyType} message GetAesKeyType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAesKeyType.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetAesKeyType message, length delimited. Does not implicitly {@link encryption.GetAesKeyType.verify|verify} messages.
         * @function encodeDelimited
         * @memberof encryption.GetAesKeyType
         * @static
         * @param {encryption.IGetAesKeyType} message GetAesKeyType message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAesKeyType.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAesKeyType message from the specified reader or buffer.
         * @function decode
         * @memberof encryption.GetAesKeyType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {encryption.GetAesKeyType} GetAesKeyType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAesKeyType.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.GetAesKeyType();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAesKeyType message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof encryption.GetAesKeyType
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {encryption.GetAesKeyType} GetAesKeyType
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAesKeyType.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAesKeyType message.
         * @function verify
         * @memberof encryption.GetAesKeyType
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAesKeyType.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetAesKeyType message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof encryption.GetAesKeyType
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {encryption.GetAesKeyType} GetAesKeyType
         */
        GetAesKeyType.fromObject = function fromObject(object) {
            if (object instanceof $root.encryption.GetAesKeyType)
                return object;
            return new $root.encryption.GetAesKeyType();
        };

        /**
         * Creates a plain object from a GetAesKeyType message. Also converts values to other types if specified.
         * @function toObject
         * @memberof encryption.GetAesKeyType
         * @static
         * @param {encryption.GetAesKeyType} message GetAesKeyType
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAesKeyType.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetAesKeyType to JSON.
         * @function toJSON
         * @memberof encryption.GetAesKeyType
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAesKeyType.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetAesKeyType.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof encryption.GetAesKeyType
             * @interface IResponse
             * @property {string|null} [key] Response key
             */

            /**
             * Constructs a new Response.
             * @memberof encryption.GetAesKeyType
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {encryption.GetAesKeyType.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response key.
             * @member {string} key
             * @memberof encryption.GetAesKeyType.Response
             * @instance
             */
            Response.prototype.key = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof encryption.GetAesKeyType.Response
             * @static
             * @param {encryption.GetAesKeyType.IResponse=} [properties] Properties to set
             * @returns {encryption.GetAesKeyType.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link encryption.GetAesKeyType.Response.verify|verify} messages.
             * @function encode
             * @memberof encryption.GetAesKeyType.Response
             * @static
             * @param {encryption.GetAesKeyType.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link encryption.GetAesKeyType.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof encryption.GetAesKeyType.Response
             * @static
             * @param {encryption.GetAesKeyType.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof encryption.GetAesKeyType.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {encryption.GetAesKeyType.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.encryption.GetAesKeyType.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.key = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof encryption.GetAesKeyType.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {encryption.GetAesKeyType.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof encryption.GetAesKeyType.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.key != null && message.hasOwnProperty("key"))
                    if (!$util.isString(message.key))
                        return "key: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof encryption.GetAesKeyType.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {encryption.GetAesKeyType.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.encryption.GetAesKeyType.Response)
                    return object;
                var message = new $root.encryption.GetAesKeyType.Response();
                if (object.key != null)
                    message.key = String(object.key);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof encryption.GetAesKeyType.Response
             * @static
             * @param {encryption.GetAesKeyType.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.key = "";
                if (message.key != null && message.hasOwnProperty("key"))
                    object.key = message.key;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof encryption.GetAesKeyType.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetAesKeyType;
    })();

    return encryption;
})();

$root.file = (function() {

    /**
     * Namespace file.
     * @exports file
     * @namespace
     */
    var file = {};

    file.FileInfo = (function() {

        /**
         * Properties of a FileInfo.
         * @memberof file
         * @interface IFileInfo
         * @property {string|null} [name] FileInfo name
         * @property {number|Long|null} [size] FileInfo size
         * @property {string|null} [type] FileInfo type
         * @property {string|null} [suffix] FileInfo suffix
         * @property {number|Long|null} [lastModified] FileInfo lastModified
         * @property {string|null} [hash] FileInfo hash
         */

        /**
         * Constructs a new FileInfo.
         * @memberof file
         * @classdesc Represents a FileInfo.
         * @implements IFileInfo
         * @constructor
         * @param {file.IFileInfo=} [properties] Properties to set
         */
        function FileInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileInfo name.
         * @member {string} name
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.name = "";

        /**
         * FileInfo size.
         * @member {number|Long} size
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FileInfo type.
         * @member {string} type
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.type = "";

        /**
         * FileInfo suffix.
         * @member {string} suffix
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.suffix = "";

        /**
         * FileInfo lastModified.
         * @member {number|Long} lastModified
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.lastModified = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FileInfo hash.
         * @member {string} hash
         * @memberof file.FileInfo
         * @instance
         */
        FileInfo.prototype.hash = "";

        /**
         * Creates a new FileInfo instance using the specified properties.
         * @function create
         * @memberof file.FileInfo
         * @static
         * @param {file.IFileInfo=} [properties] Properties to set
         * @returns {file.FileInfo} FileInfo instance
         */
        FileInfo.create = function create(properties) {
            return new FileInfo(properties);
        };

        /**
         * Encodes the specified FileInfo message. Does not implicitly {@link file.FileInfo.verify|verify} messages.
         * @function encode
         * @memberof file.FileInfo
         * @static
         * @param {file.IFileInfo} message FileInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
            if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.size);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
            if (message.suffix != null && Object.hasOwnProperty.call(message, "suffix"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.suffix);
            if (message.lastModified != null && Object.hasOwnProperty.call(message, "lastModified"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastModified);
            if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.hash);
            return writer;
        };

        /**
         * Encodes the specified FileInfo message, length delimited. Does not implicitly {@link file.FileInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.FileInfo
         * @static
         * @param {file.IFileInfo} message FileInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileInfo message from the specified reader or buffer.
         * @function decode
         * @memberof file.FileInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.FileInfo} FileInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.FileInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.size = reader.int64();
                    break;
                case 3:
                    message.type = reader.string();
                    break;
                case 4:
                    message.suffix = reader.string();
                    break;
                case 5:
                    message.lastModified = reader.int64();
                    break;
                case 6:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.FileInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.FileInfo} FileInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileInfo message.
         * @function verify
         * @memberof file.FileInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.size != null && message.hasOwnProperty("size"))
                if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                    return "size: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.suffix != null && message.hasOwnProperty("suffix"))
                if (!$util.isString(message.suffix))
                    return "suffix: string expected";
            if (message.lastModified != null && message.hasOwnProperty("lastModified"))
                if (!$util.isInteger(message.lastModified) && !(message.lastModified && $util.isInteger(message.lastModified.low) && $util.isInteger(message.lastModified.high)))
                    return "lastModified: integer|Long expected";
            if (message.hash != null && message.hasOwnProperty("hash"))
                if (!$util.isString(message.hash))
                    return "hash: string expected";
            return null;
        };

        /**
         * Creates a FileInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.FileInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.FileInfo} FileInfo
         */
        FileInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.file.FileInfo)
                return object;
            var message = new $root.file.FileInfo();
            if (object.name != null)
                message.name = String(object.name);
            if (object.size != null)
                if ($util.Long)
                    (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                else if (typeof object.size === "string")
                    message.size = parseInt(object.size, 10);
                else if (typeof object.size === "number")
                    message.size = object.size;
                else if (typeof object.size === "object")
                    message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
            if (object.type != null)
                message.type = String(object.type);
            if (object.suffix != null)
                message.suffix = String(object.suffix);
            if (object.lastModified != null)
                if ($util.Long)
                    (message.lastModified = $util.Long.fromValue(object.lastModified)).unsigned = false;
                else if (typeof object.lastModified === "string")
                    message.lastModified = parseInt(object.lastModified, 10);
                else if (typeof object.lastModified === "number")
                    message.lastModified = object.lastModified;
                else if (typeof object.lastModified === "object")
                    message.lastModified = new $util.LongBits(object.lastModified.low >>> 0, object.lastModified.high >>> 0).toNumber();
            if (object.hash != null)
                message.hash = String(object.hash);
            return message;
        };

        /**
         * Creates a plain object from a FileInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.FileInfo
         * @static
         * @param {file.FileInfo} message FileInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.name = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.size = options.longs === String ? "0" : 0;
                object.type = "";
                object.suffix = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastModified = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastModified = options.longs === String ? "0" : 0;
                object.hash = "";
            }
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.size != null && message.hasOwnProperty("size"))
                if (typeof message.size === "number")
                    object.size = options.longs === String ? String(message.size) : message.size;
                else
                    object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.suffix != null && message.hasOwnProperty("suffix"))
                object.suffix = message.suffix;
            if (message.lastModified != null && message.hasOwnProperty("lastModified"))
                if (typeof message.lastModified === "number")
                    object.lastModified = options.longs === String ? String(message.lastModified) : message.lastModified;
                else
                    object.lastModified = options.longs === String ? $util.Long.prototype.toString.call(message.lastModified) : options.longs === Number ? new $util.LongBits(message.lastModified.low >>> 0, message.lastModified.high >>> 0).toNumber() : message.lastModified;
            if (message.hash != null && message.hasOwnProperty("hash"))
                object.hash = message.hash;
            return object;
        };

        /**
         * Converts this FileInfo to JSON.
         * @function toJSON
         * @memberof file.FileInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileInfo;
    })();

    file.FileUrls = (function() {

        /**
         * Properties of a FileUrls.
         * @memberof file
         * @interface IFileUrls
         * @property {string|null} [domainUrl] FileUrls domainUrl
         * @property {string|null} [shortUrl] FileUrls shortUrl
         * @property {string|null} [url] FileUrls url
         */

        /**
         * Constructs a new FileUrls.
         * @memberof file
         * @classdesc Represents a FileUrls.
         * @implements IFileUrls
         * @constructor
         * @param {file.IFileUrls=} [properties] Properties to set
         */
        function FileUrls(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileUrls domainUrl.
         * @member {string} domainUrl
         * @memberof file.FileUrls
         * @instance
         */
        FileUrls.prototype.domainUrl = "";

        /**
         * FileUrls shortUrl.
         * @member {string} shortUrl
         * @memberof file.FileUrls
         * @instance
         */
        FileUrls.prototype.shortUrl = "";

        /**
         * FileUrls url.
         * @member {string} url
         * @memberof file.FileUrls
         * @instance
         */
        FileUrls.prototype.url = "";

        /**
         * Creates a new FileUrls instance using the specified properties.
         * @function create
         * @memberof file.FileUrls
         * @static
         * @param {file.IFileUrls=} [properties] Properties to set
         * @returns {file.FileUrls} FileUrls instance
         */
        FileUrls.create = function create(properties) {
            return new FileUrls(properties);
        };

        /**
         * Encodes the specified FileUrls message. Does not implicitly {@link file.FileUrls.verify|verify} messages.
         * @function encode
         * @memberof file.FileUrls
         * @static
         * @param {file.IFileUrls} message FileUrls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileUrls.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.domainUrl != null && Object.hasOwnProperty.call(message, "domainUrl"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.domainUrl);
            if (message.shortUrl != null && Object.hasOwnProperty.call(message, "shortUrl"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.shortUrl);
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.url);
            return writer;
        };

        /**
         * Encodes the specified FileUrls message, length delimited. Does not implicitly {@link file.FileUrls.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.FileUrls
         * @static
         * @param {file.IFileUrls} message FileUrls message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileUrls.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileUrls message from the specified reader or buffer.
         * @function decode
         * @memberof file.FileUrls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.FileUrls} FileUrls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileUrls.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.FileUrls();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.domainUrl = reader.string();
                    break;
                case 2:
                    message.shortUrl = reader.string();
                    break;
                case 3:
                    message.url = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileUrls message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.FileUrls
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.FileUrls} FileUrls
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileUrls.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileUrls message.
         * @function verify
         * @memberof file.FileUrls
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileUrls.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.domainUrl != null && message.hasOwnProperty("domainUrl"))
                if (!$util.isString(message.domainUrl))
                    return "domainUrl: string expected";
            if (message.shortUrl != null && message.hasOwnProperty("shortUrl"))
                if (!$util.isString(message.shortUrl))
                    return "shortUrl: string expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            return null;
        };

        /**
         * Creates a FileUrls message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.FileUrls
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.FileUrls} FileUrls
         */
        FileUrls.fromObject = function fromObject(object) {
            if (object instanceof $root.file.FileUrls)
                return object;
            var message = new $root.file.FileUrls();
            if (object.domainUrl != null)
                message.domainUrl = String(object.domainUrl);
            if (object.shortUrl != null)
                message.shortUrl = String(object.shortUrl);
            if (object.url != null)
                message.url = String(object.url);
            return message;
        };

        /**
         * Creates a plain object from a FileUrls message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.FileUrls
         * @static
         * @param {file.FileUrls} message FileUrls
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileUrls.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.domainUrl = "";
                object.shortUrl = "";
                object.url = "";
            }
            if (message.domainUrl != null && message.hasOwnProperty("domainUrl"))
                object.domainUrl = message.domainUrl;
            if (message.shortUrl != null && message.hasOwnProperty("shortUrl"))
                object.shortUrl = message.shortUrl;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            return object;
        };

        /**
         * Converts this FileUrls to JSON.
         * @function toJSON
         * @memberof file.FileUrls
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileUrls.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileUrls;
    })();

    file.GetUploadFileToken = (function() {

        /**
         * Properties of a GetUploadFileToken.
         * @memberof file
         * @interface IGetUploadFileToken
         */

        /**
         * Constructs a new GetUploadFileToken.
         * @memberof file
         * @classdesc Represents a GetUploadFileToken.
         * @implements IGetUploadFileToken
         * @constructor
         * @param {file.IGetUploadFileToken=} [properties] Properties to set
         */
        function GetUploadFileToken(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetUploadFileToken instance using the specified properties.
         * @function create
         * @memberof file.GetUploadFileToken
         * @static
         * @param {file.IGetUploadFileToken=} [properties] Properties to set
         * @returns {file.GetUploadFileToken} GetUploadFileToken instance
         */
        GetUploadFileToken.create = function create(properties) {
            return new GetUploadFileToken(properties);
        };

        /**
         * Encodes the specified GetUploadFileToken message. Does not implicitly {@link file.GetUploadFileToken.verify|verify} messages.
         * @function encode
         * @memberof file.GetUploadFileToken
         * @static
         * @param {file.IGetUploadFileToken} message GetUploadFileToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUploadFileToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetUploadFileToken message, length delimited. Does not implicitly {@link file.GetUploadFileToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.GetUploadFileToken
         * @static
         * @param {file.IGetUploadFileToken} message GetUploadFileToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetUploadFileToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetUploadFileToken message from the specified reader or buffer.
         * @function decode
         * @memberof file.GetUploadFileToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.GetUploadFileToken} GetUploadFileToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUploadFileToken.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetUploadFileToken();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetUploadFileToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.GetUploadFileToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.GetUploadFileToken} GetUploadFileToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetUploadFileToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetUploadFileToken message.
         * @function verify
         * @memberof file.GetUploadFileToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetUploadFileToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetUploadFileToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.GetUploadFileToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.GetUploadFileToken} GetUploadFileToken
         */
        GetUploadFileToken.fromObject = function fromObject(object) {
            if (object instanceof $root.file.GetUploadFileToken)
                return object;
            return new $root.file.GetUploadFileToken();
        };

        /**
         * Creates a plain object from a GetUploadFileToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.GetUploadFileToken
         * @static
         * @param {file.GetUploadFileToken} message GetUploadFileToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetUploadFileToken.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetUploadFileToken to JSON.
         * @function toJSON
         * @memberof file.GetUploadFileToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetUploadFileToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetUploadFileToken.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof file.GetUploadFileToken
             * @interface IRequest
             * @property {file.IFileInfo|null} [fileInfo] Request fileInfo
             */

            /**
             * Constructs a new Request.
             * @memberof file.GetUploadFileToken
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {file.GetUploadFileToken.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request fileInfo.
             * @member {file.IFileInfo|null|undefined} fileInfo
             * @memberof file.GetUploadFileToken.Request
             * @instance
             */
            Request.prototype.fileInfo = null;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof file.GetUploadFileToken.Request
             * @static
             * @param {file.GetUploadFileToken.IRequest=} [properties] Properties to set
             * @returns {file.GetUploadFileToken.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link file.GetUploadFileToken.Request.verify|verify} messages.
             * @function encode
             * @memberof file.GetUploadFileToken.Request
             * @static
             * @param {file.GetUploadFileToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.fileInfo != null && Object.hasOwnProperty.call(message, "fileInfo"))
                    $root.file.FileInfo.encode(message.fileInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link file.GetUploadFileToken.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof file.GetUploadFileToken.Request
             * @static
             * @param {file.GetUploadFileToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof file.GetUploadFileToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {file.GetUploadFileToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetUploadFileToken.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.fileInfo = $root.file.FileInfo.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof file.GetUploadFileToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {file.GetUploadFileToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof file.GetUploadFileToken.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.fileInfo != null && message.hasOwnProperty("fileInfo")) {
                    var error = $root.file.FileInfo.verify(message.fileInfo);
                    if (error)
                        return "fileInfo." + error;
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof file.GetUploadFileToken.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {file.GetUploadFileToken.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.file.GetUploadFileToken.Request)
                    return object;
                var message = new $root.file.GetUploadFileToken.Request();
                if (object.fileInfo != null) {
                    if (typeof object.fileInfo !== "object")
                        throw TypeError(".file.GetUploadFileToken.Request.fileInfo: object expected");
                    message.fileInfo = $root.file.FileInfo.fromObject(object.fileInfo);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof file.GetUploadFileToken.Request
             * @static
             * @param {file.GetUploadFileToken.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.fileInfo = null;
                if (message.fileInfo != null && message.hasOwnProperty("fileInfo"))
                    object.fileInfo = $root.file.FileInfo.toObject(message.fileInfo, options);
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof file.GetUploadFileToken.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetUploadFileToken.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof file.GetUploadFileToken
             * @interface IResponse
             * @property {file.IFileUrls|null} [urls] Response urls
             * @property {string|null} [apiUrl] Response apiUrl
             * @property {string|null} [token] Response token
             * @property {number|Long|null} [chunkSize] Response chunkSize
             * @property {Array.<number|Long>|null} [uploadedOffset] Response uploadedOffset
             */

            /**
             * Constructs a new Response.
             * @memberof file.GetUploadFileToken
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {file.GetUploadFileToken.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.uploadedOffset = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response urls.
             * @member {file.IFileUrls|null|undefined} urls
             * @memberof file.GetUploadFileToken.Response
             * @instance
             */
            Response.prototype.urls = null;

            /**
             * Response apiUrl.
             * @member {string} apiUrl
             * @memberof file.GetUploadFileToken.Response
             * @instance
             */
            Response.prototype.apiUrl = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof file.GetUploadFileToken.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response chunkSize.
             * @member {number|Long} chunkSize
             * @memberof file.GetUploadFileToken.Response
             * @instance
             */
            Response.prototype.chunkSize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Response uploadedOffset.
             * @member {Array.<number|Long>} uploadedOffset
             * @memberof file.GetUploadFileToken.Response
             * @instance
             */
            Response.prototype.uploadedOffset = $util.emptyArray;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof file.GetUploadFileToken.Response
             * @static
             * @param {file.GetUploadFileToken.IResponse=} [properties] Properties to set
             * @returns {file.GetUploadFileToken.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link file.GetUploadFileToken.Response.verify|verify} messages.
             * @function encode
             * @memberof file.GetUploadFileToken.Response
             * @static
             * @param {file.GetUploadFileToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.urls != null && Object.hasOwnProperty.call(message, "urls"))
                    $root.file.FileUrls.encode(message.urls, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.apiUrl != null && Object.hasOwnProperty.call(message, "apiUrl"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.apiUrl);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
                if (message.chunkSize != null && Object.hasOwnProperty.call(message, "chunkSize"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.chunkSize);
                if (message.uploadedOffset != null && message.uploadedOffset.length) {
                    writer.uint32(/* id 5, wireType 2 =*/42).fork();
                    for (var i = 0; i < message.uploadedOffset.length; ++i)
                        writer.int64(message.uploadedOffset[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link file.GetUploadFileToken.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof file.GetUploadFileToken.Response
             * @static
             * @param {file.GetUploadFileToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof file.GetUploadFileToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {file.GetUploadFileToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetUploadFileToken.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.urls = $root.file.FileUrls.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.apiUrl = reader.string();
                        break;
                    case 3:
                        message.token = reader.string();
                        break;
                    case 4:
                        message.chunkSize = reader.int64();
                        break;
                    case 5:
                        if (!(message.uploadedOffset && message.uploadedOffset.length))
                            message.uploadedOffset = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.uploadedOffset.push(reader.int64());
                        } else
                            message.uploadedOffset.push(reader.int64());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof file.GetUploadFileToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {file.GetUploadFileToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof file.GetUploadFileToken.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.urls != null && message.hasOwnProperty("urls")) {
                    var error = $root.file.FileUrls.verify(message.urls);
                    if (error)
                        return "urls." + error;
                }
                if (message.apiUrl != null && message.hasOwnProperty("apiUrl"))
                    if (!$util.isString(message.apiUrl))
                        return "apiUrl: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                    if (!$util.isInteger(message.chunkSize) && !(message.chunkSize && $util.isInteger(message.chunkSize.low) && $util.isInteger(message.chunkSize.high)))
                        return "chunkSize: integer|Long expected";
                if (message.uploadedOffset != null && message.hasOwnProperty("uploadedOffset")) {
                    if (!Array.isArray(message.uploadedOffset))
                        return "uploadedOffset: array expected";
                    for (var i = 0; i < message.uploadedOffset.length; ++i)
                        if (!$util.isInteger(message.uploadedOffset[i]) && !(message.uploadedOffset[i] && $util.isInteger(message.uploadedOffset[i].low) && $util.isInteger(message.uploadedOffset[i].high)))
                            return "uploadedOffset: integer|Long[] expected";
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof file.GetUploadFileToken.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {file.GetUploadFileToken.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.file.GetUploadFileToken.Response)
                    return object;
                var message = new $root.file.GetUploadFileToken.Response();
                if (object.urls != null) {
                    if (typeof object.urls !== "object")
                        throw TypeError(".file.GetUploadFileToken.Response.urls: object expected");
                    message.urls = $root.file.FileUrls.fromObject(object.urls);
                }
                if (object.apiUrl != null)
                    message.apiUrl = String(object.apiUrl);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.chunkSize != null)
                    if ($util.Long)
                        (message.chunkSize = $util.Long.fromValue(object.chunkSize)).unsigned = false;
                    else if (typeof object.chunkSize === "string")
                        message.chunkSize = parseInt(object.chunkSize, 10);
                    else if (typeof object.chunkSize === "number")
                        message.chunkSize = object.chunkSize;
                    else if (typeof object.chunkSize === "object")
                        message.chunkSize = new $util.LongBits(object.chunkSize.low >>> 0, object.chunkSize.high >>> 0).toNumber();
                if (object.uploadedOffset) {
                    if (!Array.isArray(object.uploadedOffset))
                        throw TypeError(".file.GetUploadFileToken.Response.uploadedOffset: array expected");
                    message.uploadedOffset = [];
                    for (var i = 0; i < object.uploadedOffset.length; ++i)
                        if ($util.Long)
                            (message.uploadedOffset[i] = $util.Long.fromValue(object.uploadedOffset[i])).unsigned = false;
                        else if (typeof object.uploadedOffset[i] === "string")
                            message.uploadedOffset[i] = parseInt(object.uploadedOffset[i], 10);
                        else if (typeof object.uploadedOffset[i] === "number")
                            message.uploadedOffset[i] = object.uploadedOffset[i];
                        else if (typeof object.uploadedOffset[i] === "object")
                            message.uploadedOffset[i] = new $util.LongBits(object.uploadedOffset[i].low >>> 0, object.uploadedOffset[i].high >>> 0).toNumber();
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof file.GetUploadFileToken.Response
             * @static
             * @param {file.GetUploadFileToken.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uploadedOffset = [];
                if (options.defaults) {
                    object.urls = null;
                    object.apiUrl = "";
                    object.token = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.chunkSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.chunkSize = options.longs === String ? "0" : 0;
                }
                if (message.urls != null && message.hasOwnProperty("urls"))
                    object.urls = $root.file.FileUrls.toObject(message.urls, options);
                if (message.apiUrl != null && message.hasOwnProperty("apiUrl"))
                    object.apiUrl = message.apiUrl;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                    if (typeof message.chunkSize === "number")
                        object.chunkSize = options.longs === String ? String(message.chunkSize) : message.chunkSize;
                    else
                        object.chunkSize = options.longs === String ? $util.Long.prototype.toString.call(message.chunkSize) : options.longs === Number ? new $util.LongBits(message.chunkSize.low >>> 0, message.chunkSize.high >>> 0).toNumber() : message.chunkSize;
                if (message.uploadedOffset && message.uploadedOffset.length) {
                    object.uploadedOffset = [];
                    for (var j = 0; j < message.uploadedOffset.length; ++j)
                        if (typeof message.uploadedOffset[j] === "number")
                            object.uploadedOffset[j] = options.longs === String ? String(message.uploadedOffset[j]) : message.uploadedOffset[j];
                        else
                            object.uploadedOffset[j] = options.longs === String ? $util.Long.prototype.toString.call(message.uploadedOffset[j]) : options.longs === Number ? new $util.LongBits(message.uploadedOffset[j].low >>> 0, message.uploadedOffset[j].high >>> 0).toNumber() : message.uploadedOffset[j];
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof file.GetUploadFileToken.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetUploadFileToken;
    })();

    file.GetCustomStickersUploadFileToken = (function() {

        /**
         * Properties of a GetCustomStickersUploadFileToken.
         * @memberof file
         * @interface IGetCustomStickersUploadFileToken
         */

        /**
         * Constructs a new GetCustomStickersUploadFileToken.
         * @memberof file
         * @classdesc Represents a GetCustomStickersUploadFileToken.
         * @implements IGetCustomStickersUploadFileToken
         * @constructor
         * @param {file.IGetCustomStickersUploadFileToken=} [properties] Properties to set
         */
        function GetCustomStickersUploadFileToken(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetCustomStickersUploadFileToken instance using the specified properties.
         * @function create
         * @memberof file.GetCustomStickersUploadFileToken
         * @static
         * @param {file.IGetCustomStickersUploadFileToken=} [properties] Properties to set
         * @returns {file.GetCustomStickersUploadFileToken} GetCustomStickersUploadFileToken instance
         */
        GetCustomStickersUploadFileToken.create = function create(properties) {
            return new GetCustomStickersUploadFileToken(properties);
        };

        /**
         * Encodes the specified GetCustomStickersUploadFileToken message. Does not implicitly {@link file.GetCustomStickersUploadFileToken.verify|verify} messages.
         * @function encode
         * @memberof file.GetCustomStickersUploadFileToken
         * @static
         * @param {file.IGetCustomStickersUploadFileToken} message GetCustomStickersUploadFileToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCustomStickersUploadFileToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetCustomStickersUploadFileToken message, length delimited. Does not implicitly {@link file.GetCustomStickersUploadFileToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.GetCustomStickersUploadFileToken
         * @static
         * @param {file.IGetCustomStickersUploadFileToken} message GetCustomStickersUploadFileToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCustomStickersUploadFileToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetCustomStickersUploadFileToken message from the specified reader or buffer.
         * @function decode
         * @memberof file.GetCustomStickersUploadFileToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.GetCustomStickersUploadFileToken} GetCustomStickersUploadFileToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCustomStickersUploadFileToken.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetCustomStickersUploadFileToken();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetCustomStickersUploadFileToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.GetCustomStickersUploadFileToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.GetCustomStickersUploadFileToken} GetCustomStickersUploadFileToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCustomStickersUploadFileToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetCustomStickersUploadFileToken message.
         * @function verify
         * @memberof file.GetCustomStickersUploadFileToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetCustomStickersUploadFileToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetCustomStickersUploadFileToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.GetCustomStickersUploadFileToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.GetCustomStickersUploadFileToken} GetCustomStickersUploadFileToken
         */
        GetCustomStickersUploadFileToken.fromObject = function fromObject(object) {
            if (object instanceof $root.file.GetCustomStickersUploadFileToken)
                return object;
            return new $root.file.GetCustomStickersUploadFileToken();
        };

        /**
         * Creates a plain object from a GetCustomStickersUploadFileToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.GetCustomStickersUploadFileToken
         * @static
         * @param {file.GetCustomStickersUploadFileToken} message GetCustomStickersUploadFileToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetCustomStickersUploadFileToken.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetCustomStickersUploadFileToken to JSON.
         * @function toJSON
         * @memberof file.GetCustomStickersUploadFileToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetCustomStickersUploadFileToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetCustomStickersUploadFileToken.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof file.GetCustomStickersUploadFileToken
             * @interface IRequest
             * @property {number|Long|null} [size] Request size
             * @property {string|null} [hash] Request hash
             */

            /**
             * Constructs a new Request.
             * @memberof file.GetCustomStickersUploadFileToken
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {file.GetCustomStickersUploadFileToken.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request size.
             * @member {number|Long} size
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @instance
             */
            Request.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request hash.
             * @member {string} hash
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @instance
             */
            Request.prototype.hash = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @static
             * @param {file.GetCustomStickersUploadFileToken.IRequest=} [properties] Properties to set
             * @returns {file.GetCustomStickersUploadFileToken.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link file.GetCustomStickersUploadFileToken.Request.verify|verify} messages.
             * @function encode
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @static
             * @param {file.GetCustomStickersUploadFileToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.size);
                if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.hash);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link file.GetCustomStickersUploadFileToken.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @static
             * @param {file.GetCustomStickersUploadFileToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {file.GetCustomStickersUploadFileToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetCustomStickersUploadFileToken.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.size = reader.int64();
                        break;
                    case 2:
                        message.hash = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {file.GetCustomStickersUploadFileToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                        return "size: integer|Long expected";
                if (message.hash != null && message.hasOwnProperty("hash"))
                    if (!$util.isString(message.hash))
                        return "hash: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {file.GetCustomStickersUploadFileToken.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.file.GetCustomStickersUploadFileToken.Request)
                    return object;
                var message = new $root.file.GetCustomStickersUploadFileToken.Request();
                if (object.size != null)
                    if ($util.Long)
                        (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                    else if (typeof object.size === "string")
                        message.size = parseInt(object.size, 10);
                    else if (typeof object.size === "number")
                        message.size = object.size;
                    else if (typeof object.size === "object")
                        message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
                if (object.hash != null)
                    message.hash = String(object.hash);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @static
             * @param {file.GetCustomStickersUploadFileToken.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.size = options.longs === String ? "0" : 0;
                    object.hash = "";
                }
                if (message.size != null && message.hasOwnProperty("size"))
                    if (typeof message.size === "number")
                        object.size = options.longs === String ? String(message.size) : message.size;
                    else
                        object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
                if (message.hash != null && message.hasOwnProperty("hash"))
                    object.hash = message.hash;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof file.GetCustomStickersUploadFileToken.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetCustomStickersUploadFileToken.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof file.GetCustomStickersUploadFileToken
             * @interface IResponse
             * @property {file.IFileUrls|null} [urls] Response urls
             * @property {string|null} [apiUrl] Response apiUrl
             * @property {string|null} [token] Response token
             * @property {number|Long|null} [chunkSize] Response chunkSize
             * @property {Array.<number|Long>|null} [uploadedOffset] Response uploadedOffset
             */

            /**
             * Constructs a new Response.
             * @memberof file.GetCustomStickersUploadFileToken
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {file.GetCustomStickersUploadFileToken.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.uploadedOffset = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response urls.
             * @member {file.IFileUrls|null|undefined} urls
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @instance
             */
            Response.prototype.urls = null;

            /**
             * Response apiUrl.
             * @member {string} apiUrl
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @instance
             */
            Response.prototype.apiUrl = "";

            /**
             * Response token.
             * @member {string} token
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response chunkSize.
             * @member {number|Long} chunkSize
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @instance
             */
            Response.prototype.chunkSize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Response uploadedOffset.
             * @member {Array.<number|Long>} uploadedOffset
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @instance
             */
            Response.prototype.uploadedOffset = $util.emptyArray;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @static
             * @param {file.GetCustomStickersUploadFileToken.IResponse=} [properties] Properties to set
             * @returns {file.GetCustomStickersUploadFileToken.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link file.GetCustomStickersUploadFileToken.Response.verify|verify} messages.
             * @function encode
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @static
             * @param {file.GetCustomStickersUploadFileToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.urls != null && Object.hasOwnProperty.call(message, "urls"))
                    $root.file.FileUrls.encode(message.urls, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.apiUrl != null && Object.hasOwnProperty.call(message, "apiUrl"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.apiUrl);
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.token);
                if (message.chunkSize != null && Object.hasOwnProperty.call(message, "chunkSize"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.chunkSize);
                if (message.uploadedOffset != null && message.uploadedOffset.length) {
                    writer.uint32(/* id 5, wireType 2 =*/42).fork();
                    for (var i = 0; i < message.uploadedOffset.length; ++i)
                        writer.int64(message.uploadedOffset[i]);
                    writer.ldelim();
                }
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link file.GetCustomStickersUploadFileToken.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @static
             * @param {file.GetCustomStickersUploadFileToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {file.GetCustomStickersUploadFileToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetCustomStickersUploadFileToken.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.urls = $root.file.FileUrls.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.apiUrl = reader.string();
                        break;
                    case 3:
                        message.token = reader.string();
                        break;
                    case 4:
                        message.chunkSize = reader.int64();
                        break;
                    case 5:
                        if (!(message.uploadedOffset && message.uploadedOffset.length))
                            message.uploadedOffset = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.uploadedOffset.push(reader.int64());
                        } else
                            message.uploadedOffset.push(reader.int64());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {file.GetCustomStickersUploadFileToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.urls != null && message.hasOwnProperty("urls")) {
                    var error = $root.file.FileUrls.verify(message.urls);
                    if (error)
                        return "urls." + error;
                }
                if (message.apiUrl != null && message.hasOwnProperty("apiUrl"))
                    if (!$util.isString(message.apiUrl))
                        return "apiUrl: string expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                    if (!$util.isInteger(message.chunkSize) && !(message.chunkSize && $util.isInteger(message.chunkSize.low) && $util.isInteger(message.chunkSize.high)))
                        return "chunkSize: integer|Long expected";
                if (message.uploadedOffset != null && message.hasOwnProperty("uploadedOffset")) {
                    if (!Array.isArray(message.uploadedOffset))
                        return "uploadedOffset: array expected";
                    for (var i = 0; i < message.uploadedOffset.length; ++i)
                        if (!$util.isInteger(message.uploadedOffset[i]) && !(message.uploadedOffset[i] && $util.isInteger(message.uploadedOffset[i].low) && $util.isInteger(message.uploadedOffset[i].high)))
                            return "uploadedOffset: integer|Long[] expected";
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {file.GetCustomStickersUploadFileToken.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.file.GetCustomStickersUploadFileToken.Response)
                    return object;
                var message = new $root.file.GetCustomStickersUploadFileToken.Response();
                if (object.urls != null) {
                    if (typeof object.urls !== "object")
                        throw TypeError(".file.GetCustomStickersUploadFileToken.Response.urls: object expected");
                    message.urls = $root.file.FileUrls.fromObject(object.urls);
                }
                if (object.apiUrl != null)
                    message.apiUrl = String(object.apiUrl);
                if (object.token != null)
                    message.token = String(object.token);
                if (object.chunkSize != null)
                    if ($util.Long)
                        (message.chunkSize = $util.Long.fromValue(object.chunkSize)).unsigned = false;
                    else if (typeof object.chunkSize === "string")
                        message.chunkSize = parseInt(object.chunkSize, 10);
                    else if (typeof object.chunkSize === "number")
                        message.chunkSize = object.chunkSize;
                    else if (typeof object.chunkSize === "object")
                        message.chunkSize = new $util.LongBits(object.chunkSize.low >>> 0, object.chunkSize.high >>> 0).toNumber();
                if (object.uploadedOffset) {
                    if (!Array.isArray(object.uploadedOffset))
                        throw TypeError(".file.GetCustomStickersUploadFileToken.Response.uploadedOffset: array expected");
                    message.uploadedOffset = [];
                    for (var i = 0; i < object.uploadedOffset.length; ++i)
                        if ($util.Long)
                            (message.uploadedOffset[i] = $util.Long.fromValue(object.uploadedOffset[i])).unsigned = false;
                        else if (typeof object.uploadedOffset[i] === "string")
                            message.uploadedOffset[i] = parseInt(object.uploadedOffset[i], 10);
                        else if (typeof object.uploadedOffset[i] === "number")
                            message.uploadedOffset[i] = object.uploadedOffset[i];
                        else if (typeof object.uploadedOffset[i] === "object")
                            message.uploadedOffset[i] = new $util.LongBits(object.uploadedOffset[i].low >>> 0, object.uploadedOffset[i].high >>> 0).toNumber();
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @static
             * @param {file.GetCustomStickersUploadFileToken.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uploadedOffset = [];
                if (options.defaults) {
                    object.urls = null;
                    object.apiUrl = "";
                    object.token = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.chunkSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.chunkSize = options.longs === String ? "0" : 0;
                }
                if (message.urls != null && message.hasOwnProperty("urls"))
                    object.urls = $root.file.FileUrls.toObject(message.urls, options);
                if (message.apiUrl != null && message.hasOwnProperty("apiUrl"))
                    object.apiUrl = message.apiUrl;
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                    if (typeof message.chunkSize === "number")
                        object.chunkSize = options.longs === String ? String(message.chunkSize) : message.chunkSize;
                    else
                        object.chunkSize = options.longs === String ? $util.Long.prototype.toString.call(message.chunkSize) : options.longs === Number ? new $util.LongBits(message.chunkSize.low >>> 0, message.chunkSize.high >>> 0).toNumber() : message.chunkSize;
                if (message.uploadedOffset && message.uploadedOffset.length) {
                    object.uploadedOffset = [];
                    for (var j = 0; j < message.uploadedOffset.length; ++j)
                        if (typeof message.uploadedOffset[j] === "number")
                            object.uploadedOffset[j] = options.longs === String ? String(message.uploadedOffset[j]) : message.uploadedOffset[j];
                        else
                            object.uploadedOffset[j] = options.longs === String ? $util.Long.prototype.toString.call(message.uploadedOffset[j]) : options.longs === Number ? new $util.LongBits(message.uploadedOffset[j].low >>> 0, message.uploadedOffset[j].high >>> 0).toNumber() : message.uploadedOffset[j];
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof file.GetCustomStickersUploadFileToken.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetCustomStickersUploadFileToken;
    })();

    file.GetCustomStickersFileUrl = (function() {

        /**
         * Properties of a GetCustomStickersFileUrl.
         * @memberof file
         * @interface IGetCustomStickersFileUrl
         */

        /**
         * Constructs a new GetCustomStickersFileUrl.
         * @memberof file
         * @classdesc Represents a GetCustomStickersFileUrl.
         * @implements IGetCustomStickersFileUrl
         * @constructor
         * @param {file.IGetCustomStickersFileUrl=} [properties] Properties to set
         */
        function GetCustomStickersFileUrl(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetCustomStickersFileUrl instance using the specified properties.
         * @function create
         * @memberof file.GetCustomStickersFileUrl
         * @static
         * @param {file.IGetCustomStickersFileUrl=} [properties] Properties to set
         * @returns {file.GetCustomStickersFileUrl} GetCustomStickersFileUrl instance
         */
        GetCustomStickersFileUrl.create = function create(properties) {
            return new GetCustomStickersFileUrl(properties);
        };

        /**
         * Encodes the specified GetCustomStickersFileUrl message. Does not implicitly {@link file.GetCustomStickersFileUrl.verify|verify} messages.
         * @function encode
         * @memberof file.GetCustomStickersFileUrl
         * @static
         * @param {file.IGetCustomStickersFileUrl} message GetCustomStickersFileUrl message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCustomStickersFileUrl.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetCustomStickersFileUrl message, length delimited. Does not implicitly {@link file.GetCustomStickersFileUrl.verify|verify} messages.
         * @function encodeDelimited
         * @memberof file.GetCustomStickersFileUrl
         * @static
         * @param {file.IGetCustomStickersFileUrl} message GetCustomStickersFileUrl message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetCustomStickersFileUrl.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetCustomStickersFileUrl message from the specified reader or buffer.
         * @function decode
         * @memberof file.GetCustomStickersFileUrl
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {file.GetCustomStickersFileUrl} GetCustomStickersFileUrl
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCustomStickersFileUrl.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetCustomStickersFileUrl();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetCustomStickersFileUrl message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof file.GetCustomStickersFileUrl
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {file.GetCustomStickersFileUrl} GetCustomStickersFileUrl
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetCustomStickersFileUrl.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetCustomStickersFileUrl message.
         * @function verify
         * @memberof file.GetCustomStickersFileUrl
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetCustomStickersFileUrl.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetCustomStickersFileUrl message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof file.GetCustomStickersFileUrl
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {file.GetCustomStickersFileUrl} GetCustomStickersFileUrl
         */
        GetCustomStickersFileUrl.fromObject = function fromObject(object) {
            if (object instanceof $root.file.GetCustomStickersFileUrl)
                return object;
            return new $root.file.GetCustomStickersFileUrl();
        };

        /**
         * Creates a plain object from a GetCustomStickersFileUrl message. Also converts values to other types if specified.
         * @function toObject
         * @memberof file.GetCustomStickersFileUrl
         * @static
         * @param {file.GetCustomStickersFileUrl} message GetCustomStickersFileUrl
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetCustomStickersFileUrl.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetCustomStickersFileUrl to JSON.
         * @function toJSON
         * @memberof file.GetCustomStickersFileUrl
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetCustomStickersFileUrl.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetCustomStickersFileUrl.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof file.GetCustomStickersFileUrl
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof file.GetCustomStickersFileUrl
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {file.GetCustomStickersFileUrl.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof file.GetCustomStickersFileUrl.Request
             * @static
             * @param {file.GetCustomStickersFileUrl.IRequest=} [properties] Properties to set
             * @returns {file.GetCustomStickersFileUrl.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link file.GetCustomStickersFileUrl.Request.verify|verify} messages.
             * @function encode
             * @memberof file.GetCustomStickersFileUrl.Request
             * @static
             * @param {file.GetCustomStickersFileUrl.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link file.GetCustomStickersFileUrl.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof file.GetCustomStickersFileUrl.Request
             * @static
             * @param {file.GetCustomStickersFileUrl.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof file.GetCustomStickersFileUrl.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {file.GetCustomStickersFileUrl.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetCustomStickersFileUrl.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof file.GetCustomStickersFileUrl.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {file.GetCustomStickersFileUrl.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof file.GetCustomStickersFileUrl.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof file.GetCustomStickersFileUrl.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {file.GetCustomStickersFileUrl.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.file.GetCustomStickersFileUrl.Request)
                    return object;
                return new $root.file.GetCustomStickersFileUrl.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof file.GetCustomStickersFileUrl.Request
             * @static
             * @param {file.GetCustomStickersFileUrl.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof file.GetCustomStickersFileUrl.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetCustomStickersFileUrl.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof file.GetCustomStickersFileUrl
             * @interface IResponse
             * @property {string|null} [url] Response url
             */

            /**
             * Constructs a new Response.
             * @memberof file.GetCustomStickersFileUrl
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {file.GetCustomStickersFileUrl.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response url.
             * @member {string} url
             * @memberof file.GetCustomStickersFileUrl.Response
             * @instance
             */
            Response.prototype.url = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof file.GetCustomStickersFileUrl.Response
             * @static
             * @param {file.GetCustomStickersFileUrl.IResponse=} [properties] Properties to set
             * @returns {file.GetCustomStickersFileUrl.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link file.GetCustomStickersFileUrl.Response.verify|verify} messages.
             * @function encode
             * @memberof file.GetCustomStickersFileUrl.Response
             * @static
             * @param {file.GetCustomStickersFileUrl.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link file.GetCustomStickersFileUrl.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof file.GetCustomStickersFileUrl.Response
             * @static
             * @param {file.GetCustomStickersFileUrl.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof file.GetCustomStickersFileUrl.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {file.GetCustomStickersFileUrl.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.file.GetCustomStickersFileUrl.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.url = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof file.GetCustomStickersFileUrl.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {file.GetCustomStickersFileUrl.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof file.GetCustomStickersFileUrl.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.url != null && message.hasOwnProperty("url"))
                    if (!$util.isString(message.url))
                        return "url: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof file.GetCustomStickersFileUrl.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {file.GetCustomStickersFileUrl.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.file.GetCustomStickersFileUrl.Response)
                    return object;
                var message = new $root.file.GetCustomStickersFileUrl.Response();
                if (object.url != null)
                    message.url = String(object.url);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof file.GetCustomStickersFileUrl.Response
             * @static
             * @param {file.GetCustomStickersFileUrl.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.url = "";
                if (message.url != null && message.hasOwnProperty("url"))
                    object.url = message.url;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof file.GetCustomStickersFileUrl.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetCustomStickersFileUrl;
    })();

    return file;
})();

$root.friends = (function() {

    /**
     * Namespace friends.
     * @exports friends
     * @namespace
     */
    var friends = {};

    friends.FriendItem = (function() {

        /**
         * Properties of a FriendItem.
         * @memberof friends
         * @interface IFriendItem
         * @property {string|null} [id] FriendItem id
         * @property {number|Long|null} [authorId] FriendItem authorId
         * @property {number|Long|null} [friendId] FriendItem friendId
         * @property {user.IFriendUserInfo|null} [friendInfo] FriendItem friendInfo
         * @property {string|null} [remark] FriendItem remark
         * @property {Array.<number|Long>|null} [permissions] FriendItem permissions
         * @property {number|Long|null} [status] FriendItem status
         * @property {number|Long|null} [deleteDialogTime] FriendItem deleteDialogTime
         * @property {number|Long|null} [createTime] FriendItem createTime
         * @property {number|Long|null} [deleteTime] FriendItem deleteTime
         * @property {number|Long|null} [lastSeenTime] FriendItem lastSeenTime
         */

        /**
         * Constructs a new FriendItem.
         * @memberof friends
         * @classdesc Represents a FriendItem.
         * @implements IFriendItem
         * @constructor
         * @param {friends.IFriendItem=} [properties] Properties to set
         */
        function FriendItem(properties) {
            this.permissions = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FriendItem id.
         * @member {string} id
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.id = "";

        /**
         * FriendItem authorId.
         * @member {number|Long} authorId
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.authorId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendItem friendId.
         * @member {number|Long} friendId
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.friendId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendItem friendInfo.
         * @member {user.IFriendUserInfo|null|undefined} friendInfo
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.friendInfo = null;

        /**
         * FriendItem remark.
         * @member {string} remark
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.remark = "";

        /**
         * FriendItem permissions.
         * @member {Array.<number|Long>} permissions
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.permissions = $util.emptyArray;

        /**
         * FriendItem status.
         * @member {number|Long} status
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendItem deleteDialogTime.
         * @member {number|Long} deleteDialogTime
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.deleteDialogTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendItem createTime.
         * @member {number|Long} createTime
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendItem deleteTime.
         * @member {number|Long} deleteTime
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.deleteTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * FriendItem lastSeenTime.
         * @member {number|Long} lastSeenTime
         * @memberof friends.FriendItem
         * @instance
         */
        FriendItem.prototype.lastSeenTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new FriendItem instance using the specified properties.
         * @function create
         * @memberof friends.FriendItem
         * @static
         * @param {friends.IFriendItem=} [properties] Properties to set
         * @returns {friends.FriendItem} FriendItem instance
         */
        FriendItem.create = function create(properties) {
            return new FriendItem(properties);
        };

        /**
         * Encodes the specified FriendItem message. Does not implicitly {@link friends.FriendItem.verify|verify} messages.
         * @function encode
         * @memberof friends.FriendItem
         * @static
         * @param {friends.IFriendItem} message FriendItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.authorId);
            if (message.friendId != null && Object.hasOwnProperty.call(message, "friendId"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.friendId);
            if (message.friendInfo != null && Object.hasOwnProperty.call(message, "friendInfo"))
                $root.user.FriendUserInfo.encode(message.friendInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.remark != null && Object.hasOwnProperty.call(message, "remark"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.remark);
            if (message.permissions != null && message.permissions.length) {
                writer.uint32(/* id 6, wireType 2 =*/50).fork();
                for (var i = 0; i < message.permissions.length; ++i)
                    writer.int64(message.permissions[i]);
                writer.ldelim();
            }
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.status);
            if (message.deleteDialogTime != null && Object.hasOwnProperty.call(message, "deleteDialogTime"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.deleteDialogTime);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 9, wireType 0 =*/72).int64(message.createTime);
            if (message.deleteTime != null && Object.hasOwnProperty.call(message, "deleteTime"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.deleteTime);
            if (message.lastSeenTime != null && Object.hasOwnProperty.call(message, "lastSeenTime"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.lastSeenTime);
            return writer;
        };

        /**
         * Encodes the specified FriendItem message, length delimited. Does not implicitly {@link friends.FriendItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof friends.FriendItem
         * @static
         * @param {friends.IFriendItem} message FriendItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FriendItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FriendItem message from the specified reader or buffer.
         * @function decode
         * @memberof friends.FriendItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {friends.FriendItem} FriendItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.friends.FriendItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.authorId = reader.int64();
                    break;
                case 3:
                    message.friendId = reader.int64();
                    break;
                case 4:
                    message.friendInfo = $root.user.FriendUserInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.remark = reader.string();
                    break;
                case 6:
                    if (!(message.permissions && message.permissions.length))
                        message.permissions = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.permissions.push(reader.int64());
                    } else
                        message.permissions.push(reader.int64());
                    break;
                case 7:
                    message.status = reader.int64();
                    break;
                case 8:
                    message.deleteDialogTime = reader.int64();
                    break;
                case 9:
                    message.createTime = reader.int64();
                    break;
                case 10:
                    message.deleteTime = reader.int64();
                    break;
                case 11:
                    message.lastSeenTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FriendItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof friends.FriendItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {friends.FriendItem} FriendItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FriendItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FriendItem message.
         * @function verify
         * @memberof friends.FriendItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FriendItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                if (!$util.isInteger(message.authorId) && !(message.authorId && $util.isInteger(message.authorId.low) && $util.isInteger(message.authorId.high)))
                    return "authorId: integer|Long expected";
            if (message.friendId != null && message.hasOwnProperty("friendId"))
                if (!$util.isInteger(message.friendId) && !(message.friendId && $util.isInteger(message.friendId.low) && $util.isInteger(message.friendId.high)))
                    return "friendId: integer|Long expected";
            if (message.friendInfo != null && message.hasOwnProperty("friendInfo")) {
                var error = $root.user.FriendUserInfo.verify(message.friendInfo);
                if (error)
                    return "friendInfo." + error;
            }
            if (message.remark != null && message.hasOwnProperty("remark"))
                if (!$util.isString(message.remark))
                    return "remark: string expected";
            if (message.permissions != null && message.hasOwnProperty("permissions")) {
                if (!Array.isArray(message.permissions))
                    return "permissions: array expected";
                for (var i = 0; i < message.permissions.length; ++i)
                    if (!$util.isInteger(message.permissions[i]) && !(message.permissions[i] && $util.isInteger(message.permissions[i].low) && $util.isInteger(message.permissions[i].high)))
                        return "permissions: integer|Long[] expected";
            }
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.deleteDialogTime != null && message.hasOwnProperty("deleteDialogTime"))
                if (!$util.isInteger(message.deleteDialogTime) && !(message.deleteDialogTime && $util.isInteger(message.deleteDialogTime.low) && $util.isInteger(message.deleteDialogTime.high)))
                    return "deleteDialogTime: integer|Long expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (!$util.isInteger(message.deleteTime) && !(message.deleteTime && $util.isInteger(message.deleteTime.low) && $util.isInteger(message.deleteTime.high)))
                    return "deleteTime: integer|Long expected";
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (!$util.isInteger(message.lastSeenTime) && !(message.lastSeenTime && $util.isInteger(message.lastSeenTime.low) && $util.isInteger(message.lastSeenTime.high)))
                    return "lastSeenTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a FriendItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof friends.FriendItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {friends.FriendItem} FriendItem
         */
        FriendItem.fromObject = function fromObject(object) {
            if (object instanceof $root.friends.FriendItem)
                return object;
            var message = new $root.friends.FriendItem();
            if (object.id != null)
                message.id = String(object.id);
            if (object.authorId != null)
                if ($util.Long)
                    (message.authorId = $util.Long.fromValue(object.authorId)).unsigned = false;
                else if (typeof object.authorId === "string")
                    message.authorId = parseInt(object.authorId, 10);
                else if (typeof object.authorId === "number")
                    message.authorId = object.authorId;
                else if (typeof object.authorId === "object")
                    message.authorId = new $util.LongBits(object.authorId.low >>> 0, object.authorId.high >>> 0).toNumber();
            if (object.friendId != null)
                if ($util.Long)
                    (message.friendId = $util.Long.fromValue(object.friendId)).unsigned = false;
                else if (typeof object.friendId === "string")
                    message.friendId = parseInt(object.friendId, 10);
                else if (typeof object.friendId === "number")
                    message.friendId = object.friendId;
                else if (typeof object.friendId === "object")
                    message.friendId = new $util.LongBits(object.friendId.low >>> 0, object.friendId.high >>> 0).toNumber();
            if (object.friendInfo != null) {
                if (typeof object.friendInfo !== "object")
                    throw TypeError(".friends.FriendItem.friendInfo: object expected");
                message.friendInfo = $root.user.FriendUserInfo.fromObject(object.friendInfo);
            }
            if (object.remark != null)
                message.remark = String(object.remark);
            if (object.permissions) {
                if (!Array.isArray(object.permissions))
                    throw TypeError(".friends.FriendItem.permissions: array expected");
                message.permissions = [];
                for (var i = 0; i < object.permissions.length; ++i)
                    if ($util.Long)
                        (message.permissions[i] = $util.Long.fromValue(object.permissions[i])).unsigned = false;
                    else if (typeof object.permissions[i] === "string")
                        message.permissions[i] = parseInt(object.permissions[i], 10);
                    else if (typeof object.permissions[i] === "number")
                        message.permissions[i] = object.permissions[i];
                    else if (typeof object.permissions[i] === "object")
                        message.permissions[i] = new $util.LongBits(object.permissions[i].low >>> 0, object.permissions[i].high >>> 0).toNumber();
            }
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.deleteDialogTime != null)
                if ($util.Long)
                    (message.deleteDialogTime = $util.Long.fromValue(object.deleteDialogTime)).unsigned = false;
                else if (typeof object.deleteDialogTime === "string")
                    message.deleteDialogTime = parseInt(object.deleteDialogTime, 10);
                else if (typeof object.deleteDialogTime === "number")
                    message.deleteDialogTime = object.deleteDialogTime;
                else if (typeof object.deleteDialogTime === "object")
                    message.deleteDialogTime = new $util.LongBits(object.deleteDialogTime.low >>> 0, object.deleteDialogTime.high >>> 0).toNumber();
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.deleteTime != null)
                if ($util.Long)
                    (message.deleteTime = $util.Long.fromValue(object.deleteTime)).unsigned = false;
                else if (typeof object.deleteTime === "string")
                    message.deleteTime = parseInt(object.deleteTime, 10);
                else if (typeof object.deleteTime === "number")
                    message.deleteTime = object.deleteTime;
                else if (typeof object.deleteTime === "object")
                    message.deleteTime = new $util.LongBits(object.deleteTime.low >>> 0, object.deleteTime.high >>> 0).toNumber();
            if (object.lastSeenTime != null)
                if ($util.Long)
                    (message.lastSeenTime = $util.Long.fromValue(object.lastSeenTime)).unsigned = false;
                else if (typeof object.lastSeenTime === "string")
                    message.lastSeenTime = parseInt(object.lastSeenTime, 10);
                else if (typeof object.lastSeenTime === "number")
                    message.lastSeenTime = object.lastSeenTime;
                else if (typeof object.lastSeenTime === "object")
                    message.lastSeenTime = new $util.LongBits(object.lastSeenTime.low >>> 0, object.lastSeenTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a FriendItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof friends.FriendItem
         * @static
         * @param {friends.FriendItem} message FriendItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FriendItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.permissions = [];
            if (options.defaults) {
                object.id = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.authorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.authorId = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.friendId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.friendId = options.longs === String ? "0" : 0;
                object.friendInfo = null;
                object.remark = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.deleteDialogTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deleteDialogTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.deleteTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deleteTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastSeenTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastSeenTime = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                if (typeof message.authorId === "number")
                    object.authorId = options.longs === String ? String(message.authorId) : message.authorId;
                else
                    object.authorId = options.longs === String ? $util.Long.prototype.toString.call(message.authorId) : options.longs === Number ? new $util.LongBits(message.authorId.low >>> 0, message.authorId.high >>> 0).toNumber() : message.authorId;
            if (message.friendId != null && message.hasOwnProperty("friendId"))
                if (typeof message.friendId === "number")
                    object.friendId = options.longs === String ? String(message.friendId) : message.friendId;
                else
                    object.friendId = options.longs === String ? $util.Long.prototype.toString.call(message.friendId) : options.longs === Number ? new $util.LongBits(message.friendId.low >>> 0, message.friendId.high >>> 0).toNumber() : message.friendId;
            if (message.friendInfo != null && message.hasOwnProperty("friendInfo"))
                object.friendInfo = $root.user.FriendUserInfo.toObject(message.friendInfo, options);
            if (message.remark != null && message.hasOwnProperty("remark"))
                object.remark = message.remark;
            if (message.permissions && message.permissions.length) {
                object.permissions = [];
                for (var j = 0; j < message.permissions.length; ++j)
                    if (typeof message.permissions[j] === "number")
                        object.permissions[j] = options.longs === String ? String(message.permissions[j]) : message.permissions[j];
                    else
                        object.permissions[j] = options.longs === String ? $util.Long.prototype.toString.call(message.permissions[j]) : options.longs === Number ? new $util.LongBits(message.permissions[j].low >>> 0, message.permissions[j].high >>> 0).toNumber() : message.permissions[j];
            }
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.deleteDialogTime != null && message.hasOwnProperty("deleteDialogTime"))
                if (typeof message.deleteDialogTime === "number")
                    object.deleteDialogTime = options.longs === String ? String(message.deleteDialogTime) : message.deleteDialogTime;
                else
                    object.deleteDialogTime = options.longs === String ? $util.Long.prototype.toString.call(message.deleteDialogTime) : options.longs === Number ? new $util.LongBits(message.deleteDialogTime.low >>> 0, message.deleteDialogTime.high >>> 0).toNumber() : message.deleteDialogTime;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                if (typeof message.deleteTime === "number")
                    object.deleteTime = options.longs === String ? String(message.deleteTime) : message.deleteTime;
                else
                    object.deleteTime = options.longs === String ? $util.Long.prototype.toString.call(message.deleteTime) : options.longs === Number ? new $util.LongBits(message.deleteTime.low >>> 0, message.deleteTime.high >>> 0).toNumber() : message.deleteTime;
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (typeof message.lastSeenTime === "number")
                    object.lastSeenTime = options.longs === String ? String(message.lastSeenTime) : message.lastSeenTime;
                else
                    object.lastSeenTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastSeenTime) : options.longs === Number ? new $util.LongBits(message.lastSeenTime.low >>> 0, message.lastSeenTime.high >>> 0).toNumber() : message.lastSeenTime;
            return object;
        };

        /**
         * Converts this FriendItem to JSON.
         * @function toJSON
         * @memberof friends.FriendItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FriendItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FriendItem;
    })();

    friends.GetFriendsList = (function() {

        /**
         * Properties of a GetFriendsList.
         * @memberof friends
         * @interface IGetFriendsList
         */

        /**
         * Constructs a new GetFriendsList.
         * @memberof friends
         * @classdesc Represents a GetFriendsList.
         * @implements IGetFriendsList
         * @constructor
         * @param {friends.IGetFriendsList=} [properties] Properties to set
         */
        function GetFriendsList(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetFriendsList instance using the specified properties.
         * @function create
         * @memberof friends.GetFriendsList
         * @static
         * @param {friends.IGetFriendsList=} [properties] Properties to set
         * @returns {friends.GetFriendsList} GetFriendsList instance
         */
        GetFriendsList.create = function create(properties) {
            return new GetFriendsList(properties);
        };

        /**
         * Encodes the specified GetFriendsList message. Does not implicitly {@link friends.GetFriendsList.verify|verify} messages.
         * @function encode
         * @memberof friends.GetFriendsList
         * @static
         * @param {friends.IGetFriendsList} message GetFriendsList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFriendsList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetFriendsList message, length delimited. Does not implicitly {@link friends.GetFriendsList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof friends.GetFriendsList
         * @static
         * @param {friends.IGetFriendsList} message GetFriendsList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetFriendsList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetFriendsList message from the specified reader or buffer.
         * @function decode
         * @memberof friends.GetFriendsList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {friends.GetFriendsList} GetFriendsList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFriendsList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.friends.GetFriendsList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetFriendsList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof friends.GetFriendsList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {friends.GetFriendsList} GetFriendsList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetFriendsList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetFriendsList message.
         * @function verify
         * @memberof friends.GetFriendsList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetFriendsList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetFriendsList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof friends.GetFriendsList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {friends.GetFriendsList} GetFriendsList
         */
        GetFriendsList.fromObject = function fromObject(object) {
            if (object instanceof $root.friends.GetFriendsList)
                return object;
            return new $root.friends.GetFriendsList();
        };

        /**
         * Creates a plain object from a GetFriendsList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof friends.GetFriendsList
         * @static
         * @param {friends.GetFriendsList} message GetFriendsList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetFriendsList.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetFriendsList to JSON.
         * @function toJSON
         * @memberof friends.GetFriendsList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetFriendsList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetFriendsList.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof friends.GetFriendsList
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof friends.GetFriendsList
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {friends.GetFriendsList.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof friends.GetFriendsList.Request
             * @static
             * @param {friends.GetFriendsList.IRequest=} [properties] Properties to set
             * @returns {friends.GetFriendsList.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link friends.GetFriendsList.Request.verify|verify} messages.
             * @function encode
             * @memberof friends.GetFriendsList.Request
             * @static
             * @param {friends.GetFriendsList.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link friends.GetFriendsList.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof friends.GetFriendsList.Request
             * @static
             * @param {friends.GetFriendsList.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof friends.GetFriendsList.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {friends.GetFriendsList.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.friends.GetFriendsList.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof friends.GetFriendsList.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {friends.GetFriendsList.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof friends.GetFriendsList.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof friends.GetFriendsList.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {friends.GetFriendsList.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.friends.GetFriendsList.Request)
                    return object;
                return new $root.friends.GetFriendsList.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof friends.GetFriendsList.Request
             * @static
             * @param {friends.GetFriendsList.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof friends.GetFriendsList.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetFriendsList.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof friends.GetFriendsList
             * @interface IResponse
             * @property {Array.<friends.IFriendItem>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof friends.GetFriendsList
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {friends.GetFriendsList.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<friends.IFriendItem>} list
             * @memberof friends.GetFriendsList.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof friends.GetFriendsList.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof friends.GetFriendsList.Response
             * @static
             * @param {friends.GetFriendsList.IResponse=} [properties] Properties to set
             * @returns {friends.GetFriendsList.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link friends.GetFriendsList.Response.verify|verify} messages.
             * @function encode
             * @memberof friends.GetFriendsList.Response
             * @static
             * @param {friends.GetFriendsList.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.friends.FriendItem.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link friends.GetFriendsList.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof friends.GetFriendsList.Response
             * @static
             * @param {friends.GetFriendsList.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof friends.GetFriendsList.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {friends.GetFriendsList.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.friends.GetFriendsList.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.friends.FriendItem.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof friends.GetFriendsList.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {friends.GetFriendsList.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof friends.GetFriendsList.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.friends.FriendItem.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof friends.GetFriendsList.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {friends.GetFriendsList.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.friends.GetFriendsList.Response)
                    return object;
                var message = new $root.friends.GetFriendsList.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".friends.GetFriendsList.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".friends.GetFriendsList.Response.list: object expected");
                        message.list[i] = $root.friends.FriendItem.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof friends.GetFriendsList.Response
             * @static
             * @param {friends.GetFriendsList.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.friends.FriendItem.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof friends.GetFriendsList.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetFriendsList;
    })();

    friends.DeleteFriend = (function() {

        /**
         * Properties of a DeleteFriend.
         * @memberof friends
         * @interface IDeleteFriend
         */

        /**
         * Constructs a new DeleteFriend.
         * @memberof friends
         * @classdesc Represents a DeleteFriend.
         * @implements IDeleteFriend
         * @constructor
         * @param {friends.IDeleteFriend=} [properties] Properties to set
         */
        function DeleteFriend(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DeleteFriend instance using the specified properties.
         * @function create
         * @memberof friends.DeleteFriend
         * @static
         * @param {friends.IDeleteFriend=} [properties] Properties to set
         * @returns {friends.DeleteFriend} DeleteFriend instance
         */
        DeleteFriend.create = function create(properties) {
            return new DeleteFriend(properties);
        };

        /**
         * Encodes the specified DeleteFriend message. Does not implicitly {@link friends.DeleteFriend.verify|verify} messages.
         * @function encode
         * @memberof friends.DeleteFriend
         * @static
         * @param {friends.IDeleteFriend} message DeleteFriend message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteFriend.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified DeleteFriend message, length delimited. Does not implicitly {@link friends.DeleteFriend.verify|verify} messages.
         * @function encodeDelimited
         * @memberof friends.DeleteFriend
         * @static
         * @param {friends.IDeleteFriend} message DeleteFriend message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteFriend.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteFriend message from the specified reader or buffer.
         * @function decode
         * @memberof friends.DeleteFriend
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {friends.DeleteFriend} DeleteFriend
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteFriend.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.friends.DeleteFriend();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteFriend message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof friends.DeleteFriend
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {friends.DeleteFriend} DeleteFriend
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteFriend.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteFriend message.
         * @function verify
         * @memberof friends.DeleteFriend
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteFriend.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a DeleteFriend message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof friends.DeleteFriend
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {friends.DeleteFriend} DeleteFriend
         */
        DeleteFriend.fromObject = function fromObject(object) {
            if (object instanceof $root.friends.DeleteFriend)
                return object;
            return new $root.friends.DeleteFriend();
        };

        /**
         * Creates a plain object from a DeleteFriend message. Also converts values to other types if specified.
         * @function toObject
         * @memberof friends.DeleteFriend
         * @static
         * @param {friends.DeleteFriend} message DeleteFriend
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteFriend.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DeleteFriend to JSON.
         * @function toJSON
         * @memberof friends.DeleteFriend
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteFriend.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        DeleteFriend.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof friends.DeleteFriend
             * @interface IRequest
             * @property {number|Long|null} [friendId] Request friendId
             */

            /**
             * Constructs a new Request.
             * @memberof friends.DeleteFriend
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {friends.DeleteFriend.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request friendId.
             * @member {number|Long} friendId
             * @memberof friends.DeleteFriend.Request
             * @instance
             */
            Request.prototype.friendId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof friends.DeleteFriend.Request
             * @static
             * @param {friends.DeleteFriend.IRequest=} [properties] Properties to set
             * @returns {friends.DeleteFriend.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link friends.DeleteFriend.Request.verify|verify} messages.
             * @function encode
             * @memberof friends.DeleteFriend.Request
             * @static
             * @param {friends.DeleteFriend.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.friendId != null && Object.hasOwnProperty.call(message, "friendId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.friendId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link friends.DeleteFriend.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof friends.DeleteFriend.Request
             * @static
             * @param {friends.DeleteFriend.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof friends.DeleteFriend.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {friends.DeleteFriend.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.friends.DeleteFriend.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.friendId = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof friends.DeleteFriend.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {friends.DeleteFriend.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof friends.DeleteFriend.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.friendId != null && message.hasOwnProperty("friendId"))
                    if (!$util.isInteger(message.friendId) && !(message.friendId && $util.isInteger(message.friendId.low) && $util.isInteger(message.friendId.high)))
                        return "friendId: integer|Long expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof friends.DeleteFriend.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {friends.DeleteFriend.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.friends.DeleteFriend.Request)
                    return object;
                var message = new $root.friends.DeleteFriend.Request();
                if (object.friendId != null)
                    if ($util.Long)
                        (message.friendId = $util.Long.fromValue(object.friendId)).unsigned = false;
                    else if (typeof object.friendId === "string")
                        message.friendId = parseInt(object.friendId, 10);
                    else if (typeof object.friendId === "number")
                        message.friendId = object.friendId;
                    else if (typeof object.friendId === "object")
                        message.friendId = new $util.LongBits(object.friendId.low >>> 0, object.friendId.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof friends.DeleteFriend.Request
             * @static
             * @param {friends.DeleteFriend.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.friendId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.friendId = options.longs === String ? "0" : 0;
                if (message.friendId != null && message.hasOwnProperty("friendId"))
                    if (typeof message.friendId === "number")
                        object.friendId = options.longs === String ? String(message.friendId) : message.friendId;
                    else
                        object.friendId = options.longs === String ? $util.Long.prototype.toString.call(message.friendId) : options.longs === Number ? new $util.LongBits(message.friendId.low >>> 0, message.friendId.high >>> 0).toNumber() : message.friendId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof friends.DeleteFriend.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        DeleteFriend.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof friends.DeleteFriend
             * @interface IResponse
             * @property {number|Long|null} [friendId] Response friendId
             * @property {number|Long|null} [deleteTime] Response deleteTime
             */

            /**
             * Constructs a new Response.
             * @memberof friends.DeleteFriend
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {friends.DeleteFriend.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response friendId.
             * @member {number|Long} friendId
             * @memberof friends.DeleteFriend.Response
             * @instance
             */
            Response.prototype.friendId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Response deleteTime.
             * @member {number|Long} deleteTime
             * @memberof friends.DeleteFriend.Response
             * @instance
             */
            Response.prototype.deleteTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof friends.DeleteFriend.Response
             * @static
             * @param {friends.DeleteFriend.IResponse=} [properties] Properties to set
             * @returns {friends.DeleteFriend.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link friends.DeleteFriend.Response.verify|verify} messages.
             * @function encode
             * @memberof friends.DeleteFriend.Response
             * @static
             * @param {friends.DeleteFriend.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.friendId != null && Object.hasOwnProperty.call(message, "friendId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.friendId);
                if (message.deleteTime != null && Object.hasOwnProperty.call(message, "deleteTime"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.deleteTime);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link friends.DeleteFriend.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof friends.DeleteFriend.Response
             * @static
             * @param {friends.DeleteFriend.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof friends.DeleteFriend.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {friends.DeleteFriend.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.friends.DeleteFriend.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.friendId = reader.int64();
                        break;
                    case 2:
                        message.deleteTime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof friends.DeleteFriend.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {friends.DeleteFriend.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof friends.DeleteFriend.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.friendId != null && message.hasOwnProperty("friendId"))
                    if (!$util.isInteger(message.friendId) && !(message.friendId && $util.isInteger(message.friendId.low) && $util.isInteger(message.friendId.high)))
                        return "friendId: integer|Long expected";
                if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                    if (!$util.isInteger(message.deleteTime) && !(message.deleteTime && $util.isInteger(message.deleteTime.low) && $util.isInteger(message.deleteTime.high)))
                        return "deleteTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof friends.DeleteFriend.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {friends.DeleteFriend.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.friends.DeleteFriend.Response)
                    return object;
                var message = new $root.friends.DeleteFriend.Response();
                if (object.friendId != null)
                    if ($util.Long)
                        (message.friendId = $util.Long.fromValue(object.friendId)).unsigned = false;
                    else if (typeof object.friendId === "string")
                        message.friendId = parseInt(object.friendId, 10);
                    else if (typeof object.friendId === "number")
                        message.friendId = object.friendId;
                    else if (typeof object.friendId === "object")
                        message.friendId = new $util.LongBits(object.friendId.low >>> 0, object.friendId.high >>> 0).toNumber();
                if (object.deleteTime != null)
                    if ($util.Long)
                        (message.deleteTime = $util.Long.fromValue(object.deleteTime)).unsigned = false;
                    else if (typeof object.deleteTime === "string")
                        message.deleteTime = parseInt(object.deleteTime, 10);
                    else if (typeof object.deleteTime === "number")
                        message.deleteTime = object.deleteTime;
                    else if (typeof object.deleteTime === "object")
                        message.deleteTime = new $util.LongBits(object.deleteTime.low >>> 0, object.deleteTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof friends.DeleteFriend.Response
             * @static
             * @param {friends.DeleteFriend.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.friendId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.friendId = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.deleteTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.deleteTime = options.longs === String ? "0" : 0;
                }
                if (message.friendId != null && message.hasOwnProperty("friendId"))
                    if (typeof message.friendId === "number")
                        object.friendId = options.longs === String ? String(message.friendId) : message.friendId;
                    else
                        object.friendId = options.longs === String ? $util.Long.prototype.toString.call(message.friendId) : options.longs === Number ? new $util.LongBits(message.friendId.low >>> 0, message.friendId.high >>> 0).toNumber() : message.friendId;
                if (message.deleteTime != null && message.hasOwnProperty("deleteTime"))
                    if (typeof message.deleteTime === "number")
                        object.deleteTime = options.longs === String ? String(message.deleteTime) : message.deleteTime;
                    else
                        object.deleteTime = options.longs === String ? $util.Long.prototype.toString.call(message.deleteTime) : options.longs === Number ? new $util.LongBits(message.deleteTime.low >>> 0, message.deleteTime.high >>> 0).toNumber() : message.deleteTime;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof friends.DeleteFriend.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return DeleteFriend;
    })();

    return friends;
})();

$root.group = (function() {

    /**
     * Namespace group.
     * @exports group
     * @namespace
     */
    var group = {};

    group.GroupMembers = (function() {

        /**
         * Properties of a GroupMembers.
         * @memberof group
         * @interface IGroupMembers
         * @property {string|null} [authorId] GroupMembers authorId
         * @property {string|null} [nickname] GroupMembers nickname
         * @property {group.GroupMembers.IPermissions|null} [permissions] GroupMembers permissions
         * @property {number|Long|null} [createTime] GroupMembers createTime
         * @property {number|Long|null} [lastSeenTime] GroupMembers lastSeenTime
         * @property {string|null} [lastMessage] GroupMembers lastMessage
         * @property {number|Long|null} [lastMessageTime] GroupMembers lastMessageTime
         * @property {user.ISimpleSSOUserInfo|null} [userInfo] GroupMembers userInfo
         */

        /**
         * Constructs a new GroupMembers.
         * @memberof group
         * @classdesc Represents a GroupMembers.
         * @implements IGroupMembers
         * @constructor
         * @param {group.IGroupMembers=} [properties] Properties to set
         */
        function GroupMembers(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GroupMembers authorId.
         * @member {string} authorId
         * @memberof group.GroupMembers
         * @instance
         */
        GroupMembers.prototype.authorId = "";

        /**
         * GroupMembers nickname.
         * @member {string} nickname
         * @memberof group.GroupMembers
         * @instance
         */
        GroupMembers.prototype.nickname = "";

        /**
         * GroupMembers permissions.
         * @member {group.GroupMembers.IPermissions|null|undefined} permissions
         * @memberof group.GroupMembers
         * @instance
         */
        GroupMembers.prototype.permissions = null;

        /**
         * GroupMembers createTime.
         * @member {number|Long} createTime
         * @memberof group.GroupMembers
         * @instance
         */
        GroupMembers.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GroupMembers lastSeenTime.
         * @member {number|Long} lastSeenTime
         * @memberof group.GroupMembers
         * @instance
         */
        GroupMembers.prototype.lastSeenTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GroupMembers lastMessage.
         * @member {string} lastMessage
         * @memberof group.GroupMembers
         * @instance
         */
        GroupMembers.prototype.lastMessage = "";

        /**
         * GroupMembers lastMessageTime.
         * @member {number|Long} lastMessageTime
         * @memberof group.GroupMembers
         * @instance
         */
        GroupMembers.prototype.lastMessageTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * GroupMembers userInfo.
         * @member {user.ISimpleSSOUserInfo|null|undefined} userInfo
         * @memberof group.GroupMembers
         * @instance
         */
        GroupMembers.prototype.userInfo = null;

        /**
         * Creates a new GroupMembers instance using the specified properties.
         * @function create
         * @memberof group.GroupMembers
         * @static
         * @param {group.IGroupMembers=} [properties] Properties to set
         * @returns {group.GroupMembers} GroupMembers instance
         */
        GroupMembers.create = function create(properties) {
            return new GroupMembers(properties);
        };

        /**
         * Encodes the specified GroupMembers message. Does not implicitly {@link group.GroupMembers.verify|verify} messages.
         * @function encode
         * @memberof group.GroupMembers
         * @static
         * @param {group.IGroupMembers} message GroupMembers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupMembers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.authorId);
            if (message.nickname != null && Object.hasOwnProperty.call(message, "nickname"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nickname);
            if (message.permissions != null && Object.hasOwnProperty.call(message, "permissions"))
                $root.group.GroupMembers.Permissions.encode(message.permissions, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createTime);
            if (message.lastSeenTime != null && Object.hasOwnProperty.call(message, "lastSeenTime"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastSeenTime);
            if (message.userInfo != null && Object.hasOwnProperty.call(message, "userInfo"))
                $root.user.SimpleSSOUserInfo.encode(message.userInfo, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.lastMessageTime != null && Object.hasOwnProperty.call(message, "lastMessageTime"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastMessageTime);
            if (message.lastMessage != null && Object.hasOwnProperty.call(message, "lastMessage"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.lastMessage);
            return writer;
        };

        /**
         * Encodes the specified GroupMembers message, length delimited. Does not implicitly {@link group.GroupMembers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.GroupMembers
         * @static
         * @param {group.IGroupMembers} message GroupMembers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupMembers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GroupMembers message from the specified reader or buffer.
         * @function decode
         * @memberof group.GroupMembers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.GroupMembers} GroupMembers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupMembers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GroupMembers();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.authorId = reader.string();
                    break;
                case 2:
                    message.nickname = reader.string();
                    break;
                case 3:
                    message.permissions = $root.group.GroupMembers.Permissions.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.createTime = reader.int64();
                    break;
                case 5:
                    message.lastSeenTime = reader.int64();
                    break;
                case 8:
                    message.lastMessage = reader.string();
                    break;
                case 7:
                    message.lastMessageTime = reader.int64();
                    break;
                case 6:
                    message.userInfo = $root.user.SimpleSSOUserInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GroupMembers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.GroupMembers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.GroupMembers} GroupMembers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupMembers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GroupMembers message.
         * @function verify
         * @memberof group.GroupMembers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GroupMembers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                if (!$util.isString(message.authorId))
                    return "authorId: string expected";
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                if (!$util.isString(message.nickname))
                    return "nickname: string expected";
            if (message.permissions != null && message.hasOwnProperty("permissions")) {
                var error = $root.group.GroupMembers.Permissions.verify(message.permissions);
                if (error)
                    return "permissions." + error;
            }
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (!$util.isInteger(message.lastSeenTime) && !(message.lastSeenTime && $util.isInteger(message.lastSeenTime.low) && $util.isInteger(message.lastSeenTime.high)))
                    return "lastSeenTime: integer|Long expected";
            if (message.lastMessage != null && message.hasOwnProperty("lastMessage"))
                if (!$util.isString(message.lastMessage))
                    return "lastMessage: string expected";
            if (message.lastMessageTime != null && message.hasOwnProperty("lastMessageTime"))
                if (!$util.isInteger(message.lastMessageTime) && !(message.lastMessageTime && $util.isInteger(message.lastMessageTime.low) && $util.isInteger(message.lastMessageTime.high)))
                    return "lastMessageTime: integer|Long expected";
            if (message.userInfo != null && message.hasOwnProperty("userInfo")) {
                var error = $root.user.SimpleSSOUserInfo.verify(message.userInfo);
                if (error)
                    return "userInfo." + error;
            }
            return null;
        };

        /**
         * Creates a GroupMembers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.GroupMembers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.GroupMembers} GroupMembers
         */
        GroupMembers.fromObject = function fromObject(object) {
            if (object instanceof $root.group.GroupMembers)
                return object;
            var message = new $root.group.GroupMembers();
            if (object.authorId != null)
                message.authorId = String(object.authorId);
            if (object.nickname != null)
                message.nickname = String(object.nickname);
            if (object.permissions != null) {
                if (typeof object.permissions !== "object")
                    throw TypeError(".group.GroupMembers.permissions: object expected");
                message.permissions = $root.group.GroupMembers.Permissions.fromObject(object.permissions);
            }
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.lastSeenTime != null)
                if ($util.Long)
                    (message.lastSeenTime = $util.Long.fromValue(object.lastSeenTime)).unsigned = false;
                else if (typeof object.lastSeenTime === "string")
                    message.lastSeenTime = parseInt(object.lastSeenTime, 10);
                else if (typeof object.lastSeenTime === "number")
                    message.lastSeenTime = object.lastSeenTime;
                else if (typeof object.lastSeenTime === "object")
                    message.lastSeenTime = new $util.LongBits(object.lastSeenTime.low >>> 0, object.lastSeenTime.high >>> 0).toNumber();
            if (object.lastMessage != null)
                message.lastMessage = String(object.lastMessage);
            if (object.lastMessageTime != null)
                if ($util.Long)
                    (message.lastMessageTime = $util.Long.fromValue(object.lastMessageTime)).unsigned = false;
                else if (typeof object.lastMessageTime === "string")
                    message.lastMessageTime = parseInt(object.lastMessageTime, 10);
                else if (typeof object.lastMessageTime === "number")
                    message.lastMessageTime = object.lastMessageTime;
                else if (typeof object.lastMessageTime === "object")
                    message.lastMessageTime = new $util.LongBits(object.lastMessageTime.low >>> 0, object.lastMessageTime.high >>> 0).toNumber();
            if (object.userInfo != null) {
                if (typeof object.userInfo !== "object")
                    throw TypeError(".group.GroupMembers.userInfo: object expected");
                message.userInfo = $root.user.SimpleSSOUserInfo.fromObject(object.userInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a GroupMembers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.GroupMembers
         * @static
         * @param {group.GroupMembers} message GroupMembers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GroupMembers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.authorId = "";
                object.nickname = "";
                object.permissions = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastSeenTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastSeenTime = options.longs === String ? "0" : 0;
                object.userInfo = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastMessageTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastMessageTime = options.longs === String ? "0" : 0;
                object.lastMessage = "";
            }
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                object.authorId = message.authorId;
            if (message.nickname != null && message.hasOwnProperty("nickname"))
                object.nickname = message.nickname;
            if (message.permissions != null && message.hasOwnProperty("permissions"))
                object.permissions = $root.group.GroupMembers.Permissions.toObject(message.permissions, options);
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.lastSeenTime != null && message.hasOwnProperty("lastSeenTime"))
                if (typeof message.lastSeenTime === "number")
                    object.lastSeenTime = options.longs === String ? String(message.lastSeenTime) : message.lastSeenTime;
                else
                    object.lastSeenTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastSeenTime) : options.longs === Number ? new $util.LongBits(message.lastSeenTime.low >>> 0, message.lastSeenTime.high >>> 0).toNumber() : message.lastSeenTime;
            if (message.userInfo != null && message.hasOwnProperty("userInfo"))
                object.userInfo = $root.user.SimpleSSOUserInfo.toObject(message.userInfo, options);
            if (message.lastMessageTime != null && message.hasOwnProperty("lastMessageTime"))
                if (typeof message.lastMessageTime === "number")
                    object.lastMessageTime = options.longs === String ? String(message.lastMessageTime) : message.lastMessageTime;
                else
                    object.lastMessageTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastMessageTime) : options.longs === Number ? new $util.LongBits(message.lastMessageTime.low >>> 0, message.lastMessageTime.high >>> 0).toNumber() : message.lastMessageTime;
            if (message.lastMessage != null && message.hasOwnProperty("lastMessage"))
                object.lastMessage = message.lastMessage;
            return object;
        };

        /**
         * Converts this GroupMembers to JSON.
         * @function toJSON
         * @memberof group.GroupMembers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GroupMembers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GroupMembers.Permissions = (function() {

            /**
             * Properties of a Permissions.
             * @memberof group.GroupMembers
             * @interface IPermissions
             * @property {boolean|null} [receiveMessage] Permissions receiveMessage
             */

            /**
             * Constructs a new Permissions.
             * @memberof group.GroupMembers
             * @classdesc Represents a Permissions.
             * @implements IPermissions
             * @constructor
             * @param {group.GroupMembers.IPermissions=} [properties] Properties to set
             */
            function Permissions(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Permissions receiveMessage.
             * @member {boolean} receiveMessage
             * @memberof group.GroupMembers.Permissions
             * @instance
             */
            Permissions.prototype.receiveMessage = false;

            /**
             * Creates a new Permissions instance using the specified properties.
             * @function create
             * @memberof group.GroupMembers.Permissions
             * @static
             * @param {group.GroupMembers.IPermissions=} [properties] Properties to set
             * @returns {group.GroupMembers.Permissions} Permissions instance
             */
            Permissions.create = function create(properties) {
                return new Permissions(properties);
            };

            /**
             * Encodes the specified Permissions message. Does not implicitly {@link group.GroupMembers.Permissions.verify|verify} messages.
             * @function encode
             * @memberof group.GroupMembers.Permissions
             * @static
             * @param {group.GroupMembers.IPermissions} message Permissions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Permissions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.receiveMessage != null && Object.hasOwnProperty.call(message, "receiveMessage"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.receiveMessage);
                return writer;
            };

            /**
             * Encodes the specified Permissions message, length delimited. Does not implicitly {@link group.GroupMembers.Permissions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.GroupMembers.Permissions
             * @static
             * @param {group.GroupMembers.IPermissions} message Permissions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Permissions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Permissions message from the specified reader or buffer.
             * @function decode
             * @memberof group.GroupMembers.Permissions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.GroupMembers.Permissions} Permissions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Permissions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GroupMembers.Permissions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.receiveMessage = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Permissions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.GroupMembers.Permissions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.GroupMembers.Permissions} Permissions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Permissions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Permissions message.
             * @function verify
             * @memberof group.GroupMembers.Permissions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Permissions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.receiveMessage != null && message.hasOwnProperty("receiveMessage"))
                    if (typeof message.receiveMessage !== "boolean")
                        return "receiveMessage: boolean expected";
                return null;
            };

            /**
             * Creates a Permissions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.GroupMembers.Permissions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.GroupMembers.Permissions} Permissions
             */
            Permissions.fromObject = function fromObject(object) {
                if (object instanceof $root.group.GroupMembers.Permissions)
                    return object;
                var message = new $root.group.GroupMembers.Permissions();
                if (object.receiveMessage != null)
                    message.receiveMessage = Boolean(object.receiveMessage);
                return message;
            };

            /**
             * Creates a plain object from a Permissions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.GroupMembers.Permissions
             * @static
             * @param {group.GroupMembers.Permissions} message Permissions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Permissions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.receiveMessage = false;
                if (message.receiveMessage != null && message.hasOwnProperty("receiveMessage"))
                    object.receiveMessage = message.receiveMessage;
                return object;
            };

            /**
             * Converts this Permissions to JSON.
             * @function toJSON
             * @memberof group.GroupMembers.Permissions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Permissions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Permissions;
        })();

        return GroupMembers;
    })();

    group.Group = (function() {

        /**
         * Properties of a Group.
         * @memberof group
         * @interface IGroup
         * @property {string|null} [id] Group id
         * @property {string|null} [authorId] Group authorId
         * @property {string|null} [name] Group name
         * @property {string|null} [avatar] Group avatar
         * @property {group.Group.IPermissions|null} [permissions] Group permissions
         * @property {number|Long|null} [members] Group members
         * @property {number|Long|null} [status] Group status
         * @property {number|Long|null} [createTime] Group createTime
         * @property {number|Long|null} [lastUpdateTime] Group lastUpdateTime
         * @property {string|null} [lastMessage] Group lastMessage
         * @property {number|Long|null} [lastMessageTime] Group lastMessageTime
         * @property {group.IGroupMembers|null} [ownMemberInfo] Group ownMemberInfo
         */

        /**
         * Constructs a new Group.
         * @memberof group
         * @classdesc Represents a Group.
         * @implements IGroup
         * @constructor
         * @param {group.IGroup=} [properties] Properties to set
         */
        function Group(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Group id.
         * @member {string} id
         * @memberof group.Group
         * @instance
         */
        Group.prototype.id = "";

        /**
         * Group authorId.
         * @member {string} authorId
         * @memberof group.Group
         * @instance
         */
        Group.prototype.authorId = "";

        /**
         * Group name.
         * @member {string} name
         * @memberof group.Group
         * @instance
         */
        Group.prototype.name = "";

        /**
         * Group avatar.
         * @member {string} avatar
         * @memberof group.Group
         * @instance
         */
        Group.prototype.avatar = "";

        /**
         * Group permissions.
         * @member {group.Group.IPermissions|null|undefined} permissions
         * @memberof group.Group
         * @instance
         */
        Group.prototype.permissions = null;

        /**
         * Group members.
         * @member {number|Long} members
         * @memberof group.Group
         * @instance
         */
        Group.prototype.members = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Group status.
         * @member {number|Long} status
         * @memberof group.Group
         * @instance
         */
        Group.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Group createTime.
         * @member {number|Long} createTime
         * @memberof group.Group
         * @instance
         */
        Group.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Group lastUpdateTime.
         * @member {number|Long} lastUpdateTime
         * @memberof group.Group
         * @instance
         */
        Group.prototype.lastUpdateTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Group lastMessage.
         * @member {string} lastMessage
         * @memberof group.Group
         * @instance
         */
        Group.prototype.lastMessage = "";

        /**
         * Group lastMessageTime.
         * @member {number|Long} lastMessageTime
         * @memberof group.Group
         * @instance
         */
        Group.prototype.lastMessageTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Group ownMemberInfo.
         * @member {group.IGroupMembers|null|undefined} ownMemberInfo
         * @memberof group.Group
         * @instance
         */
        Group.prototype.ownMemberInfo = null;

        /**
         * Creates a new Group instance using the specified properties.
         * @function create
         * @memberof group.Group
         * @static
         * @param {group.IGroup=} [properties] Properties to set
         * @returns {group.Group} Group instance
         */
        Group.create = function create(properties) {
            return new Group(properties);
        };

        /**
         * Encodes the specified Group message. Does not implicitly {@link group.Group.verify|verify} messages.
         * @function encode
         * @memberof group.Group
         * @static
         * @param {group.IGroup} message Group message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Group.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.authorId);
            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
            if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.avatar);
            if (message.permissions != null && Object.hasOwnProperty.call(message, "permissions"))
                $root.group.Group.Permissions.encode(message.permissions, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 6, wireType 0 =*/48).int64(message.status);
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTime);
            if (message.lastMessageTime != null && Object.hasOwnProperty.call(message, "lastMessageTime"))
                writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastMessageTime);
            if (message.ownMemberInfo != null && Object.hasOwnProperty.call(message, "ownMemberInfo"))
                $root.group.GroupMembers.encode(message.ownMemberInfo, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.lastMessage != null && Object.hasOwnProperty.call(message, "lastMessage"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.lastMessage);
            if (message.members != null && Object.hasOwnProperty.call(message, "members"))
                writer.uint32(/* id 11, wireType 0 =*/88).int64(message.members);
            if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.lastUpdateTime);
            return writer;
        };

        /**
         * Encodes the specified Group message, length delimited. Does not implicitly {@link group.Group.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.Group
         * @static
         * @param {group.IGroup} message Group message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Group.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Group message from the specified reader or buffer.
         * @function decode
         * @memberof group.Group
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.Group} Group
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Group.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.Group();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.authorId = reader.string();
                    break;
                case 3:
                    message.name = reader.string();
                    break;
                case 4:
                    message.avatar = reader.string();
                    break;
                case 5:
                    message.permissions = $root.group.Group.Permissions.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.members = reader.int64();
                    break;
                case 6:
                    message.status = reader.int64();
                    break;
                case 7:
                    message.createTime = reader.int64();
                    break;
                case 12:
                    message.lastUpdateTime = reader.int64();
                    break;
                case 10:
                    message.lastMessage = reader.string();
                    break;
                case 8:
                    message.lastMessageTime = reader.int64();
                    break;
                case 9:
                    message.ownMemberInfo = $root.group.GroupMembers.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Group message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.Group
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.Group} Group
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Group.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Group message.
         * @function verify
         * @memberof group.Group
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Group.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                if (!$util.isString(message.authorId))
                    return "authorId: string expected";
            if (message.name != null && message.hasOwnProperty("name"))
                if (!$util.isString(message.name))
                    return "name: string expected";
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                if (!$util.isString(message.avatar))
                    return "avatar: string expected";
            if (message.permissions != null && message.hasOwnProperty("permissions")) {
                var error = $root.group.Group.Permissions.verify(message.permissions);
                if (error)
                    return "permissions." + error;
            }
            if (message.members != null && message.hasOwnProperty("members"))
                if (!$util.isInteger(message.members) && !(message.members && $util.isInteger(message.members.low) && $util.isInteger(message.members.high)))
                    return "members: integer|Long expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (!$util.isInteger(message.lastUpdateTime) && !(message.lastUpdateTime && $util.isInteger(message.lastUpdateTime.low) && $util.isInteger(message.lastUpdateTime.high)))
                    return "lastUpdateTime: integer|Long expected";
            if (message.lastMessage != null && message.hasOwnProperty("lastMessage"))
                if (!$util.isString(message.lastMessage))
                    return "lastMessage: string expected";
            if (message.lastMessageTime != null && message.hasOwnProperty("lastMessageTime"))
                if (!$util.isInteger(message.lastMessageTime) && !(message.lastMessageTime && $util.isInteger(message.lastMessageTime.low) && $util.isInteger(message.lastMessageTime.high)))
                    return "lastMessageTime: integer|Long expected";
            if (message.ownMemberInfo != null && message.hasOwnProperty("ownMemberInfo")) {
                var error = $root.group.GroupMembers.verify(message.ownMemberInfo);
                if (error)
                    return "ownMemberInfo." + error;
            }
            return null;
        };

        /**
         * Creates a Group message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.Group
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.Group} Group
         */
        Group.fromObject = function fromObject(object) {
            if (object instanceof $root.group.Group)
                return object;
            var message = new $root.group.Group();
            if (object.id != null)
                message.id = String(object.id);
            if (object.authorId != null)
                message.authorId = String(object.authorId);
            if (object.name != null)
                message.name = String(object.name);
            if (object.avatar != null)
                message.avatar = String(object.avatar);
            if (object.permissions != null) {
                if (typeof object.permissions !== "object")
                    throw TypeError(".group.Group.permissions: object expected");
                message.permissions = $root.group.Group.Permissions.fromObject(object.permissions);
            }
            if (object.members != null)
                if ($util.Long)
                    (message.members = $util.Long.fromValue(object.members)).unsigned = false;
                else if (typeof object.members === "string")
                    message.members = parseInt(object.members, 10);
                else if (typeof object.members === "number")
                    message.members = object.members;
                else if (typeof object.members === "object")
                    message.members = new $util.LongBits(object.members.low >>> 0, object.members.high >>> 0).toNumber();
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.lastUpdateTime != null)
                if ($util.Long)
                    (message.lastUpdateTime = $util.Long.fromValue(object.lastUpdateTime)).unsigned = false;
                else if (typeof object.lastUpdateTime === "string")
                    message.lastUpdateTime = parseInt(object.lastUpdateTime, 10);
                else if (typeof object.lastUpdateTime === "number")
                    message.lastUpdateTime = object.lastUpdateTime;
                else if (typeof object.lastUpdateTime === "object")
                    message.lastUpdateTime = new $util.LongBits(object.lastUpdateTime.low >>> 0, object.lastUpdateTime.high >>> 0).toNumber();
            if (object.lastMessage != null)
                message.lastMessage = String(object.lastMessage);
            if (object.lastMessageTime != null)
                if ($util.Long)
                    (message.lastMessageTime = $util.Long.fromValue(object.lastMessageTime)).unsigned = false;
                else if (typeof object.lastMessageTime === "string")
                    message.lastMessageTime = parseInt(object.lastMessageTime, 10);
                else if (typeof object.lastMessageTime === "number")
                    message.lastMessageTime = object.lastMessageTime;
                else if (typeof object.lastMessageTime === "object")
                    message.lastMessageTime = new $util.LongBits(object.lastMessageTime.low >>> 0, object.lastMessageTime.high >>> 0).toNumber();
            if (object.ownMemberInfo != null) {
                if (typeof object.ownMemberInfo !== "object")
                    throw TypeError(".group.Group.ownMemberInfo: object expected");
                message.ownMemberInfo = $root.group.GroupMembers.fromObject(object.ownMemberInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a Group message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.Group
         * @static
         * @param {group.Group} message Group
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Group.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.id = "";
                object.authorId = "";
                object.name = "";
                object.avatar = "";
                object.permissions = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastMessageTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastMessageTime = options.longs === String ? "0" : 0;
                object.ownMemberInfo = null;
                object.lastMessage = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.members = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.members = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastUpdateTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastUpdateTime = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                object.authorId = message.authorId;
            if (message.name != null && message.hasOwnProperty("name"))
                object.name = message.name;
            if (message.avatar != null && message.hasOwnProperty("avatar"))
                object.avatar = message.avatar;
            if (message.permissions != null && message.hasOwnProperty("permissions"))
                object.permissions = $root.group.Group.Permissions.toObject(message.permissions, options);
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.lastMessageTime != null && message.hasOwnProperty("lastMessageTime"))
                if (typeof message.lastMessageTime === "number")
                    object.lastMessageTime = options.longs === String ? String(message.lastMessageTime) : message.lastMessageTime;
                else
                    object.lastMessageTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastMessageTime) : options.longs === Number ? new $util.LongBits(message.lastMessageTime.low >>> 0, message.lastMessageTime.high >>> 0).toNumber() : message.lastMessageTime;
            if (message.ownMemberInfo != null && message.hasOwnProperty("ownMemberInfo"))
                object.ownMemberInfo = $root.group.GroupMembers.toObject(message.ownMemberInfo, options);
            if (message.lastMessage != null && message.hasOwnProperty("lastMessage"))
                object.lastMessage = message.lastMessage;
            if (message.members != null && message.hasOwnProperty("members"))
                if (typeof message.members === "number")
                    object.members = options.longs === String ? String(message.members) : message.members;
                else
                    object.members = options.longs === String ? $util.Long.prototype.toString.call(message.members) : options.longs === Number ? new $util.LongBits(message.members.low >>> 0, message.members.high >>> 0).toNumber() : message.members;
            if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                if (typeof message.lastUpdateTime === "number")
                    object.lastUpdateTime = options.longs === String ? String(message.lastUpdateTime) : message.lastUpdateTime;
                else
                    object.lastUpdateTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTime) : options.longs === Number ? new $util.LongBits(message.lastUpdateTime.low >>> 0, message.lastUpdateTime.high >>> 0).toNumber() : message.lastUpdateTime;
            return object;
        };

        /**
         * Converts this Group to JSON.
         * @function toJSON
         * @memberof group.Group
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Group.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Group.Permissions = (function() {

            /**
             * Properties of a Permissions.
             * @memberof group.Group
             * @interface IPermissions
             * @property {number|Long|null} [maximumMembers] Permissions maximumMembers
             * @property {boolean|null} [allowMembersJoin] Permissions allowMembersJoin
             * @property {boolean|null} [allowMembersChat] Permissions allowMembersChat
             * @property {boolean|null} [joinWithoutAuthentication] Permissions joinWithoutAuthentication
             * @property {Array.<group.Group.Permissions.IAdministratorList>|null} [administratorList] Permissions administratorList
             */

            /**
             * Constructs a new Permissions.
             * @memberof group.Group
             * @classdesc Represents a Permissions.
             * @implements IPermissions
             * @constructor
             * @param {group.Group.IPermissions=} [properties] Properties to set
             */
            function Permissions(properties) {
                this.administratorList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Permissions maximumMembers.
             * @member {number|Long} maximumMembers
             * @memberof group.Group.Permissions
             * @instance
             */
            Permissions.prototype.maximumMembers = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Permissions allowMembersJoin.
             * @member {boolean} allowMembersJoin
             * @memberof group.Group.Permissions
             * @instance
             */
            Permissions.prototype.allowMembersJoin = false;

            /**
             * Permissions allowMembersChat.
             * @member {boolean} allowMembersChat
             * @memberof group.Group.Permissions
             * @instance
             */
            Permissions.prototype.allowMembersChat = false;

            /**
             * Permissions joinWithoutAuthentication.
             * @member {boolean} joinWithoutAuthentication
             * @memberof group.Group.Permissions
             * @instance
             */
            Permissions.prototype.joinWithoutAuthentication = false;

            /**
             * Permissions administratorList.
             * @member {Array.<group.Group.Permissions.IAdministratorList>} administratorList
             * @memberof group.Group.Permissions
             * @instance
             */
            Permissions.prototype.administratorList = $util.emptyArray;

            /**
             * Creates a new Permissions instance using the specified properties.
             * @function create
             * @memberof group.Group.Permissions
             * @static
             * @param {group.Group.IPermissions=} [properties] Properties to set
             * @returns {group.Group.Permissions} Permissions instance
             */
            Permissions.create = function create(properties) {
                return new Permissions(properties);
            };

            /**
             * Encodes the specified Permissions message. Does not implicitly {@link group.Group.Permissions.verify|verify} messages.
             * @function encode
             * @memberof group.Group.Permissions
             * @static
             * @param {group.Group.IPermissions} message Permissions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Permissions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.maximumMembers != null && Object.hasOwnProperty.call(message, "maximumMembers"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int64(message.maximumMembers);
                if (message.allowMembersJoin != null && Object.hasOwnProperty.call(message, "allowMembersJoin"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.allowMembersJoin);
                if (message.allowMembersChat != null && Object.hasOwnProperty.call(message, "allowMembersChat"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.allowMembersChat);
                if (message.joinWithoutAuthentication != null && Object.hasOwnProperty.call(message, "joinWithoutAuthentication"))
                    writer.uint32(/* id 4, wireType 0 =*/32).bool(message.joinWithoutAuthentication);
                if (message.administratorList != null && message.administratorList.length)
                    for (var i = 0; i < message.administratorList.length; ++i)
                        $root.group.Group.Permissions.AdministratorList.encode(message.administratorList[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Permissions message, length delimited. Does not implicitly {@link group.Group.Permissions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.Group.Permissions
             * @static
             * @param {group.Group.IPermissions} message Permissions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Permissions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Permissions message from the specified reader or buffer.
             * @function decode
             * @memberof group.Group.Permissions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.Group.Permissions} Permissions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Permissions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.Group.Permissions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.maximumMembers = reader.int64();
                        break;
                    case 2:
                        message.allowMembersJoin = reader.bool();
                        break;
                    case 3:
                        message.allowMembersChat = reader.bool();
                        break;
                    case 4:
                        message.joinWithoutAuthentication = reader.bool();
                        break;
                    case 5:
                        if (!(message.administratorList && message.administratorList.length))
                            message.administratorList = [];
                        message.administratorList.push($root.group.Group.Permissions.AdministratorList.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Permissions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.Group.Permissions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.Group.Permissions} Permissions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Permissions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Permissions message.
             * @function verify
             * @memberof group.Group.Permissions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Permissions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.maximumMembers != null && message.hasOwnProperty("maximumMembers"))
                    if (!$util.isInteger(message.maximumMembers) && !(message.maximumMembers && $util.isInteger(message.maximumMembers.low) && $util.isInteger(message.maximumMembers.high)))
                        return "maximumMembers: integer|Long expected";
                if (message.allowMembersJoin != null && message.hasOwnProperty("allowMembersJoin"))
                    if (typeof message.allowMembersJoin !== "boolean")
                        return "allowMembersJoin: boolean expected";
                if (message.allowMembersChat != null && message.hasOwnProperty("allowMembersChat"))
                    if (typeof message.allowMembersChat !== "boolean")
                        return "allowMembersChat: boolean expected";
                if (message.joinWithoutAuthentication != null && message.hasOwnProperty("joinWithoutAuthentication"))
                    if (typeof message.joinWithoutAuthentication !== "boolean")
                        return "joinWithoutAuthentication: boolean expected";
                if (message.administratorList != null && message.hasOwnProperty("administratorList")) {
                    if (!Array.isArray(message.administratorList))
                        return "administratorList: array expected";
                    for (var i = 0; i < message.administratorList.length; ++i) {
                        var error = $root.group.Group.Permissions.AdministratorList.verify(message.administratorList[i]);
                        if (error)
                            return "administratorList." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Permissions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.Group.Permissions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.Group.Permissions} Permissions
             */
            Permissions.fromObject = function fromObject(object) {
                if (object instanceof $root.group.Group.Permissions)
                    return object;
                var message = new $root.group.Group.Permissions();
                if (object.maximumMembers != null)
                    if ($util.Long)
                        (message.maximumMembers = $util.Long.fromValue(object.maximumMembers)).unsigned = false;
                    else if (typeof object.maximumMembers === "string")
                        message.maximumMembers = parseInt(object.maximumMembers, 10);
                    else if (typeof object.maximumMembers === "number")
                        message.maximumMembers = object.maximumMembers;
                    else if (typeof object.maximumMembers === "object")
                        message.maximumMembers = new $util.LongBits(object.maximumMembers.low >>> 0, object.maximumMembers.high >>> 0).toNumber();
                if (object.allowMembersJoin != null)
                    message.allowMembersJoin = Boolean(object.allowMembersJoin);
                if (object.allowMembersChat != null)
                    message.allowMembersChat = Boolean(object.allowMembersChat);
                if (object.joinWithoutAuthentication != null)
                    message.joinWithoutAuthentication = Boolean(object.joinWithoutAuthentication);
                if (object.administratorList) {
                    if (!Array.isArray(object.administratorList))
                        throw TypeError(".group.Group.Permissions.administratorList: array expected");
                    message.administratorList = [];
                    for (var i = 0; i < object.administratorList.length; ++i) {
                        if (typeof object.administratorList[i] !== "object")
                            throw TypeError(".group.Group.Permissions.administratorList: object expected");
                        message.administratorList[i] = $root.group.Group.Permissions.AdministratorList.fromObject(object.administratorList[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Permissions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.Group.Permissions
             * @static
             * @param {group.Group.Permissions} message Permissions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Permissions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.administratorList = [];
                if (options.defaults) {
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.maximumMembers = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.maximumMembers = options.longs === String ? "0" : 0;
                    object.allowMembersJoin = false;
                    object.allowMembersChat = false;
                    object.joinWithoutAuthentication = false;
                }
                if (message.maximumMembers != null && message.hasOwnProperty("maximumMembers"))
                    if (typeof message.maximumMembers === "number")
                        object.maximumMembers = options.longs === String ? String(message.maximumMembers) : message.maximumMembers;
                    else
                        object.maximumMembers = options.longs === String ? $util.Long.prototype.toString.call(message.maximumMembers) : options.longs === Number ? new $util.LongBits(message.maximumMembers.low >>> 0, message.maximumMembers.high >>> 0).toNumber() : message.maximumMembers;
                if (message.allowMembersJoin != null && message.hasOwnProperty("allowMembersJoin"))
                    object.allowMembersJoin = message.allowMembersJoin;
                if (message.allowMembersChat != null && message.hasOwnProperty("allowMembersChat"))
                    object.allowMembersChat = message.allowMembersChat;
                if (message.joinWithoutAuthentication != null && message.hasOwnProperty("joinWithoutAuthentication"))
                    object.joinWithoutAuthentication = message.joinWithoutAuthentication;
                if (message.administratorList && message.administratorList.length) {
                    object.administratorList = [];
                    for (var j = 0; j < message.administratorList.length; ++j)
                        object.administratorList[j] = $root.group.Group.Permissions.AdministratorList.toObject(message.administratorList[j], options);
                }
                return object;
            };

            /**
             * Converts this Permissions to JSON.
             * @function toJSON
             * @memberof group.Group.Permissions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Permissions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Permissions.AdministratorList = (function() {

                /**
                 * Properties of an AdministratorList.
                 * @memberof group.Group.Permissions
                 * @interface IAdministratorList
                 * @property {string|null} [uid] AdministratorList uid
                 */

                /**
                 * Constructs a new AdministratorList.
                 * @memberof group.Group.Permissions
                 * @classdesc Represents an AdministratorList.
                 * @implements IAdministratorList
                 * @constructor
                 * @param {group.Group.Permissions.IAdministratorList=} [properties] Properties to set
                 */
                function AdministratorList(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AdministratorList uid.
                 * @member {string} uid
                 * @memberof group.Group.Permissions.AdministratorList
                 * @instance
                 */
                AdministratorList.prototype.uid = "";

                /**
                 * Creates a new AdministratorList instance using the specified properties.
                 * @function create
                 * @memberof group.Group.Permissions.AdministratorList
                 * @static
                 * @param {group.Group.Permissions.IAdministratorList=} [properties] Properties to set
                 * @returns {group.Group.Permissions.AdministratorList} AdministratorList instance
                 */
                AdministratorList.create = function create(properties) {
                    return new AdministratorList(properties);
                };

                /**
                 * Encodes the specified AdministratorList message. Does not implicitly {@link group.Group.Permissions.AdministratorList.verify|verify} messages.
                 * @function encode
                 * @memberof group.Group.Permissions.AdministratorList
                 * @static
                 * @param {group.Group.Permissions.IAdministratorList} message AdministratorList message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AdministratorList.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
                    return writer;
                };

                /**
                 * Encodes the specified AdministratorList message, length delimited. Does not implicitly {@link group.Group.Permissions.AdministratorList.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof group.Group.Permissions.AdministratorList
                 * @static
                 * @param {group.Group.Permissions.IAdministratorList} message AdministratorList message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AdministratorList.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AdministratorList message from the specified reader or buffer.
                 * @function decode
                 * @memberof group.Group.Permissions.AdministratorList
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {group.Group.Permissions.AdministratorList} AdministratorList
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AdministratorList.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.Group.Permissions.AdministratorList();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.uid = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AdministratorList message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof group.Group.Permissions.AdministratorList
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {group.Group.Permissions.AdministratorList} AdministratorList
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AdministratorList.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AdministratorList message.
                 * @function verify
                 * @memberof group.Group.Permissions.AdministratorList
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AdministratorList.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.uid != null && message.hasOwnProperty("uid"))
                        if (!$util.isString(message.uid))
                            return "uid: string expected";
                    return null;
                };

                /**
                 * Creates an AdministratorList message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof group.Group.Permissions.AdministratorList
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {group.Group.Permissions.AdministratorList} AdministratorList
                 */
                AdministratorList.fromObject = function fromObject(object) {
                    if (object instanceof $root.group.Group.Permissions.AdministratorList)
                        return object;
                    var message = new $root.group.Group.Permissions.AdministratorList();
                    if (object.uid != null)
                        message.uid = String(object.uid);
                    return message;
                };

                /**
                 * Creates a plain object from an AdministratorList message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof group.Group.Permissions.AdministratorList
                 * @static
                 * @param {group.Group.Permissions.AdministratorList} message AdministratorList
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AdministratorList.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.uid = "";
                    if (message.uid != null && message.hasOwnProperty("uid"))
                        object.uid = message.uid;
                    return object;
                };

                /**
                 * Converts this AdministratorList to JSON.
                 * @function toJSON
                 * @memberof group.Group.Permissions.AdministratorList
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AdministratorList.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AdministratorList;
            })();

            return Permissions;
        })();

        return Group;
    })();

    group.GroupMemberUpdateParams = (function() {

        /**
         * Properties of a GroupMemberUpdateParams.
         * @memberof group
         * @interface IGroupMemberUpdateParams
         * @property {string|null} [type] GroupMemberUpdateParams type
         * @property {string|null} [uid] GroupMemberUpdateParams uid
         */

        /**
         * Constructs a new GroupMemberUpdateParams.
         * @memberof group
         * @classdesc Represents a GroupMemberUpdateParams.
         * @implements IGroupMemberUpdateParams
         * @constructor
         * @param {group.IGroupMemberUpdateParams=} [properties] Properties to set
         */
        function GroupMemberUpdateParams(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GroupMemberUpdateParams type.
         * @member {string} type
         * @memberof group.GroupMemberUpdateParams
         * @instance
         */
        GroupMemberUpdateParams.prototype.type = "";

        /**
         * GroupMemberUpdateParams uid.
         * @member {string} uid
         * @memberof group.GroupMemberUpdateParams
         * @instance
         */
        GroupMemberUpdateParams.prototype.uid = "";

        /**
         * Creates a new GroupMemberUpdateParams instance using the specified properties.
         * @function create
         * @memberof group.GroupMemberUpdateParams
         * @static
         * @param {group.IGroupMemberUpdateParams=} [properties] Properties to set
         * @returns {group.GroupMemberUpdateParams} GroupMemberUpdateParams instance
         */
        GroupMemberUpdateParams.create = function create(properties) {
            return new GroupMemberUpdateParams(properties);
        };

        /**
         * Encodes the specified GroupMemberUpdateParams message. Does not implicitly {@link group.GroupMemberUpdateParams.verify|verify} messages.
         * @function encode
         * @memberof group.GroupMemberUpdateParams
         * @static
         * @param {group.IGroupMemberUpdateParams} message GroupMemberUpdateParams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupMemberUpdateParams.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.uid);
            return writer;
        };

        /**
         * Encodes the specified GroupMemberUpdateParams message, length delimited. Does not implicitly {@link group.GroupMemberUpdateParams.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.GroupMemberUpdateParams
         * @static
         * @param {group.IGroupMemberUpdateParams} message GroupMemberUpdateParams message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GroupMemberUpdateParams.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GroupMemberUpdateParams message from the specified reader or buffer.
         * @function decode
         * @memberof group.GroupMemberUpdateParams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.GroupMemberUpdateParams} GroupMemberUpdateParams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupMemberUpdateParams.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GroupMemberUpdateParams();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.uid = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GroupMemberUpdateParams message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.GroupMemberUpdateParams
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.GroupMemberUpdateParams} GroupMemberUpdateParams
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GroupMemberUpdateParams.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GroupMemberUpdateParams message.
         * @function verify
         * @memberof group.GroupMemberUpdateParams
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GroupMemberUpdateParams.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            return null;
        };

        /**
         * Creates a GroupMemberUpdateParams message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.GroupMemberUpdateParams
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.GroupMemberUpdateParams} GroupMemberUpdateParams
         */
        GroupMemberUpdateParams.fromObject = function fromObject(object) {
            if (object instanceof $root.group.GroupMemberUpdateParams)
                return object;
            var message = new $root.group.GroupMemberUpdateParams();
            if (object.type != null)
                message.type = String(object.type);
            if (object.uid != null)
                message.uid = String(object.uid);
            return message;
        };

        /**
         * Creates a plain object from a GroupMemberUpdateParams message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.GroupMemberUpdateParams
         * @static
         * @param {group.GroupMemberUpdateParams} message GroupMemberUpdateParams
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GroupMemberUpdateParams.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = "";
                object.uid = "";
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this GroupMemberUpdateParams to JSON.
         * @function toJSON
         * @memberof group.GroupMemberUpdateParams
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GroupMemberUpdateParams.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GroupMemberUpdateParams;
    })();

    group.NewGroup = (function() {

        /**
         * Properties of a NewGroup.
         * @memberof group
         * @interface INewGroup
         */

        /**
         * Constructs a new NewGroup.
         * @memberof group
         * @classdesc Represents a NewGroup.
         * @implements INewGroup
         * @constructor
         * @param {group.INewGroup=} [properties] Properties to set
         */
        function NewGroup(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new NewGroup instance using the specified properties.
         * @function create
         * @memberof group.NewGroup
         * @static
         * @param {group.INewGroup=} [properties] Properties to set
         * @returns {group.NewGroup} NewGroup instance
         */
        NewGroup.create = function create(properties) {
            return new NewGroup(properties);
        };

        /**
         * Encodes the specified NewGroup message. Does not implicitly {@link group.NewGroup.verify|verify} messages.
         * @function encode
         * @memberof group.NewGroup
         * @static
         * @param {group.INewGroup} message NewGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NewGroup.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified NewGroup message, length delimited. Does not implicitly {@link group.NewGroup.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.NewGroup
         * @static
         * @param {group.INewGroup} message NewGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NewGroup.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NewGroup message from the specified reader or buffer.
         * @function decode
         * @memberof group.NewGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.NewGroup} NewGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NewGroup.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.NewGroup();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NewGroup message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.NewGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.NewGroup} NewGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NewGroup.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NewGroup message.
         * @function verify
         * @memberof group.NewGroup
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NewGroup.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a NewGroup message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.NewGroup
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.NewGroup} NewGroup
         */
        NewGroup.fromObject = function fromObject(object) {
            if (object instanceof $root.group.NewGroup)
                return object;
            return new $root.group.NewGroup();
        };

        /**
         * Creates a plain object from a NewGroup message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.NewGroup
         * @static
         * @param {group.NewGroup} message NewGroup
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NewGroup.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this NewGroup to JSON.
         * @function toJSON
         * @memberof group.NewGroup
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NewGroup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NewGroup.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof group.NewGroup
             * @interface IRequest
             * @property {string|null} [name] Request name
             * @property {string|null} [avatar] Request avatar
             * @property {Array.<group.IGroupMemberUpdateParams>|null} [members] Request members
             */

            /**
             * Constructs a new Request.
             * @memberof group.NewGroup
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {group.NewGroup.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.members = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request name.
             * @member {string} name
             * @memberof group.NewGroup.Request
             * @instance
             */
            Request.prototype.name = "";

            /**
             * Request avatar.
             * @member {string} avatar
             * @memberof group.NewGroup.Request
             * @instance
             */
            Request.prototype.avatar = "";

            /**
             * Request members.
             * @member {Array.<group.IGroupMemberUpdateParams>} members
             * @memberof group.NewGroup.Request
             * @instance
             */
            Request.prototype.members = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof group.NewGroup.Request
             * @static
             * @param {group.NewGroup.IRequest=} [properties] Properties to set
             * @returns {group.NewGroup.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link group.NewGroup.Request.verify|verify} messages.
             * @function encode
             * @memberof group.NewGroup.Request
             * @static
             * @param {group.NewGroup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.avatar);
                if (message.members != null && message.members.length)
                    for (var i = 0; i < message.members.length; ++i)
                        $root.group.GroupMemberUpdateParams.encode(message.members[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link group.NewGroup.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.NewGroup.Request
             * @static
             * @param {group.NewGroup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof group.NewGroup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.NewGroup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.NewGroup.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.avatar = reader.string();
                        break;
                    case 3:
                        if (!(message.members && message.members.length))
                            message.members = [];
                        message.members.push($root.group.GroupMemberUpdateParams.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.NewGroup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.NewGroup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof group.NewGroup.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    if (!$util.isString(message.avatar))
                        return "avatar: string expected";
                if (message.members != null && message.hasOwnProperty("members")) {
                    if (!Array.isArray(message.members))
                        return "members: array expected";
                    for (var i = 0; i < message.members.length; ++i) {
                        var error = $root.group.GroupMemberUpdateParams.verify(message.members[i]);
                        if (error)
                            return "members." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.NewGroup.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.NewGroup.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.group.NewGroup.Request)
                    return object;
                var message = new $root.group.NewGroup.Request();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.avatar != null)
                    message.avatar = String(object.avatar);
                if (object.members) {
                    if (!Array.isArray(object.members))
                        throw TypeError(".group.NewGroup.Request.members: array expected");
                    message.members = [];
                    for (var i = 0; i < object.members.length; ++i) {
                        if (typeof object.members[i] !== "object")
                            throw TypeError(".group.NewGroup.Request.members: object expected");
                        message.members[i] = $root.group.GroupMemberUpdateParams.fromObject(object.members[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.NewGroup.Request
             * @static
             * @param {group.NewGroup.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.members = [];
                if (options.defaults) {
                    object.name = "";
                    object.avatar = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    object.avatar = message.avatar;
                if (message.members && message.members.length) {
                    object.members = [];
                    for (var j = 0; j < message.members.length; ++j)
                        object.members[j] = $root.group.GroupMemberUpdateParams.toObject(message.members[j], options);
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof group.NewGroup.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        NewGroup.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.NewGroup
             * @interface IResponse
             * @property {string|null} [type] Response type
             */

            /**
             * Constructs a new Response.
             * @memberof group.NewGroup
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.NewGroup.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response type.
             * @member {string} type
             * @memberof group.NewGroup.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.NewGroup.Response
             * @static
             * @param {group.NewGroup.IResponse=} [properties] Properties to set
             * @returns {group.NewGroup.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.NewGroup.Response.verify|verify} messages.
             * @function encode
             * @memberof group.NewGroup.Response
             * @static
             * @param {group.NewGroup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.NewGroup.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.NewGroup.Response
             * @static
             * @param {group.NewGroup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.NewGroup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.NewGroup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.NewGroup.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.NewGroup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.NewGroup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.NewGroup.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.NewGroup.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.NewGroup.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.NewGroup.Response)
                    return object;
                var message = new $root.group.NewGroup.Response();
                if (object.type != null)
                    message.type = String(object.type);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.NewGroup.Response
             * @static
             * @param {group.NewGroup.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.type = "";
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.NewGroup.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return NewGroup;
    })();

    group.UpdateGroupInfo = (function() {

        /**
         * Properties of an UpdateGroupInfo.
         * @memberof group
         * @interface IUpdateGroupInfo
         */

        /**
         * Constructs a new UpdateGroupInfo.
         * @memberof group
         * @classdesc Represents an UpdateGroupInfo.
         * @implements IUpdateGroupInfo
         * @constructor
         * @param {group.IUpdateGroupInfo=} [properties] Properties to set
         */
        function UpdateGroupInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateGroupInfo instance using the specified properties.
         * @function create
         * @memberof group.UpdateGroupInfo
         * @static
         * @param {group.IUpdateGroupInfo=} [properties] Properties to set
         * @returns {group.UpdateGroupInfo} UpdateGroupInfo instance
         */
        UpdateGroupInfo.create = function create(properties) {
            return new UpdateGroupInfo(properties);
        };

        /**
         * Encodes the specified UpdateGroupInfo message. Does not implicitly {@link group.UpdateGroupInfo.verify|verify} messages.
         * @function encode
         * @memberof group.UpdateGroupInfo
         * @static
         * @param {group.IUpdateGroupInfo} message UpdateGroupInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateGroupInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UpdateGroupInfo message, length delimited. Does not implicitly {@link group.UpdateGroupInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.UpdateGroupInfo
         * @static
         * @param {group.IUpdateGroupInfo} message UpdateGroupInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateGroupInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateGroupInfo message from the specified reader or buffer.
         * @function decode
         * @memberof group.UpdateGroupInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.UpdateGroupInfo} UpdateGroupInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateGroupInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.UpdateGroupInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateGroupInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.UpdateGroupInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.UpdateGroupInfo} UpdateGroupInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateGroupInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateGroupInfo message.
         * @function verify
         * @memberof group.UpdateGroupInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateGroupInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UpdateGroupInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.UpdateGroupInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.UpdateGroupInfo} UpdateGroupInfo
         */
        UpdateGroupInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.group.UpdateGroupInfo)
                return object;
            return new $root.group.UpdateGroupInfo();
        };

        /**
         * Creates a plain object from an UpdateGroupInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.UpdateGroupInfo
         * @static
         * @param {group.UpdateGroupInfo} message UpdateGroupInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGroupInfo.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateGroupInfo to JSON.
         * @function toJSON
         * @memberof group.UpdateGroupInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGroupInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UpdateGroupInfo.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof group.UpdateGroupInfo
             * @interface IRequest
             * @property {string|null} [groupId] Request groupId
             * @property {string|null} [name] Request name
             * @property {string|null} [avatar] Request avatar
             */

            /**
             * Constructs a new Request.
             * @memberof group.UpdateGroupInfo
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {group.UpdateGroupInfo.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request groupId.
             * @member {string} groupId
             * @memberof group.UpdateGroupInfo.Request
             * @instance
             */
            Request.prototype.groupId = "";

            /**
             * Request name.
             * @member {string} name
             * @memberof group.UpdateGroupInfo.Request
             * @instance
             */
            Request.prototype.name = "";

            /**
             * Request avatar.
             * @member {string} avatar
             * @memberof group.UpdateGroupInfo.Request
             * @instance
             */
            Request.prototype.avatar = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof group.UpdateGroupInfo.Request
             * @static
             * @param {group.UpdateGroupInfo.IRequest=} [properties] Properties to set
             * @returns {group.UpdateGroupInfo.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link group.UpdateGroupInfo.Request.verify|verify} messages.
             * @function encode
             * @memberof group.UpdateGroupInfo.Request
             * @static
             * @param {group.UpdateGroupInfo.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.groupId);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link group.UpdateGroupInfo.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.UpdateGroupInfo.Request
             * @static
             * @param {group.UpdateGroupInfo.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof group.UpdateGroupInfo.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.UpdateGroupInfo.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.UpdateGroupInfo.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.groupId = reader.string();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.avatar = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.UpdateGroupInfo.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.UpdateGroupInfo.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof group.UpdateGroupInfo.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    if (!$util.isString(message.groupId))
                        return "groupId: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    if (!$util.isString(message.avatar))
                        return "avatar: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.UpdateGroupInfo.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.UpdateGroupInfo.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.group.UpdateGroupInfo.Request)
                    return object;
                var message = new $root.group.UpdateGroupInfo.Request();
                if (object.groupId != null)
                    message.groupId = String(object.groupId);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.avatar != null)
                    message.avatar = String(object.avatar);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.UpdateGroupInfo.Request
             * @static
             * @param {group.UpdateGroupInfo.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.groupId = "";
                    object.name = "";
                    object.avatar = "";
                }
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    object.groupId = message.groupId;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    object.avatar = message.avatar;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof group.UpdateGroupInfo.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        UpdateGroupInfo.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.UpdateGroupInfo
             * @interface IResponse
             * @property {string|null} [groupId] Response groupId
             * @property {string|null} [name] Response name
             * @property {string|null} [avatar] Response avatar
             */

            /**
             * Constructs a new Response.
             * @memberof group.UpdateGroupInfo
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.UpdateGroupInfo.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response groupId.
             * @member {string} groupId
             * @memberof group.UpdateGroupInfo.Response
             * @instance
             */
            Response.prototype.groupId = "";

            /**
             * Response name.
             * @member {string} name
             * @memberof group.UpdateGroupInfo.Response
             * @instance
             */
            Response.prototype.name = "";

            /**
             * Response avatar.
             * @member {string} avatar
             * @memberof group.UpdateGroupInfo.Response
             * @instance
             */
            Response.prototype.avatar = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.UpdateGroupInfo.Response
             * @static
             * @param {group.UpdateGroupInfo.IResponse=} [properties] Properties to set
             * @returns {group.UpdateGroupInfo.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.UpdateGroupInfo.Response.verify|verify} messages.
             * @function encode
             * @memberof group.UpdateGroupInfo.Response
             * @static
             * @param {group.UpdateGroupInfo.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.groupId);
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                if (message.avatar != null && Object.hasOwnProperty.call(message, "avatar"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.avatar);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.UpdateGroupInfo.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.UpdateGroupInfo.Response
             * @static
             * @param {group.UpdateGroupInfo.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.UpdateGroupInfo.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.UpdateGroupInfo.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.UpdateGroupInfo.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.groupId = reader.string();
                        break;
                    case 2:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.avatar = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.UpdateGroupInfo.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.UpdateGroupInfo.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.UpdateGroupInfo.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    if (!$util.isString(message.groupId))
                        return "groupId: string expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    if (!$util.isString(message.avatar))
                        return "avatar: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.UpdateGroupInfo.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.UpdateGroupInfo.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.UpdateGroupInfo.Response)
                    return object;
                var message = new $root.group.UpdateGroupInfo.Response();
                if (object.groupId != null)
                    message.groupId = String(object.groupId);
                if (object.name != null)
                    message.name = String(object.name);
                if (object.avatar != null)
                    message.avatar = String(object.avatar);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.UpdateGroupInfo.Response
             * @static
             * @param {group.UpdateGroupInfo.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.groupId = "";
                    object.name = "";
                    object.avatar = "";
                }
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    object.groupId = message.groupId;
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.avatar != null && message.hasOwnProperty("avatar"))
                    object.avatar = message.avatar;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.UpdateGroupInfo.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return UpdateGroupInfo;
    })();

    group.GetAllJoinedGroups = (function() {

        /**
         * Properties of a GetAllJoinedGroups.
         * @memberof group
         * @interface IGetAllJoinedGroups
         */

        /**
         * Constructs a new GetAllJoinedGroups.
         * @memberof group
         * @classdesc Represents a GetAllJoinedGroups.
         * @implements IGetAllJoinedGroups
         * @constructor
         * @param {group.IGetAllJoinedGroups=} [properties] Properties to set
         */
        function GetAllJoinedGroups(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetAllJoinedGroups instance using the specified properties.
         * @function create
         * @memberof group.GetAllJoinedGroups
         * @static
         * @param {group.IGetAllJoinedGroups=} [properties] Properties to set
         * @returns {group.GetAllJoinedGroups} GetAllJoinedGroups instance
         */
        GetAllJoinedGroups.create = function create(properties) {
            return new GetAllJoinedGroups(properties);
        };

        /**
         * Encodes the specified GetAllJoinedGroups message. Does not implicitly {@link group.GetAllJoinedGroups.verify|verify} messages.
         * @function encode
         * @memberof group.GetAllJoinedGroups
         * @static
         * @param {group.IGetAllJoinedGroups} message GetAllJoinedGroups message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAllJoinedGroups.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetAllJoinedGroups message, length delimited. Does not implicitly {@link group.GetAllJoinedGroups.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.GetAllJoinedGroups
         * @static
         * @param {group.IGetAllJoinedGroups} message GetAllJoinedGroups message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAllJoinedGroups.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAllJoinedGroups message from the specified reader or buffer.
         * @function decode
         * @memberof group.GetAllJoinedGroups
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.GetAllJoinedGroups} GetAllJoinedGroups
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAllJoinedGroups.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetAllJoinedGroups();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAllJoinedGroups message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.GetAllJoinedGroups
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.GetAllJoinedGroups} GetAllJoinedGroups
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAllJoinedGroups.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAllJoinedGroups message.
         * @function verify
         * @memberof group.GetAllJoinedGroups
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAllJoinedGroups.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetAllJoinedGroups message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.GetAllJoinedGroups
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.GetAllJoinedGroups} GetAllJoinedGroups
         */
        GetAllJoinedGroups.fromObject = function fromObject(object) {
            if (object instanceof $root.group.GetAllJoinedGroups)
                return object;
            return new $root.group.GetAllJoinedGroups();
        };

        /**
         * Creates a plain object from a GetAllJoinedGroups message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.GetAllJoinedGroups
         * @static
         * @param {group.GetAllJoinedGroups} message GetAllJoinedGroups
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAllJoinedGroups.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetAllJoinedGroups to JSON.
         * @function toJSON
         * @memberof group.GetAllJoinedGroups
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAllJoinedGroups.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetAllJoinedGroups.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof group.GetAllJoinedGroups
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof group.GetAllJoinedGroups
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {group.GetAllJoinedGroups.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof group.GetAllJoinedGroups.Request
             * @static
             * @param {group.GetAllJoinedGroups.IRequest=} [properties] Properties to set
             * @returns {group.GetAllJoinedGroups.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link group.GetAllJoinedGroups.Request.verify|verify} messages.
             * @function encode
             * @memberof group.GetAllJoinedGroups.Request
             * @static
             * @param {group.GetAllJoinedGroups.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link group.GetAllJoinedGroups.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.GetAllJoinedGroups.Request
             * @static
             * @param {group.GetAllJoinedGroups.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof group.GetAllJoinedGroups.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.GetAllJoinedGroups.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetAllJoinedGroups.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.GetAllJoinedGroups.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.GetAllJoinedGroups.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof group.GetAllJoinedGroups.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.GetAllJoinedGroups.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.GetAllJoinedGroups.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.group.GetAllJoinedGroups.Request)
                    return object;
                return new $root.group.GetAllJoinedGroups.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.GetAllJoinedGroups.Request
             * @static
             * @param {group.GetAllJoinedGroups.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof group.GetAllJoinedGroups.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetAllJoinedGroups.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.GetAllJoinedGroups
             * @interface IResponse
             * @property {Array.<group.IGroup>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof group.GetAllJoinedGroups
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.GetAllJoinedGroups.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<group.IGroup>} list
             * @memberof group.GetAllJoinedGroups.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof group.GetAllJoinedGroups.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.GetAllJoinedGroups.Response
             * @static
             * @param {group.GetAllJoinedGroups.IResponse=} [properties] Properties to set
             * @returns {group.GetAllJoinedGroups.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.GetAllJoinedGroups.Response.verify|verify} messages.
             * @function encode
             * @memberof group.GetAllJoinedGroups.Response
             * @static
             * @param {group.GetAllJoinedGroups.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.group.Group.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.GetAllJoinedGroups.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.GetAllJoinedGroups.Response
             * @static
             * @param {group.GetAllJoinedGroups.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.GetAllJoinedGroups.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.GetAllJoinedGroups.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetAllJoinedGroups.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.group.Group.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.GetAllJoinedGroups.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.GetAllJoinedGroups.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.GetAllJoinedGroups.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.group.Group.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.GetAllJoinedGroups.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.GetAllJoinedGroups.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.GetAllJoinedGroups.Response)
                    return object;
                var message = new $root.group.GetAllJoinedGroups.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".group.GetAllJoinedGroups.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".group.GetAllJoinedGroups.Response.list: object expected");
                        message.list[i] = $root.group.Group.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.GetAllJoinedGroups.Response
             * @static
             * @param {group.GetAllJoinedGroups.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.group.Group.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.GetAllJoinedGroups.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetAllJoinedGroups;
    })();

    group.GetGroupInfo = (function() {

        /**
         * Properties of a GetGroupInfo.
         * @memberof group
         * @interface IGetGroupInfo
         */

        /**
         * Constructs a new GetGroupInfo.
         * @memberof group
         * @classdesc Represents a GetGroupInfo.
         * @implements IGetGroupInfo
         * @constructor
         * @param {group.IGetGroupInfo=} [properties] Properties to set
         */
        function GetGroupInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetGroupInfo instance using the specified properties.
         * @function create
         * @memberof group.GetGroupInfo
         * @static
         * @param {group.IGetGroupInfo=} [properties] Properties to set
         * @returns {group.GetGroupInfo} GetGroupInfo instance
         */
        GetGroupInfo.create = function create(properties) {
            return new GetGroupInfo(properties);
        };

        /**
         * Encodes the specified GetGroupInfo message. Does not implicitly {@link group.GetGroupInfo.verify|verify} messages.
         * @function encode
         * @memberof group.GetGroupInfo
         * @static
         * @param {group.IGetGroupInfo} message GetGroupInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetGroupInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetGroupInfo message, length delimited. Does not implicitly {@link group.GetGroupInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.GetGroupInfo
         * @static
         * @param {group.IGetGroupInfo} message GetGroupInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetGroupInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetGroupInfo message from the specified reader or buffer.
         * @function decode
         * @memberof group.GetGroupInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.GetGroupInfo} GetGroupInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetGroupInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetGroupInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetGroupInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.GetGroupInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.GetGroupInfo} GetGroupInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetGroupInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetGroupInfo message.
         * @function verify
         * @memberof group.GetGroupInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetGroupInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetGroupInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.GetGroupInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.GetGroupInfo} GetGroupInfo
         */
        GetGroupInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.group.GetGroupInfo)
                return object;
            return new $root.group.GetGroupInfo();
        };

        /**
         * Creates a plain object from a GetGroupInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.GetGroupInfo
         * @static
         * @param {group.GetGroupInfo} message GetGroupInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGroupInfo.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetGroupInfo to JSON.
         * @function toJSON
         * @memberof group.GetGroupInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGroupInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetGroupInfo.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof group.GetGroupInfo
             * @interface IRequest
             * @property {string|null} [groupId] Request groupId
             */

            /**
             * Constructs a new Request.
             * @memberof group.GetGroupInfo
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {group.GetGroupInfo.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request groupId.
             * @member {string} groupId
             * @memberof group.GetGroupInfo.Request
             * @instance
             */
            Request.prototype.groupId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof group.GetGroupInfo.Request
             * @static
             * @param {group.GetGroupInfo.IRequest=} [properties] Properties to set
             * @returns {group.GetGroupInfo.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link group.GetGroupInfo.Request.verify|verify} messages.
             * @function encode
             * @memberof group.GetGroupInfo.Request
             * @static
             * @param {group.GetGroupInfo.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.groupId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link group.GetGroupInfo.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.GetGroupInfo.Request
             * @static
             * @param {group.GetGroupInfo.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof group.GetGroupInfo.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.GetGroupInfo.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetGroupInfo.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.groupId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.GetGroupInfo.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.GetGroupInfo.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof group.GetGroupInfo.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    if (!$util.isString(message.groupId))
                        return "groupId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.GetGroupInfo.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.GetGroupInfo.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.group.GetGroupInfo.Request)
                    return object;
                var message = new $root.group.GetGroupInfo.Request();
                if (object.groupId != null)
                    message.groupId = String(object.groupId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.GetGroupInfo.Request
             * @static
             * @param {group.GetGroupInfo.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.groupId = "";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    object.groupId = message.groupId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof group.GetGroupInfo.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetGroupInfo.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.GetGroupInfo
             * @interface IResponse
             * @property {group.IGroup|null} [group] Response group
             */

            /**
             * Constructs a new Response.
             * @memberof group.GetGroupInfo
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.GetGroupInfo.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response group.
             * @member {group.IGroup|null|undefined} group
             * @memberof group.GetGroupInfo.Response
             * @instance
             */
            Response.prototype.group = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.GetGroupInfo.Response
             * @static
             * @param {group.GetGroupInfo.IResponse=} [properties] Properties to set
             * @returns {group.GetGroupInfo.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.GetGroupInfo.Response.verify|verify} messages.
             * @function encode
             * @memberof group.GetGroupInfo.Response
             * @static
             * @param {group.GetGroupInfo.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.group != null && Object.hasOwnProperty.call(message, "group"))
                    $root.group.Group.encode(message.group, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.GetGroupInfo.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.GetGroupInfo.Response
             * @static
             * @param {group.GetGroupInfo.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.GetGroupInfo.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.GetGroupInfo.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetGroupInfo.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.group = $root.group.Group.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.GetGroupInfo.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.GetGroupInfo.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.GetGroupInfo.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.group != null && message.hasOwnProperty("group")) {
                    var error = $root.group.Group.verify(message.group);
                    if (error)
                        return "group." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.GetGroupInfo.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.GetGroupInfo.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.GetGroupInfo.Response)
                    return object;
                var message = new $root.group.GetGroupInfo.Response();
                if (object.group != null) {
                    if (typeof object.group !== "object")
                        throw TypeError(".group.GetGroupInfo.Response.group: object expected");
                    message.group = $root.group.Group.fromObject(object.group);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.GetGroupInfo.Response
             * @static
             * @param {group.GetGroupInfo.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.group = null;
                if (message.group != null && message.hasOwnProperty("group"))
                    object.group = $root.group.Group.toObject(message.group, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.GetGroupInfo.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetGroupInfo;
    })();

    group.GetGroupMembers = (function() {

        /**
         * Properties of a GetGroupMembers.
         * @memberof group
         * @interface IGetGroupMembers
         */

        /**
         * Constructs a new GetGroupMembers.
         * @memberof group
         * @classdesc Represents a GetGroupMembers.
         * @implements IGetGroupMembers
         * @constructor
         * @param {group.IGetGroupMembers=} [properties] Properties to set
         */
        function GetGroupMembers(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetGroupMembers instance using the specified properties.
         * @function create
         * @memberof group.GetGroupMembers
         * @static
         * @param {group.IGetGroupMembers=} [properties] Properties to set
         * @returns {group.GetGroupMembers} GetGroupMembers instance
         */
        GetGroupMembers.create = function create(properties) {
            return new GetGroupMembers(properties);
        };

        /**
         * Encodes the specified GetGroupMembers message. Does not implicitly {@link group.GetGroupMembers.verify|verify} messages.
         * @function encode
         * @memberof group.GetGroupMembers
         * @static
         * @param {group.IGetGroupMembers} message GetGroupMembers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetGroupMembers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetGroupMembers message, length delimited. Does not implicitly {@link group.GetGroupMembers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.GetGroupMembers
         * @static
         * @param {group.IGetGroupMembers} message GetGroupMembers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetGroupMembers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetGroupMembers message from the specified reader or buffer.
         * @function decode
         * @memberof group.GetGroupMembers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.GetGroupMembers} GetGroupMembers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetGroupMembers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetGroupMembers();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetGroupMembers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.GetGroupMembers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.GetGroupMembers} GetGroupMembers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetGroupMembers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetGroupMembers message.
         * @function verify
         * @memberof group.GetGroupMembers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetGroupMembers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetGroupMembers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.GetGroupMembers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.GetGroupMembers} GetGroupMembers
         */
        GetGroupMembers.fromObject = function fromObject(object) {
            if (object instanceof $root.group.GetGroupMembers)
                return object;
            return new $root.group.GetGroupMembers();
        };

        /**
         * Creates a plain object from a GetGroupMembers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.GetGroupMembers
         * @static
         * @param {group.GetGroupMembers} message GetGroupMembers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetGroupMembers.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetGroupMembers to JSON.
         * @function toJSON
         * @memberof group.GetGroupMembers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetGroupMembers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetGroupMembers.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof group.GetGroupMembers
             * @interface IRequest
             * @property {string|null} [groupId] Request groupId
             */

            /**
             * Constructs a new Request.
             * @memberof group.GetGroupMembers
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {group.GetGroupMembers.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request groupId.
             * @member {string} groupId
             * @memberof group.GetGroupMembers.Request
             * @instance
             */
            Request.prototype.groupId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof group.GetGroupMembers.Request
             * @static
             * @param {group.GetGroupMembers.IRequest=} [properties] Properties to set
             * @returns {group.GetGroupMembers.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link group.GetGroupMembers.Request.verify|verify} messages.
             * @function encode
             * @memberof group.GetGroupMembers.Request
             * @static
             * @param {group.GetGroupMembers.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.groupId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link group.GetGroupMembers.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.GetGroupMembers.Request
             * @static
             * @param {group.GetGroupMembers.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof group.GetGroupMembers.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.GetGroupMembers.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetGroupMembers.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.groupId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.GetGroupMembers.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.GetGroupMembers.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof group.GetGroupMembers.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    if (!$util.isString(message.groupId))
                        return "groupId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.GetGroupMembers.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.GetGroupMembers.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.group.GetGroupMembers.Request)
                    return object;
                var message = new $root.group.GetGroupMembers.Request();
                if (object.groupId != null)
                    message.groupId = String(object.groupId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.GetGroupMembers.Request
             * @static
             * @param {group.GetGroupMembers.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.groupId = "";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    object.groupId = message.groupId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof group.GetGroupMembers.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetGroupMembers.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.GetGroupMembers
             * @interface IResponse
             * @property {Array.<group.IGroupMembers>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof group.GetGroupMembers
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.GetGroupMembers.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<group.IGroupMembers>} list
             * @memberof group.GetGroupMembers.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof group.GetGroupMembers.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.GetGroupMembers.Response
             * @static
             * @param {group.GetGroupMembers.IResponse=} [properties] Properties to set
             * @returns {group.GetGroupMembers.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.GetGroupMembers.Response.verify|verify} messages.
             * @function encode
             * @memberof group.GetGroupMembers.Response
             * @static
             * @param {group.GetGroupMembers.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.group.GroupMembers.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.GetGroupMembers.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.GetGroupMembers.Response
             * @static
             * @param {group.GetGroupMembers.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.GetGroupMembers.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.GetGroupMembers.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.GetGroupMembers.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.group.GroupMembers.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.GetGroupMembers.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.GetGroupMembers.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.GetGroupMembers.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.group.GroupMembers.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.GetGroupMembers.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.GetGroupMembers.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.GetGroupMembers.Response)
                    return object;
                var message = new $root.group.GetGroupMembers.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".group.GetGroupMembers.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".group.GetGroupMembers.Response.list: object expected");
                        message.list[i] = $root.group.GroupMembers.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.GetGroupMembers.Response
             * @static
             * @param {group.GetGroupMembers.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.group.GroupMembers.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.GetGroupMembers.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetGroupMembers;
    })();

    group.LeaveGroup = (function() {

        /**
         * Properties of a LeaveGroup.
         * @memberof group
         * @interface ILeaveGroup
         */

        /**
         * Constructs a new LeaveGroup.
         * @memberof group
         * @classdesc Represents a LeaveGroup.
         * @implements ILeaveGroup
         * @constructor
         * @param {group.ILeaveGroup=} [properties] Properties to set
         */
        function LeaveGroup(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new LeaveGroup instance using the specified properties.
         * @function create
         * @memberof group.LeaveGroup
         * @static
         * @param {group.ILeaveGroup=} [properties] Properties to set
         * @returns {group.LeaveGroup} LeaveGroup instance
         */
        LeaveGroup.create = function create(properties) {
            return new LeaveGroup(properties);
        };

        /**
         * Encodes the specified LeaveGroup message. Does not implicitly {@link group.LeaveGroup.verify|verify} messages.
         * @function encode
         * @memberof group.LeaveGroup
         * @static
         * @param {group.ILeaveGroup} message LeaveGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveGroup.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified LeaveGroup message, length delimited. Does not implicitly {@link group.LeaveGroup.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.LeaveGroup
         * @static
         * @param {group.ILeaveGroup} message LeaveGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveGroup.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LeaveGroup message from the specified reader or buffer.
         * @function decode
         * @memberof group.LeaveGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.LeaveGroup} LeaveGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveGroup.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.LeaveGroup();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LeaveGroup message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.LeaveGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.LeaveGroup} LeaveGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveGroup.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LeaveGroup message.
         * @function verify
         * @memberof group.LeaveGroup
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LeaveGroup.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a LeaveGroup message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.LeaveGroup
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.LeaveGroup} LeaveGroup
         */
        LeaveGroup.fromObject = function fromObject(object) {
            if (object instanceof $root.group.LeaveGroup)
                return object;
            return new $root.group.LeaveGroup();
        };

        /**
         * Creates a plain object from a LeaveGroup message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.LeaveGroup
         * @static
         * @param {group.LeaveGroup} message LeaveGroup
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LeaveGroup.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this LeaveGroup to JSON.
         * @function toJSON
         * @memberof group.LeaveGroup
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LeaveGroup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        LeaveGroup.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof group.LeaveGroup
             * @interface IRequest
             * @property {string|null} [groupId] Request groupId
             * @property {Array.<string>|null} [uid] Request uid
             */

            /**
             * Constructs a new Request.
             * @memberof group.LeaveGroup
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {group.LeaveGroup.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.uid = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request groupId.
             * @member {string} groupId
             * @memberof group.LeaveGroup.Request
             * @instance
             */
            Request.prototype.groupId = "";

            /**
             * Request uid.
             * @member {Array.<string>} uid
             * @memberof group.LeaveGroup.Request
             * @instance
             */
            Request.prototype.uid = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof group.LeaveGroup.Request
             * @static
             * @param {group.LeaveGroup.IRequest=} [properties] Properties to set
             * @returns {group.LeaveGroup.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link group.LeaveGroup.Request.verify|verify} messages.
             * @function encode
             * @memberof group.LeaveGroup.Request
             * @static
             * @param {group.LeaveGroup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.groupId);
                if (message.uid != null && message.uid.length)
                    for (var i = 0; i < message.uid.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.uid[i]);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link group.LeaveGroup.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.LeaveGroup.Request
             * @static
             * @param {group.LeaveGroup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof group.LeaveGroup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.LeaveGroup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.LeaveGroup.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.groupId = reader.string();
                        break;
                    case 2:
                        if (!(message.uid && message.uid.length))
                            message.uid = [];
                        message.uid.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.LeaveGroup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.LeaveGroup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof group.LeaveGroup.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    if (!$util.isString(message.groupId))
                        return "groupId: string expected";
                if (message.uid != null && message.hasOwnProperty("uid")) {
                    if (!Array.isArray(message.uid))
                        return "uid: array expected";
                    for (var i = 0; i < message.uid.length; ++i)
                        if (!$util.isString(message.uid[i]))
                            return "uid: string[] expected";
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.LeaveGroup.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.LeaveGroup.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.group.LeaveGroup.Request)
                    return object;
                var message = new $root.group.LeaveGroup.Request();
                if (object.groupId != null)
                    message.groupId = String(object.groupId);
                if (object.uid) {
                    if (!Array.isArray(object.uid))
                        throw TypeError(".group.LeaveGroup.Request.uid: array expected");
                    message.uid = [];
                    for (var i = 0; i < object.uid.length; ++i)
                        message.uid[i] = String(object.uid[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.LeaveGroup.Request
             * @static
             * @param {group.LeaveGroup.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uid = [];
                if (options.defaults)
                    object.groupId = "";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    object.groupId = message.groupId;
                if (message.uid && message.uid.length) {
                    object.uid = [];
                    for (var j = 0; j < message.uid.length; ++j)
                        object.uid[j] = message.uid[j];
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof group.LeaveGroup.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        LeaveGroup.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.LeaveGroup
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof group.LeaveGroup
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.LeaveGroup.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.LeaveGroup.Response
             * @static
             * @param {group.LeaveGroup.IResponse=} [properties] Properties to set
             * @returns {group.LeaveGroup.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.LeaveGroup.Response.verify|verify} messages.
             * @function encode
             * @memberof group.LeaveGroup.Response
             * @static
             * @param {group.LeaveGroup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.LeaveGroup.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.LeaveGroup.Response
             * @static
             * @param {group.LeaveGroup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.LeaveGroup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.LeaveGroup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.LeaveGroup.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.LeaveGroup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.LeaveGroup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.LeaveGroup.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.LeaveGroup.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.LeaveGroup.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.LeaveGroup.Response)
                    return object;
                return new $root.group.LeaveGroup.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.LeaveGroup.Response
             * @static
             * @param {group.LeaveGroup.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.LeaveGroup.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return LeaveGroup;
    })();

    group.JoinGroup = (function() {

        /**
         * Properties of a JoinGroup.
         * @memberof group
         * @interface IJoinGroup
         */

        /**
         * Constructs a new JoinGroup.
         * @memberof group
         * @classdesc Represents a JoinGroup.
         * @implements IJoinGroup
         * @constructor
         * @param {group.IJoinGroup=} [properties] Properties to set
         */
        function JoinGroup(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new JoinGroup instance using the specified properties.
         * @function create
         * @memberof group.JoinGroup
         * @static
         * @param {group.IJoinGroup=} [properties] Properties to set
         * @returns {group.JoinGroup} JoinGroup instance
         */
        JoinGroup.create = function create(properties) {
            return new JoinGroup(properties);
        };

        /**
         * Encodes the specified JoinGroup message. Does not implicitly {@link group.JoinGroup.verify|verify} messages.
         * @function encode
         * @memberof group.JoinGroup
         * @static
         * @param {group.IJoinGroup} message JoinGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JoinGroup.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified JoinGroup message, length delimited. Does not implicitly {@link group.JoinGroup.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.JoinGroup
         * @static
         * @param {group.IJoinGroup} message JoinGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JoinGroup.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JoinGroup message from the specified reader or buffer.
         * @function decode
         * @memberof group.JoinGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.JoinGroup} JoinGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JoinGroup.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.JoinGroup();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JoinGroup message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.JoinGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.JoinGroup} JoinGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JoinGroup.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JoinGroup message.
         * @function verify
         * @memberof group.JoinGroup
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JoinGroup.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a JoinGroup message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.JoinGroup
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.JoinGroup} JoinGroup
         */
        JoinGroup.fromObject = function fromObject(object) {
            if (object instanceof $root.group.JoinGroup)
                return object;
            return new $root.group.JoinGroup();
        };

        /**
         * Creates a plain object from a JoinGroup message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.JoinGroup
         * @static
         * @param {group.JoinGroup} message JoinGroup
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JoinGroup.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this JoinGroup to JSON.
         * @function toJSON
         * @memberof group.JoinGroup
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JoinGroup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        JoinGroup.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof group.JoinGroup
             * @interface IRequest
             * @property {string|null} [groupId] Request groupId
             * @property {Array.<string>|null} [uid] Request uid
             * @property {string|null} [remark] Request remark
             */

            /**
             * Constructs a new Request.
             * @memberof group.JoinGroup
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {group.JoinGroup.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.uid = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request groupId.
             * @member {string} groupId
             * @memberof group.JoinGroup.Request
             * @instance
             */
            Request.prototype.groupId = "";

            /**
             * Request uid.
             * @member {Array.<string>} uid
             * @memberof group.JoinGroup.Request
             * @instance
             */
            Request.prototype.uid = $util.emptyArray;

            /**
             * Request remark.
             * @member {string} remark
             * @memberof group.JoinGroup.Request
             * @instance
             */
            Request.prototype.remark = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof group.JoinGroup.Request
             * @static
             * @param {group.JoinGroup.IRequest=} [properties] Properties to set
             * @returns {group.JoinGroup.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link group.JoinGroup.Request.verify|verify} messages.
             * @function encode
             * @memberof group.JoinGroup.Request
             * @static
             * @param {group.JoinGroup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.groupId);
                if (message.uid != null && message.uid.length)
                    for (var i = 0; i < message.uid.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.uid[i]);
                if (message.remark != null && Object.hasOwnProperty.call(message, "remark"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.remark);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link group.JoinGroup.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.JoinGroup.Request
             * @static
             * @param {group.JoinGroup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof group.JoinGroup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.JoinGroup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.JoinGroup.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.groupId = reader.string();
                        break;
                    case 2:
                        if (!(message.uid && message.uid.length))
                            message.uid = [];
                        message.uid.push(reader.string());
                        break;
                    case 3:
                        message.remark = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.JoinGroup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.JoinGroup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof group.JoinGroup.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    if (!$util.isString(message.groupId))
                        return "groupId: string expected";
                if (message.uid != null && message.hasOwnProperty("uid")) {
                    if (!Array.isArray(message.uid))
                        return "uid: array expected";
                    for (var i = 0; i < message.uid.length; ++i)
                        if (!$util.isString(message.uid[i]))
                            return "uid: string[] expected";
                }
                if (message.remark != null && message.hasOwnProperty("remark"))
                    if (!$util.isString(message.remark))
                        return "remark: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.JoinGroup.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.JoinGroup.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.group.JoinGroup.Request)
                    return object;
                var message = new $root.group.JoinGroup.Request();
                if (object.groupId != null)
                    message.groupId = String(object.groupId);
                if (object.uid) {
                    if (!Array.isArray(object.uid))
                        throw TypeError(".group.JoinGroup.Request.uid: array expected");
                    message.uid = [];
                    for (var i = 0; i < object.uid.length; ++i)
                        message.uid[i] = String(object.uid[i]);
                }
                if (object.remark != null)
                    message.remark = String(object.remark);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.JoinGroup.Request
             * @static
             * @param {group.JoinGroup.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uid = [];
                if (options.defaults) {
                    object.groupId = "";
                    object.remark = "";
                }
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    object.groupId = message.groupId;
                if (message.uid && message.uid.length) {
                    object.uid = [];
                    for (var j = 0; j < message.uid.length; ++j)
                        object.uid[j] = message.uid[j];
                }
                if (message.remark != null && message.hasOwnProperty("remark"))
                    object.remark = message.remark;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof group.JoinGroup.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        JoinGroup.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.JoinGroup
             * @interface IResponse
             * @property {string|null} [type] Response type
             */

            /**
             * Constructs a new Response.
             * @memberof group.JoinGroup
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.JoinGroup.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response type.
             * @member {string} type
             * @memberof group.JoinGroup.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.JoinGroup.Response
             * @static
             * @param {group.JoinGroup.IResponse=} [properties] Properties to set
             * @returns {group.JoinGroup.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.JoinGroup.Response.verify|verify} messages.
             * @function encode
             * @memberof group.JoinGroup.Response
             * @static
             * @param {group.JoinGroup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.JoinGroup.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.JoinGroup.Response
             * @static
             * @param {group.JoinGroup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.JoinGroup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.JoinGroup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.JoinGroup.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.JoinGroup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.JoinGroup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.JoinGroup.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.JoinGroup.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.JoinGroup.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.JoinGroup.Response)
                    return object;
                var message = new $root.group.JoinGroup.Response();
                if (object.type != null)
                    message.type = String(object.type);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.JoinGroup.Response
             * @static
             * @param {group.JoinGroup.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.type = "";
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.JoinGroup.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return JoinGroup;
    })();

    group.DisbandGroup = (function() {

        /**
         * Properties of a DisbandGroup.
         * @memberof group
         * @interface IDisbandGroup
         */

        /**
         * Constructs a new DisbandGroup.
         * @memberof group
         * @classdesc Represents a DisbandGroup.
         * @implements IDisbandGroup
         * @constructor
         * @param {group.IDisbandGroup=} [properties] Properties to set
         */
        function DisbandGroup(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DisbandGroup instance using the specified properties.
         * @function create
         * @memberof group.DisbandGroup
         * @static
         * @param {group.IDisbandGroup=} [properties] Properties to set
         * @returns {group.DisbandGroup} DisbandGroup instance
         */
        DisbandGroup.create = function create(properties) {
            return new DisbandGroup(properties);
        };

        /**
         * Encodes the specified DisbandGroup message. Does not implicitly {@link group.DisbandGroup.verify|verify} messages.
         * @function encode
         * @memberof group.DisbandGroup
         * @static
         * @param {group.IDisbandGroup} message DisbandGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DisbandGroup.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified DisbandGroup message, length delimited. Does not implicitly {@link group.DisbandGroup.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.DisbandGroup
         * @static
         * @param {group.IDisbandGroup} message DisbandGroup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DisbandGroup.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DisbandGroup message from the specified reader or buffer.
         * @function decode
         * @memberof group.DisbandGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.DisbandGroup} DisbandGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DisbandGroup.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.DisbandGroup();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DisbandGroup message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.DisbandGroup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.DisbandGroup} DisbandGroup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DisbandGroup.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DisbandGroup message.
         * @function verify
         * @memberof group.DisbandGroup
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DisbandGroup.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a DisbandGroup message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.DisbandGroup
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.DisbandGroup} DisbandGroup
         */
        DisbandGroup.fromObject = function fromObject(object) {
            if (object instanceof $root.group.DisbandGroup)
                return object;
            return new $root.group.DisbandGroup();
        };

        /**
         * Creates a plain object from a DisbandGroup message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.DisbandGroup
         * @static
         * @param {group.DisbandGroup} message DisbandGroup
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DisbandGroup.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DisbandGroup to JSON.
         * @function toJSON
         * @memberof group.DisbandGroup
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DisbandGroup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        DisbandGroup.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof group.DisbandGroup
             * @interface IRequest
             * @property {string|null} [groupId] Request groupId
             */

            /**
             * Constructs a new Request.
             * @memberof group.DisbandGroup
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {group.DisbandGroup.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request groupId.
             * @member {string} groupId
             * @memberof group.DisbandGroup.Request
             * @instance
             */
            Request.prototype.groupId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof group.DisbandGroup.Request
             * @static
             * @param {group.DisbandGroup.IRequest=} [properties] Properties to set
             * @returns {group.DisbandGroup.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link group.DisbandGroup.Request.verify|verify} messages.
             * @function encode
             * @memberof group.DisbandGroup.Request
             * @static
             * @param {group.DisbandGroup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.groupId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link group.DisbandGroup.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.DisbandGroup.Request
             * @static
             * @param {group.DisbandGroup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof group.DisbandGroup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.DisbandGroup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.DisbandGroup.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.groupId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.DisbandGroup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.DisbandGroup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof group.DisbandGroup.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    if (!$util.isString(message.groupId))
                        return "groupId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.DisbandGroup.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.DisbandGroup.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.group.DisbandGroup.Request)
                    return object;
                var message = new $root.group.DisbandGroup.Request();
                if (object.groupId != null)
                    message.groupId = String(object.groupId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.DisbandGroup.Request
             * @static
             * @param {group.DisbandGroup.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.groupId = "";
                if (message.groupId != null && message.hasOwnProperty("groupId"))
                    object.groupId = message.groupId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof group.DisbandGroup.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        DisbandGroup.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.DisbandGroup
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof group.DisbandGroup
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.DisbandGroup.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.DisbandGroup.Response
             * @static
             * @param {group.DisbandGroup.IResponse=} [properties] Properties to set
             * @returns {group.DisbandGroup.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.DisbandGroup.Response.verify|verify} messages.
             * @function encode
             * @memberof group.DisbandGroup.Response
             * @static
             * @param {group.DisbandGroup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.DisbandGroup.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.DisbandGroup.Response
             * @static
             * @param {group.DisbandGroup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.DisbandGroup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.DisbandGroup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.DisbandGroup.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.DisbandGroup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.DisbandGroup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.DisbandGroup.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.DisbandGroup.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.DisbandGroup.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.DisbandGroup.Response)
                    return object;
                return new $root.group.DisbandGroup.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.DisbandGroup.Response
             * @static
             * @param {group.DisbandGroup.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.DisbandGroup.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return DisbandGroup;
    })();

    group.UpdateGroupStatus = (function() {

        /**
         * Properties of an UpdateGroupStatus.
         * @memberof group
         * @interface IUpdateGroupStatus
         */

        /**
         * Constructs a new UpdateGroupStatus.
         * @memberof group
         * @classdesc Represents an UpdateGroupStatus.
         * @implements IUpdateGroupStatus
         * @constructor
         * @param {group.IUpdateGroupStatus=} [properties] Properties to set
         */
        function UpdateGroupStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UpdateGroupStatus instance using the specified properties.
         * @function create
         * @memberof group.UpdateGroupStatus
         * @static
         * @param {group.IUpdateGroupStatus=} [properties] Properties to set
         * @returns {group.UpdateGroupStatus} UpdateGroupStatus instance
         */
        UpdateGroupStatus.create = function create(properties) {
            return new UpdateGroupStatus(properties);
        };

        /**
         * Encodes the specified UpdateGroupStatus message. Does not implicitly {@link group.UpdateGroupStatus.verify|verify} messages.
         * @function encode
         * @memberof group.UpdateGroupStatus
         * @static
         * @param {group.IUpdateGroupStatus} message UpdateGroupStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateGroupStatus.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UpdateGroupStatus message, length delimited. Does not implicitly {@link group.UpdateGroupStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof group.UpdateGroupStatus
         * @static
         * @param {group.IUpdateGroupStatus} message UpdateGroupStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UpdateGroupStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UpdateGroupStatus message from the specified reader or buffer.
         * @function decode
         * @memberof group.UpdateGroupStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {group.UpdateGroupStatus} UpdateGroupStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateGroupStatus.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.UpdateGroupStatus();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UpdateGroupStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof group.UpdateGroupStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {group.UpdateGroupStatus} UpdateGroupStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UpdateGroupStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UpdateGroupStatus message.
         * @function verify
         * @memberof group.UpdateGroupStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UpdateGroupStatus.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UpdateGroupStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof group.UpdateGroupStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {group.UpdateGroupStatus} UpdateGroupStatus
         */
        UpdateGroupStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.group.UpdateGroupStatus)
                return object;
            return new $root.group.UpdateGroupStatus();
        };

        /**
         * Creates a plain object from an UpdateGroupStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof group.UpdateGroupStatus
         * @static
         * @param {group.UpdateGroupStatus} message UpdateGroupStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UpdateGroupStatus.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UpdateGroupStatus to JSON.
         * @function toJSON
         * @memberof group.UpdateGroupStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UpdateGroupStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UpdateGroupStatus.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof group.UpdateGroupStatus
             * @interface IResponse
             * @property {string|null} [type] Response type
             * @property {string|null} [roomId] Response roomId
             * @property {Array.<string>|null} [uid] Response uid
             */

            /**
             * Constructs a new Response.
             * @memberof group.UpdateGroupStatus
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {group.UpdateGroupStatus.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.uid = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response type.
             * @member {string} type
             * @memberof group.UpdateGroupStatus.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof group.UpdateGroupStatus.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response uid.
             * @member {Array.<string>} uid
             * @memberof group.UpdateGroupStatus.Response
             * @instance
             */
            Response.prototype.uid = $util.emptyArray;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof group.UpdateGroupStatus.Response
             * @static
             * @param {group.UpdateGroupStatus.IResponse=} [properties] Properties to set
             * @returns {group.UpdateGroupStatus.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link group.UpdateGroupStatus.Response.verify|verify} messages.
             * @function encode
             * @memberof group.UpdateGroupStatus.Response
             * @static
             * @param {group.UpdateGroupStatus.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.roomId);
                if (message.uid != null && message.uid.length)
                    for (var i = 0; i < message.uid.length; ++i)
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.uid[i]);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link group.UpdateGroupStatus.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof group.UpdateGroupStatus.Response
             * @static
             * @param {group.UpdateGroupStatus.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof group.UpdateGroupStatus.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {group.UpdateGroupStatus.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.group.UpdateGroupStatus.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.type = reader.string();
                        break;
                    case 2:
                        message.roomId = reader.string();
                        break;
                    case 3:
                        if (!(message.uid && message.uid.length))
                            message.uid = [];
                        message.uid.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof group.UpdateGroupStatus.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {group.UpdateGroupStatus.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof group.UpdateGroupStatus.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.uid != null && message.hasOwnProperty("uid")) {
                    if (!Array.isArray(message.uid))
                        return "uid: array expected";
                    for (var i = 0; i < message.uid.length; ++i)
                        if (!$util.isString(message.uid[i]))
                            return "uid: string[] expected";
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof group.UpdateGroupStatus.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {group.UpdateGroupStatus.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.group.UpdateGroupStatus.Response)
                    return object;
                var message = new $root.group.UpdateGroupStatus.Response();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.uid) {
                    if (!Array.isArray(object.uid))
                        throw TypeError(".group.UpdateGroupStatus.Response.uid: array expected");
                    message.uid = [];
                    for (var i = 0; i < object.uid.length; ++i)
                        message.uid[i] = String(object.uid[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof group.UpdateGroupStatus.Response
             * @static
             * @param {group.UpdateGroupStatus.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uid = [];
                if (options.defaults) {
                    object.type = "";
                    object.roomId = "";
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.uid && message.uid.length) {
                    object.uid = [];
                    for (var j = 0; j < message.uid.length; ++j)
                        object.uid[j] = message.uid[j];
                }
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof group.UpdateGroupStatus.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return UpdateGroupStatus;
    })();

    return group;
})();

$root.message = (function() {

    /**
     * Namespace message.
     * @exports message
     * @namespace
     */
    var message = {};

    message.ChatDialogue = (function() {

        /**
         * Properties of a ChatDialogue.
         * @memberof message
         * @interface IChatDialogue
         * @property {string|null} [type] ChatDialogue type
         * @property {string|null} [lastMessageId] ChatDialogue lastMessageId
         * @property {number|Long|null} [lastMessageTime] ChatDialogue lastMessageTime
         * @property {string|null} [id] ChatDialogue id
         * @property {number|Long|null} [unreadMessageCount] ChatDialogue unreadMessageCount
         * @property {string|null} [roomId] ChatDialogue roomId
         * @property {message.IMessages|null} [lastMessage] ChatDialogue lastMessage
         */

        /**
         * Constructs a new ChatDialogue.
         * @memberof message
         * @classdesc Represents a ChatDialogue.
         * @implements IChatDialogue
         * @constructor
         * @param {message.IChatDialogue=} [properties] Properties to set
         */
        function ChatDialogue(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatDialogue type.
         * @member {string} type
         * @memberof message.ChatDialogue
         * @instance
         */
        ChatDialogue.prototype.type = "";

        /**
         * ChatDialogue lastMessageId.
         * @member {string} lastMessageId
         * @memberof message.ChatDialogue
         * @instance
         */
        ChatDialogue.prototype.lastMessageId = "";

        /**
         * ChatDialogue lastMessageTime.
         * @member {number|Long} lastMessageTime
         * @memberof message.ChatDialogue
         * @instance
         */
        ChatDialogue.prototype.lastMessageTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ChatDialogue id.
         * @member {string} id
         * @memberof message.ChatDialogue
         * @instance
         */
        ChatDialogue.prototype.id = "";

        /**
         * ChatDialogue unreadMessageCount.
         * @member {number|Long} unreadMessageCount
         * @memberof message.ChatDialogue
         * @instance
         */
        ChatDialogue.prototype.unreadMessageCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ChatDialogue roomId.
         * @member {string} roomId
         * @memberof message.ChatDialogue
         * @instance
         */
        ChatDialogue.prototype.roomId = "";

        /**
         * ChatDialogue lastMessage.
         * @member {message.IMessages|null|undefined} lastMessage
         * @memberof message.ChatDialogue
         * @instance
         */
        ChatDialogue.prototype.lastMessage = null;

        /**
         * Creates a new ChatDialogue instance using the specified properties.
         * @function create
         * @memberof message.ChatDialogue
         * @static
         * @param {message.IChatDialogue=} [properties] Properties to set
         * @returns {message.ChatDialogue} ChatDialogue instance
         */
        ChatDialogue.create = function create(properties) {
            return new ChatDialogue(properties);
        };

        /**
         * Encodes the specified ChatDialogue message. Does not implicitly {@link message.ChatDialogue.verify|verify} messages.
         * @function encode
         * @memberof message.ChatDialogue
         * @static
         * @param {message.IChatDialogue} message ChatDialogue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatDialogue.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.type);
            if (message.lastMessageId != null && Object.hasOwnProperty.call(message, "lastMessageId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.lastMessageId);
            if (message.lastMessageTime != null && Object.hasOwnProperty.call(message, "lastMessageTime"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.lastMessageTime);
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.id);
            if (message.unreadMessageCount != null && Object.hasOwnProperty.call(message, "unreadMessageCount"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.unreadMessageCount);
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.roomId);
            if (message.lastMessage != null && Object.hasOwnProperty.call(message, "lastMessage"))
                $root.message.Messages.encode(message.lastMessage, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ChatDialogue message, length delimited. Does not implicitly {@link message.ChatDialogue.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.ChatDialogue
         * @static
         * @param {message.IChatDialogue} message ChatDialogue message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatDialogue.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatDialogue message from the specified reader or buffer.
         * @function decode
         * @memberof message.ChatDialogue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.ChatDialogue} ChatDialogue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatDialogue.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.ChatDialogue();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.lastMessageId = reader.string();
                    break;
                case 3:
                    message.lastMessageTime = reader.int64();
                    break;
                case 4:
                    message.id = reader.string();
                    break;
                case 5:
                    message.unreadMessageCount = reader.int64();
                    break;
                case 6:
                    message.roomId = reader.string();
                    break;
                case 7:
                    message.lastMessage = $root.message.Messages.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatDialogue message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.ChatDialogue
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.ChatDialogue} ChatDialogue
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatDialogue.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatDialogue message.
         * @function verify
         * @memberof message.ChatDialogue
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatDialogue.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.lastMessageId != null && message.hasOwnProperty("lastMessageId"))
                if (!$util.isString(message.lastMessageId))
                    return "lastMessageId: string expected";
            if (message.lastMessageTime != null && message.hasOwnProperty("lastMessageTime"))
                if (!$util.isInteger(message.lastMessageTime) && !(message.lastMessageTime && $util.isInteger(message.lastMessageTime.low) && $util.isInteger(message.lastMessageTime.high)))
                    return "lastMessageTime: integer|Long expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.unreadMessageCount != null && message.hasOwnProperty("unreadMessageCount"))
                if (!$util.isInteger(message.unreadMessageCount) && !(message.unreadMessageCount && $util.isInteger(message.unreadMessageCount.low) && $util.isInteger(message.unreadMessageCount.high)))
                    return "unreadMessageCount: integer|Long expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.lastMessage != null && message.hasOwnProperty("lastMessage")) {
                var error = $root.message.Messages.verify(message.lastMessage);
                if (error)
                    return "lastMessage." + error;
            }
            return null;
        };

        /**
         * Creates a ChatDialogue message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.ChatDialogue
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.ChatDialogue} ChatDialogue
         */
        ChatDialogue.fromObject = function fromObject(object) {
            if (object instanceof $root.message.ChatDialogue)
                return object;
            var message = new $root.message.ChatDialogue();
            if (object.type != null)
                message.type = String(object.type);
            if (object.lastMessageId != null)
                message.lastMessageId = String(object.lastMessageId);
            if (object.lastMessageTime != null)
                if ($util.Long)
                    (message.lastMessageTime = $util.Long.fromValue(object.lastMessageTime)).unsigned = false;
                else if (typeof object.lastMessageTime === "string")
                    message.lastMessageTime = parseInt(object.lastMessageTime, 10);
                else if (typeof object.lastMessageTime === "number")
                    message.lastMessageTime = object.lastMessageTime;
                else if (typeof object.lastMessageTime === "object")
                    message.lastMessageTime = new $util.LongBits(object.lastMessageTime.low >>> 0, object.lastMessageTime.high >>> 0).toNumber();
            if (object.id != null)
                message.id = String(object.id);
            if (object.unreadMessageCount != null)
                if ($util.Long)
                    (message.unreadMessageCount = $util.Long.fromValue(object.unreadMessageCount)).unsigned = false;
                else if (typeof object.unreadMessageCount === "string")
                    message.unreadMessageCount = parseInt(object.unreadMessageCount, 10);
                else if (typeof object.unreadMessageCount === "number")
                    message.unreadMessageCount = object.unreadMessageCount;
                else if (typeof object.unreadMessageCount === "object")
                    message.unreadMessageCount = new $util.LongBits(object.unreadMessageCount.low >>> 0, object.unreadMessageCount.high >>> 0).toNumber();
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.lastMessage != null) {
                if (typeof object.lastMessage !== "object")
                    throw TypeError(".message.ChatDialogue.lastMessage: object expected");
                message.lastMessage = $root.message.Messages.fromObject(object.lastMessage);
            }
            return message;
        };

        /**
         * Creates a plain object from a ChatDialogue message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.ChatDialogue
         * @static
         * @param {message.ChatDialogue} message ChatDialogue
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatDialogue.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = "";
                object.lastMessageId = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.lastMessageTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.lastMessageTime = options.longs === String ? "0" : 0;
                object.id = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.unreadMessageCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.unreadMessageCount = options.longs === String ? "0" : 0;
                object.roomId = "";
                object.lastMessage = null;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.lastMessageId != null && message.hasOwnProperty("lastMessageId"))
                object.lastMessageId = message.lastMessageId;
            if (message.lastMessageTime != null && message.hasOwnProperty("lastMessageTime"))
                if (typeof message.lastMessageTime === "number")
                    object.lastMessageTime = options.longs === String ? String(message.lastMessageTime) : message.lastMessageTime;
                else
                    object.lastMessageTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastMessageTime) : options.longs === Number ? new $util.LongBits(message.lastMessageTime.low >>> 0, message.lastMessageTime.high >>> 0).toNumber() : message.lastMessageTime;
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.unreadMessageCount != null && message.hasOwnProperty("unreadMessageCount"))
                if (typeof message.unreadMessageCount === "number")
                    object.unreadMessageCount = options.longs === String ? String(message.unreadMessageCount) : message.unreadMessageCount;
                else
                    object.unreadMessageCount = options.longs === String ? $util.Long.prototype.toString.call(message.unreadMessageCount) : options.longs === Number ? new $util.LongBits(message.unreadMessageCount.low >>> 0, message.unreadMessageCount.high >>> 0).toNumber() : message.unreadMessageCount;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.lastMessage != null && message.hasOwnProperty("lastMessage"))
                object.lastMessage = $root.message.Messages.toObject(message.lastMessage, options);
            return object;
        };

        /**
         * Converts this ChatDialogue to JSON.
         * @function toJSON
         * @memberof message.ChatDialogue
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatDialogue.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChatDialogue;
    })();

    message.MessagesAudio = (function() {

        /**
         * Properties of a MessagesAudio.
         * @memberof message
         * @interface IMessagesAudio
         * @property {number|Long|null} [time] MessagesAudio time
         * @property {string|null} [url] MessagesAudio url
         */

        /**
         * Constructs a new MessagesAudio.
         * @memberof message
         * @classdesc Represents a MessagesAudio.
         * @implements IMessagesAudio
         * @constructor
         * @param {message.IMessagesAudio=} [properties] Properties to set
         */
        function MessagesAudio(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessagesAudio time.
         * @member {number|Long} time
         * @memberof message.MessagesAudio
         * @instance
         */
        MessagesAudio.prototype.time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessagesAudio url.
         * @member {string} url
         * @memberof message.MessagesAudio
         * @instance
         */
        MessagesAudio.prototype.url = "";

        /**
         * Creates a new MessagesAudio instance using the specified properties.
         * @function create
         * @memberof message.MessagesAudio
         * @static
         * @param {message.IMessagesAudio=} [properties] Properties to set
         * @returns {message.MessagesAudio} MessagesAudio instance
         */
        MessagesAudio.create = function create(properties) {
            return new MessagesAudio(properties);
        };

        /**
         * Encodes the specified MessagesAudio message. Does not implicitly {@link message.MessagesAudio.verify|verify} messages.
         * @function encode
         * @memberof message.MessagesAudio
         * @static
         * @param {message.IMessagesAudio} message MessagesAudio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesAudio.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.time);
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
            return writer;
        };

        /**
         * Encodes the specified MessagesAudio message, length delimited. Does not implicitly {@link message.MessagesAudio.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.MessagesAudio
         * @static
         * @param {message.IMessagesAudio} message MessagesAudio message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesAudio.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessagesAudio message from the specified reader or buffer.
         * @function decode
         * @memberof message.MessagesAudio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.MessagesAudio} MessagesAudio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesAudio.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.MessagesAudio();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.time = reader.int64();
                    break;
                case 2:
                    message.url = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessagesAudio message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.MessagesAudio
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.MessagesAudio} MessagesAudio
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesAudio.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessagesAudio message.
         * @function verify
         * @memberof message.MessagesAudio
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessagesAudio.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                    return "time: integer|Long expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            return null;
        };

        /**
         * Creates a MessagesAudio message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.MessagesAudio
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.MessagesAudio} MessagesAudio
         */
        MessagesAudio.fromObject = function fromObject(object) {
            if (object instanceof $root.message.MessagesAudio)
                return object;
            var message = new $root.message.MessagesAudio();
            if (object.time != null)
                if ($util.Long)
                    (message.time = $util.Long.fromValue(object.time)).unsigned = false;
                else if (typeof object.time === "string")
                    message.time = parseInt(object.time, 10);
                else if (typeof object.time === "number")
                    message.time = object.time;
                else if (typeof object.time === "object")
                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
            if (object.url != null)
                message.url = String(object.url);
            return message;
        };

        /**
         * Creates a plain object from a MessagesAudio message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.MessagesAudio
         * @static
         * @param {message.MessagesAudio} message MessagesAudio
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessagesAudio.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.time = options.longs === String ? "0" : 0;
                object.url = "";
            }
            if (message.time != null && message.hasOwnProperty("time"))
                if (typeof message.time === "number")
                    object.time = options.longs === String ? String(message.time) : message.time;
                else
                    object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            return object;
        };

        /**
         * Converts this MessagesAudio to JSON.
         * @function toJSON
         * @memberof message.MessagesAudio
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessagesAudio.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessagesAudio;
    })();

    message.MessagesVideo = (function() {

        /**
         * Properties of a MessagesVideo.
         * @memberof message
         * @interface IMessagesVideo
         * @property {number|Long|null} [time] MessagesVideo time
         * @property {string|null} [url] MessagesVideo url
         * @property {number|Long|null} [width] MessagesVideo width
         * @property {number|Long|null} [height] MessagesVideo height
         * @property {string|null} [type] MessagesVideo type
         */

        /**
         * Constructs a new MessagesVideo.
         * @memberof message
         * @classdesc Represents a MessagesVideo.
         * @implements IMessagesVideo
         * @constructor
         * @param {message.IMessagesVideo=} [properties] Properties to set
         */
        function MessagesVideo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessagesVideo time.
         * @member {number|Long} time
         * @memberof message.MessagesVideo
         * @instance
         */
        MessagesVideo.prototype.time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessagesVideo url.
         * @member {string} url
         * @memberof message.MessagesVideo
         * @instance
         */
        MessagesVideo.prototype.url = "";

        /**
         * MessagesVideo width.
         * @member {number|Long} width
         * @memberof message.MessagesVideo
         * @instance
         */
        MessagesVideo.prototype.width = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessagesVideo height.
         * @member {number|Long} height
         * @memberof message.MessagesVideo
         * @instance
         */
        MessagesVideo.prototype.height = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessagesVideo type.
         * @member {string} type
         * @memberof message.MessagesVideo
         * @instance
         */
        MessagesVideo.prototype.type = "";

        /**
         * Creates a new MessagesVideo instance using the specified properties.
         * @function create
         * @memberof message.MessagesVideo
         * @static
         * @param {message.IMessagesVideo=} [properties] Properties to set
         * @returns {message.MessagesVideo} MessagesVideo instance
         */
        MessagesVideo.create = function create(properties) {
            return new MessagesVideo(properties);
        };

        /**
         * Encodes the specified MessagesVideo message. Does not implicitly {@link message.MessagesVideo.verify|verify} messages.
         * @function encode
         * @memberof message.MessagesVideo
         * @static
         * @param {message.IMessagesVideo} message MessagesVideo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesVideo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.time);
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
            if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.width);
            if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.height);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.type);
            return writer;
        };

        /**
         * Encodes the specified MessagesVideo message, length delimited. Does not implicitly {@link message.MessagesVideo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.MessagesVideo
         * @static
         * @param {message.IMessagesVideo} message MessagesVideo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesVideo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessagesVideo message from the specified reader or buffer.
         * @function decode
         * @memberof message.MessagesVideo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.MessagesVideo} MessagesVideo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesVideo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.MessagesVideo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.time = reader.int64();
                    break;
                case 2:
                    message.url = reader.string();
                    break;
                case 3:
                    message.width = reader.int64();
                    break;
                case 4:
                    message.height = reader.int64();
                    break;
                case 5:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessagesVideo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.MessagesVideo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.MessagesVideo} MessagesVideo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesVideo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessagesVideo message.
         * @function verify
         * @memberof message.MessagesVideo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessagesVideo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                    return "time: integer|Long expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.width != null && message.hasOwnProperty("width"))
                if (!$util.isInteger(message.width) && !(message.width && $util.isInteger(message.width.low) && $util.isInteger(message.width.high)))
                    return "width: integer|Long expected";
            if (message.height != null && message.hasOwnProperty("height"))
                if (!$util.isInteger(message.height) && !(message.height && $util.isInteger(message.height.low) && $util.isInteger(message.height.high)))
                    return "height: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            return null;
        };

        /**
         * Creates a MessagesVideo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.MessagesVideo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.MessagesVideo} MessagesVideo
         */
        MessagesVideo.fromObject = function fromObject(object) {
            if (object instanceof $root.message.MessagesVideo)
                return object;
            var message = new $root.message.MessagesVideo();
            if (object.time != null)
                if ($util.Long)
                    (message.time = $util.Long.fromValue(object.time)).unsigned = false;
                else if (typeof object.time === "string")
                    message.time = parseInt(object.time, 10);
                else if (typeof object.time === "number")
                    message.time = object.time;
                else if (typeof object.time === "object")
                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
            if (object.url != null)
                message.url = String(object.url);
            if (object.width != null)
                if ($util.Long)
                    (message.width = $util.Long.fromValue(object.width)).unsigned = false;
                else if (typeof object.width === "string")
                    message.width = parseInt(object.width, 10);
                else if (typeof object.width === "number")
                    message.width = object.width;
                else if (typeof object.width === "object")
                    message.width = new $util.LongBits(object.width.low >>> 0, object.width.high >>> 0).toNumber();
            if (object.height != null)
                if ($util.Long)
                    (message.height = $util.Long.fromValue(object.height)).unsigned = false;
                else if (typeof object.height === "string")
                    message.height = parseInt(object.height, 10);
                else if (typeof object.height === "number")
                    message.height = object.height;
                else if (typeof object.height === "object")
                    message.height = new $util.LongBits(object.height.low >>> 0, object.height.high >>> 0).toNumber();
            if (object.type != null)
                message.type = String(object.type);
            return message;
        };

        /**
         * Creates a plain object from a MessagesVideo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.MessagesVideo
         * @static
         * @param {message.MessagesVideo} message MessagesVideo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessagesVideo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.time = options.longs === String ? "0" : 0;
                object.url = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.width = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.width = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.height = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.height = options.longs === String ? "0" : 0;
                object.type = "";
            }
            if (message.time != null && message.hasOwnProperty("time"))
                if (typeof message.time === "number")
                    object.time = options.longs === String ? String(message.time) : message.time;
                else
                    object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.width != null && message.hasOwnProperty("width"))
                if (typeof message.width === "number")
                    object.width = options.longs === String ? String(message.width) : message.width;
                else
                    object.width = options.longs === String ? $util.Long.prototype.toString.call(message.width) : options.longs === Number ? new $util.LongBits(message.width.low >>> 0, message.width.high >>> 0).toNumber() : message.width;
            if (message.height != null && message.hasOwnProperty("height"))
                if (typeof message.height === "number")
                    object.height = options.longs === String ? String(message.height) : message.height;
                else
                    object.height = options.longs === String ? $util.Long.prototype.toString.call(message.height) : options.longs === Number ? new $util.LongBits(message.height.low >>> 0, message.height.high >>> 0).toNumber() : message.height;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this MessagesVideo to JSON.
         * @function toJSON
         * @memberof message.MessagesVideo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessagesVideo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessagesVideo;
    })();

    message.MessagesImage = (function() {

        /**
         * Properties of a MessagesImage.
         * @memberof message
         * @interface IMessagesImage
         * @property {string|null} [url] MessagesImage url
         * @property {number|Long|null} [width] MessagesImage width
         * @property {number|Long|null} [height] MessagesImage height
         * @property {string|null} [type] MessagesImage type
         */

        /**
         * Constructs a new MessagesImage.
         * @memberof message
         * @classdesc Represents a MessagesImage.
         * @implements IMessagesImage
         * @constructor
         * @param {message.IMessagesImage=} [properties] Properties to set
         */
        function MessagesImage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessagesImage url.
         * @member {string} url
         * @memberof message.MessagesImage
         * @instance
         */
        MessagesImage.prototype.url = "";

        /**
         * MessagesImage width.
         * @member {number|Long} width
         * @memberof message.MessagesImage
         * @instance
         */
        MessagesImage.prototype.width = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessagesImage height.
         * @member {number|Long} height
         * @memberof message.MessagesImage
         * @instance
         */
        MessagesImage.prototype.height = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessagesImage type.
         * @member {string} type
         * @memberof message.MessagesImage
         * @instance
         */
        MessagesImage.prototype.type = "";

        /**
         * Creates a new MessagesImage instance using the specified properties.
         * @function create
         * @memberof message.MessagesImage
         * @static
         * @param {message.IMessagesImage=} [properties] Properties to set
         * @returns {message.MessagesImage} MessagesImage instance
         */
        MessagesImage.create = function create(properties) {
            return new MessagesImage(properties);
        };

        /**
         * Encodes the specified MessagesImage message. Does not implicitly {@link message.MessagesImage.verify|verify} messages.
         * @function encode
         * @memberof message.MessagesImage
         * @static
         * @param {message.IMessagesImage} message MessagesImage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesImage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
            if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.width);
            if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.height);
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.type);
            return writer;
        };

        /**
         * Encodes the specified MessagesImage message, length delimited. Does not implicitly {@link message.MessagesImage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.MessagesImage
         * @static
         * @param {message.IMessagesImage} message MessagesImage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesImage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessagesImage message from the specified reader or buffer.
         * @function decode
         * @memberof message.MessagesImage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.MessagesImage} MessagesImage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesImage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.MessagesImage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.url = reader.string();
                    break;
                case 2:
                    message.width = reader.int64();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessagesImage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.MessagesImage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.MessagesImage} MessagesImage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesImage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessagesImage message.
         * @function verify
         * @memberof message.MessagesImage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessagesImage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.url != null && message.hasOwnProperty("url"))
                if (!$util.isString(message.url))
                    return "url: string expected";
            if (message.width != null && message.hasOwnProperty("width"))
                if (!$util.isInteger(message.width) && !(message.width && $util.isInteger(message.width.low) && $util.isInteger(message.width.high)))
                    return "width: integer|Long expected";
            if (message.height != null && message.hasOwnProperty("height"))
                if (!$util.isInteger(message.height) && !(message.height && $util.isInteger(message.height.low) && $util.isInteger(message.height.high)))
                    return "height: integer|Long expected";
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            return null;
        };

        /**
         * Creates a MessagesImage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.MessagesImage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.MessagesImage} MessagesImage
         */
        MessagesImage.fromObject = function fromObject(object) {
            if (object instanceof $root.message.MessagesImage)
                return object;
            var message = new $root.message.MessagesImage();
            if (object.url != null)
                message.url = String(object.url);
            if (object.width != null)
                if ($util.Long)
                    (message.width = $util.Long.fromValue(object.width)).unsigned = false;
                else if (typeof object.width === "string")
                    message.width = parseInt(object.width, 10);
                else if (typeof object.width === "number")
                    message.width = object.width;
                else if (typeof object.width === "object")
                    message.width = new $util.LongBits(object.width.low >>> 0, object.width.high >>> 0).toNumber();
            if (object.height != null)
                if ($util.Long)
                    (message.height = $util.Long.fromValue(object.height)).unsigned = false;
                else if (typeof object.height === "string")
                    message.height = parseInt(object.height, 10);
                else if (typeof object.height === "number")
                    message.height = object.height;
                else if (typeof object.height === "object")
                    message.height = new $util.LongBits(object.height.low >>> 0, object.height.high >>> 0).toNumber();
            if (object.type != null)
                message.type = String(object.type);
            return message;
        };

        /**
         * Creates a plain object from a MessagesImage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.MessagesImage
         * @static
         * @param {message.MessagesImage} message MessagesImage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessagesImage.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.url = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.width = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.width = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.height = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.height = options.longs === String ? "0" : 0;
                object.type = "";
            }
            if (message.url != null && message.hasOwnProperty("url"))
                object.url = message.url;
            if (message.width != null && message.hasOwnProperty("width"))
                if (typeof message.width === "number")
                    object.width = options.longs === String ? String(message.width) : message.width;
                else
                    object.width = options.longs === String ? $util.Long.prototype.toString.call(message.width) : options.longs === Number ? new $util.LongBits(message.width.low >>> 0, message.width.high >>> 0).toNumber() : message.width;
            if (message.height != null && message.hasOwnProperty("height"))
                if (typeof message.height === "number")
                    object.height = options.longs === String ? String(message.height) : message.height;
                else
                    object.height = options.longs === String ? $util.Long.prototype.toString.call(message.height) : options.longs === Number ? new $util.LongBits(message.height.low >>> 0, message.height.high >>> 0).toNumber() : message.height;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            return object;
        };

        /**
         * Converts this MessagesImage to JSON.
         * @function toJSON
         * @memberof message.MessagesImage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessagesImage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessagesImage;
    })();

    message.MessagesCall = (function() {

        /**
         * Properties of a MessagesCall.
         * @memberof message
         * @interface IMessagesCall
         * @property {number|Long|null} [status] MessagesCall status
         * @property {string|null} [roomId] MessagesCall roomId
         * @property {Array.<message.IMessagesCallParticipants>|null} [participants] MessagesCall participants
         * @property {string|null} [type] MessagesCall type
         * @property {number|Long|null} [time] MessagesCall time
         */

        /**
         * Constructs a new MessagesCall.
         * @memberof message
         * @classdesc Represents a MessagesCall.
         * @implements IMessagesCall
         * @constructor
         * @param {message.IMessagesCall=} [properties] Properties to set
         */
        function MessagesCall(properties) {
            this.participants = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessagesCall status.
         * @member {number|Long} status
         * @memberof message.MessagesCall
         * @instance
         */
        MessagesCall.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MessagesCall roomId.
         * @member {string} roomId
         * @memberof message.MessagesCall
         * @instance
         */
        MessagesCall.prototype.roomId = "";

        /**
         * MessagesCall participants.
         * @member {Array.<message.IMessagesCallParticipants>} participants
         * @memberof message.MessagesCall
         * @instance
         */
        MessagesCall.prototype.participants = $util.emptyArray;

        /**
         * MessagesCall type.
         * @member {string} type
         * @memberof message.MessagesCall
         * @instance
         */
        MessagesCall.prototype.type = "";

        /**
         * MessagesCall time.
         * @member {number|Long} time
         * @memberof message.MessagesCall
         * @instance
         */
        MessagesCall.prototype.time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new MessagesCall instance using the specified properties.
         * @function create
         * @memberof message.MessagesCall
         * @static
         * @param {message.IMessagesCall=} [properties] Properties to set
         * @returns {message.MessagesCall} MessagesCall instance
         */
        MessagesCall.create = function create(properties) {
            return new MessagesCall(properties);
        };

        /**
         * Encodes the specified MessagesCall message. Does not implicitly {@link message.MessagesCall.verify|verify} messages.
         * @function encode
         * @memberof message.MessagesCall
         * @static
         * @param {message.IMessagesCall} message MessagesCall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesCall.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.status);
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.roomId);
            if (message.participants != null && message.participants.length)
                for (var i = 0; i < message.participants.length; ++i)
                    $root.message.MessagesCallParticipants.encode(message.participants[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.type);
            if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.time);
            return writer;
        };

        /**
         * Encodes the specified MessagesCall message, length delimited. Does not implicitly {@link message.MessagesCall.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.MessagesCall
         * @static
         * @param {message.IMessagesCall} message MessagesCall message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesCall.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessagesCall message from the specified reader or buffer.
         * @function decode
         * @memberof message.MessagesCall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.MessagesCall} MessagesCall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesCall.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.MessagesCall();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.status = reader.int64();
                    break;
                case 2:
                    message.roomId = reader.string();
                    break;
                case 3:
                    if (!(message.participants && message.participants.length))
                        message.participants = [];
                    message.participants.push($root.message.MessagesCallParticipants.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.type = reader.string();
                    break;
                case 5:
                    message.time = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessagesCall message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.MessagesCall
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.MessagesCall} MessagesCall
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesCall.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessagesCall message.
         * @function verify
         * @memberof message.MessagesCall
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessagesCall.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                    return "status: integer|Long expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.participants != null && message.hasOwnProperty("participants")) {
                if (!Array.isArray(message.participants))
                    return "participants: array expected";
                for (var i = 0; i < message.participants.length; ++i) {
                    var error = $root.message.MessagesCallParticipants.verify(message.participants[i]);
                    if (error)
                        return "participants." + error;
                }
            }
            if (message.type != null && message.hasOwnProperty("type"))
                if (!$util.isString(message.type))
                    return "type: string expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                    return "time: integer|Long expected";
            return null;
        };

        /**
         * Creates a MessagesCall message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.MessagesCall
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.MessagesCall} MessagesCall
         */
        MessagesCall.fromObject = function fromObject(object) {
            if (object instanceof $root.message.MessagesCall)
                return object;
            var message = new $root.message.MessagesCall();
            if (object.status != null)
                if ($util.Long)
                    (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                else if (typeof object.status === "string")
                    message.status = parseInt(object.status, 10);
                else if (typeof object.status === "number")
                    message.status = object.status;
                else if (typeof object.status === "object")
                    message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.participants) {
                if (!Array.isArray(object.participants))
                    throw TypeError(".message.MessagesCall.participants: array expected");
                message.participants = [];
                for (var i = 0; i < object.participants.length; ++i) {
                    if (typeof object.participants[i] !== "object")
                        throw TypeError(".message.MessagesCall.participants: object expected");
                    message.participants[i] = $root.message.MessagesCallParticipants.fromObject(object.participants[i]);
                }
            }
            if (object.type != null)
                message.type = String(object.type);
            if (object.time != null)
                if ($util.Long)
                    (message.time = $util.Long.fromValue(object.time)).unsigned = false;
                else if (typeof object.time === "string")
                    message.time = parseInt(object.time, 10);
                else if (typeof object.time === "number")
                    message.time = object.time;
                else if (typeof object.time === "object")
                    message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a MessagesCall message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.MessagesCall
         * @static
         * @param {message.MessagesCall} message MessagesCall
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessagesCall.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.participants = [];
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.status = options.longs === String ? "0" : 0;
                object.roomId = "";
                object.type = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.time = options.longs === String ? "0" : 0;
            }
            if (message.status != null && message.hasOwnProperty("status"))
                if (typeof message.status === "number")
                    object.status = options.longs === String ? String(message.status) : message.status;
                else
                    object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.participants && message.participants.length) {
                object.participants = [];
                for (var j = 0; j < message.participants.length; ++j)
                    object.participants[j] = $root.message.MessagesCallParticipants.toObject(message.participants[j], options);
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.time != null && message.hasOwnProperty("time"))
                if (typeof message.time === "number")
                    object.time = options.longs === String ? String(message.time) : message.time;
                else
                    object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
            return object;
        };

        /**
         * Converts this MessagesCall to JSON.
         * @function toJSON
         * @memberof message.MessagesCall
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessagesCall.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessagesCall;
    })();

    message.MessagesAtUsers = (function() {

        /**
         * Properties of a MessagesAtUsers.
         * @memberof message
         * @interface IMessagesAtUsers
         * @property {string|null} [uid] MessagesAtUsers uid
         */

        /**
         * Constructs a new MessagesAtUsers.
         * @memberof message
         * @classdesc Represents a MessagesAtUsers.
         * @implements IMessagesAtUsers
         * @constructor
         * @param {message.IMessagesAtUsers=} [properties] Properties to set
         */
        function MessagesAtUsers(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessagesAtUsers uid.
         * @member {string} uid
         * @memberof message.MessagesAtUsers
         * @instance
         */
        MessagesAtUsers.prototype.uid = "";

        /**
         * Creates a new MessagesAtUsers instance using the specified properties.
         * @function create
         * @memberof message.MessagesAtUsers
         * @static
         * @param {message.IMessagesAtUsers=} [properties] Properties to set
         * @returns {message.MessagesAtUsers} MessagesAtUsers instance
         */
        MessagesAtUsers.create = function create(properties) {
            return new MessagesAtUsers(properties);
        };

        /**
         * Encodes the specified MessagesAtUsers message. Does not implicitly {@link message.MessagesAtUsers.verify|verify} messages.
         * @function encode
         * @memberof message.MessagesAtUsers
         * @static
         * @param {message.IMessagesAtUsers} message MessagesAtUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesAtUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
            return writer;
        };

        /**
         * Encodes the specified MessagesAtUsers message, length delimited. Does not implicitly {@link message.MessagesAtUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.MessagesAtUsers
         * @static
         * @param {message.IMessagesAtUsers} message MessagesAtUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesAtUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessagesAtUsers message from the specified reader or buffer.
         * @function decode
         * @memberof message.MessagesAtUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.MessagesAtUsers} MessagesAtUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesAtUsers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.MessagesAtUsers();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessagesAtUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.MessagesAtUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.MessagesAtUsers} MessagesAtUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesAtUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessagesAtUsers message.
         * @function verify
         * @memberof message.MessagesAtUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessagesAtUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            return null;
        };

        /**
         * Creates a MessagesAtUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.MessagesAtUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.MessagesAtUsers} MessagesAtUsers
         */
        MessagesAtUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.message.MessagesAtUsers)
                return object;
            var message = new $root.message.MessagesAtUsers();
            if (object.uid != null)
                message.uid = String(object.uid);
            return message;
        };

        /**
         * Creates a plain object from a MessagesAtUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.MessagesAtUsers
         * @static
         * @param {message.MessagesAtUsers} message MessagesAtUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessagesAtUsers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.uid = "";
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this MessagesAtUsers to JSON.
         * @function toJSON
         * @memberof message.MessagesAtUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessagesAtUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessagesAtUsers;
    })();

    message.MessagesReadUsers = (function() {

        /**
         * Properties of a MessagesReadUsers.
         * @memberof message
         * @interface IMessagesReadUsers
         * @property {string|null} [uid] MessagesReadUsers uid
         */

        /**
         * Constructs a new MessagesReadUsers.
         * @memberof message
         * @classdesc Represents a MessagesReadUsers.
         * @implements IMessagesReadUsers
         * @constructor
         * @param {message.IMessagesReadUsers=} [properties] Properties to set
         */
        function MessagesReadUsers(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessagesReadUsers uid.
         * @member {string} uid
         * @memberof message.MessagesReadUsers
         * @instance
         */
        MessagesReadUsers.prototype.uid = "";

        /**
         * Creates a new MessagesReadUsers instance using the specified properties.
         * @function create
         * @memberof message.MessagesReadUsers
         * @static
         * @param {message.IMessagesReadUsers=} [properties] Properties to set
         * @returns {message.MessagesReadUsers} MessagesReadUsers instance
         */
        MessagesReadUsers.create = function create(properties) {
            return new MessagesReadUsers(properties);
        };

        /**
         * Encodes the specified MessagesReadUsers message. Does not implicitly {@link message.MessagesReadUsers.verify|verify} messages.
         * @function encode
         * @memberof message.MessagesReadUsers
         * @static
         * @param {message.IMessagesReadUsers} message MessagesReadUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesReadUsers.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
            return writer;
        };

        /**
         * Encodes the specified MessagesReadUsers message, length delimited. Does not implicitly {@link message.MessagesReadUsers.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.MessagesReadUsers
         * @static
         * @param {message.IMessagesReadUsers} message MessagesReadUsers message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesReadUsers.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessagesReadUsers message from the specified reader or buffer.
         * @function decode
         * @memberof message.MessagesReadUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.MessagesReadUsers} MessagesReadUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesReadUsers.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.MessagesReadUsers();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessagesReadUsers message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.MessagesReadUsers
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.MessagesReadUsers} MessagesReadUsers
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesReadUsers.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessagesReadUsers message.
         * @function verify
         * @memberof message.MessagesReadUsers
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessagesReadUsers.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            return null;
        };

        /**
         * Creates a MessagesReadUsers message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.MessagesReadUsers
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.MessagesReadUsers} MessagesReadUsers
         */
        MessagesReadUsers.fromObject = function fromObject(object) {
            if (object instanceof $root.message.MessagesReadUsers)
                return object;
            var message = new $root.message.MessagesReadUsers();
            if (object.uid != null)
                message.uid = String(object.uid);
            return message;
        };

        /**
         * Creates a plain object from a MessagesReadUsers message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.MessagesReadUsers
         * @static
         * @param {message.MessagesReadUsers} message MessagesReadUsers
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessagesReadUsers.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.uid = "";
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            return object;
        };

        /**
         * Converts this MessagesReadUsers to JSON.
         * @function toJSON
         * @memberof message.MessagesReadUsers
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessagesReadUsers.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessagesReadUsers;
    })();

    message.MessagesForwardMessages = (function() {

        /**
         * Properties of a MessagesForwardMessages.
         * @memberof message
         * @interface IMessagesForwardMessages
         * @property {string|null} [id] MessagesForwardMessages id
         */

        /**
         * Constructs a new MessagesForwardMessages.
         * @memberof message
         * @classdesc Represents a MessagesForwardMessages.
         * @implements IMessagesForwardMessages
         * @constructor
         * @param {message.IMessagesForwardMessages=} [properties] Properties to set
         */
        function MessagesForwardMessages(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessagesForwardMessages id.
         * @member {string} id
         * @memberof message.MessagesForwardMessages
         * @instance
         */
        MessagesForwardMessages.prototype.id = "";

        /**
         * Creates a new MessagesForwardMessages instance using the specified properties.
         * @function create
         * @memberof message.MessagesForwardMessages
         * @static
         * @param {message.IMessagesForwardMessages=} [properties] Properties to set
         * @returns {message.MessagesForwardMessages} MessagesForwardMessages instance
         */
        MessagesForwardMessages.create = function create(properties) {
            return new MessagesForwardMessages(properties);
        };

        /**
         * Encodes the specified MessagesForwardMessages message. Does not implicitly {@link message.MessagesForwardMessages.verify|verify} messages.
         * @function encode
         * @memberof message.MessagesForwardMessages
         * @static
         * @param {message.IMessagesForwardMessages} message MessagesForwardMessages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesForwardMessages.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            return writer;
        };

        /**
         * Encodes the specified MessagesForwardMessages message, length delimited. Does not implicitly {@link message.MessagesForwardMessages.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.MessagesForwardMessages
         * @static
         * @param {message.IMessagesForwardMessages} message MessagesForwardMessages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesForwardMessages.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessagesForwardMessages message from the specified reader or buffer.
         * @function decode
         * @memberof message.MessagesForwardMessages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.MessagesForwardMessages} MessagesForwardMessages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesForwardMessages.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.MessagesForwardMessages();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessagesForwardMessages message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.MessagesForwardMessages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.MessagesForwardMessages} MessagesForwardMessages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesForwardMessages.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessagesForwardMessages message.
         * @function verify
         * @memberof message.MessagesForwardMessages
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessagesForwardMessages.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            return null;
        };

        /**
         * Creates a MessagesForwardMessages message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.MessagesForwardMessages
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.MessagesForwardMessages} MessagesForwardMessages
         */
        MessagesForwardMessages.fromObject = function fromObject(object) {
            if (object instanceof $root.message.MessagesForwardMessages)
                return object;
            var message = new $root.message.MessagesForwardMessages();
            if (object.id != null)
                message.id = String(object.id);
            return message;
        };

        /**
         * Creates a plain object from a MessagesForwardMessages message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.MessagesForwardMessages
         * @static
         * @param {message.MessagesForwardMessages} message MessagesForwardMessages
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessagesForwardMessages.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            return object;
        };

        /**
         * Converts this MessagesForwardMessages to JSON.
         * @function toJSON
         * @memberof message.MessagesForwardMessages
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessagesForwardMessages.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessagesForwardMessages;
    })();

    message.Messages = (function() {

        /**
         * Properties of a Messages.
         * @memberof message
         * @interface IMessages
         * @property {string|null} [id] Messages id
         * @property {string|null} [roomId] Messages roomId
         * @property {string|null} [authorId] Messages authorId
         * @property {string|null} [replyId] Messages replyId
         * @property {message.IMessages|null} [replyMessage] Messages replyMessage
         * @property {Array.<message.IMessagesAtUsers>|null} [atUsers] Messages atUsers
         * @property {Array.<message.IMessagesReadUsers>|null} [readUsers] Messages readUsers
         * @property {Array.<message.IMessagesForwardMessages>|null} [forwardMessages] Messages forwardMessages
         * @property {string|null} [message] Messages message
         * @property {message.IMessagesAudio|null} [audio] Messages audio
         * @property {message.IMessagesVideo|null} [video] Messages video
         * @property {message.IMessagesImage|null} [image] Messages image
         * @property {message.IMessagesCall|null} [call] Messages call
         * @property {number|Long|null} [createTime] Messages createTime
         * @property {number|Long|null} [deadlineTime] Messages deadlineTime
         * @property {number|Long|null} [recallTime] Messages recallTime
         * @property {number|Long|null} [editTime] Messages editTime
         */

        /**
         * Constructs a new Messages.
         * @memberof message
         * @classdesc Represents a Messages.
         * @implements IMessages
         * @constructor
         * @param {message.IMessages=} [properties] Properties to set
         */
        function Messages(properties) {
            this.atUsers = [];
            this.readUsers = [];
            this.forwardMessages = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Messages id.
         * @member {string} id
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.id = "";

        /**
         * Messages roomId.
         * @member {string} roomId
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.roomId = "";

        /**
         * Messages authorId.
         * @member {string} authorId
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.authorId = "";

        /**
         * Messages replyId.
         * @member {string} replyId
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.replyId = "";

        /**
         * Messages replyMessage.
         * @member {message.IMessages|null|undefined} replyMessage
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.replyMessage = null;

        /**
         * Messages atUsers.
         * @member {Array.<message.IMessagesAtUsers>} atUsers
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.atUsers = $util.emptyArray;

        /**
         * Messages readUsers.
         * @member {Array.<message.IMessagesReadUsers>} readUsers
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.readUsers = $util.emptyArray;

        /**
         * Messages forwardMessages.
         * @member {Array.<message.IMessagesForwardMessages>} forwardMessages
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.forwardMessages = $util.emptyArray;

        /**
         * Messages message.
         * @member {string} message
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.message = "";

        /**
         * Messages audio.
         * @member {message.IMessagesAudio|null|undefined} audio
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.audio = null;

        /**
         * Messages video.
         * @member {message.IMessagesVideo|null|undefined} video
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.video = null;

        /**
         * Messages image.
         * @member {message.IMessagesImage|null|undefined} image
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.image = null;

        /**
         * Messages call.
         * @member {message.IMessagesCall|null|undefined} call
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.call = null;

        /**
         * Messages createTime.
         * @member {number|Long} createTime
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Messages deadlineTime.
         * @member {number|Long} deadlineTime
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.deadlineTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Messages recallTime.
         * @member {number|Long} recallTime
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.recallTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Messages editTime.
         * @member {number|Long} editTime
         * @memberof message.Messages
         * @instance
         */
        Messages.prototype.editTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new Messages instance using the specified properties.
         * @function create
         * @memberof message.Messages
         * @static
         * @param {message.IMessages=} [properties] Properties to set
         * @returns {message.Messages} Messages instance
         */
        Messages.create = function create(properties) {
            return new Messages(properties);
        };

        /**
         * Encodes the specified Messages message. Does not implicitly {@link message.Messages.verify|verify} messages.
         * @function encode
         * @memberof message.Messages
         * @static
         * @param {message.IMessages} message Messages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Messages.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.roomId);
            if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.authorId);
            if (message.replyId != null && Object.hasOwnProperty.call(message, "replyId"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.replyId);
            if (message.atUsers != null && message.atUsers.length)
                for (var i = 0; i < message.atUsers.length; ++i)
                    $root.message.MessagesAtUsers.encode(message.atUsers[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.readUsers != null && message.readUsers.length)
                for (var i = 0; i < message.readUsers.length; ++i)
                    $root.message.MessagesReadUsers.encode(message.readUsers[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.forwardMessages != null && message.forwardMessages.length)
                for (var i = 0; i < message.forwardMessages.length; ++i)
                    $root.message.MessagesForwardMessages.encode(message.forwardMessages[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.message);
            if (message.audio != null && Object.hasOwnProperty.call(message, "audio"))
                $root.message.MessagesAudio.encode(message.audio, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            if (message.video != null && Object.hasOwnProperty.call(message, "video"))
                $root.message.MessagesVideo.encode(message.video, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
            if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                $root.message.MessagesImage.encode(message.image, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.call != null && Object.hasOwnProperty.call(message, "call"))
                $root.message.MessagesCall.encode(message.call, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                writer.uint32(/* id 13, wireType 0 =*/104).int64(message.createTime);
            if (message.deadlineTime != null && Object.hasOwnProperty.call(message, "deadlineTime"))
                writer.uint32(/* id 14, wireType 0 =*/112).int64(message.deadlineTime);
            if (message.recallTime != null && Object.hasOwnProperty.call(message, "recallTime"))
                writer.uint32(/* id 15, wireType 0 =*/120).int64(message.recallTime);
            if (message.replyMessage != null && Object.hasOwnProperty.call(message, "replyMessage"))
                $root.message.Messages.encode(message.replyMessage, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
            if (message.editTime != null && Object.hasOwnProperty.call(message, "editTime"))
                writer.uint32(/* id 17, wireType 0 =*/136).int64(message.editTime);
            return writer;
        };

        /**
         * Encodes the specified Messages message, length delimited. Does not implicitly {@link message.Messages.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.Messages
         * @static
         * @param {message.IMessages} message Messages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Messages.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Messages message from the specified reader or buffer.
         * @function decode
         * @memberof message.Messages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.Messages} Messages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Messages.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.Messages();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.roomId = reader.string();
                    break;
                case 3:
                    message.authorId = reader.string();
                    break;
                case 4:
                    message.replyId = reader.string();
                    break;
                case 16:
                    message.replyMessage = $root.message.Messages.decode(reader, reader.uint32());
                    break;
                case 5:
                    if (!(message.atUsers && message.atUsers.length))
                        message.atUsers = [];
                    message.atUsers.push($root.message.MessagesAtUsers.decode(reader, reader.uint32()));
                    break;
                case 6:
                    if (!(message.readUsers && message.readUsers.length))
                        message.readUsers = [];
                    message.readUsers.push($root.message.MessagesReadUsers.decode(reader, reader.uint32()));
                    break;
                case 7:
                    if (!(message.forwardMessages && message.forwardMessages.length))
                        message.forwardMessages = [];
                    message.forwardMessages.push($root.message.MessagesForwardMessages.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.message = reader.string();
                    break;
                case 9:
                    message.audio = $root.message.MessagesAudio.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.video = $root.message.MessagesVideo.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.image = $root.message.MessagesImage.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.call = $root.message.MessagesCall.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.createTime = reader.int64();
                    break;
                case 14:
                    message.deadlineTime = reader.int64();
                    break;
                case 15:
                    message.recallTime = reader.int64();
                    break;
                case 17:
                    message.editTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Messages message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.Messages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.Messages} Messages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Messages.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Messages message.
         * @function verify
         * @memberof message.Messages
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Messages.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isString(message.roomId))
                    return "roomId: string expected";
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                if (!$util.isString(message.authorId))
                    return "authorId: string expected";
            if (message.replyId != null && message.hasOwnProperty("replyId"))
                if (!$util.isString(message.replyId))
                    return "replyId: string expected";
            if (message.replyMessage != null && message.hasOwnProperty("replyMessage")) {
                var error = $root.message.Messages.verify(message.replyMessage);
                if (error)
                    return "replyMessage." + error;
            }
            if (message.atUsers != null && message.hasOwnProperty("atUsers")) {
                if (!Array.isArray(message.atUsers))
                    return "atUsers: array expected";
                for (var i = 0; i < message.atUsers.length; ++i) {
                    var error = $root.message.MessagesAtUsers.verify(message.atUsers[i]);
                    if (error)
                        return "atUsers." + error;
                }
            }
            if (message.readUsers != null && message.hasOwnProperty("readUsers")) {
                if (!Array.isArray(message.readUsers))
                    return "readUsers: array expected";
                for (var i = 0; i < message.readUsers.length; ++i) {
                    var error = $root.message.MessagesReadUsers.verify(message.readUsers[i]);
                    if (error)
                        return "readUsers." + error;
                }
            }
            if (message.forwardMessages != null && message.hasOwnProperty("forwardMessages")) {
                if (!Array.isArray(message.forwardMessages))
                    return "forwardMessages: array expected";
                for (var i = 0; i < message.forwardMessages.length; ++i) {
                    var error = $root.message.MessagesForwardMessages.verify(message.forwardMessages[i]);
                    if (error)
                        return "forwardMessages." + error;
                }
            }
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.audio != null && message.hasOwnProperty("audio")) {
                var error = $root.message.MessagesAudio.verify(message.audio);
                if (error)
                    return "audio." + error;
            }
            if (message.video != null && message.hasOwnProperty("video")) {
                var error = $root.message.MessagesVideo.verify(message.video);
                if (error)
                    return "video." + error;
            }
            if (message.image != null && message.hasOwnProperty("image")) {
                var error = $root.message.MessagesImage.verify(message.image);
                if (error)
                    return "image." + error;
            }
            if (message.call != null && message.hasOwnProperty("call")) {
                var error = $root.message.MessagesCall.verify(message.call);
                if (error)
                    return "call." + error;
            }
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                    return "createTime: integer|Long expected";
            if (message.deadlineTime != null && message.hasOwnProperty("deadlineTime"))
                if (!$util.isInteger(message.deadlineTime) && !(message.deadlineTime && $util.isInteger(message.deadlineTime.low) && $util.isInteger(message.deadlineTime.high)))
                    return "deadlineTime: integer|Long expected";
            if (message.recallTime != null && message.hasOwnProperty("recallTime"))
                if (!$util.isInteger(message.recallTime) && !(message.recallTime && $util.isInteger(message.recallTime.low) && $util.isInteger(message.recallTime.high)))
                    return "recallTime: integer|Long expected";
            if (message.editTime != null && message.hasOwnProperty("editTime"))
                if (!$util.isInteger(message.editTime) && !(message.editTime && $util.isInteger(message.editTime.low) && $util.isInteger(message.editTime.high)))
                    return "editTime: integer|Long expected";
            return null;
        };

        /**
         * Creates a Messages message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.Messages
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.Messages} Messages
         */
        Messages.fromObject = function fromObject(object) {
            if (object instanceof $root.message.Messages)
                return object;
            var message = new $root.message.Messages();
            if (object.id != null)
                message.id = String(object.id);
            if (object.roomId != null)
                message.roomId = String(object.roomId);
            if (object.authorId != null)
                message.authorId = String(object.authorId);
            if (object.replyId != null)
                message.replyId = String(object.replyId);
            if (object.replyMessage != null) {
                if (typeof object.replyMessage !== "object")
                    throw TypeError(".message.Messages.replyMessage: object expected");
                message.replyMessage = $root.message.Messages.fromObject(object.replyMessage);
            }
            if (object.atUsers) {
                if (!Array.isArray(object.atUsers))
                    throw TypeError(".message.Messages.atUsers: array expected");
                message.atUsers = [];
                for (var i = 0; i < object.atUsers.length; ++i) {
                    if (typeof object.atUsers[i] !== "object")
                        throw TypeError(".message.Messages.atUsers: object expected");
                    message.atUsers[i] = $root.message.MessagesAtUsers.fromObject(object.atUsers[i]);
                }
            }
            if (object.readUsers) {
                if (!Array.isArray(object.readUsers))
                    throw TypeError(".message.Messages.readUsers: array expected");
                message.readUsers = [];
                for (var i = 0; i < object.readUsers.length; ++i) {
                    if (typeof object.readUsers[i] !== "object")
                        throw TypeError(".message.Messages.readUsers: object expected");
                    message.readUsers[i] = $root.message.MessagesReadUsers.fromObject(object.readUsers[i]);
                }
            }
            if (object.forwardMessages) {
                if (!Array.isArray(object.forwardMessages))
                    throw TypeError(".message.Messages.forwardMessages: array expected");
                message.forwardMessages = [];
                for (var i = 0; i < object.forwardMessages.length; ++i) {
                    if (typeof object.forwardMessages[i] !== "object")
                        throw TypeError(".message.Messages.forwardMessages: object expected");
                    message.forwardMessages[i] = $root.message.MessagesForwardMessages.fromObject(object.forwardMessages[i]);
                }
            }
            if (object.message != null)
                message.message = String(object.message);
            if (object.audio != null) {
                if (typeof object.audio !== "object")
                    throw TypeError(".message.Messages.audio: object expected");
                message.audio = $root.message.MessagesAudio.fromObject(object.audio);
            }
            if (object.video != null) {
                if (typeof object.video !== "object")
                    throw TypeError(".message.Messages.video: object expected");
                message.video = $root.message.MessagesVideo.fromObject(object.video);
            }
            if (object.image != null) {
                if (typeof object.image !== "object")
                    throw TypeError(".message.Messages.image: object expected");
                message.image = $root.message.MessagesImage.fromObject(object.image);
            }
            if (object.call != null) {
                if (typeof object.call !== "object")
                    throw TypeError(".message.Messages.call: object expected");
                message.call = $root.message.MessagesCall.fromObject(object.call);
            }
            if (object.createTime != null)
                if ($util.Long)
                    (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                else if (typeof object.createTime === "string")
                    message.createTime = parseInt(object.createTime, 10);
                else if (typeof object.createTime === "number")
                    message.createTime = object.createTime;
                else if (typeof object.createTime === "object")
                    message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
            if (object.deadlineTime != null)
                if ($util.Long)
                    (message.deadlineTime = $util.Long.fromValue(object.deadlineTime)).unsigned = false;
                else if (typeof object.deadlineTime === "string")
                    message.deadlineTime = parseInt(object.deadlineTime, 10);
                else if (typeof object.deadlineTime === "number")
                    message.deadlineTime = object.deadlineTime;
                else if (typeof object.deadlineTime === "object")
                    message.deadlineTime = new $util.LongBits(object.deadlineTime.low >>> 0, object.deadlineTime.high >>> 0).toNumber();
            if (object.recallTime != null)
                if ($util.Long)
                    (message.recallTime = $util.Long.fromValue(object.recallTime)).unsigned = false;
                else if (typeof object.recallTime === "string")
                    message.recallTime = parseInt(object.recallTime, 10);
                else if (typeof object.recallTime === "number")
                    message.recallTime = object.recallTime;
                else if (typeof object.recallTime === "object")
                    message.recallTime = new $util.LongBits(object.recallTime.low >>> 0, object.recallTime.high >>> 0).toNumber();
            if (object.editTime != null)
                if ($util.Long)
                    (message.editTime = $util.Long.fromValue(object.editTime)).unsigned = false;
                else if (typeof object.editTime === "string")
                    message.editTime = parseInt(object.editTime, 10);
                else if (typeof object.editTime === "number")
                    message.editTime = object.editTime;
                else if (typeof object.editTime === "object")
                    message.editTime = new $util.LongBits(object.editTime.low >>> 0, object.editTime.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a Messages message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.Messages
         * @static
         * @param {message.Messages} message Messages
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Messages.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.atUsers = [];
                object.readUsers = [];
                object.forwardMessages = [];
            }
            if (options.defaults) {
                object.id = "";
                object.roomId = "";
                object.authorId = "";
                object.replyId = "";
                object.message = "";
                object.audio = null;
                object.video = null;
                object.image = null;
                object.call = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.createTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.deadlineTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.deadlineTime = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.recallTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.recallTime = options.longs === String ? "0" : 0;
                object.replyMessage = null;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.editTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.editTime = options.longs === String ? "0" : 0;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.authorId != null && message.hasOwnProperty("authorId"))
                object.authorId = message.authorId;
            if (message.replyId != null && message.hasOwnProperty("replyId"))
                object.replyId = message.replyId;
            if (message.atUsers && message.atUsers.length) {
                object.atUsers = [];
                for (var j = 0; j < message.atUsers.length; ++j)
                    object.atUsers[j] = $root.message.MessagesAtUsers.toObject(message.atUsers[j], options);
            }
            if (message.readUsers && message.readUsers.length) {
                object.readUsers = [];
                for (var j = 0; j < message.readUsers.length; ++j)
                    object.readUsers[j] = $root.message.MessagesReadUsers.toObject(message.readUsers[j], options);
            }
            if (message.forwardMessages && message.forwardMessages.length) {
                object.forwardMessages = [];
                for (var j = 0; j < message.forwardMessages.length; ++j)
                    object.forwardMessages[j] = $root.message.MessagesForwardMessages.toObject(message.forwardMessages[j], options);
            }
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.audio != null && message.hasOwnProperty("audio"))
                object.audio = $root.message.MessagesAudio.toObject(message.audio, options);
            if (message.video != null && message.hasOwnProperty("video"))
                object.video = $root.message.MessagesVideo.toObject(message.video, options);
            if (message.image != null && message.hasOwnProperty("image"))
                object.image = $root.message.MessagesImage.toObject(message.image, options);
            if (message.call != null && message.hasOwnProperty("call"))
                object.call = $root.message.MessagesCall.toObject(message.call, options);
            if (message.createTime != null && message.hasOwnProperty("createTime"))
                if (typeof message.createTime === "number")
                    object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                else
                    object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
            if (message.deadlineTime != null && message.hasOwnProperty("deadlineTime"))
                if (typeof message.deadlineTime === "number")
                    object.deadlineTime = options.longs === String ? String(message.deadlineTime) : message.deadlineTime;
                else
                    object.deadlineTime = options.longs === String ? $util.Long.prototype.toString.call(message.deadlineTime) : options.longs === Number ? new $util.LongBits(message.deadlineTime.low >>> 0, message.deadlineTime.high >>> 0).toNumber() : message.deadlineTime;
            if (message.recallTime != null && message.hasOwnProperty("recallTime"))
                if (typeof message.recallTime === "number")
                    object.recallTime = options.longs === String ? String(message.recallTime) : message.recallTime;
                else
                    object.recallTime = options.longs === String ? $util.Long.prototype.toString.call(message.recallTime) : options.longs === Number ? new $util.LongBits(message.recallTime.low >>> 0, message.recallTime.high >>> 0).toNumber() : message.recallTime;
            if (message.replyMessage != null && message.hasOwnProperty("replyMessage"))
                object.replyMessage = $root.message.Messages.toObject(message.replyMessage, options);
            if (message.editTime != null && message.hasOwnProperty("editTime"))
                if (typeof message.editTime === "number")
                    object.editTime = options.longs === String ? String(message.editTime) : message.editTime;
                else
                    object.editTime = options.longs === String ? $util.Long.prototype.toString.call(message.editTime) : options.longs === Number ? new $util.LongBits(message.editTime.low >>> 0, message.editTime.high >>> 0).toNumber() : message.editTime;
            return object;
        };

        /**
         * Converts this Messages to JSON.
         * @function toJSON
         * @memberof message.Messages
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Messages.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Messages;
    })();

    message.GetRecentChatDialogueList = (function() {

        /**
         * Properties of a GetRecentChatDialogueList.
         * @memberof message
         * @interface IGetRecentChatDialogueList
         */

        /**
         * Constructs a new GetRecentChatDialogueList.
         * @memberof message
         * @classdesc Represents a GetRecentChatDialogueList.
         * @implements IGetRecentChatDialogueList
         * @constructor
         * @param {message.IGetRecentChatDialogueList=} [properties] Properties to set
         */
        function GetRecentChatDialogueList(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetRecentChatDialogueList instance using the specified properties.
         * @function create
         * @memberof message.GetRecentChatDialogueList
         * @static
         * @param {message.IGetRecentChatDialogueList=} [properties] Properties to set
         * @returns {message.GetRecentChatDialogueList} GetRecentChatDialogueList instance
         */
        GetRecentChatDialogueList.create = function create(properties) {
            return new GetRecentChatDialogueList(properties);
        };

        /**
         * Encodes the specified GetRecentChatDialogueList message. Does not implicitly {@link message.GetRecentChatDialogueList.verify|verify} messages.
         * @function encode
         * @memberof message.GetRecentChatDialogueList
         * @static
         * @param {message.IGetRecentChatDialogueList} message GetRecentChatDialogueList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRecentChatDialogueList.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetRecentChatDialogueList message, length delimited. Does not implicitly {@link message.GetRecentChatDialogueList.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.GetRecentChatDialogueList
         * @static
         * @param {message.IGetRecentChatDialogueList} message GetRecentChatDialogueList message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetRecentChatDialogueList.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetRecentChatDialogueList message from the specified reader or buffer.
         * @function decode
         * @memberof message.GetRecentChatDialogueList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.GetRecentChatDialogueList} GetRecentChatDialogueList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRecentChatDialogueList.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetRecentChatDialogueList();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetRecentChatDialogueList message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.GetRecentChatDialogueList
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.GetRecentChatDialogueList} GetRecentChatDialogueList
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetRecentChatDialogueList.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetRecentChatDialogueList message.
         * @function verify
         * @memberof message.GetRecentChatDialogueList
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetRecentChatDialogueList.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetRecentChatDialogueList message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.GetRecentChatDialogueList
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.GetRecentChatDialogueList} GetRecentChatDialogueList
         */
        GetRecentChatDialogueList.fromObject = function fromObject(object) {
            if (object instanceof $root.message.GetRecentChatDialogueList)
                return object;
            return new $root.message.GetRecentChatDialogueList();
        };

        /**
         * Creates a plain object from a GetRecentChatDialogueList message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.GetRecentChatDialogueList
         * @static
         * @param {message.GetRecentChatDialogueList} message GetRecentChatDialogueList
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetRecentChatDialogueList.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetRecentChatDialogueList to JSON.
         * @function toJSON
         * @memberof message.GetRecentChatDialogueList
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetRecentChatDialogueList.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetRecentChatDialogueList.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.GetRecentChatDialogueList
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof message.GetRecentChatDialogueList
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.GetRecentChatDialogueList.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.GetRecentChatDialogueList.Request
             * @static
             * @param {message.GetRecentChatDialogueList.IRequest=} [properties] Properties to set
             * @returns {message.GetRecentChatDialogueList.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.GetRecentChatDialogueList.Request.verify|verify} messages.
             * @function encode
             * @memberof message.GetRecentChatDialogueList.Request
             * @static
             * @param {message.GetRecentChatDialogueList.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.GetRecentChatDialogueList.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.GetRecentChatDialogueList.Request
             * @static
             * @param {message.GetRecentChatDialogueList.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.GetRecentChatDialogueList.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.GetRecentChatDialogueList.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetRecentChatDialogueList.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.GetRecentChatDialogueList.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.GetRecentChatDialogueList.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.GetRecentChatDialogueList.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.GetRecentChatDialogueList.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.GetRecentChatDialogueList.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.GetRecentChatDialogueList.Request)
                    return object;
                return new $root.message.GetRecentChatDialogueList.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.GetRecentChatDialogueList.Request
             * @static
             * @param {message.GetRecentChatDialogueList.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.GetRecentChatDialogueList.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetRecentChatDialogueList.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.GetRecentChatDialogueList
             * @interface IResponse
             * @property {Array.<message.IChatDialogue>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof message.GetRecentChatDialogueList
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.GetRecentChatDialogueList.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<message.IChatDialogue>} list
             * @memberof message.GetRecentChatDialogueList.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof message.GetRecentChatDialogueList.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.GetRecentChatDialogueList.Response
             * @static
             * @param {message.GetRecentChatDialogueList.IResponse=} [properties] Properties to set
             * @returns {message.GetRecentChatDialogueList.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.GetRecentChatDialogueList.Response.verify|verify} messages.
             * @function encode
             * @memberof message.GetRecentChatDialogueList.Response
             * @static
             * @param {message.GetRecentChatDialogueList.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.message.ChatDialogue.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.GetRecentChatDialogueList.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.GetRecentChatDialogueList.Response
             * @static
             * @param {message.GetRecentChatDialogueList.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.GetRecentChatDialogueList.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.GetRecentChatDialogueList.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetRecentChatDialogueList.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.message.ChatDialogue.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.GetRecentChatDialogueList.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.GetRecentChatDialogueList.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.GetRecentChatDialogueList.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.message.ChatDialogue.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.GetRecentChatDialogueList.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.GetRecentChatDialogueList.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.GetRecentChatDialogueList.Response)
                    return object;
                var message = new $root.message.GetRecentChatDialogueList.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".message.GetRecentChatDialogueList.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".message.GetRecentChatDialogueList.Response.list: object expected");
                        message.list[i] = $root.message.ChatDialogue.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.GetRecentChatDialogueList.Response
             * @static
             * @param {message.GetRecentChatDialogueList.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.message.ChatDialogue.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.GetRecentChatDialogueList.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetRecentChatDialogueList;
    })();

    message.JoinRoom = (function() {

        /**
         * Properties of a JoinRoom.
         * @memberof message
         * @interface IJoinRoom
         */

        /**
         * Constructs a new JoinRoom.
         * @memberof message
         * @classdesc Represents a JoinRoom.
         * @implements IJoinRoom
         * @constructor
         * @param {message.IJoinRoom=} [properties] Properties to set
         */
        function JoinRoom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new JoinRoom instance using the specified properties.
         * @function create
         * @memberof message.JoinRoom
         * @static
         * @param {message.IJoinRoom=} [properties] Properties to set
         * @returns {message.JoinRoom} JoinRoom instance
         */
        JoinRoom.create = function create(properties) {
            return new JoinRoom(properties);
        };

        /**
         * Encodes the specified JoinRoom message. Does not implicitly {@link message.JoinRoom.verify|verify} messages.
         * @function encode
         * @memberof message.JoinRoom
         * @static
         * @param {message.IJoinRoom} message JoinRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JoinRoom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified JoinRoom message, length delimited. Does not implicitly {@link message.JoinRoom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.JoinRoom
         * @static
         * @param {message.IJoinRoom} message JoinRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JoinRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JoinRoom message from the specified reader or buffer.
         * @function decode
         * @memberof message.JoinRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.JoinRoom} JoinRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JoinRoom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.JoinRoom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JoinRoom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.JoinRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.JoinRoom} JoinRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JoinRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JoinRoom message.
         * @function verify
         * @memberof message.JoinRoom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JoinRoom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a JoinRoom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.JoinRoom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.JoinRoom} JoinRoom
         */
        JoinRoom.fromObject = function fromObject(object) {
            if (object instanceof $root.message.JoinRoom)
                return object;
            return new $root.message.JoinRoom();
        };

        /**
         * Creates a plain object from a JoinRoom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.JoinRoom
         * @static
         * @param {message.JoinRoom} message JoinRoom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JoinRoom.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this JoinRoom to JSON.
         * @function toJSON
         * @memberof message.JoinRoom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JoinRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        JoinRoom.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.JoinRoom
             * @interface IRequest
             * @property {Array.<string>|null} [roomIds] Request roomIds
             */

            /**
             * Constructs a new Request.
             * @memberof message.JoinRoom
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.JoinRoom.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.roomIds = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomIds.
             * @member {Array.<string>} roomIds
             * @memberof message.JoinRoom.Request
             * @instance
             */
            Request.prototype.roomIds = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.JoinRoom.Request
             * @static
             * @param {message.JoinRoom.IRequest=} [properties] Properties to set
             * @returns {message.JoinRoom.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.JoinRoom.Request.verify|verify} messages.
             * @function encode
             * @memberof message.JoinRoom.Request
             * @static
             * @param {message.JoinRoom.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomIds != null && message.roomIds.length)
                    for (var i = 0; i < message.roomIds.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomIds[i]);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.JoinRoom.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.JoinRoom.Request
             * @static
             * @param {message.JoinRoom.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.JoinRoom.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.JoinRoom.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.JoinRoom.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.roomIds && message.roomIds.length))
                            message.roomIds = [];
                        message.roomIds.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.JoinRoom.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.JoinRoom.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.JoinRoom.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomIds != null && message.hasOwnProperty("roomIds")) {
                    if (!Array.isArray(message.roomIds))
                        return "roomIds: array expected";
                    for (var i = 0; i < message.roomIds.length; ++i)
                        if (!$util.isString(message.roomIds[i]))
                            return "roomIds: string[] expected";
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.JoinRoom.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.JoinRoom.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.JoinRoom.Request)
                    return object;
                var message = new $root.message.JoinRoom.Request();
                if (object.roomIds) {
                    if (!Array.isArray(object.roomIds))
                        throw TypeError(".message.JoinRoom.Request.roomIds: array expected");
                    message.roomIds = [];
                    for (var i = 0; i < object.roomIds.length; ++i)
                        message.roomIds[i] = String(object.roomIds[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.JoinRoom.Request
             * @static
             * @param {message.JoinRoom.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.roomIds = [];
                if (message.roomIds && message.roomIds.length) {
                    object.roomIds = [];
                    for (var j = 0; j < message.roomIds.length; ++j)
                        object.roomIds[j] = message.roomIds[j];
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.JoinRoom.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        JoinRoom.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.JoinRoom
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof message.JoinRoom
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.JoinRoom.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.JoinRoom.Response
             * @static
             * @param {message.JoinRoom.IResponse=} [properties] Properties to set
             * @returns {message.JoinRoom.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.JoinRoom.Response.verify|verify} messages.
             * @function encode
             * @memberof message.JoinRoom.Response
             * @static
             * @param {message.JoinRoom.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.JoinRoom.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.JoinRoom.Response
             * @static
             * @param {message.JoinRoom.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.JoinRoom.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.JoinRoom.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.JoinRoom.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.JoinRoom.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.JoinRoom.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.JoinRoom.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.JoinRoom.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.JoinRoom.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.JoinRoom.Response)
                    return object;
                return new $root.message.JoinRoom.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.JoinRoom.Response
             * @static
             * @param {message.JoinRoom.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.JoinRoom.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return JoinRoom;
    })();

    message.LeaveRoom = (function() {

        /**
         * Properties of a LeaveRoom.
         * @memberof message
         * @interface ILeaveRoom
         */

        /**
         * Constructs a new LeaveRoom.
         * @memberof message
         * @classdesc Represents a LeaveRoom.
         * @implements ILeaveRoom
         * @constructor
         * @param {message.ILeaveRoom=} [properties] Properties to set
         */
        function LeaveRoom(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new LeaveRoom instance using the specified properties.
         * @function create
         * @memberof message.LeaveRoom
         * @static
         * @param {message.ILeaveRoom=} [properties] Properties to set
         * @returns {message.LeaveRoom} LeaveRoom instance
         */
        LeaveRoom.create = function create(properties) {
            return new LeaveRoom(properties);
        };

        /**
         * Encodes the specified LeaveRoom message. Does not implicitly {@link message.LeaveRoom.verify|verify} messages.
         * @function encode
         * @memberof message.LeaveRoom
         * @static
         * @param {message.ILeaveRoom} message LeaveRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveRoom.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified LeaveRoom message, length delimited. Does not implicitly {@link message.LeaveRoom.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.LeaveRoom
         * @static
         * @param {message.ILeaveRoom} message LeaveRoom message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LeaveRoom message from the specified reader or buffer.
         * @function decode
         * @memberof message.LeaveRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.LeaveRoom} LeaveRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveRoom.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.LeaveRoom();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LeaveRoom message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.LeaveRoom
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.LeaveRoom} LeaveRoom
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LeaveRoom message.
         * @function verify
         * @memberof message.LeaveRoom
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LeaveRoom.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a LeaveRoom message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.LeaveRoom
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.LeaveRoom} LeaveRoom
         */
        LeaveRoom.fromObject = function fromObject(object) {
            if (object instanceof $root.message.LeaveRoom)
                return object;
            return new $root.message.LeaveRoom();
        };

        /**
         * Creates a plain object from a LeaveRoom message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.LeaveRoom
         * @static
         * @param {message.LeaveRoom} message LeaveRoom
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LeaveRoom.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this LeaveRoom to JSON.
         * @function toJSON
         * @memberof message.LeaveRoom
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LeaveRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        LeaveRoom.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.LeaveRoom
             * @interface IRequest
             * @property {Array.<string>|null} [roomIds] Request roomIds
             */

            /**
             * Constructs a new Request.
             * @memberof message.LeaveRoom
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.LeaveRoom.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.roomIds = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomIds.
             * @member {Array.<string>} roomIds
             * @memberof message.LeaveRoom.Request
             * @instance
             */
            Request.prototype.roomIds = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.LeaveRoom.Request
             * @static
             * @param {message.LeaveRoom.IRequest=} [properties] Properties to set
             * @returns {message.LeaveRoom.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.LeaveRoom.Request.verify|verify} messages.
             * @function encode
             * @memberof message.LeaveRoom.Request
             * @static
             * @param {message.LeaveRoom.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomIds != null && message.roomIds.length)
                    for (var i = 0; i < message.roomIds.length; ++i)
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomIds[i]);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.LeaveRoom.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.LeaveRoom.Request
             * @static
             * @param {message.LeaveRoom.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.LeaveRoom.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.LeaveRoom.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.LeaveRoom.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.roomIds && message.roomIds.length))
                            message.roomIds = [];
                        message.roomIds.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.LeaveRoom.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.LeaveRoom.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.LeaveRoom.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomIds != null && message.hasOwnProperty("roomIds")) {
                    if (!Array.isArray(message.roomIds))
                        return "roomIds: array expected";
                    for (var i = 0; i < message.roomIds.length; ++i)
                        if (!$util.isString(message.roomIds[i]))
                            return "roomIds: string[] expected";
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.LeaveRoom.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.LeaveRoom.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.LeaveRoom.Request)
                    return object;
                var message = new $root.message.LeaveRoom.Request();
                if (object.roomIds) {
                    if (!Array.isArray(object.roomIds))
                        throw TypeError(".message.LeaveRoom.Request.roomIds: array expected");
                    message.roomIds = [];
                    for (var i = 0; i < object.roomIds.length; ++i)
                        message.roomIds[i] = String(object.roomIds[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.LeaveRoom.Request
             * @static
             * @param {message.LeaveRoom.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.roomIds = [];
                if (message.roomIds && message.roomIds.length) {
                    object.roomIds = [];
                    for (var j = 0; j < message.roomIds.length; ++j)
                        object.roomIds[j] = message.roomIds[j];
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.LeaveRoom.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        LeaveRoom.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.LeaveRoom
             * @interface IResponse
             */

            /**
             * Constructs a new Response.
             * @memberof message.LeaveRoom
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.LeaveRoom.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.LeaveRoom.Response
             * @static
             * @param {message.LeaveRoom.IResponse=} [properties] Properties to set
             * @returns {message.LeaveRoom.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.LeaveRoom.Response.verify|verify} messages.
             * @function encode
             * @memberof message.LeaveRoom.Response
             * @static
             * @param {message.LeaveRoom.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.LeaveRoom.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.LeaveRoom.Response
             * @static
             * @param {message.LeaveRoom.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.LeaveRoom.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.LeaveRoom.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.LeaveRoom.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.LeaveRoom.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.LeaveRoom.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.LeaveRoom.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.LeaveRoom.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.LeaveRoom.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.LeaveRoom.Response)
                    return object;
                return new $root.message.LeaveRoom.Response();
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.LeaveRoom.Response
             * @static
             * @param {message.LeaveRoom.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.LeaveRoom.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return LeaveRoom;
    })();

    message.GetAllUnreadMessage = (function() {

        /**
         * Properties of a GetAllUnreadMessage.
         * @memberof message
         * @interface IGetAllUnreadMessage
         */

        /**
         * Constructs a new GetAllUnreadMessage.
         * @memberof message
         * @classdesc Represents a GetAllUnreadMessage.
         * @implements IGetAllUnreadMessage
         * @constructor
         * @param {message.IGetAllUnreadMessage=} [properties] Properties to set
         */
        function GetAllUnreadMessage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetAllUnreadMessage instance using the specified properties.
         * @function create
         * @memberof message.GetAllUnreadMessage
         * @static
         * @param {message.IGetAllUnreadMessage=} [properties] Properties to set
         * @returns {message.GetAllUnreadMessage} GetAllUnreadMessage instance
         */
        GetAllUnreadMessage.create = function create(properties) {
            return new GetAllUnreadMessage(properties);
        };

        /**
         * Encodes the specified GetAllUnreadMessage message. Does not implicitly {@link message.GetAllUnreadMessage.verify|verify} messages.
         * @function encode
         * @memberof message.GetAllUnreadMessage
         * @static
         * @param {message.IGetAllUnreadMessage} message GetAllUnreadMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAllUnreadMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetAllUnreadMessage message, length delimited. Does not implicitly {@link message.GetAllUnreadMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.GetAllUnreadMessage
         * @static
         * @param {message.IGetAllUnreadMessage} message GetAllUnreadMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetAllUnreadMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetAllUnreadMessage message from the specified reader or buffer.
         * @function decode
         * @memberof message.GetAllUnreadMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.GetAllUnreadMessage} GetAllUnreadMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAllUnreadMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetAllUnreadMessage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetAllUnreadMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.GetAllUnreadMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.GetAllUnreadMessage} GetAllUnreadMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetAllUnreadMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetAllUnreadMessage message.
         * @function verify
         * @memberof message.GetAllUnreadMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetAllUnreadMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetAllUnreadMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.GetAllUnreadMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.GetAllUnreadMessage} GetAllUnreadMessage
         */
        GetAllUnreadMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.message.GetAllUnreadMessage)
                return object;
            return new $root.message.GetAllUnreadMessage();
        };

        /**
         * Creates a plain object from a GetAllUnreadMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.GetAllUnreadMessage
         * @static
         * @param {message.GetAllUnreadMessage} message GetAllUnreadMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetAllUnreadMessage.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetAllUnreadMessage to JSON.
         * @function toJSON
         * @memberof message.GetAllUnreadMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetAllUnreadMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetAllUnreadMessage.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.GetAllUnreadMessage
             * @interface IRequest
             */

            /**
             * Constructs a new Request.
             * @memberof message.GetAllUnreadMessage
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.GetAllUnreadMessage.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.GetAllUnreadMessage.Request
             * @static
             * @param {message.GetAllUnreadMessage.IRequest=} [properties] Properties to set
             * @returns {message.GetAllUnreadMessage.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.GetAllUnreadMessage.Request.verify|verify} messages.
             * @function encode
             * @memberof message.GetAllUnreadMessage.Request
             * @static
             * @param {message.GetAllUnreadMessage.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.GetAllUnreadMessage.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.GetAllUnreadMessage.Request
             * @static
             * @param {message.GetAllUnreadMessage.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.GetAllUnreadMessage.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.GetAllUnreadMessage.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetAllUnreadMessage.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.GetAllUnreadMessage.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.GetAllUnreadMessage.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.GetAllUnreadMessage.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.GetAllUnreadMessage.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.GetAllUnreadMessage.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.GetAllUnreadMessage.Request)
                    return object;
                return new $root.message.GetAllUnreadMessage.Request();
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.GetAllUnreadMessage.Request
             * @static
             * @param {message.GetAllUnreadMessage.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject() {
                return {};
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.GetAllUnreadMessage.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        GetAllUnreadMessage.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.GetAllUnreadMessage
             * @interface IResponse
             * @property {Array.<message.GetAllUnreadMessage.Response.IUnreadMessageCountItem>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof message.GetAllUnreadMessage
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.GetAllUnreadMessage.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<message.GetAllUnreadMessage.Response.IUnreadMessageCountItem>} list
             * @memberof message.GetAllUnreadMessage.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof message.GetAllUnreadMessage.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.GetAllUnreadMessage.Response
             * @static
             * @param {message.GetAllUnreadMessage.IResponse=} [properties] Properties to set
             * @returns {message.GetAllUnreadMessage.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.GetAllUnreadMessage.Response.verify|verify} messages.
             * @function encode
             * @memberof message.GetAllUnreadMessage.Response
             * @static
             * @param {message.GetAllUnreadMessage.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.message.GetAllUnreadMessage.Response.UnreadMessageCountItem.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.GetAllUnreadMessage.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.GetAllUnreadMessage.Response
             * @static
             * @param {message.GetAllUnreadMessage.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.GetAllUnreadMessage.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.GetAllUnreadMessage.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetAllUnreadMessage.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.message.GetAllUnreadMessage.Response.UnreadMessageCountItem.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.GetAllUnreadMessage.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.GetAllUnreadMessage.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.GetAllUnreadMessage.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.message.GetAllUnreadMessage.Response.UnreadMessageCountItem.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.GetAllUnreadMessage.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.GetAllUnreadMessage.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.GetAllUnreadMessage.Response)
                    return object;
                var message = new $root.message.GetAllUnreadMessage.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".message.GetAllUnreadMessage.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".message.GetAllUnreadMessage.Response.list: object expected");
                        message.list[i] = $root.message.GetAllUnreadMessage.Response.UnreadMessageCountItem.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.GetAllUnreadMessage.Response
             * @static
             * @param {message.GetAllUnreadMessage.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.message.GetAllUnreadMessage.Response.UnreadMessageCountItem.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.GetAllUnreadMessage.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Response.UnreadMessageCountItem = (function() {

                /**
                 * Properties of an UnreadMessageCountItem.
                 * @memberof message.GetAllUnreadMessage.Response
                 * @interface IUnreadMessageCountItem
                 */

                /**
                 * Constructs a new UnreadMessageCountItem.
                 * @memberof message.GetAllUnreadMessage.Response
                 * @classdesc Represents an UnreadMessageCountItem.
                 * @implements IUnreadMessageCountItem
                 * @constructor
                 * @param {message.GetAllUnreadMessage.Response.IUnreadMessageCountItem=} [properties] Properties to set
                 */
                function UnreadMessageCountItem(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new UnreadMessageCountItem instance using the specified properties.
                 * @function create
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @static
                 * @param {message.GetAllUnreadMessage.Response.IUnreadMessageCountItem=} [properties] Properties to set
                 * @returns {message.GetAllUnreadMessage.Response.UnreadMessageCountItem} UnreadMessageCountItem instance
                 */
                UnreadMessageCountItem.create = function create(properties) {
                    return new UnreadMessageCountItem(properties);
                };

                /**
                 * Encodes the specified UnreadMessageCountItem message. Does not implicitly {@link message.GetAllUnreadMessage.Response.UnreadMessageCountItem.verify|verify} messages.
                 * @function encode
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @static
                 * @param {message.GetAllUnreadMessage.Response.IUnreadMessageCountItem} message UnreadMessageCountItem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UnreadMessageCountItem.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified UnreadMessageCountItem message, length delimited. Does not implicitly {@link message.GetAllUnreadMessage.Response.UnreadMessageCountItem.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @static
                 * @param {message.GetAllUnreadMessage.Response.IUnreadMessageCountItem} message UnreadMessageCountItem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UnreadMessageCountItem.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UnreadMessageCountItem message from the specified reader or buffer.
                 * @function decode
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {message.GetAllUnreadMessage.Response.UnreadMessageCountItem} UnreadMessageCountItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UnreadMessageCountItem.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetAllUnreadMessage.Response.UnreadMessageCountItem();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UnreadMessageCountItem message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {message.GetAllUnreadMessage.Response.UnreadMessageCountItem} UnreadMessageCountItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UnreadMessageCountItem.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UnreadMessageCountItem message.
                 * @function verify
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UnreadMessageCountItem.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates an UnreadMessageCountItem message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {message.GetAllUnreadMessage.Response.UnreadMessageCountItem} UnreadMessageCountItem
                 */
                UnreadMessageCountItem.fromObject = function fromObject(object) {
                    if (object instanceof $root.message.GetAllUnreadMessage.Response.UnreadMessageCountItem)
                        return object;
                    return new $root.message.GetAllUnreadMessage.Response.UnreadMessageCountItem();
                };

                /**
                 * Creates a plain object from an UnreadMessageCountItem message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @static
                 * @param {message.GetAllUnreadMessage.Response.UnreadMessageCountItem} message UnreadMessageCountItem
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UnreadMessageCountItem.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this UnreadMessageCountItem to JSON.
                 * @function toJSON
                 * @memberof message.GetAllUnreadMessage.Response.UnreadMessageCountItem
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UnreadMessageCountItem.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UnreadMessageCountItem;
            })();

            return Response;
        })();

        return GetAllUnreadMessage;
    })();

    message.SendMessage = (function() {

        /**
         * Properties of a SendMessage.
         * @memberof message
         * @interface ISendMessage
         */

        /**
         * Constructs a new SendMessage.
         * @memberof message
         * @classdesc Represents a SendMessage.
         * @implements ISendMessage
         * @constructor
         * @param {message.ISendMessage=} [properties] Properties to set
         */
        function SendMessage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new SendMessage instance using the specified properties.
         * @function create
         * @memberof message.SendMessage
         * @static
         * @param {message.ISendMessage=} [properties] Properties to set
         * @returns {message.SendMessage} SendMessage instance
         */
        SendMessage.create = function create(properties) {
            return new SendMessage(properties);
        };

        /**
         * Encodes the specified SendMessage message. Does not implicitly {@link message.SendMessage.verify|verify} messages.
         * @function encode
         * @memberof message.SendMessage
         * @static
         * @param {message.ISendMessage} message SendMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified SendMessage message, length delimited. Does not implicitly {@link message.SendMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.SendMessage
         * @static
         * @param {message.ISendMessage} message SendMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SendMessage message from the specified reader or buffer.
         * @function decode
         * @memberof message.SendMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.SendMessage} SendMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.SendMessage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SendMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.SendMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.SendMessage} SendMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SendMessage message.
         * @function verify
         * @memberof message.SendMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SendMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a SendMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.SendMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.SendMessage} SendMessage
         */
        SendMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.message.SendMessage)
                return object;
            return new $root.message.SendMessage();
        };

        /**
         * Creates a plain object from a SendMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.SendMessage
         * @static
         * @param {message.SendMessage} message SendMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendMessage.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this SendMessage to JSON.
         * @function toJSON
         * @memberof message.SendMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SendMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SendMessage.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.SendMessage
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             * @property {string|null} [authorId] Request authorId
             * @property {string|null} [replyId] Request replyId
             * @property {Array.<message.IMessagesAtUsers>|null} [atUsers] Request atUsers
             * @property {Array.<message.IMessagesReadUsers>|null} [readUsers] Request readUsers
             * @property {Array.<message.IMessagesForwardMessages>|null} [forwardMessages] Request forwardMessages
             * @property {string|null} [message] Request message
             * @property {message.IMessagesAudio|null} [audio] Request audio
             * @property {message.IMessagesVideo|null} [video] Request video
             * @property {message.IMessagesImage|null} [image] Request image
             * @property {message.IMessagesCall|null} [call] Request call
             * @property {string|null} [type] Request type
             */

            /**
             * Constructs a new Request.
             * @memberof message.SendMessage
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.SendMessage.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.atUsers = [];
                this.readUsers = [];
                this.forwardMessages = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Request authorId.
             * @member {string} authorId
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.authorId = "";

            /**
             * Request replyId.
             * @member {string} replyId
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.replyId = "";

            /**
             * Request atUsers.
             * @member {Array.<message.IMessagesAtUsers>} atUsers
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.atUsers = $util.emptyArray;

            /**
             * Request readUsers.
             * @member {Array.<message.IMessagesReadUsers>} readUsers
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.readUsers = $util.emptyArray;

            /**
             * Request forwardMessages.
             * @member {Array.<message.IMessagesForwardMessages>} forwardMessages
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.forwardMessages = $util.emptyArray;

            /**
             * Request message.
             * @member {string} message
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.message = "";

            /**
             * Request audio.
             * @member {message.IMessagesAudio|null|undefined} audio
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.audio = null;

            /**
             * Request video.
             * @member {message.IMessagesVideo|null|undefined} video
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.video = null;

            /**
             * Request image.
             * @member {message.IMessagesImage|null|undefined} image
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.image = null;

            /**
             * Request call.
             * @member {message.IMessagesCall|null|undefined} call
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.call = null;

            /**
             * Request type.
             * @member {string} type
             * @memberof message.SendMessage.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.SendMessage.Request
             * @static
             * @param {message.SendMessage.IRequest=} [properties] Properties to set
             * @returns {message.SendMessage.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.SendMessage.Request.verify|verify} messages.
             * @function encode
             * @memberof message.SendMessage.Request
             * @static
             * @param {message.SendMessage.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.roomId);
                if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.authorId);
                if (message.replyId != null && Object.hasOwnProperty.call(message, "replyId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.replyId);
                if (message.atUsers != null && message.atUsers.length)
                    for (var i = 0; i < message.atUsers.length; ++i)
                        $root.message.MessagesAtUsers.encode(message.atUsers[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.readUsers != null && message.readUsers.length)
                    for (var i = 0; i < message.readUsers.length; ++i)
                        $root.message.MessagesReadUsers.encode(message.readUsers[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.forwardMessages != null && message.forwardMessages.length)
                    for (var i = 0; i < message.forwardMessages.length; ++i)
                        $root.message.MessagesForwardMessages.encode(message.forwardMessages[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.message);
                if (message.audio != null && Object.hasOwnProperty.call(message, "audio"))
                    $root.message.MessagesAudio.encode(message.audio, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.video != null && Object.hasOwnProperty.call(message, "video"))
                    $root.message.MessagesVideo.encode(message.video, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                    $root.message.MessagesImage.encode(message.image, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                if (message.call != null && Object.hasOwnProperty.call(message, "call"))
                    $root.message.MessagesCall.encode(message.call, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 13, wireType 2 =*/106).string(message.type);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.SendMessage.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.SendMessage.Request
             * @static
             * @param {message.SendMessage.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.SendMessage.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.SendMessage.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.SendMessage.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.roomId = reader.string();
                        break;
                    case 3:
                        message.authorId = reader.string();
                        break;
                    case 4:
                        message.replyId = reader.string();
                        break;
                    case 5:
                        if (!(message.atUsers && message.atUsers.length))
                            message.atUsers = [];
                        message.atUsers.push($root.message.MessagesAtUsers.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.readUsers && message.readUsers.length))
                            message.readUsers = [];
                        message.readUsers.push($root.message.MessagesReadUsers.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        if (!(message.forwardMessages && message.forwardMessages.length))
                            message.forwardMessages = [];
                        message.forwardMessages.push($root.message.MessagesForwardMessages.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        message.message = reader.string();
                        break;
                    case 9:
                        message.audio = $root.message.MessagesAudio.decode(reader, reader.uint32());
                        break;
                    case 10:
                        message.video = $root.message.MessagesVideo.decode(reader, reader.uint32());
                        break;
                    case 11:
                        message.image = $root.message.MessagesImage.decode(reader, reader.uint32());
                        break;
                    case 12:
                        message.call = $root.message.MessagesCall.decode(reader, reader.uint32());
                        break;
                    case 13:
                        message.type = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.SendMessage.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.SendMessage.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.SendMessage.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.authorId != null && message.hasOwnProperty("authorId"))
                    if (!$util.isString(message.authorId))
                        return "authorId: string expected";
                if (message.replyId != null && message.hasOwnProperty("replyId"))
                    if (!$util.isString(message.replyId))
                        return "replyId: string expected";
                if (message.atUsers != null && message.hasOwnProperty("atUsers")) {
                    if (!Array.isArray(message.atUsers))
                        return "atUsers: array expected";
                    for (var i = 0; i < message.atUsers.length; ++i) {
                        var error = $root.message.MessagesAtUsers.verify(message.atUsers[i]);
                        if (error)
                            return "atUsers." + error;
                    }
                }
                if (message.readUsers != null && message.hasOwnProperty("readUsers")) {
                    if (!Array.isArray(message.readUsers))
                        return "readUsers: array expected";
                    for (var i = 0; i < message.readUsers.length; ++i) {
                        var error = $root.message.MessagesReadUsers.verify(message.readUsers[i]);
                        if (error)
                            return "readUsers." + error;
                    }
                }
                if (message.forwardMessages != null && message.hasOwnProperty("forwardMessages")) {
                    if (!Array.isArray(message.forwardMessages))
                        return "forwardMessages: array expected";
                    for (var i = 0; i < message.forwardMessages.length; ++i) {
                        var error = $root.message.MessagesForwardMessages.verify(message.forwardMessages[i]);
                        if (error)
                            return "forwardMessages." + error;
                    }
                }
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                if (message.audio != null && message.hasOwnProperty("audio")) {
                    var error = $root.message.MessagesAudio.verify(message.audio);
                    if (error)
                        return "audio." + error;
                }
                if (message.video != null && message.hasOwnProperty("video")) {
                    var error = $root.message.MessagesVideo.verify(message.video);
                    if (error)
                        return "video." + error;
                }
                if (message.image != null && message.hasOwnProperty("image")) {
                    var error = $root.message.MessagesImage.verify(message.image);
                    if (error)
                        return "image." + error;
                }
                if (message.call != null && message.hasOwnProperty("call")) {
                    var error = $root.message.MessagesCall.verify(message.call);
                    if (error)
                        return "call." + error;
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.SendMessage.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.SendMessage.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.SendMessage.Request)
                    return object;
                var message = new $root.message.SendMessage.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.authorId != null)
                    message.authorId = String(object.authorId);
                if (object.replyId != null)
                    message.replyId = String(object.replyId);
                if (object.atUsers) {
                    if (!Array.isArray(object.atUsers))
                        throw TypeError(".message.SendMessage.Request.atUsers: array expected");
                    message.atUsers = [];
                    for (var i = 0; i < object.atUsers.length; ++i) {
                        if (typeof object.atUsers[i] !== "object")
                            throw TypeError(".message.SendMessage.Request.atUsers: object expected");
                        message.atUsers[i] = $root.message.MessagesAtUsers.fromObject(object.atUsers[i]);
                    }
                }
                if (object.readUsers) {
                    if (!Array.isArray(object.readUsers))
                        throw TypeError(".message.SendMessage.Request.readUsers: array expected");
                    message.readUsers = [];
                    for (var i = 0; i < object.readUsers.length; ++i) {
                        if (typeof object.readUsers[i] !== "object")
                            throw TypeError(".message.SendMessage.Request.readUsers: object expected");
                        message.readUsers[i] = $root.message.MessagesReadUsers.fromObject(object.readUsers[i]);
                    }
                }
                if (object.forwardMessages) {
                    if (!Array.isArray(object.forwardMessages))
                        throw TypeError(".message.SendMessage.Request.forwardMessages: array expected");
                    message.forwardMessages = [];
                    for (var i = 0; i < object.forwardMessages.length; ++i) {
                        if (typeof object.forwardMessages[i] !== "object")
                            throw TypeError(".message.SendMessage.Request.forwardMessages: object expected");
                        message.forwardMessages[i] = $root.message.MessagesForwardMessages.fromObject(object.forwardMessages[i]);
                    }
                }
                if (object.message != null)
                    message.message = String(object.message);
                if (object.audio != null) {
                    if (typeof object.audio !== "object")
                        throw TypeError(".message.SendMessage.Request.audio: object expected");
                    message.audio = $root.message.MessagesAudio.fromObject(object.audio);
                }
                if (object.video != null) {
                    if (typeof object.video !== "object")
                        throw TypeError(".message.SendMessage.Request.video: object expected");
                    message.video = $root.message.MessagesVideo.fromObject(object.video);
                }
                if (object.image != null) {
                    if (typeof object.image !== "object")
                        throw TypeError(".message.SendMessage.Request.image: object expected");
                    message.image = $root.message.MessagesImage.fromObject(object.image);
                }
                if (object.call != null) {
                    if (typeof object.call !== "object")
                        throw TypeError(".message.SendMessage.Request.call: object expected");
                    message.call = $root.message.MessagesCall.fromObject(object.call);
                }
                if (object.type != null)
                    message.type = String(object.type);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.SendMessage.Request
             * @static
             * @param {message.SendMessage.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.atUsers = [];
                    object.readUsers = [];
                    object.forwardMessages = [];
                }
                if (options.defaults) {
                    object.roomId = "";
                    object.authorId = "";
                    object.replyId = "";
                    object.message = "";
                    object.audio = null;
                    object.video = null;
                    object.image = null;
                    object.call = null;
                    object.type = "";
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.authorId != null && message.hasOwnProperty("authorId"))
                    object.authorId = message.authorId;
                if (message.replyId != null && message.hasOwnProperty("replyId"))
                    object.replyId = message.replyId;
                if (message.atUsers && message.atUsers.length) {
                    object.atUsers = [];
                    for (var j = 0; j < message.atUsers.length; ++j)
                        object.atUsers[j] = $root.message.MessagesAtUsers.toObject(message.atUsers[j], options);
                }
                if (message.readUsers && message.readUsers.length) {
                    object.readUsers = [];
                    for (var j = 0; j < message.readUsers.length; ++j)
                        object.readUsers[j] = $root.message.MessagesReadUsers.toObject(message.readUsers[j], options);
                }
                if (message.forwardMessages && message.forwardMessages.length) {
                    object.forwardMessages = [];
                    for (var j = 0; j < message.forwardMessages.length; ++j)
                        object.forwardMessages[j] = $root.message.MessagesForwardMessages.toObject(message.forwardMessages[j], options);
                }
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                if (message.audio != null && message.hasOwnProperty("audio"))
                    object.audio = $root.message.MessagesAudio.toObject(message.audio, options);
                if (message.video != null && message.hasOwnProperty("video"))
                    object.video = $root.message.MessagesVideo.toObject(message.video, options);
                if (message.image != null && message.hasOwnProperty("image"))
                    object.image = $root.message.MessagesImage.toObject(message.image, options);
                if (message.call != null && message.hasOwnProperty("call"))
                    object.call = $root.message.MessagesCall.toObject(message.call, options);
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.SendMessage.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        SendMessage.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.SendMessage
             * @interface IResponse
             * @property {message.IMessages|null} [message] Response message
             */

            /**
             * Constructs a new Response.
             * @memberof message.SendMessage
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.SendMessage.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response message.
             * @member {message.IMessages|null|undefined} message
             * @memberof message.SendMessage.Response
             * @instance
             */
            Response.prototype.message = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.SendMessage.Response
             * @static
             * @param {message.SendMessage.IResponse=} [properties] Properties to set
             * @returns {message.SendMessage.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.SendMessage.Response.verify|verify} messages.
             * @function encode
             * @memberof message.SendMessage.Response
             * @static
             * @param {message.SendMessage.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    $root.message.Messages.encode(message.message, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.SendMessage.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.SendMessage.Response
             * @static
             * @param {message.SendMessage.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.SendMessage.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.SendMessage.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.SendMessage.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.message = $root.message.Messages.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.SendMessage.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.SendMessage.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.SendMessage.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.message != null && message.hasOwnProperty("message")) {
                    var error = $root.message.Messages.verify(message.message);
                    if (error)
                        return "message." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.SendMessage.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.SendMessage.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.SendMessage.Response)
                    return object;
                var message = new $root.message.SendMessage.Response();
                if (object.message != null) {
                    if (typeof object.message !== "object")
                        throw TypeError(".message.SendMessage.Response.message: object expected");
                    message.message = $root.message.Messages.fromObject(object.message);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.SendMessage.Response
             * @static
             * @param {message.SendMessage.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.message = null;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = $root.message.Messages.toObject(message.message, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.SendMessage.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return SendMessage;
    })();

    message.EditMessage = (function() {

        /**
         * Properties of an EditMessage.
         * @memberof message
         * @interface IEditMessage
         */

        /**
         * Constructs a new EditMessage.
         * @memberof message
         * @classdesc Represents an EditMessage.
         * @implements IEditMessage
         * @constructor
         * @param {message.IEditMessage=} [properties] Properties to set
         */
        function EditMessage(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new EditMessage instance using the specified properties.
         * @function create
         * @memberof message.EditMessage
         * @static
         * @param {message.IEditMessage=} [properties] Properties to set
         * @returns {message.EditMessage} EditMessage instance
         */
        EditMessage.create = function create(properties) {
            return new EditMessage(properties);
        };

        /**
         * Encodes the specified EditMessage message. Does not implicitly {@link message.EditMessage.verify|verify} messages.
         * @function encode
         * @memberof message.EditMessage
         * @static
         * @param {message.IEditMessage} message EditMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EditMessage.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified EditMessage message, length delimited. Does not implicitly {@link message.EditMessage.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.EditMessage
         * @static
         * @param {message.IEditMessage} message EditMessage message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EditMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EditMessage message from the specified reader or buffer.
         * @function decode
         * @memberof message.EditMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.EditMessage} EditMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EditMessage.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.EditMessage();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EditMessage message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.EditMessage
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.EditMessage} EditMessage
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EditMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EditMessage message.
         * @function verify
         * @memberof message.EditMessage
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EditMessage.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an EditMessage message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.EditMessage
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.EditMessage} EditMessage
         */
        EditMessage.fromObject = function fromObject(object) {
            if (object instanceof $root.message.EditMessage)
                return object;
            return new $root.message.EditMessage();
        };

        /**
         * Creates a plain object from an EditMessage message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.EditMessage
         * @static
         * @param {message.EditMessage} message EditMessage
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EditMessage.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this EditMessage to JSON.
         * @function toJSON
         * @memberof message.EditMessage
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EditMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        EditMessage.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.EditMessage
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             * @property {string|null} [messageId] Request messageId
             * @property {string|null} [authorId] Request authorId
             * @property {string|null} [message] Request message
             */

            /**
             * Constructs a new Request.
             * @memberof message.EditMessage
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.EditMessage.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.EditMessage.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Request messageId.
             * @member {string} messageId
             * @memberof message.EditMessage.Request
             * @instance
             */
            Request.prototype.messageId = "";

            /**
             * Request authorId.
             * @member {string} authorId
             * @memberof message.EditMessage.Request
             * @instance
             */
            Request.prototype.authorId = "";

            /**
             * Request message.
             * @member {string} message
             * @memberof message.EditMessage.Request
             * @instance
             */
            Request.prototype.message = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.EditMessage.Request
             * @static
             * @param {message.EditMessage.IRequest=} [properties] Properties to set
             * @returns {message.EditMessage.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.EditMessage.Request.verify|verify} messages.
             * @function encode
             * @memberof message.EditMessage.Request
             * @static
             * @param {message.EditMessage.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.messageId != null && Object.hasOwnProperty.call(message, "messageId"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageId);
                if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.authorId);
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.EditMessage.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.EditMessage.Request
             * @static
             * @param {message.EditMessage.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.EditMessage.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.EditMessage.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.EditMessage.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        message.messageId = reader.string();
                        break;
                    case 3:
                        message.authorId = reader.string();
                        break;
                    case 4:
                        message.message = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.EditMessage.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.EditMessage.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.EditMessage.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.messageId != null && message.hasOwnProperty("messageId"))
                    if (!$util.isString(message.messageId))
                        return "messageId: string expected";
                if (message.authorId != null && message.hasOwnProperty("authorId"))
                    if (!$util.isString(message.authorId))
                        return "authorId: string expected";
                if (message.message != null && message.hasOwnProperty("message"))
                    if (!$util.isString(message.message))
                        return "message: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.EditMessage.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.EditMessage.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.EditMessage.Request)
                    return object;
                var message = new $root.message.EditMessage.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.messageId != null)
                    message.messageId = String(object.messageId);
                if (object.authorId != null)
                    message.authorId = String(object.authorId);
                if (object.message != null)
                    message.message = String(object.message);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.EditMessage.Request
             * @static
             * @param {message.EditMessage.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.roomId = "";
                    object.messageId = "";
                    object.authorId = "";
                    object.message = "";
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.messageId != null && message.hasOwnProperty("messageId"))
                    object.messageId = message.messageId;
                if (message.authorId != null && message.hasOwnProperty("authorId"))
                    object.authorId = message.authorId;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = message.message;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.EditMessage.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        EditMessage.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.EditMessage
             * @interface IResponse
             * @property {message.IMessages|null} [message] Response message
             */

            /**
             * Constructs a new Response.
             * @memberof message.EditMessage
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.EditMessage.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response message.
             * @member {message.IMessages|null|undefined} message
             * @memberof message.EditMessage.Response
             * @instance
             */
            Response.prototype.message = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.EditMessage.Response
             * @static
             * @param {message.EditMessage.IResponse=} [properties] Properties to set
             * @returns {message.EditMessage.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.EditMessage.Response.verify|verify} messages.
             * @function encode
             * @memberof message.EditMessage.Response
             * @static
             * @param {message.EditMessage.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                    $root.message.Messages.encode(message.message, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.EditMessage.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.EditMessage.Response
             * @static
             * @param {message.EditMessage.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.EditMessage.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.EditMessage.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.EditMessage.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.message = $root.message.Messages.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.EditMessage.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.EditMessage.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.EditMessage.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.message != null && message.hasOwnProperty("message")) {
                    var error = $root.message.Messages.verify(message.message);
                    if (error)
                        return "message." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.EditMessage.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.EditMessage.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.EditMessage.Response)
                    return object;
                var message = new $root.message.EditMessage.Response();
                if (object.message != null) {
                    if (typeof object.message !== "object")
                        throw TypeError(".message.EditMessage.Response.message: object expected");
                    message.message = $root.message.Messages.fromObject(object.message);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.EditMessage.Response
             * @static
             * @param {message.EditMessage.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.message = null;
                if (message.message != null && message.hasOwnProperty("message"))
                    object.message = $root.message.Messages.toObject(message.message, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.EditMessage.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return EditMessage;
    })();

    message.GetHistoricalMessages = (function() {

        /**
         * Properties of a GetHistoricalMessages.
         * @memberof message
         * @interface IGetHistoricalMessages
         */

        /**
         * Constructs a new GetHistoricalMessages.
         * @memberof message
         * @classdesc Represents a GetHistoricalMessages.
         * @implements IGetHistoricalMessages
         * @constructor
         * @param {message.IGetHistoricalMessages=} [properties] Properties to set
         */
        function GetHistoricalMessages(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new GetHistoricalMessages instance using the specified properties.
         * @function create
         * @memberof message.GetHistoricalMessages
         * @static
         * @param {message.IGetHistoricalMessages=} [properties] Properties to set
         * @returns {message.GetHistoricalMessages} GetHistoricalMessages instance
         */
        GetHistoricalMessages.create = function create(properties) {
            return new GetHistoricalMessages(properties);
        };

        /**
         * Encodes the specified GetHistoricalMessages message. Does not implicitly {@link message.GetHistoricalMessages.verify|verify} messages.
         * @function encode
         * @memberof message.GetHistoricalMessages
         * @static
         * @param {message.IGetHistoricalMessages} message GetHistoricalMessages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetHistoricalMessages.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified GetHistoricalMessages message, length delimited. Does not implicitly {@link message.GetHistoricalMessages.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.GetHistoricalMessages
         * @static
         * @param {message.IGetHistoricalMessages} message GetHistoricalMessages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GetHistoricalMessages.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GetHistoricalMessages message from the specified reader or buffer.
         * @function decode
         * @memberof message.GetHistoricalMessages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.GetHistoricalMessages} GetHistoricalMessages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetHistoricalMessages.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetHistoricalMessages();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GetHistoricalMessages message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.GetHistoricalMessages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.GetHistoricalMessages} GetHistoricalMessages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GetHistoricalMessages.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GetHistoricalMessages message.
         * @function verify
         * @memberof message.GetHistoricalMessages
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GetHistoricalMessages.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a GetHistoricalMessages message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.GetHistoricalMessages
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.GetHistoricalMessages} GetHistoricalMessages
         */
        GetHistoricalMessages.fromObject = function fromObject(object) {
            if (object instanceof $root.message.GetHistoricalMessages)
                return object;
            return new $root.message.GetHistoricalMessages();
        };

        /**
         * Creates a plain object from a GetHistoricalMessages message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.GetHistoricalMessages
         * @static
         * @param {message.GetHistoricalMessages} message GetHistoricalMessages
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GetHistoricalMessages.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this GetHistoricalMessages to JSON.
         * @function toJSON
         * @memberof message.GetHistoricalMessages
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GetHistoricalMessages.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GetHistoricalMessages.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.GetHistoricalMessages
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             * @property {number|Long|null} [pageNum] Request pageNum
             * @property {number|Long|null} [pageSize] Request pageSize
             * @property {message.GetHistoricalMessages.Request.ITimeRange|null} [timeRange] Request timeRange
             * @property {string|null} [type] Request type
             */

            /**
             * Constructs a new Request.
             * @memberof message.GetHistoricalMessages
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.GetHistoricalMessages.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.GetHistoricalMessages.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Request pageNum.
             * @member {number|Long} pageNum
             * @memberof message.GetHistoricalMessages.Request
             * @instance
             */
            Request.prototype.pageNum = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request pageSize.
             * @member {number|Long} pageSize
             * @memberof message.GetHistoricalMessages.Request
             * @instance
             */
            Request.prototype.pageSize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request timeRange.
             * @member {message.GetHistoricalMessages.Request.ITimeRange|null|undefined} timeRange
             * @memberof message.GetHistoricalMessages.Request
             * @instance
             */
            Request.prototype.timeRange = null;

            /**
             * Request type.
             * @member {string} type
             * @memberof message.GetHistoricalMessages.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.GetHistoricalMessages.Request
             * @static
             * @param {message.GetHistoricalMessages.IRequest=} [properties] Properties to set
             * @returns {message.GetHistoricalMessages.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.GetHistoricalMessages.Request.verify|verify} messages.
             * @function encode
             * @memberof message.GetHistoricalMessages.Request
             * @static
             * @param {message.GetHistoricalMessages.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.pageNum != null && Object.hasOwnProperty.call(message, "pageNum"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int64(message.pageNum);
                if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.pageSize);
                if (message.timeRange != null && Object.hasOwnProperty.call(message, "timeRange"))
                    $root.message.GetHistoricalMessages.Request.TimeRange.encode(message.timeRange, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.type);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.GetHistoricalMessages.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.GetHistoricalMessages.Request
             * @static
             * @param {message.GetHistoricalMessages.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.GetHistoricalMessages.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.GetHistoricalMessages.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetHistoricalMessages.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 3:
                        message.pageNum = reader.int64();
                        break;
                    case 4:
                        message.pageSize = reader.int64();
                        break;
                    case 5:
                        message.timeRange = $root.message.GetHistoricalMessages.Request.TimeRange.decode(reader, reader.uint32());
                        break;
                    case 6:
                        message.type = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.GetHistoricalMessages.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.GetHistoricalMessages.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.GetHistoricalMessages.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.pageNum != null && message.hasOwnProperty("pageNum"))
                    if (!$util.isInteger(message.pageNum) && !(message.pageNum && $util.isInteger(message.pageNum.low) && $util.isInteger(message.pageNum.high)))
                        return "pageNum: integer|Long expected";
                if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                    if (!$util.isInteger(message.pageSize) && !(message.pageSize && $util.isInteger(message.pageSize.low) && $util.isInteger(message.pageSize.high)))
                        return "pageSize: integer|Long expected";
                if (message.timeRange != null && message.hasOwnProperty("timeRange")) {
                    var error = $root.message.GetHistoricalMessages.Request.TimeRange.verify(message.timeRange);
                    if (error)
                        return "timeRange." + error;
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.GetHistoricalMessages.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.GetHistoricalMessages.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.GetHistoricalMessages.Request)
                    return object;
                var message = new $root.message.GetHistoricalMessages.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.pageNum != null)
                    if ($util.Long)
                        (message.pageNum = $util.Long.fromValue(object.pageNum)).unsigned = false;
                    else if (typeof object.pageNum === "string")
                        message.pageNum = parseInt(object.pageNum, 10);
                    else if (typeof object.pageNum === "number")
                        message.pageNum = object.pageNum;
                    else if (typeof object.pageNum === "object")
                        message.pageNum = new $util.LongBits(object.pageNum.low >>> 0, object.pageNum.high >>> 0).toNumber();
                if (object.pageSize != null)
                    if ($util.Long)
                        (message.pageSize = $util.Long.fromValue(object.pageSize)).unsigned = false;
                    else if (typeof object.pageSize === "string")
                        message.pageSize = parseInt(object.pageSize, 10);
                    else if (typeof object.pageSize === "number")
                        message.pageSize = object.pageSize;
                    else if (typeof object.pageSize === "object")
                        message.pageSize = new $util.LongBits(object.pageSize.low >>> 0, object.pageSize.high >>> 0).toNumber();
                if (object.timeRange != null) {
                    if (typeof object.timeRange !== "object")
                        throw TypeError(".message.GetHistoricalMessages.Request.timeRange: object expected");
                    message.timeRange = $root.message.GetHistoricalMessages.Request.TimeRange.fromObject(object.timeRange);
                }
                if (object.type != null)
                    message.type = String(object.type);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.GetHistoricalMessages.Request
             * @static
             * @param {message.GetHistoricalMessages.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.roomId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.pageNum = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.pageNum = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.pageSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.pageSize = options.longs === String ? "0" : 0;
                    object.timeRange = null;
                    object.type = "";
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.pageNum != null && message.hasOwnProperty("pageNum"))
                    if (typeof message.pageNum === "number")
                        object.pageNum = options.longs === String ? String(message.pageNum) : message.pageNum;
                    else
                        object.pageNum = options.longs === String ? $util.Long.prototype.toString.call(message.pageNum) : options.longs === Number ? new $util.LongBits(message.pageNum.low >>> 0, message.pageNum.high >>> 0).toNumber() : message.pageNum;
                if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                    if (typeof message.pageSize === "number")
                        object.pageSize = options.longs === String ? String(message.pageSize) : message.pageSize;
                    else
                        object.pageSize = options.longs === String ? $util.Long.prototype.toString.call(message.pageSize) : options.longs === Number ? new $util.LongBits(message.pageSize.low >>> 0, message.pageSize.high >>> 0).toNumber() : message.pageSize;
                if (message.timeRange != null && message.hasOwnProperty("timeRange"))
                    object.timeRange = $root.message.GetHistoricalMessages.Request.TimeRange.toObject(message.timeRange, options);
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.GetHistoricalMessages.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Request.TimeRange = (function() {

                /**
                 * Properties of a TimeRange.
                 * @memberof message.GetHistoricalMessages.Request
                 * @interface ITimeRange
                 * @property {number|Long|null} [start] TimeRange start
                 * @property {number|Long|null} [end] TimeRange end
                 */

                /**
                 * Constructs a new TimeRange.
                 * @memberof message.GetHistoricalMessages.Request
                 * @classdesc Represents a TimeRange.
                 * @implements ITimeRange
                 * @constructor
                 * @param {message.GetHistoricalMessages.Request.ITimeRange=} [properties] Properties to set
                 */
                function TimeRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TimeRange start.
                 * @member {number|Long} start
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @instance
                 */
                TimeRange.prototype.start = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * TimeRange end.
                 * @member {number|Long} end
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @instance
                 */
                TimeRange.prototype.end = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new TimeRange instance using the specified properties.
                 * @function create
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @static
                 * @param {message.GetHistoricalMessages.Request.ITimeRange=} [properties] Properties to set
                 * @returns {message.GetHistoricalMessages.Request.TimeRange} TimeRange instance
                 */
                TimeRange.create = function create(properties) {
                    return new TimeRange(properties);
                };

                /**
                 * Encodes the specified TimeRange message. Does not implicitly {@link message.GetHistoricalMessages.Request.TimeRange.verify|verify} messages.
                 * @function encode
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @static
                 * @param {message.GetHistoricalMessages.Request.ITimeRange} message TimeRange message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TimeRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.end);
                    return writer;
                };

                /**
                 * Encodes the specified TimeRange message, length delimited. Does not implicitly {@link message.GetHistoricalMessages.Request.TimeRange.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @static
                 * @param {message.GetHistoricalMessages.Request.ITimeRange} message TimeRange message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TimeRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TimeRange message from the specified reader or buffer.
                 * @function decode
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {message.GetHistoricalMessages.Request.TimeRange} TimeRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TimeRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetHistoricalMessages.Request.TimeRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int64();
                            break;
                        case 2:
                            message.end = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TimeRange message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {message.GetHistoricalMessages.Request.TimeRange} TimeRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TimeRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TimeRange message.
                 * @function verify
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TimeRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start) && !(message.start && $util.isInteger(message.start.low) && $util.isInteger(message.start.high)))
                            return "start: integer|Long expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end) && !(message.end && $util.isInteger(message.end.low) && $util.isInteger(message.end.high)))
                            return "end: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a TimeRange message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {message.GetHistoricalMessages.Request.TimeRange} TimeRange
                 */
                TimeRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.message.GetHistoricalMessages.Request.TimeRange)
                        return object;
                    var message = new $root.message.GetHistoricalMessages.Request.TimeRange();
                    if (object.start != null)
                        if ($util.Long)
                            (message.start = $util.Long.fromValue(object.start)).unsigned = false;
                        else if (typeof object.start === "string")
                            message.start = parseInt(object.start, 10);
                        else if (typeof object.start === "number")
                            message.start = object.start;
                        else if (typeof object.start === "object")
                            message.start = new $util.LongBits(object.start.low >>> 0, object.start.high >>> 0).toNumber();
                    if (object.end != null)
                        if ($util.Long)
                            (message.end = $util.Long.fromValue(object.end)).unsigned = false;
                        else if (typeof object.end === "string")
                            message.end = parseInt(object.end, 10);
                        else if (typeof object.end === "number")
                            message.end = object.end;
                        else if (typeof object.end === "object")
                            message.end = new $util.LongBits(object.end.low >>> 0, object.end.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a TimeRange message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @static
                 * @param {message.GetHistoricalMessages.Request.TimeRange} message TimeRange
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TimeRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.start = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.start = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.end = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.end = options.longs === String ? "0" : 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (typeof message.start === "number")
                            object.start = options.longs === String ? String(message.start) : message.start;
                        else
                            object.start = options.longs === String ? $util.Long.prototype.toString.call(message.start) : options.longs === Number ? new $util.LongBits(message.start.low >>> 0, message.start.high >>> 0).toNumber() : message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (typeof message.end === "number")
                            object.end = options.longs === String ? String(message.end) : message.end;
                        else
                            object.end = options.longs === String ? $util.Long.prototype.toString.call(message.end) : options.longs === Number ? new $util.LongBits(message.end.low >>> 0, message.end.high >>> 0).toNumber() : message.end;
                    return object;
                };

                /**
                 * Converts this TimeRange to JSON.
                 * @function toJSON
                 * @memberof message.GetHistoricalMessages.Request.TimeRange
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TimeRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TimeRange;
            })();

            return Request;
        })();

        GetHistoricalMessages.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.GetHistoricalMessages
             * @interface IResponse
             * @property {Array.<message.IMessages>|null} [list] Response list
             * @property {number|Long|null} [total] Response total
             */

            /**
             * Constructs a new Response.
             * @memberof message.GetHistoricalMessages
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.GetHistoricalMessages.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.list = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response list.
             * @member {Array.<message.IMessages>} list
             * @memberof message.GetHistoricalMessages.Response
             * @instance
             */
            Response.prototype.list = $util.emptyArray;

            /**
             * Response total.
             * @member {number|Long} total
             * @memberof message.GetHistoricalMessages.Response
             * @instance
             */
            Response.prototype.total = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.GetHistoricalMessages.Response
             * @static
             * @param {message.GetHistoricalMessages.IResponse=} [properties] Properties to set
             * @returns {message.GetHistoricalMessages.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.GetHistoricalMessages.Response.verify|verify} messages.
             * @function encode
             * @memberof message.GetHistoricalMessages.Response
             * @static
             * @param {message.GetHistoricalMessages.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.list != null && message.list.length)
                    for (var i = 0; i < message.list.length; ++i)
                        $root.message.Messages.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.total);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.GetHistoricalMessages.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.GetHistoricalMessages.Response
             * @static
             * @param {message.GetHistoricalMessages.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.GetHistoricalMessages.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.GetHistoricalMessages.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.GetHistoricalMessages.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.list && message.list.length))
                            message.list = [];
                        message.list.push($root.message.Messages.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        message.total = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.GetHistoricalMessages.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.GetHistoricalMessages.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.GetHistoricalMessages.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.list != null && message.hasOwnProperty("list")) {
                    if (!Array.isArray(message.list))
                        return "list: array expected";
                    for (var i = 0; i < message.list.length; ++i) {
                        var error = $root.message.Messages.verify(message.list[i]);
                        if (error)
                            return "list." + error;
                    }
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (!$util.isInteger(message.total) && !(message.total && $util.isInteger(message.total.low) && $util.isInteger(message.total.high)))
                        return "total: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.GetHistoricalMessages.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.GetHistoricalMessages.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.GetHistoricalMessages.Response)
                    return object;
                var message = new $root.message.GetHistoricalMessages.Response();
                if (object.list) {
                    if (!Array.isArray(object.list))
                        throw TypeError(".message.GetHistoricalMessages.Response.list: array expected");
                    message.list = [];
                    for (var i = 0; i < object.list.length; ++i) {
                        if (typeof object.list[i] !== "object")
                            throw TypeError(".message.GetHistoricalMessages.Response.list: object expected");
                        message.list[i] = $root.message.Messages.fromObject(object.list[i]);
                    }
                }
                if (object.total != null)
                    if ($util.Long)
                        (message.total = $util.Long.fromValue(object.total)).unsigned = false;
                    else if (typeof object.total === "string")
                        message.total = parseInt(object.total, 10);
                    else if (typeof object.total === "number")
                        message.total = object.total;
                    else if (typeof object.total === "object")
                        message.total = new $util.LongBits(object.total.low >>> 0, object.total.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.GetHistoricalMessages.Response
             * @static
             * @param {message.GetHistoricalMessages.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.list = [];
                if (options.defaults)
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.total = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.total = options.longs === String ? "0" : 0;
                if (message.list && message.list.length) {
                    object.list = [];
                    for (var j = 0; j < message.list.length; ++j)
                        object.list[j] = $root.message.Messages.toObject(message.list[j], options);
                }
                if (message.total != null && message.hasOwnProperty("total"))
                    if (typeof message.total === "number")
                        object.total = options.longs === String ? String(message.total) : message.total;
                    else
                        object.total = options.longs === String ? $util.Long.prototype.toString.call(message.total) : options.longs === Number ? new $util.LongBits(message.total.low >>> 0, message.total.high >>> 0).toNumber() : message.total;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.GetHistoricalMessages.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return GetHistoricalMessages;
    })();

    message.ReadMessageItem = (function() {

        /**
         * Properties of a ReadMessageItem.
         * @memberof message
         * @interface IReadMessageItem
         * @property {string|null} [id] ReadMessageItem id
         * @property {Array.<number|Long>|null} [readUserIds] ReadMessageItem readUserIds
         */

        /**
         * Constructs a new ReadMessageItem.
         * @memberof message
         * @classdesc Represents a ReadMessageItem.
         * @implements IReadMessageItem
         * @constructor
         * @param {message.IReadMessageItem=} [properties] Properties to set
         */
        function ReadMessageItem(properties) {
            this.readUserIds = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReadMessageItem id.
         * @member {string} id
         * @memberof message.ReadMessageItem
         * @instance
         */
        ReadMessageItem.prototype.id = "";

        /**
         * ReadMessageItem readUserIds.
         * @member {Array.<number|Long>} readUserIds
         * @memberof message.ReadMessageItem
         * @instance
         */
        ReadMessageItem.prototype.readUserIds = $util.emptyArray;

        /**
         * Creates a new ReadMessageItem instance using the specified properties.
         * @function create
         * @memberof message.ReadMessageItem
         * @static
         * @param {message.IReadMessageItem=} [properties] Properties to set
         * @returns {message.ReadMessageItem} ReadMessageItem instance
         */
        ReadMessageItem.create = function create(properties) {
            return new ReadMessageItem(properties);
        };

        /**
         * Encodes the specified ReadMessageItem message. Does not implicitly {@link message.ReadMessageItem.verify|verify} messages.
         * @function encode
         * @memberof message.ReadMessageItem
         * @static
         * @param {message.IReadMessageItem} message ReadMessageItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadMessageItem.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
            if (message.readUserIds != null && message.readUserIds.length) {
                writer.uint32(/* id 6, wireType 2 =*/50).fork();
                for (var i = 0; i < message.readUserIds.length; ++i)
                    writer.int64(message.readUserIds[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified ReadMessageItem message, length delimited. Does not implicitly {@link message.ReadMessageItem.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.ReadMessageItem
         * @static
         * @param {message.IReadMessageItem} message ReadMessageItem message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadMessageItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReadMessageItem message from the specified reader or buffer.
         * @function decode
         * @memberof message.ReadMessageItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.ReadMessageItem} ReadMessageItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadMessageItem.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.ReadMessageItem();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                case 6:
                    if (!(message.readUserIds && message.readUserIds.length))
                        message.readUserIds = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.readUserIds.push(reader.int64());
                    } else
                        message.readUserIds.push(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReadMessageItem message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.ReadMessageItem
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.ReadMessageItem} ReadMessageItem
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadMessageItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReadMessageItem message.
         * @function verify
         * @memberof message.ReadMessageItem
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReadMessageItem.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.id != null && message.hasOwnProperty("id"))
                if (!$util.isString(message.id))
                    return "id: string expected";
            if (message.readUserIds != null && message.hasOwnProperty("readUserIds")) {
                if (!Array.isArray(message.readUserIds))
                    return "readUserIds: array expected";
                for (var i = 0; i < message.readUserIds.length; ++i)
                    if (!$util.isInteger(message.readUserIds[i]) && !(message.readUserIds[i] && $util.isInteger(message.readUserIds[i].low) && $util.isInteger(message.readUserIds[i].high)))
                        return "readUserIds: integer|Long[] expected";
            }
            return null;
        };

        /**
         * Creates a ReadMessageItem message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.ReadMessageItem
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.ReadMessageItem} ReadMessageItem
         */
        ReadMessageItem.fromObject = function fromObject(object) {
            if (object instanceof $root.message.ReadMessageItem)
                return object;
            var message = new $root.message.ReadMessageItem();
            if (object.id != null)
                message.id = String(object.id);
            if (object.readUserIds) {
                if (!Array.isArray(object.readUserIds))
                    throw TypeError(".message.ReadMessageItem.readUserIds: array expected");
                message.readUserIds = [];
                for (var i = 0; i < object.readUserIds.length; ++i)
                    if ($util.Long)
                        (message.readUserIds[i] = $util.Long.fromValue(object.readUserIds[i])).unsigned = false;
                    else if (typeof object.readUserIds[i] === "string")
                        message.readUserIds[i] = parseInt(object.readUserIds[i], 10);
                    else if (typeof object.readUserIds[i] === "number")
                        message.readUserIds[i] = object.readUserIds[i];
                    else if (typeof object.readUserIds[i] === "object")
                        message.readUserIds[i] = new $util.LongBits(object.readUserIds[i].low >>> 0, object.readUserIds[i].high >>> 0).toNumber();
            }
            return message;
        };

        /**
         * Creates a plain object from a ReadMessageItem message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.ReadMessageItem
         * @static
         * @param {message.ReadMessageItem} message ReadMessageItem
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReadMessageItem.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.readUserIds = [];
            if (options.defaults)
                object.id = "";
            if (message.id != null && message.hasOwnProperty("id"))
                object.id = message.id;
            if (message.readUserIds && message.readUserIds.length) {
                object.readUserIds = [];
                for (var j = 0; j < message.readUserIds.length; ++j)
                    if (typeof message.readUserIds[j] === "number")
                        object.readUserIds[j] = options.longs === String ? String(message.readUserIds[j]) : message.readUserIds[j];
                    else
                        object.readUserIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.readUserIds[j]) : options.longs === Number ? new $util.LongBits(message.readUserIds[j].low >>> 0, message.readUserIds[j].high >>> 0).toNumber() : message.readUserIds[j];
            }
            return object;
        };

        /**
         * Converts this ReadMessageItem to JSON.
         * @function toJSON
         * @memberof message.ReadMessageItem
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReadMessageItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReadMessageItem;
    })();

    message.ReadAllMessages = (function() {

        /**
         * Properties of a ReadAllMessages.
         * @memberof message
         * @interface IReadAllMessages
         */

        /**
         * Constructs a new ReadAllMessages.
         * @memberof message
         * @classdesc Represents a ReadAllMessages.
         * @implements IReadAllMessages
         * @constructor
         * @param {message.IReadAllMessages=} [properties] Properties to set
         */
        function ReadAllMessages(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new ReadAllMessages instance using the specified properties.
         * @function create
         * @memberof message.ReadAllMessages
         * @static
         * @param {message.IReadAllMessages=} [properties] Properties to set
         * @returns {message.ReadAllMessages} ReadAllMessages instance
         */
        ReadAllMessages.create = function create(properties) {
            return new ReadAllMessages(properties);
        };

        /**
         * Encodes the specified ReadAllMessages message. Does not implicitly {@link message.ReadAllMessages.verify|verify} messages.
         * @function encode
         * @memberof message.ReadAllMessages
         * @static
         * @param {message.IReadAllMessages} message ReadAllMessages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadAllMessages.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified ReadAllMessages message, length delimited. Does not implicitly {@link message.ReadAllMessages.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.ReadAllMessages
         * @static
         * @param {message.IReadAllMessages} message ReadAllMessages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadAllMessages.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReadAllMessages message from the specified reader or buffer.
         * @function decode
         * @memberof message.ReadAllMessages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.ReadAllMessages} ReadAllMessages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadAllMessages.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.ReadAllMessages();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReadAllMessages message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.ReadAllMessages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.ReadAllMessages} ReadAllMessages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadAllMessages.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReadAllMessages message.
         * @function verify
         * @memberof message.ReadAllMessages
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReadAllMessages.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a ReadAllMessages message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.ReadAllMessages
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.ReadAllMessages} ReadAllMessages
         */
        ReadAllMessages.fromObject = function fromObject(object) {
            if (object instanceof $root.message.ReadAllMessages)
                return object;
            return new $root.message.ReadAllMessages();
        };

        /**
         * Creates a plain object from a ReadAllMessages message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.ReadAllMessages
         * @static
         * @param {message.ReadAllMessages} message ReadAllMessages
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReadAllMessages.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this ReadAllMessages to JSON.
         * @function toJSON
         * @memberof message.ReadAllMessages
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReadAllMessages.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ReadAllMessages.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.ReadAllMessages
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             */

            /**
             * Constructs a new Request.
             * @memberof message.ReadAllMessages
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.ReadAllMessages.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.ReadAllMessages.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.ReadAllMessages.Request
             * @static
             * @param {message.ReadAllMessages.IRequest=} [properties] Properties to set
             * @returns {message.ReadAllMessages.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.ReadAllMessages.Request.verify|verify} messages.
             * @function encode
             * @memberof message.ReadAllMessages.Request
             * @static
             * @param {message.ReadAllMessages.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.ReadAllMessages.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.ReadAllMessages.Request
             * @static
             * @param {message.ReadAllMessages.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.ReadAllMessages.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.ReadAllMessages.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.ReadAllMessages.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.ReadAllMessages.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.ReadAllMessages.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.ReadAllMessages.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.ReadAllMessages.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.ReadAllMessages.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.ReadAllMessages.Request)
                    return object;
                var message = new $root.message.ReadAllMessages.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.ReadAllMessages.Request
             * @static
             * @param {message.ReadAllMessages.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.roomId = "";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.ReadAllMessages.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        ReadAllMessages.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.ReadAllMessages
             * @interface IResponse
             * @property {string|null} [roomId] Response roomId
             * @property {string|null} [uid] Response uid
             */

            /**
             * Constructs a new Response.
             * @memberof message.ReadAllMessages
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.ReadAllMessages.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof message.ReadAllMessages.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response uid.
             * @member {string} uid
             * @memberof message.ReadAllMessages.Response
             * @instance
             */
            Response.prototype.uid = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.ReadAllMessages.Response
             * @static
             * @param {message.ReadAllMessages.IResponse=} [properties] Properties to set
             * @returns {message.ReadAllMessages.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.ReadAllMessages.Response.verify|verify} messages.
             * @function encode
             * @memberof message.ReadAllMessages.Response
             * @static
             * @param {message.ReadAllMessages.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.uid);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.ReadAllMessages.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.ReadAllMessages.Response
             * @static
             * @param {message.ReadAllMessages.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.ReadAllMessages.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.ReadAllMessages.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.ReadAllMessages.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        message.uid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.ReadAllMessages.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.ReadAllMessages.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.ReadAllMessages.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.ReadAllMessages.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.ReadAllMessages.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.ReadAllMessages.Response)
                    return object;
                var message = new $root.message.ReadAllMessages.Response();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.uid != null)
                    message.uid = String(object.uid);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.ReadAllMessages.Response
             * @static
             * @param {message.ReadAllMessages.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.roomId = "";
                    object.uid = "";
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.ReadAllMessages.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return ReadAllMessages;
    })();

    message.DeleteMessages = (function() {

        /**
         * Properties of a DeleteMessages.
         * @memberof message
         * @interface IDeleteMessages
         */

        /**
         * Constructs a new DeleteMessages.
         * @memberof message
         * @classdesc Represents a DeleteMessages.
         * @implements IDeleteMessages
         * @constructor
         * @param {message.IDeleteMessages=} [properties] Properties to set
         */
        function DeleteMessages(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DeleteMessages instance using the specified properties.
         * @function create
         * @memberof message.DeleteMessages
         * @static
         * @param {message.IDeleteMessages=} [properties] Properties to set
         * @returns {message.DeleteMessages} DeleteMessages instance
         */
        DeleteMessages.create = function create(properties) {
            return new DeleteMessages(properties);
        };

        /**
         * Encodes the specified DeleteMessages message. Does not implicitly {@link message.DeleteMessages.verify|verify} messages.
         * @function encode
         * @memberof message.DeleteMessages
         * @static
         * @param {message.IDeleteMessages} message DeleteMessages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteMessages.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified DeleteMessages message, length delimited. Does not implicitly {@link message.DeleteMessages.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.DeleteMessages
         * @static
         * @param {message.IDeleteMessages} message DeleteMessages message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DeleteMessages.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DeleteMessages message from the specified reader or buffer.
         * @function decode
         * @memberof message.DeleteMessages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.DeleteMessages} DeleteMessages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteMessages.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.DeleteMessages();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DeleteMessages message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.DeleteMessages
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.DeleteMessages} DeleteMessages
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DeleteMessages.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DeleteMessages message.
         * @function verify
         * @memberof message.DeleteMessages
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DeleteMessages.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a DeleteMessages message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.DeleteMessages
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.DeleteMessages} DeleteMessages
         */
        DeleteMessages.fromObject = function fromObject(object) {
            if (object instanceof $root.message.DeleteMessages)
                return object;
            return new $root.message.DeleteMessages();
        };

        /**
         * Creates a plain object from a DeleteMessages message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.DeleteMessages
         * @static
         * @param {message.DeleteMessages} message DeleteMessages
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DeleteMessages.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this DeleteMessages to JSON.
         * @function toJSON
         * @memberof message.DeleteMessages
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DeleteMessages.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        DeleteMessages.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.DeleteMessages
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             * @property {Array.<string>|null} [messageIdList] Request messageIdList
             * @property {string|null} [type] Request type
             * @property {number|Long|null} [expirationTime] Request expirationTime
             */

            /**
             * Constructs a new Request.
             * @memberof message.DeleteMessages
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.DeleteMessages.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.messageIdList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.DeleteMessages.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Request messageIdList.
             * @member {Array.<string>} messageIdList
             * @memberof message.DeleteMessages.Request
             * @instance
             */
            Request.prototype.messageIdList = $util.emptyArray;

            /**
             * Request type.
             * @member {string} type
             * @memberof message.DeleteMessages.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Request expirationTime.
             * @member {number|Long} expirationTime
             * @memberof message.DeleteMessages.Request
             * @instance
             */
            Request.prototype.expirationTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.DeleteMessages.Request
             * @static
             * @param {message.DeleteMessages.IRequest=} [properties] Properties to set
             * @returns {message.DeleteMessages.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.DeleteMessages.Request.verify|verify} messages.
             * @function encode
             * @memberof message.DeleteMessages.Request
             * @static
             * @param {message.DeleteMessages.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.messageIdList != null && message.messageIdList.length)
                    for (var i = 0; i < message.messageIdList.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageIdList[i]);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
                if (message.expirationTime != null && Object.hasOwnProperty.call(message, "expirationTime"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.expirationTime);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.DeleteMessages.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.DeleteMessages.Request
             * @static
             * @param {message.DeleteMessages.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.DeleteMessages.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.DeleteMessages.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.DeleteMessages.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        if (!(message.messageIdList && message.messageIdList.length))
                            message.messageIdList = [];
                        message.messageIdList.push(reader.string());
                        break;
                    case 3:
                        message.type = reader.string();
                        break;
                    case 4:
                        message.expirationTime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.DeleteMessages.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.DeleteMessages.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.DeleteMessages.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.messageIdList != null && message.hasOwnProperty("messageIdList")) {
                    if (!Array.isArray(message.messageIdList))
                        return "messageIdList: array expected";
                    for (var i = 0; i < message.messageIdList.length; ++i)
                        if (!$util.isString(message.messageIdList[i]))
                            return "messageIdList: string[] expected";
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.expirationTime != null && message.hasOwnProperty("expirationTime"))
                    if (!$util.isInteger(message.expirationTime) && !(message.expirationTime && $util.isInteger(message.expirationTime.low) && $util.isInteger(message.expirationTime.high)))
                        return "expirationTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.DeleteMessages.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.DeleteMessages.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.DeleteMessages.Request)
                    return object;
                var message = new $root.message.DeleteMessages.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.messageIdList) {
                    if (!Array.isArray(object.messageIdList))
                        throw TypeError(".message.DeleteMessages.Request.messageIdList: array expected");
                    message.messageIdList = [];
                    for (var i = 0; i < object.messageIdList.length; ++i)
                        message.messageIdList[i] = String(object.messageIdList[i]);
                }
                if (object.type != null)
                    message.type = String(object.type);
                if (object.expirationTime != null)
                    if ($util.Long)
                        (message.expirationTime = $util.Long.fromValue(object.expirationTime)).unsigned = false;
                    else if (typeof object.expirationTime === "string")
                        message.expirationTime = parseInt(object.expirationTime, 10);
                    else if (typeof object.expirationTime === "number")
                        message.expirationTime = object.expirationTime;
                    else if (typeof object.expirationTime === "object")
                        message.expirationTime = new $util.LongBits(object.expirationTime.low >>> 0, object.expirationTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.DeleteMessages.Request
             * @static
             * @param {message.DeleteMessages.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.messageIdList = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.type = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.expirationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.expirationTime = options.longs === String ? "0" : 0;
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.messageIdList && message.messageIdList.length) {
                    object.messageIdList = [];
                    for (var j = 0; j < message.messageIdList.length; ++j)
                        object.messageIdList[j] = message.messageIdList[j];
                }
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.expirationTime != null && message.hasOwnProperty("expirationTime"))
                    if (typeof message.expirationTime === "number")
                        object.expirationTime = options.longs === String ? String(message.expirationTime) : message.expirationTime;
                    else
                        object.expirationTime = options.longs === String ? $util.Long.prototype.toString.call(message.expirationTime) : options.longs === Number ? new $util.LongBits(message.expirationTime.low >>> 0, message.expirationTime.high >>> 0).toNumber() : message.expirationTime;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.DeleteMessages.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        DeleteMessages.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.DeleteMessages
             * @interface IResponse
             * @property {string|null} [roomId] Response roomId
             * @property {Array.<string>|null} [messageIdList] Response messageIdList
             * @property {string|null} [uid] Response uid
             */

            /**
             * Constructs a new Response.
             * @memberof message.DeleteMessages
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.DeleteMessages.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.messageIdList = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof message.DeleteMessages.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response messageIdList.
             * @member {Array.<string>} messageIdList
             * @memberof message.DeleteMessages.Response
             * @instance
             */
            Response.prototype.messageIdList = $util.emptyArray;

            /**
             * Response uid.
             * @member {string} uid
             * @memberof message.DeleteMessages.Response
             * @instance
             */
            Response.prototype.uid = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.DeleteMessages.Response
             * @static
             * @param {message.DeleteMessages.IResponse=} [properties] Properties to set
             * @returns {message.DeleteMessages.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.DeleteMessages.Response.verify|verify} messages.
             * @function encode
             * @memberof message.DeleteMessages.Response
             * @static
             * @param {message.DeleteMessages.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.messageIdList != null && message.messageIdList.length)
                    for (var i = 0; i < message.messageIdList.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.messageIdList[i]);
                if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.uid);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.DeleteMessages.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.DeleteMessages.Response
             * @static
             * @param {message.DeleteMessages.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.DeleteMessages.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.DeleteMessages.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.DeleteMessages.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        if (!(message.messageIdList && message.messageIdList.length))
                            message.messageIdList = [];
                        message.messageIdList.push(reader.string());
                        break;
                    case 3:
                        message.uid = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.DeleteMessages.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.DeleteMessages.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.DeleteMessages.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.messageIdList != null && message.hasOwnProperty("messageIdList")) {
                    if (!Array.isArray(message.messageIdList))
                        return "messageIdList: array expected";
                    for (var i = 0; i < message.messageIdList.length; ++i)
                        if (!$util.isString(message.messageIdList[i]))
                            return "messageIdList: string[] expected";
                }
                if (message.uid != null && message.hasOwnProperty("uid"))
                    if (!$util.isString(message.uid))
                        return "uid: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.DeleteMessages.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.DeleteMessages.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.DeleteMessages.Response)
                    return object;
                var message = new $root.message.DeleteMessages.Response();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.messageIdList) {
                    if (!Array.isArray(object.messageIdList))
                        throw TypeError(".message.DeleteMessages.Response.messageIdList: array expected");
                    message.messageIdList = [];
                    for (var i = 0; i < object.messageIdList.length; ++i)
                        message.messageIdList[i] = String(object.messageIdList[i]);
                }
                if (object.uid != null)
                    message.uid = String(object.uid);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.DeleteMessages.Response
             * @static
             * @param {message.DeleteMessages.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.messageIdList = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.uid = "";
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.messageIdList && message.messageIdList.length) {
                    object.messageIdList = [];
                    for (var j = 0; j < message.messageIdList.length; ++j)
                        object.messageIdList[j] = message.messageIdList[j];
                }
                if (message.uid != null && message.hasOwnProperty("uid"))
                    object.uid = message.uid;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.DeleteMessages.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return DeleteMessages;
    })();

    message.MessagesCallParticipants = (function() {

        /**
         * Properties of a MessagesCallParticipants.
         * @memberof message
         * @interface IMessagesCallParticipants
         * @property {string|null} [uid] MessagesCallParticipants uid
         * @property {boolean|null} [caller] MessagesCallParticipants caller
         */

        /**
         * Constructs a new MessagesCallParticipants.
         * @memberof message
         * @classdesc Represents a MessagesCallParticipants.
         * @implements IMessagesCallParticipants
         * @constructor
         * @param {message.IMessagesCallParticipants=} [properties] Properties to set
         */
        function MessagesCallParticipants(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessagesCallParticipants uid.
         * @member {string} uid
         * @memberof message.MessagesCallParticipants
         * @instance
         */
        MessagesCallParticipants.prototype.uid = "";

        /**
         * MessagesCallParticipants caller.
         * @member {boolean} caller
         * @memberof message.MessagesCallParticipants
         * @instance
         */
        MessagesCallParticipants.prototype.caller = false;

        /**
         * Creates a new MessagesCallParticipants instance using the specified properties.
         * @function create
         * @memberof message.MessagesCallParticipants
         * @static
         * @param {message.IMessagesCallParticipants=} [properties] Properties to set
         * @returns {message.MessagesCallParticipants} MessagesCallParticipants instance
         */
        MessagesCallParticipants.create = function create(properties) {
            return new MessagesCallParticipants(properties);
        };

        /**
         * Encodes the specified MessagesCallParticipants message. Does not implicitly {@link message.MessagesCallParticipants.verify|verify} messages.
         * @function encode
         * @memberof message.MessagesCallParticipants
         * @static
         * @param {message.IMessagesCallParticipants} message MessagesCallParticipants message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesCallParticipants.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.uid != null && Object.hasOwnProperty.call(message, "uid"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.uid);
            if (message.caller != null && Object.hasOwnProperty.call(message, "caller"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.caller);
            return writer;
        };

        /**
         * Encodes the specified MessagesCallParticipants message, length delimited. Does not implicitly {@link message.MessagesCallParticipants.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.MessagesCallParticipants
         * @static
         * @param {message.IMessagesCallParticipants} message MessagesCallParticipants message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessagesCallParticipants.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MessagesCallParticipants message from the specified reader or buffer.
         * @function decode
         * @memberof message.MessagesCallParticipants
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.MessagesCallParticipants} MessagesCallParticipants
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesCallParticipants.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.MessagesCallParticipants();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.uid = reader.string();
                    break;
                case 2:
                    message.caller = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MessagesCallParticipants message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.MessagesCallParticipants
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.MessagesCallParticipants} MessagesCallParticipants
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessagesCallParticipants.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MessagesCallParticipants message.
         * @function verify
         * @memberof message.MessagesCallParticipants
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MessagesCallParticipants.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.uid != null && message.hasOwnProperty("uid"))
                if (!$util.isString(message.uid))
                    return "uid: string expected";
            if (message.caller != null && message.hasOwnProperty("caller"))
                if (typeof message.caller !== "boolean")
                    return "caller: boolean expected";
            return null;
        };

        /**
         * Creates a MessagesCallParticipants message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.MessagesCallParticipants
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.MessagesCallParticipants} MessagesCallParticipants
         */
        MessagesCallParticipants.fromObject = function fromObject(object) {
            if (object instanceof $root.message.MessagesCallParticipants)
                return object;
            var message = new $root.message.MessagesCallParticipants();
            if (object.uid != null)
                message.uid = String(object.uid);
            if (object.caller != null)
                message.caller = Boolean(object.caller);
            return message;
        };

        /**
         * Creates a plain object from a MessagesCallParticipants message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.MessagesCallParticipants
         * @static
         * @param {message.MessagesCallParticipants} message MessagesCallParticipants
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessagesCallParticipants.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.uid = "";
                object.caller = false;
            }
            if (message.uid != null && message.hasOwnProperty("uid"))
                object.uid = message.uid;
            if (message.caller != null && message.hasOwnProperty("caller"))
                object.caller = message.caller;
            return object;
        };

        /**
         * Converts this MessagesCallParticipants to JSON.
         * @function toJSON
         * @memberof message.MessagesCallParticipants
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MessagesCallParticipants.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessagesCallParticipants;
    })();

    message.TurnServer = (function() {

        /**
         * Properties of a TurnServer.
         * @memberof message
         * @interface ITurnServer
         * @property {Array.<string>|null} [urls] TurnServer urls
         * @property {string|null} [username] TurnServer username
         * @property {string|null} [credential] TurnServer credential
         */

        /**
         * Constructs a new TurnServer.
         * @memberof message
         * @classdesc Represents a TurnServer.
         * @implements ITurnServer
         * @constructor
         * @param {message.ITurnServer=} [properties] Properties to set
         */
        function TurnServer(properties) {
            this.urls = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TurnServer urls.
         * @member {Array.<string>} urls
         * @memberof message.TurnServer
         * @instance
         */
        TurnServer.prototype.urls = $util.emptyArray;

        /**
         * TurnServer username.
         * @member {string} username
         * @memberof message.TurnServer
         * @instance
         */
        TurnServer.prototype.username = "";

        /**
         * TurnServer credential.
         * @member {string} credential
         * @memberof message.TurnServer
         * @instance
         */
        TurnServer.prototype.credential = "";

        /**
         * Creates a new TurnServer instance using the specified properties.
         * @function create
         * @memberof message.TurnServer
         * @static
         * @param {message.ITurnServer=} [properties] Properties to set
         * @returns {message.TurnServer} TurnServer instance
         */
        TurnServer.create = function create(properties) {
            return new TurnServer(properties);
        };

        /**
         * Encodes the specified TurnServer message. Does not implicitly {@link message.TurnServer.verify|verify} messages.
         * @function encode
         * @memberof message.TurnServer
         * @static
         * @param {message.ITurnServer} message TurnServer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TurnServer.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.urls != null && message.urls.length)
                for (var i = 0; i < message.urls.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.urls[i]);
            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
            if (message.credential != null && Object.hasOwnProperty.call(message, "credential"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.credential);
            return writer;
        };

        /**
         * Encodes the specified TurnServer message, length delimited. Does not implicitly {@link message.TurnServer.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.TurnServer
         * @static
         * @param {message.ITurnServer} message TurnServer message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TurnServer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TurnServer message from the specified reader or buffer.
         * @function decode
         * @memberof message.TurnServer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.TurnServer} TurnServer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TurnServer.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.TurnServer();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.urls && message.urls.length))
                        message.urls = [];
                    message.urls.push(reader.string());
                    break;
                case 2:
                    message.username = reader.string();
                    break;
                case 3:
                    message.credential = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TurnServer message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.TurnServer
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.TurnServer} TurnServer
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TurnServer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TurnServer message.
         * @function verify
         * @memberof message.TurnServer
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TurnServer.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.urls != null && message.hasOwnProperty("urls")) {
                if (!Array.isArray(message.urls))
                    return "urls: array expected";
                for (var i = 0; i < message.urls.length; ++i)
                    if (!$util.isString(message.urls[i]))
                        return "urls: string[] expected";
            }
            if (message.username != null && message.hasOwnProperty("username"))
                if (!$util.isString(message.username))
                    return "username: string expected";
            if (message.credential != null && message.hasOwnProperty("credential"))
                if (!$util.isString(message.credential))
                    return "credential: string expected";
            return null;
        };

        /**
         * Creates a TurnServer message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.TurnServer
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.TurnServer} TurnServer
         */
        TurnServer.fromObject = function fromObject(object) {
            if (object instanceof $root.message.TurnServer)
                return object;
            var message = new $root.message.TurnServer();
            if (object.urls) {
                if (!Array.isArray(object.urls))
                    throw TypeError(".message.TurnServer.urls: array expected");
                message.urls = [];
                for (var i = 0; i < object.urls.length; ++i)
                    message.urls[i] = String(object.urls[i]);
            }
            if (object.username != null)
                message.username = String(object.username);
            if (object.credential != null)
                message.credential = String(object.credential);
            return message;
        };

        /**
         * Creates a plain object from a TurnServer message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.TurnServer
         * @static
         * @param {message.TurnServer} message TurnServer
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TurnServer.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.urls = [];
            if (options.defaults) {
                object.username = "";
                object.credential = "";
            }
            if (message.urls && message.urls.length) {
                object.urls = [];
                for (var j = 0; j < message.urls.length; ++j)
                    object.urls[j] = message.urls[j];
            }
            if (message.username != null && message.hasOwnProperty("username"))
                object.username = message.username;
            if (message.credential != null && message.hasOwnProperty("credential"))
                object.credential = message.credential;
            return object;
        };

        /**
         * Converts this TurnServer to JSON.
         * @function toJSON
         * @memberof message.TurnServer
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TurnServer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TurnServer;
    })();

    message.StartCalling = (function() {

        /**
         * Properties of a StartCalling.
         * @memberof message
         * @interface IStartCalling
         */

        /**
         * Constructs a new StartCalling.
         * @memberof message
         * @classdesc Represents a StartCalling.
         * @implements IStartCalling
         * @constructor
         * @param {message.IStartCalling=} [properties] Properties to set
         */
        function StartCalling(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new StartCalling instance using the specified properties.
         * @function create
         * @memberof message.StartCalling
         * @static
         * @param {message.IStartCalling=} [properties] Properties to set
         * @returns {message.StartCalling} StartCalling instance
         */
        StartCalling.create = function create(properties) {
            return new StartCalling(properties);
        };

        /**
         * Encodes the specified StartCalling message. Does not implicitly {@link message.StartCalling.verify|verify} messages.
         * @function encode
         * @memberof message.StartCalling
         * @static
         * @param {message.IStartCalling} message StartCalling message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartCalling.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified StartCalling message, length delimited. Does not implicitly {@link message.StartCalling.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.StartCalling
         * @static
         * @param {message.IStartCalling} message StartCalling message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartCalling.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StartCalling message from the specified reader or buffer.
         * @function decode
         * @memberof message.StartCalling
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.StartCalling} StartCalling
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartCalling.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.StartCalling();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StartCalling message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.StartCalling
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.StartCalling} StartCalling
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartCalling.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StartCalling message.
         * @function verify
         * @memberof message.StartCalling
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StartCalling.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a StartCalling message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.StartCalling
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.StartCalling} StartCalling
         */
        StartCalling.fromObject = function fromObject(object) {
            if (object instanceof $root.message.StartCalling)
                return object;
            return new $root.message.StartCalling();
        };

        /**
         * Creates a plain object from a StartCalling message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.StartCalling
         * @static
         * @param {message.StartCalling} message StartCalling
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StartCalling.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this StartCalling to JSON.
         * @function toJSON
         * @memberof message.StartCalling
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StartCalling.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        StartCalling.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.StartCalling
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             * @property {string|null} [type] Request type
             * @property {Array.<message.IMessagesCallParticipants>|null} [participants] Request participants
             */

            /**
             * Constructs a new Request.
             * @memberof message.StartCalling
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.StartCalling.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.participants = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.StartCalling.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Request type.
             * @member {string} type
             * @memberof message.StartCalling.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Request participants.
             * @member {Array.<message.IMessagesCallParticipants>} participants
             * @memberof message.StartCalling.Request
             * @instance
             */
            Request.prototype.participants = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.StartCalling.Request
             * @static
             * @param {message.StartCalling.IRequest=} [properties] Properties to set
             * @returns {message.StartCalling.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.StartCalling.Request.verify|verify} messages.
             * @function encode
             * @memberof message.StartCalling.Request
             * @static
             * @param {message.StartCalling.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.participants != null && message.participants.length)
                    for (var i = 0; i < message.participants.length; ++i)
                        $root.message.MessagesCallParticipants.encode(message.participants[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.StartCalling.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.StartCalling.Request
             * @static
             * @param {message.StartCalling.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.StartCalling.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.StartCalling.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.StartCalling.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.message.MessagesCallParticipants.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.StartCalling.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.StartCalling.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.StartCalling.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.participants != null && message.hasOwnProperty("participants")) {
                    if (!Array.isArray(message.participants))
                        return "participants: array expected";
                    for (var i = 0; i < message.participants.length; ++i) {
                        var error = $root.message.MessagesCallParticipants.verify(message.participants[i]);
                        if (error)
                            return "participants." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.StartCalling.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.StartCalling.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.StartCalling.Request)
                    return object;
                var message = new $root.message.StartCalling.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.participants) {
                    if (!Array.isArray(object.participants))
                        throw TypeError(".message.StartCalling.Request.participants: array expected");
                    message.participants = [];
                    for (var i = 0; i < object.participants.length; ++i) {
                        if (typeof object.participants[i] !== "object")
                            throw TypeError(".message.StartCalling.Request.participants: object expected");
                        message.participants[i] = $root.message.MessagesCallParticipants.fromObject(object.participants[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.StartCalling.Request
             * @static
             * @param {message.StartCalling.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.participants = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.type = "";
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.participants && message.participants.length) {
                    object.participants = [];
                    for (var j = 0; j < message.participants.length; ++j)
                        object.participants[j] = $root.message.MessagesCallParticipants.toObject(message.participants[j], options);
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.StartCalling.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        StartCalling.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.StartCalling
             * @interface IResponse
             * @property {string|null} [roomId] Response roomId
             * @property {string|null} [type] Response type
             * @property {Array.<message.IMessagesCallParticipants>|null} [participants] Response participants
             * @property {string|null} [currentUserId] Response currentUserId
             * @property {string|null} [callToken] Response callToken
             * @property {message.ITurnServer|null} [turnServer] Response turnServer
             */

            /**
             * Constructs a new Response.
             * @memberof message.StartCalling
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.StartCalling.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.participants = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof message.StartCalling.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response type.
             * @member {string} type
             * @memberof message.StartCalling.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Response participants.
             * @member {Array.<message.IMessagesCallParticipants>} participants
             * @memberof message.StartCalling.Response
             * @instance
             */
            Response.prototype.participants = $util.emptyArray;

            /**
             * Response currentUserId.
             * @member {string} currentUserId
             * @memberof message.StartCalling.Response
             * @instance
             */
            Response.prototype.currentUserId = "";

            /**
             * Response callToken.
             * @member {string} callToken
             * @memberof message.StartCalling.Response
             * @instance
             */
            Response.prototype.callToken = "";

            /**
             * Response turnServer.
             * @member {message.ITurnServer|null|undefined} turnServer
             * @memberof message.StartCalling.Response
             * @instance
             */
            Response.prototype.turnServer = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.StartCalling.Response
             * @static
             * @param {message.StartCalling.IResponse=} [properties] Properties to set
             * @returns {message.StartCalling.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.StartCalling.Response.verify|verify} messages.
             * @function encode
             * @memberof message.StartCalling.Response
             * @static
             * @param {message.StartCalling.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.participants != null && message.participants.length)
                    for (var i = 0; i < message.participants.length; ++i)
                        $root.message.MessagesCallParticipants.encode(message.participants[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.currentUserId != null && Object.hasOwnProperty.call(message, "currentUserId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.currentUserId);
                if (message.callToken != null && Object.hasOwnProperty.call(message, "callToken"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.callToken);
                if (message.turnServer != null && Object.hasOwnProperty.call(message, "turnServer"))
                    $root.message.TurnServer.encode(message.turnServer, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.StartCalling.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.StartCalling.Response
             * @static
             * @param {message.StartCalling.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.StartCalling.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.StartCalling.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.StartCalling.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.message.MessagesCallParticipants.decode(reader, reader.uint32()));
                        break;
                    case 4:
                        message.currentUserId = reader.string();
                        break;
                    case 5:
                        message.callToken = reader.string();
                        break;
                    case 6:
                        message.turnServer = $root.message.TurnServer.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.StartCalling.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.StartCalling.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.StartCalling.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.participants != null && message.hasOwnProperty("participants")) {
                    if (!Array.isArray(message.participants))
                        return "participants: array expected";
                    for (var i = 0; i < message.participants.length; ++i) {
                        var error = $root.message.MessagesCallParticipants.verify(message.participants[i]);
                        if (error)
                            return "participants." + error;
                    }
                }
                if (message.currentUserId != null && message.hasOwnProperty("currentUserId"))
                    if (!$util.isString(message.currentUserId))
                        return "currentUserId: string expected";
                if (message.callToken != null && message.hasOwnProperty("callToken"))
                    if (!$util.isString(message.callToken))
                        return "callToken: string expected";
                if (message.turnServer != null && message.hasOwnProperty("turnServer")) {
                    var error = $root.message.TurnServer.verify(message.turnServer);
                    if (error)
                        return "turnServer." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.StartCalling.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.StartCalling.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.StartCalling.Response)
                    return object;
                var message = new $root.message.StartCalling.Response();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.participants) {
                    if (!Array.isArray(object.participants))
                        throw TypeError(".message.StartCalling.Response.participants: array expected");
                    message.participants = [];
                    for (var i = 0; i < object.participants.length; ++i) {
                        if (typeof object.participants[i] !== "object")
                            throw TypeError(".message.StartCalling.Response.participants: object expected");
                        message.participants[i] = $root.message.MessagesCallParticipants.fromObject(object.participants[i]);
                    }
                }
                if (object.currentUserId != null)
                    message.currentUserId = String(object.currentUserId);
                if (object.callToken != null)
                    message.callToken = String(object.callToken);
                if (object.turnServer != null) {
                    if (typeof object.turnServer !== "object")
                        throw TypeError(".message.StartCalling.Response.turnServer: object expected");
                    message.turnServer = $root.message.TurnServer.fromObject(object.turnServer);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.StartCalling.Response
             * @static
             * @param {message.StartCalling.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.participants = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.type = "";
                    object.currentUserId = "";
                    object.callToken = "";
                    object.turnServer = null;
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.participants && message.participants.length) {
                    object.participants = [];
                    for (var j = 0; j < message.participants.length; ++j)
                        object.participants[j] = $root.message.MessagesCallParticipants.toObject(message.participants[j], options);
                }
                if (message.currentUserId != null && message.hasOwnProperty("currentUserId"))
                    object.currentUserId = message.currentUserId;
                if (message.callToken != null && message.hasOwnProperty("callToken"))
                    object.callToken = message.callToken;
                if (message.turnServer != null && message.hasOwnProperty("turnServer"))
                    object.turnServer = $root.message.TurnServer.toObject(message.turnServer, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.StartCalling.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return StartCalling;
    })();

    message.CallReconnect = (function() {

        /**
         * Properties of a CallReconnect.
         * @memberof message
         * @interface ICallReconnect
         */

        /**
         * Constructs a new CallReconnect.
         * @memberof message
         * @classdesc Represents a CallReconnect.
         * @implements ICallReconnect
         * @constructor
         * @param {message.ICallReconnect=} [properties] Properties to set
         */
        function CallReconnect(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new CallReconnect instance using the specified properties.
         * @function create
         * @memberof message.CallReconnect
         * @static
         * @param {message.ICallReconnect=} [properties] Properties to set
         * @returns {message.CallReconnect} CallReconnect instance
         */
        CallReconnect.create = function create(properties) {
            return new CallReconnect(properties);
        };

        /**
         * Encodes the specified CallReconnect message. Does not implicitly {@link message.CallReconnect.verify|verify} messages.
         * @function encode
         * @memberof message.CallReconnect
         * @static
         * @param {message.ICallReconnect} message CallReconnect message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallReconnect.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified CallReconnect message, length delimited. Does not implicitly {@link message.CallReconnect.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.CallReconnect
         * @static
         * @param {message.ICallReconnect} message CallReconnect message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CallReconnect.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CallReconnect message from the specified reader or buffer.
         * @function decode
         * @memberof message.CallReconnect
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.CallReconnect} CallReconnect
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallReconnect.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.CallReconnect();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CallReconnect message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.CallReconnect
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.CallReconnect} CallReconnect
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CallReconnect.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CallReconnect message.
         * @function verify
         * @memberof message.CallReconnect
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CallReconnect.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a CallReconnect message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.CallReconnect
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.CallReconnect} CallReconnect
         */
        CallReconnect.fromObject = function fromObject(object) {
            if (object instanceof $root.message.CallReconnect)
                return object;
            return new $root.message.CallReconnect();
        };

        /**
         * Creates a plain object from a CallReconnect message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.CallReconnect
         * @static
         * @param {message.CallReconnect} message CallReconnect
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CallReconnect.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this CallReconnect to JSON.
         * @function toJSON
         * @memberof message.CallReconnect
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CallReconnect.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        CallReconnect.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.CallReconnect
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             * @property {Array.<string>|null} [reconnectUserId] Request reconnectUserId
             */

            /**
             * Constructs a new Request.
             * @memberof message.CallReconnect
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.CallReconnect.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.reconnectUserId = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.CallReconnect.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Request reconnectUserId.
             * @member {Array.<string>} reconnectUserId
             * @memberof message.CallReconnect.Request
             * @instance
             */
            Request.prototype.reconnectUserId = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.CallReconnect.Request
             * @static
             * @param {message.CallReconnect.IRequest=} [properties] Properties to set
             * @returns {message.CallReconnect.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.CallReconnect.Request.verify|verify} messages.
             * @function encode
             * @memberof message.CallReconnect.Request
             * @static
             * @param {message.CallReconnect.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.reconnectUserId != null && message.reconnectUserId.length)
                    for (var i = 0; i < message.reconnectUserId.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.reconnectUserId[i]);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.CallReconnect.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.CallReconnect.Request
             * @static
             * @param {message.CallReconnect.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.CallReconnect.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.CallReconnect.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.CallReconnect.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        if (!(message.reconnectUserId && message.reconnectUserId.length))
                            message.reconnectUserId = [];
                        message.reconnectUserId.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.CallReconnect.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.CallReconnect.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.CallReconnect.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.reconnectUserId != null && message.hasOwnProperty("reconnectUserId")) {
                    if (!Array.isArray(message.reconnectUserId))
                        return "reconnectUserId: array expected";
                    for (var i = 0; i < message.reconnectUserId.length; ++i)
                        if (!$util.isString(message.reconnectUserId[i]))
                            return "reconnectUserId: string[] expected";
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.CallReconnect.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.CallReconnect.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.CallReconnect.Request)
                    return object;
                var message = new $root.message.CallReconnect.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.reconnectUserId) {
                    if (!Array.isArray(object.reconnectUserId))
                        throw TypeError(".message.CallReconnect.Request.reconnectUserId: array expected");
                    message.reconnectUserId = [];
                    for (var i = 0; i < object.reconnectUserId.length; ++i)
                        message.reconnectUserId[i] = String(object.reconnectUserId[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.CallReconnect.Request
             * @static
             * @param {message.CallReconnect.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.reconnectUserId = [];
                if (options.defaults)
                    object.roomId = "";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.reconnectUserId && message.reconnectUserId.length) {
                    object.reconnectUserId = [];
                    for (var j = 0; j < message.reconnectUserId.length; ++j)
                        object.reconnectUserId[j] = message.reconnectUserId[j];
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.CallReconnect.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        CallReconnect.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.CallReconnect
             * @interface IResponse
             * @property {string|null} [roomId] Response roomId
             * @property {Array.<string>|null} [reconnectUserId] Response reconnectUserId
             * @property {string|null} [currentUserId] Response currentUserId
             * @property {string|null} [callToken] Response callToken
             * @property {message.ITurnServer|null} [turnServer] Response turnServer
             */

            /**
             * Constructs a new Response.
             * @memberof message.CallReconnect
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.CallReconnect.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.reconnectUserId = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof message.CallReconnect.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response reconnectUserId.
             * @member {Array.<string>} reconnectUserId
             * @memberof message.CallReconnect.Response
             * @instance
             */
            Response.prototype.reconnectUserId = $util.emptyArray;

            /**
             * Response currentUserId.
             * @member {string} currentUserId
             * @memberof message.CallReconnect.Response
             * @instance
             */
            Response.prototype.currentUserId = "";

            /**
             * Response callToken.
             * @member {string} callToken
             * @memberof message.CallReconnect.Response
             * @instance
             */
            Response.prototype.callToken = "";

            /**
             * Response turnServer.
             * @member {message.ITurnServer|null|undefined} turnServer
             * @memberof message.CallReconnect.Response
             * @instance
             */
            Response.prototype.turnServer = null;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.CallReconnect.Response
             * @static
             * @param {message.CallReconnect.IResponse=} [properties] Properties to set
             * @returns {message.CallReconnect.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.CallReconnect.Response.verify|verify} messages.
             * @function encode
             * @memberof message.CallReconnect.Response
             * @static
             * @param {message.CallReconnect.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.reconnectUserId != null && message.reconnectUserId.length)
                    for (var i = 0; i < message.reconnectUserId.length; ++i)
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.reconnectUserId[i]);
                if (message.currentUserId != null && Object.hasOwnProperty.call(message, "currentUserId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.currentUserId);
                if (message.callToken != null && Object.hasOwnProperty.call(message, "callToken"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.callToken);
                if (message.turnServer != null && Object.hasOwnProperty.call(message, "turnServer"))
                    $root.message.TurnServer.encode(message.turnServer, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.CallReconnect.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.CallReconnect.Response
             * @static
             * @param {message.CallReconnect.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.CallReconnect.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.CallReconnect.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.CallReconnect.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        if (!(message.reconnectUserId && message.reconnectUserId.length))
                            message.reconnectUserId = [];
                        message.reconnectUserId.push(reader.string());
                        break;
                    case 4:
                        message.currentUserId = reader.string();
                        break;
                    case 5:
                        message.callToken = reader.string();
                        break;
                    case 6:
                        message.turnServer = $root.message.TurnServer.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.CallReconnect.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.CallReconnect.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.CallReconnect.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.reconnectUserId != null && message.hasOwnProperty("reconnectUserId")) {
                    if (!Array.isArray(message.reconnectUserId))
                        return "reconnectUserId: array expected";
                    for (var i = 0; i < message.reconnectUserId.length; ++i)
                        if (!$util.isString(message.reconnectUserId[i]))
                            return "reconnectUserId: string[] expected";
                }
                if (message.currentUserId != null && message.hasOwnProperty("currentUserId"))
                    if (!$util.isString(message.currentUserId))
                        return "currentUserId: string expected";
                if (message.callToken != null && message.hasOwnProperty("callToken"))
                    if (!$util.isString(message.callToken))
                        return "callToken: string expected";
                if (message.turnServer != null && message.hasOwnProperty("turnServer")) {
                    var error = $root.message.TurnServer.verify(message.turnServer);
                    if (error)
                        return "turnServer." + error;
                }
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.CallReconnect.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.CallReconnect.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.CallReconnect.Response)
                    return object;
                var message = new $root.message.CallReconnect.Response();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.reconnectUserId) {
                    if (!Array.isArray(object.reconnectUserId))
                        throw TypeError(".message.CallReconnect.Response.reconnectUserId: array expected");
                    message.reconnectUserId = [];
                    for (var i = 0; i < object.reconnectUserId.length; ++i)
                        message.reconnectUserId[i] = String(object.reconnectUserId[i]);
                }
                if (object.currentUserId != null)
                    message.currentUserId = String(object.currentUserId);
                if (object.callToken != null)
                    message.callToken = String(object.callToken);
                if (object.turnServer != null) {
                    if (typeof object.turnServer !== "object")
                        throw TypeError(".message.CallReconnect.Response.turnServer: object expected");
                    message.turnServer = $root.message.TurnServer.fromObject(object.turnServer);
                }
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.CallReconnect.Response
             * @static
             * @param {message.CallReconnect.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.reconnectUserId = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.currentUserId = "";
                    object.callToken = "";
                    object.turnServer = null;
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.reconnectUserId && message.reconnectUserId.length) {
                    object.reconnectUserId = [];
                    for (var j = 0; j < message.reconnectUserId.length; ++j)
                        object.reconnectUserId[j] = message.reconnectUserId[j];
                }
                if (message.currentUserId != null && message.hasOwnProperty("currentUserId"))
                    object.currentUserId = message.currentUserId;
                if (message.callToken != null && message.hasOwnProperty("callToken"))
                    object.callToken = message.callToken;
                if (message.turnServer != null && message.hasOwnProperty("turnServer"))
                    object.turnServer = $root.message.TurnServer.toObject(message.turnServer, options);
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.CallReconnect.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return CallReconnect;
    })();

    message.JoinCalling = (function() {

        /**
         * Properties of a JoinCalling.
         * @memberof message
         * @interface IJoinCalling
         */

        /**
         * Constructs a new JoinCalling.
         * @memberof message
         * @classdesc Represents a JoinCalling.
         * @implements IJoinCalling
         * @constructor
         * @param {message.IJoinCalling=} [properties] Properties to set
         */
        function JoinCalling(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new JoinCalling instance using the specified properties.
         * @function create
         * @memberof message.JoinCalling
         * @static
         * @param {message.IJoinCalling=} [properties] Properties to set
         * @returns {message.JoinCalling} JoinCalling instance
         */
        JoinCalling.create = function create(properties) {
            return new JoinCalling(properties);
        };

        /**
         * Encodes the specified JoinCalling message. Does not implicitly {@link message.JoinCalling.verify|verify} messages.
         * @function encode
         * @memberof message.JoinCalling
         * @static
         * @param {message.IJoinCalling} message JoinCalling message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JoinCalling.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified JoinCalling message, length delimited. Does not implicitly {@link message.JoinCalling.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.JoinCalling
         * @static
         * @param {message.IJoinCalling} message JoinCalling message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        JoinCalling.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a JoinCalling message from the specified reader or buffer.
         * @function decode
         * @memberof message.JoinCalling
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.JoinCalling} JoinCalling
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JoinCalling.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.JoinCalling();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a JoinCalling message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.JoinCalling
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.JoinCalling} JoinCalling
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        JoinCalling.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a JoinCalling message.
         * @function verify
         * @memberof message.JoinCalling
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        JoinCalling.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a JoinCalling message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.JoinCalling
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.JoinCalling} JoinCalling
         */
        JoinCalling.fromObject = function fromObject(object) {
            if (object instanceof $root.message.JoinCalling)
                return object;
            return new $root.message.JoinCalling();
        };

        /**
         * Creates a plain object from a JoinCalling message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.JoinCalling
         * @static
         * @param {message.JoinCalling} message JoinCalling
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        JoinCalling.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this JoinCalling to JSON.
         * @function toJSON
         * @memberof message.JoinCalling
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        JoinCalling.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        JoinCalling.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.JoinCalling
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             * @property {string|null} [type] Request type
             * @property {Array.<message.IMessagesCallParticipants>|null} [participants] Request participants
             */

            /**
             * Constructs a new Request.
             * @memberof message.JoinCalling
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.JoinCalling.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.participants = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.JoinCalling.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Request type.
             * @member {string} type
             * @memberof message.JoinCalling.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Request participants.
             * @member {Array.<message.IMessagesCallParticipants>} participants
             * @memberof message.JoinCalling.Request
             * @instance
             */
            Request.prototype.participants = $util.emptyArray;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.JoinCalling.Request
             * @static
             * @param {message.JoinCalling.IRequest=} [properties] Properties to set
             * @returns {message.JoinCalling.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.JoinCalling.Request.verify|verify} messages.
             * @function encode
             * @memberof message.JoinCalling.Request
             * @static
             * @param {message.JoinCalling.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.participants != null && message.participants.length)
                    for (var i = 0; i < message.participants.length; ++i)
                        $root.message.MessagesCallParticipants.encode(message.participants[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.JoinCalling.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.JoinCalling.Request
             * @static
             * @param {message.JoinCalling.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.JoinCalling.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.JoinCalling.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.JoinCalling.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.message.MessagesCallParticipants.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.JoinCalling.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.JoinCalling.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.JoinCalling.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.participants != null && message.hasOwnProperty("participants")) {
                    if (!Array.isArray(message.participants))
                        return "participants: array expected";
                    for (var i = 0; i < message.participants.length; ++i) {
                        var error = $root.message.MessagesCallParticipants.verify(message.participants[i]);
                        if (error)
                            return "participants." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.JoinCalling.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.JoinCalling.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.JoinCalling.Request)
                    return object;
                var message = new $root.message.JoinCalling.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.participants) {
                    if (!Array.isArray(object.participants))
                        throw TypeError(".message.JoinCalling.Request.participants: array expected");
                    message.participants = [];
                    for (var i = 0; i < object.participants.length; ++i) {
                        if (typeof object.participants[i] !== "object")
                            throw TypeError(".message.JoinCalling.Request.participants: object expected");
                        message.participants[i] = $root.message.MessagesCallParticipants.fromObject(object.participants[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.JoinCalling.Request
             * @static
             * @param {message.JoinCalling.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.participants = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.type = "";
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.participants && message.participants.length) {
                    object.participants = [];
                    for (var j = 0; j < message.participants.length; ++j)
                        object.participants[j] = $root.message.MessagesCallParticipants.toObject(message.participants[j], options);
                }
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.JoinCalling.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        JoinCalling.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.JoinCalling
             * @interface IResponse
             * @property {string|null} [roomId] Response roomId
             * @property {string|null} [type] Response type
             * @property {Array.<message.IMessagesCallParticipants>|null} [participants] Response participants
             * @property {string|null} [currentUserId] Response currentUserId
             */

            /**
             * Constructs a new Response.
             * @memberof message.JoinCalling
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.JoinCalling.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.participants = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof message.JoinCalling.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response type.
             * @member {string} type
             * @memberof message.JoinCalling.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Response participants.
             * @member {Array.<message.IMessagesCallParticipants>} participants
             * @memberof message.JoinCalling.Response
             * @instance
             */
            Response.prototype.participants = $util.emptyArray;

            /**
             * Response currentUserId.
             * @member {string} currentUserId
             * @memberof message.JoinCalling.Response
             * @instance
             */
            Response.prototype.currentUserId = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.JoinCalling.Response
             * @static
             * @param {message.JoinCalling.IResponse=} [properties] Properties to set
             * @returns {message.JoinCalling.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.JoinCalling.Response.verify|verify} messages.
             * @function encode
             * @memberof message.JoinCalling.Response
             * @static
             * @param {message.JoinCalling.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.participants != null && message.participants.length)
                    for (var i = 0; i < message.participants.length; ++i)
                        $root.message.MessagesCallParticipants.encode(message.participants[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.currentUserId != null && Object.hasOwnProperty.call(message, "currentUserId"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.currentUserId);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.JoinCalling.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.JoinCalling.Response
             * @static
             * @param {message.JoinCalling.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.JoinCalling.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.JoinCalling.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.JoinCalling.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.message.MessagesCallParticipants.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        message.currentUserId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.JoinCalling.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.JoinCalling.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.JoinCalling.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.participants != null && message.hasOwnProperty("participants")) {
                    if (!Array.isArray(message.participants))
                        return "participants: array expected";
                    for (var i = 0; i < message.participants.length; ++i) {
                        var error = $root.message.MessagesCallParticipants.verify(message.participants[i]);
                        if (error)
                            return "participants." + error;
                    }
                }
                if (message.currentUserId != null && message.hasOwnProperty("currentUserId"))
                    if (!$util.isString(message.currentUserId))
                        return "currentUserId: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.JoinCalling.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.JoinCalling.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.JoinCalling.Response)
                    return object;
                var message = new $root.message.JoinCalling.Response();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.participants) {
                    if (!Array.isArray(object.participants))
                        throw TypeError(".message.JoinCalling.Response.participants: array expected");
                    message.participants = [];
                    for (var i = 0; i < object.participants.length; ++i) {
                        if (typeof object.participants[i] !== "object")
                            throw TypeError(".message.JoinCalling.Response.participants: object expected");
                        message.participants[i] = $root.message.MessagesCallParticipants.fromObject(object.participants[i]);
                    }
                }
                if (object.currentUserId != null)
                    message.currentUserId = String(object.currentUserId);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.JoinCalling.Response
             * @static
             * @param {message.JoinCalling.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.participants = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.type = "";
                    object.currentUserId = "";
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.participants && message.participants.length) {
                    object.participants = [];
                    for (var j = 0; j < message.participants.length; ++j)
                        object.participants[j] = $root.message.MessagesCallParticipants.toObject(message.participants[j], options);
                }
                if (message.currentUserId != null && message.hasOwnProperty("currentUserId"))
                    object.currentUserId = message.currentUserId;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.JoinCalling.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return JoinCalling;
    })();

    message.Hangup = (function() {

        /**
         * Properties of a Hangup.
         * @memberof message
         * @interface IHangup
         */

        /**
         * Constructs a new Hangup.
         * @memberof message
         * @classdesc Represents a Hangup.
         * @implements IHangup
         * @constructor
         * @param {message.IHangup=} [properties] Properties to set
         */
        function Hangup(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Hangup instance using the specified properties.
         * @function create
         * @memberof message.Hangup
         * @static
         * @param {message.IHangup=} [properties] Properties to set
         * @returns {message.Hangup} Hangup instance
         */
        Hangup.create = function create(properties) {
            return new Hangup(properties);
        };

        /**
         * Encodes the specified Hangup message. Does not implicitly {@link message.Hangup.verify|verify} messages.
         * @function encode
         * @memberof message.Hangup
         * @static
         * @param {message.IHangup} message Hangup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Hangup.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Hangup message, length delimited. Does not implicitly {@link message.Hangup.verify|verify} messages.
         * @function encodeDelimited
         * @memberof message.Hangup
         * @static
         * @param {message.IHangup} message Hangup message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Hangup.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Hangup message from the specified reader or buffer.
         * @function decode
         * @memberof message.Hangup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {message.Hangup} Hangup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Hangup.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.Hangup();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Hangup message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof message.Hangup
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {message.Hangup} Hangup
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Hangup.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Hangup message.
         * @function verify
         * @memberof message.Hangup
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Hangup.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Hangup message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof message.Hangup
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {message.Hangup} Hangup
         */
        Hangup.fromObject = function fromObject(object) {
            if (object instanceof $root.message.Hangup)
                return object;
            return new $root.message.Hangup();
        };

        /**
         * Creates a plain object from a Hangup message. Also converts values to other types if specified.
         * @function toObject
         * @memberof message.Hangup
         * @static
         * @param {message.Hangup} message Hangup
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Hangup.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Hangup to JSON.
         * @function toJSON
         * @memberof message.Hangup
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Hangup.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        Hangup.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof message.Hangup
             * @interface IRequest
             * @property {string|null} [roomId] Request roomId
             * @property {string|null} [type] Request type
             * @property {Array.<message.IMessagesCallParticipants>|null} [participants] Request participants
             * @property {number|Long|null} [status] Request status
             * @property {number|Long|null} [callTime] Request callTime
             */

            /**
             * Constructs a new Request.
             * @memberof message.Hangup
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {message.Hangup.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                this.participants = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request roomId.
             * @member {string} roomId
             * @memberof message.Hangup.Request
             * @instance
             */
            Request.prototype.roomId = "";

            /**
             * Request type.
             * @member {string} type
             * @memberof message.Hangup.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Request participants.
             * @member {Array.<message.IMessagesCallParticipants>} participants
             * @memberof message.Hangup.Request
             * @instance
             */
            Request.prototype.participants = $util.emptyArray;

            /**
             * Request status.
             * @member {number|Long} status
             * @memberof message.Hangup.Request
             * @instance
             */
            Request.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request callTime.
             * @member {number|Long} callTime
             * @memberof message.Hangup.Request
             * @instance
             */
            Request.prototype.callTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof message.Hangup.Request
             * @static
             * @param {message.Hangup.IRequest=} [properties] Properties to set
             * @returns {message.Hangup.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link message.Hangup.Request.verify|verify} messages.
             * @function encode
             * @memberof message.Hangup.Request
             * @static
             * @param {message.Hangup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.participants != null && message.participants.length)
                    for (var i = 0; i < message.participants.length; ++i)
                        $root.message.MessagesCallParticipants.encode(message.participants[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.status);
                if (message.callTime != null && Object.hasOwnProperty.call(message, "callTime"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.callTime);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link message.Hangup.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.Hangup.Request
             * @static
             * @param {message.Hangup.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof message.Hangup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.Hangup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.Hangup.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.message.MessagesCallParticipants.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        message.status = reader.int64();
                        break;
                    case 6:
                        message.callTime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.Hangup.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.Hangup.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof message.Hangup.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.participants != null && message.hasOwnProperty("participants")) {
                    if (!Array.isArray(message.participants))
                        return "participants: array expected";
                    for (var i = 0; i < message.participants.length; ++i) {
                        var error = $root.message.MessagesCallParticipants.verify(message.participants[i]);
                        if (error)
                            return "participants." + error;
                    }
                }
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                        return "status: integer|Long expected";
                if (message.callTime != null && message.hasOwnProperty("callTime"))
                    if (!$util.isInteger(message.callTime) && !(message.callTime && $util.isInteger(message.callTime.low) && $util.isInteger(message.callTime.high)))
                        return "callTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.Hangup.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.Hangup.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.message.Hangup.Request)
                    return object;
                var message = new $root.message.Hangup.Request();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.participants) {
                    if (!Array.isArray(object.participants))
                        throw TypeError(".message.Hangup.Request.participants: array expected");
                    message.participants = [];
                    for (var i = 0; i < object.participants.length; ++i) {
                        if (typeof object.participants[i] !== "object")
                            throw TypeError(".message.Hangup.Request.participants: object expected");
                        message.participants[i] = $root.message.MessagesCallParticipants.fromObject(object.participants[i]);
                    }
                }
                if (object.status != null)
                    if ($util.Long)
                        (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                    else if (typeof object.status === "string")
                        message.status = parseInt(object.status, 10);
                    else if (typeof object.status === "number")
                        message.status = object.status;
                    else if (typeof object.status === "object")
                        message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
                if (object.callTime != null)
                    if ($util.Long)
                        (message.callTime = $util.Long.fromValue(object.callTime)).unsigned = false;
                    else if (typeof object.callTime === "string")
                        message.callTime = parseInt(object.callTime, 10);
                    else if (typeof object.callTime === "number")
                        message.callTime = object.callTime;
                    else if (typeof object.callTime === "object")
                        message.callTime = new $util.LongBits(object.callTime.low >>> 0, object.callTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.Hangup.Request
             * @static
             * @param {message.Hangup.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.participants = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.type = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.status = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.callTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.callTime = options.longs === String ? "0" : 0;
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.participants && message.participants.length) {
                    object.participants = [];
                    for (var j = 0; j < message.participants.length; ++j)
                        object.participants[j] = $root.message.MessagesCallParticipants.toObject(message.participants[j], options);
                }
                if (message.status != null && message.hasOwnProperty("status"))
                    if (typeof message.status === "number")
                        object.status = options.longs === String ? String(message.status) : message.status;
                    else
                        object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
                if (message.callTime != null && message.hasOwnProperty("callTime"))
                    if (typeof message.callTime === "number")
                        object.callTime = options.longs === String ? String(message.callTime) : message.callTime;
                    else
                        object.callTime = options.longs === String ? $util.Long.prototype.toString.call(message.callTime) : options.longs === Number ? new $util.LongBits(message.callTime.low >>> 0, message.callTime.high >>> 0).toNumber() : message.callTime;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof message.Hangup.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        Hangup.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof message.Hangup
             * @interface IResponse
             * @property {string|null} [roomId] Response roomId
             * @property {string|null} [type] Response type
             * @property {Array.<message.IMessagesCallParticipants>|null} [participants] Response participants
             * @property {string|null} [currentUserId] Response currentUserId
             * @property {number|Long|null} [status] Response status
             * @property {number|Long|null} [callTime] Response callTime
             */

            /**
             * Constructs a new Response.
             * @memberof message.Hangup
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {message.Hangup.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.participants = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response roomId.
             * @member {string} roomId
             * @memberof message.Hangup.Response
             * @instance
             */
            Response.prototype.roomId = "";

            /**
             * Response type.
             * @member {string} type
             * @memberof message.Hangup.Response
             * @instance
             */
            Response.prototype.type = "";

            /**
             * Response participants.
             * @member {Array.<message.IMessagesCallParticipants>} participants
             * @memberof message.Hangup.Response
             * @instance
             */
            Response.prototype.participants = $util.emptyArray;

            /**
             * Response currentUserId.
             * @member {string} currentUserId
             * @memberof message.Hangup.Response
             * @instance
             */
            Response.prototype.currentUserId = "";

            /**
             * Response status.
             * @member {number|Long} status
             * @memberof message.Hangup.Response
             * @instance
             */
            Response.prototype.status = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Response callTime.
             * @member {number|Long} callTime
             * @memberof message.Hangup.Response
             * @instance
             */
            Response.prototype.callTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof message.Hangup.Response
             * @static
             * @param {message.Hangup.IResponse=} [properties] Properties to set
             * @returns {message.Hangup.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link message.Hangup.Response.verify|verify} messages.
             * @function encode
             * @memberof message.Hangup.Response
             * @static
             * @param {message.Hangup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.roomId != null && Object.hasOwnProperty.call(message, "roomId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomId);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                if (message.participants != null && message.participants.length)
                    for (var i = 0; i < message.participants.length; ++i)
                        $root.message.MessagesCallParticipants.encode(message.participants[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.currentUserId != null && Object.hasOwnProperty.call(message, "currentUserId"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.currentUserId);
                if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.status);
                if (message.callTime != null && Object.hasOwnProperty.call(message, "callTime"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.callTime);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link message.Hangup.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof message.Hangup.Response
             * @static
             * @param {message.Hangup.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof message.Hangup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {message.Hangup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.message.Hangup.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.roomId = reader.string();
                        break;
                    case 2:
                        message.type = reader.string();
                        break;
                    case 3:
                        if (!(message.participants && message.participants.length))
                            message.participants = [];
                        message.participants.push($root.message.MessagesCallParticipants.decode(reader, reader.uint32()));
                        break;
                    case 4:
                        message.currentUserId = reader.string();
                        break;
                    case 5:
                        message.status = reader.int64();
                        break;
                    case 6:
                        message.callTime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof message.Hangup.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {message.Hangup.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof message.Hangup.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    if (!$util.isString(message.roomId))
                        return "roomId: string expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.participants != null && message.hasOwnProperty("participants")) {
                    if (!Array.isArray(message.participants))
                        return "participants: array expected";
                    for (var i = 0; i < message.participants.length; ++i) {
                        var error = $root.message.MessagesCallParticipants.verify(message.participants[i]);
                        if (error)
                            return "participants." + error;
                    }
                }
                if (message.currentUserId != null && message.hasOwnProperty("currentUserId"))
                    if (!$util.isString(message.currentUserId))
                        return "currentUserId: string expected";
                if (message.status != null && message.hasOwnProperty("status"))
                    if (!$util.isInteger(message.status) && !(message.status && $util.isInteger(message.status.low) && $util.isInteger(message.status.high)))
                        return "status: integer|Long expected";
                if (message.callTime != null && message.hasOwnProperty("callTime"))
                    if (!$util.isInteger(message.callTime) && !(message.callTime && $util.isInteger(message.callTime.low) && $util.isInteger(message.callTime.high)))
                        return "callTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof message.Hangup.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {message.Hangup.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.message.Hangup.Response)
                    return object;
                var message = new $root.message.Hangup.Response();
                if (object.roomId != null)
                    message.roomId = String(object.roomId);
                if (object.type != null)
                    message.type = String(object.type);
                if (object.participants) {
                    if (!Array.isArray(object.participants))
                        throw TypeError(".message.Hangup.Response.participants: array expected");
                    message.participants = [];
                    for (var i = 0; i < object.participants.length; ++i) {
                        if (typeof object.participants[i] !== "object")
                            throw TypeError(".message.Hangup.Response.participants: object expected");
                        message.participants[i] = $root.message.MessagesCallParticipants.fromObject(object.participants[i]);
                    }
                }
                if (object.currentUserId != null)
                    message.currentUserId = String(object.currentUserId);
                if (object.status != null)
                    if ($util.Long)
                        (message.status = $util.Long.fromValue(object.status)).unsigned = false;
                    else if (typeof object.status === "string")
                        message.status = parseInt(object.status, 10);
                    else if (typeof object.status === "number")
                        message.status = object.status;
                    else if (typeof object.status === "object")
                        message.status = new $util.LongBits(object.status.low >>> 0, object.status.high >>> 0).toNumber();
                if (object.callTime != null)
                    if ($util.Long)
                        (message.callTime = $util.Long.fromValue(object.callTime)).unsigned = false;
                    else if (typeof object.callTime === "string")
                        message.callTime = parseInt(object.callTime, 10);
                    else if (typeof object.callTime === "number")
                        message.callTime = object.callTime;
                    else if (typeof object.callTime === "object")
                        message.callTime = new $util.LongBits(object.callTime.low >>> 0, object.callTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof message.Hangup.Response
             * @static
             * @param {message.Hangup.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.participants = [];
                if (options.defaults) {
                    object.roomId = "";
                    object.type = "";
                    object.currentUserId = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.status = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.status = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.callTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.callTime = options.longs === String ? "0" : 0;
                }
                if (message.roomId != null && message.hasOwnProperty("roomId"))
                    object.roomId = message.roomId;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.participants && message.participants.length) {
                    object.participants = [];
                    for (var j = 0; j < message.participants.length; ++j)
                        object.participants[j] = $root.message.MessagesCallParticipants.toObject(message.participants[j], options);
                }
                if (message.currentUserId != null && message.hasOwnProperty("currentUserId"))
                    object.currentUserId = message.currentUserId;
                if (message.status != null && message.hasOwnProperty("status"))
                    if (typeof message.status === "number")
                        object.status = options.longs === String ? String(message.status) : message.status;
                    else
                        object.status = options.longs === String ? $util.Long.prototype.toString.call(message.status) : options.longs === Number ? new $util.LongBits(message.status.low >>> 0, message.status.high >>> 0).toNumber() : message.status;
                if (message.callTime != null && message.hasOwnProperty("callTime"))
                    if (typeof message.callTime === "number")
                        object.callTime = options.longs === String ? String(message.callTime) : message.callTime;
                    else
                        object.callTime = options.longs === String ? $util.Long.prototype.toString.call(message.callTime) : options.longs === Number ? new $util.LongBits(message.callTime.low >>> 0, message.callTime.high >>> 0).toNumber() : message.callTime;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof message.Hangup.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return Hangup;
    })();

    return message;
})();

$root.sso = (function() {

    /**
     * Namespace sso.
     * @exports sso
     * @namespace
     */
    var sso = {};

    sso.CreateAppToken = (function() {

        /**
         * Properties of a CreateAppToken.
         * @memberof sso
         * @interface ICreateAppToken
         */

        /**
         * Constructs a new CreateAppToken.
         * @memberof sso
         * @classdesc Represents a CreateAppToken.
         * @implements ICreateAppToken
         * @constructor
         * @param {sso.ICreateAppToken=} [properties] Properties to set
         */
        function CreateAppToken(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new CreateAppToken instance using the specified properties.
         * @function create
         * @memberof sso.CreateAppToken
         * @static
         * @param {sso.ICreateAppToken=} [properties] Properties to set
         * @returns {sso.CreateAppToken} CreateAppToken instance
         */
        CreateAppToken.create = function create(properties) {
            return new CreateAppToken(properties);
        };

        /**
         * Encodes the specified CreateAppToken message. Does not implicitly {@link sso.CreateAppToken.verify|verify} messages.
         * @function encode
         * @memberof sso.CreateAppToken
         * @static
         * @param {sso.ICreateAppToken} message CreateAppToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateAppToken.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified CreateAppToken message, length delimited. Does not implicitly {@link sso.CreateAppToken.verify|verify} messages.
         * @function encodeDelimited
         * @memberof sso.CreateAppToken
         * @static
         * @param {sso.ICreateAppToken} message CreateAppToken message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateAppToken.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateAppToken message from the specified reader or buffer.
         * @function decode
         * @memberof sso.CreateAppToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {sso.CreateAppToken} CreateAppToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateAppToken.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sso.CreateAppToken();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateAppToken message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof sso.CreateAppToken
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {sso.CreateAppToken} CreateAppToken
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateAppToken.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateAppToken message.
         * @function verify
         * @memberof sso.CreateAppToken
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateAppToken.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a CreateAppToken message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof sso.CreateAppToken
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {sso.CreateAppToken} CreateAppToken
         */
        CreateAppToken.fromObject = function fromObject(object) {
            if (object instanceof $root.sso.CreateAppToken)
                return object;
            return new $root.sso.CreateAppToken();
        };

        /**
         * Creates a plain object from a CreateAppToken message. Also converts values to other types if specified.
         * @function toObject
         * @memberof sso.CreateAppToken
         * @static
         * @param {sso.CreateAppToken} message CreateAppToken
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateAppToken.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this CreateAppToken to JSON.
         * @function toJSON
         * @memberof sso.CreateAppToken
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateAppToken.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        CreateAppToken.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof sso.CreateAppToken
             * @interface IRequest
             * @property {string|null} [appId] Request appId
             */

            /**
             * Constructs a new Request.
             * @memberof sso.CreateAppToken
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {sso.CreateAppToken.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request appId.
             * @member {string} appId
             * @memberof sso.CreateAppToken.Request
             * @instance
             */
            Request.prototype.appId = "";

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof sso.CreateAppToken.Request
             * @static
             * @param {sso.CreateAppToken.IRequest=} [properties] Properties to set
             * @returns {sso.CreateAppToken.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link sso.CreateAppToken.Request.verify|verify} messages.
             * @function encode
             * @memberof sso.CreateAppToken.Request
             * @static
             * @param {sso.CreateAppToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.appId != null && Object.hasOwnProperty.call(message, "appId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.appId);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link sso.CreateAppToken.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sso.CreateAppToken.Request
             * @static
             * @param {sso.CreateAppToken.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof sso.CreateAppToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sso.CreateAppToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sso.CreateAppToken.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.appId = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sso.CreateAppToken.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sso.CreateAppToken.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof sso.CreateAppToken.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.appId != null && message.hasOwnProperty("appId"))
                    if (!$util.isString(message.appId))
                        return "appId: string expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sso.CreateAppToken.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sso.CreateAppToken.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.sso.CreateAppToken.Request)
                    return object;
                var message = new $root.sso.CreateAppToken.Request();
                if (object.appId != null)
                    message.appId = String(object.appId);
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sso.CreateAppToken.Request
             * @static
             * @param {sso.CreateAppToken.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults)
                    object.appId = "";
                if (message.appId != null && message.hasOwnProperty("appId"))
                    object.appId = message.appId;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof sso.CreateAppToken.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        CreateAppToken.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof sso.CreateAppToken
             * @interface IResponse
             * @property {string|null} [token] Response token
             * @property {number|Long|null} [createTime] Response createTime
             */

            /**
             * Constructs a new Response.
             * @memberof sso.CreateAppToken
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {sso.CreateAppToken.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response token.
             * @member {string} token
             * @memberof sso.CreateAppToken.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response createTime.
             * @member {number|Long} createTime
             * @memberof sso.CreateAppToken.Response
             * @instance
             */
            Response.prototype.createTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof sso.CreateAppToken.Response
             * @static
             * @param {sso.CreateAppToken.IResponse=} [properties] Properties to set
             * @returns {sso.CreateAppToken.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link sso.CreateAppToken.Response.verify|verify} messages.
             * @function encode
             * @memberof sso.CreateAppToken.Response
             * @static
             * @param {sso.CreateAppToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
                if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.createTime);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link sso.CreateAppToken.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof sso.CreateAppToken.Response
             * @static
             * @param {sso.CreateAppToken.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof sso.CreateAppToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {sso.CreateAppToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.sso.CreateAppToken.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.token = reader.string();
                        break;
                    case 2:
                        message.createTime = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof sso.CreateAppToken.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {sso.CreateAppToken.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof sso.CreateAppToken.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.createTime != null && message.hasOwnProperty("createTime"))
                    if (!$util.isInteger(message.createTime) && !(message.createTime && $util.isInteger(message.createTime.low) && $util.isInteger(message.createTime.high)))
                        return "createTime: integer|Long expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof sso.CreateAppToken.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {sso.CreateAppToken.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.sso.CreateAppToken.Response)
                    return object;
                var message = new $root.sso.CreateAppToken.Response();
                if (object.token != null)
                    message.token = String(object.token);
                if (object.createTime != null)
                    if ($util.Long)
                        (message.createTime = $util.Long.fromValue(object.createTime)).unsigned = false;
                    else if (typeof object.createTime === "string")
                        message.createTime = parseInt(object.createTime, 10);
                    else if (typeof object.createTime === "number")
                        message.createTime = object.createTime;
                    else if (typeof object.createTime === "object")
                        message.createTime = new $util.LongBits(object.createTime.low >>> 0, object.createTime.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof sso.CreateAppToken.Response
             * @static
             * @param {sso.CreateAppToken.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.token = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.createTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.createTime = options.longs === String ? "0" : 0;
                }
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.createTime != null && message.hasOwnProperty("createTime"))
                    if (typeof message.createTime === "number")
                        object.createTime = options.longs === String ? String(message.createTime) : message.createTime;
                    else
                        object.createTime = options.longs === String ? $util.Long.prototype.toString.call(message.createTime) : options.longs === Number ? new $util.LongBits(message.createTime.low >>> 0, message.createTime.high >>> 0).toNumber() : message.createTime;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof sso.CreateAppToken.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Response;
        })();

        return CreateAppToken;
    })();

    return sso;
})();

$root.upload = (function() {

    /**
     * Namespace upload.
     * @exports upload
     * @namespace
     */
    var upload = {};

    upload.UploadFile = (function() {

        /**
         * Properties of an UploadFile.
         * @memberof upload
         * @interface IUploadFile
         */

        /**
         * Constructs a new UploadFile.
         * @memberof upload
         * @classdesc Represents an UploadFile.
         * @implements IUploadFile
         * @constructor
         * @param {upload.IUploadFile=} [properties] Properties to set
         */
        function UploadFile(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UploadFile instance using the specified properties.
         * @function create
         * @memberof upload.UploadFile
         * @static
         * @param {upload.IUploadFile=} [properties] Properties to set
         * @returns {upload.UploadFile} UploadFile instance
         */
        UploadFile.create = function create(properties) {
            return new UploadFile(properties);
        };

        /**
         * Encodes the specified UploadFile message. Does not implicitly {@link upload.UploadFile.verify|verify} messages.
         * @function encode
         * @memberof upload.UploadFile
         * @static
         * @param {upload.IUploadFile} message UploadFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadFile.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UploadFile message, length delimited. Does not implicitly {@link upload.UploadFile.verify|verify} messages.
         * @function encodeDelimited
         * @memberof upload.UploadFile
         * @static
         * @param {upload.IUploadFile} message UploadFile message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UploadFile.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an UploadFile message from the specified reader or buffer.
         * @function decode
         * @memberof upload.UploadFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {upload.UploadFile} UploadFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadFile.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.upload.UploadFile();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an UploadFile message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof upload.UploadFile
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {upload.UploadFile} UploadFile
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UploadFile.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an UploadFile message.
         * @function verify
         * @memberof upload.UploadFile
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UploadFile.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an UploadFile message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof upload.UploadFile
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {upload.UploadFile} UploadFile
         */
        UploadFile.fromObject = function fromObject(object) {
            if (object instanceof $root.upload.UploadFile)
                return object;
            return new $root.upload.UploadFile();
        };

        /**
         * Creates a plain object from an UploadFile message. Also converts values to other types if specified.
         * @function toObject
         * @memberof upload.UploadFile
         * @static
         * @param {upload.UploadFile} message UploadFile
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UploadFile.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UploadFile to JSON.
         * @function toJSON
         * @memberof upload.UploadFile
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UploadFile.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        UploadFile.Request = (function() {

            /**
             * Properties of a Request.
             * @memberof upload.UploadFile
             * @interface IRequest
             * @property {string|null} [name] Request name
             * @property {number|Long|null} [size] Request size
             * @property {string|null} [type] Request type
             * @property {number|Long|null} [lastModified] Request lastModified
             * @property {string|null} [hash] Request hash
             * @property {number|Long|null} [expirationTime] Request expirationTime
             * @property {number|Long|null} [visitCount] Request visitCount
             */

            /**
             * Constructs a new Request.
             * @memberof upload.UploadFile
             * @classdesc Represents a Request.
             * @implements IRequest
             * @constructor
             * @param {upload.UploadFile.IRequest=} [properties] Properties to set
             */
            function Request(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Request name.
             * @member {string} name
             * @memberof upload.UploadFile.Request
             * @instance
             */
            Request.prototype.name = "";

            /**
             * Request size.
             * @member {number|Long} size
             * @memberof upload.UploadFile.Request
             * @instance
             */
            Request.prototype.size = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request type.
             * @member {string} type
             * @memberof upload.UploadFile.Request
             * @instance
             */
            Request.prototype.type = "";

            /**
             * Request lastModified.
             * @member {number|Long} lastModified
             * @memberof upload.UploadFile.Request
             * @instance
             */
            Request.prototype.lastModified = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request hash.
             * @member {string} hash
             * @memberof upload.UploadFile.Request
             * @instance
             */
            Request.prototype.hash = "";

            /**
             * Request expirationTime.
             * @member {number|Long} expirationTime
             * @memberof upload.UploadFile.Request
             * @instance
             */
            Request.prototype.expirationTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Request visitCount.
             * @member {number|Long} visitCount
             * @memberof upload.UploadFile.Request
             * @instance
             */
            Request.prototype.visitCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Request instance using the specified properties.
             * @function create
             * @memberof upload.UploadFile.Request
             * @static
             * @param {upload.UploadFile.IRequest=} [properties] Properties to set
             * @returns {upload.UploadFile.Request} Request instance
             */
            Request.create = function create(properties) {
                return new Request(properties);
            };

            /**
             * Encodes the specified Request message. Does not implicitly {@link upload.UploadFile.Request.verify|verify} messages.
             * @function encode
             * @memberof upload.UploadFile.Request
             * @static
             * @param {upload.UploadFile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.size != null && Object.hasOwnProperty.call(message, "size"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.size);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
                if (message.lastModified != null && Object.hasOwnProperty.call(message, "lastModified"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lastModified);
                if (message.hash != null && Object.hasOwnProperty.call(message, "hash"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.hash);
                if (message.expirationTime != null && Object.hasOwnProperty.call(message, "expirationTime"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int64(message.expirationTime);
                if (message.visitCount != null && Object.hasOwnProperty.call(message, "visitCount"))
                    writer.uint32(/* id 7, wireType 0 =*/56).int64(message.visitCount);
                return writer;
            };

            /**
             * Encodes the specified Request message, length delimited. Does not implicitly {@link upload.UploadFile.Request.verify|verify} messages.
             * @function encodeDelimited
             * @memberof upload.UploadFile.Request
             * @static
             * @param {upload.UploadFile.IRequest} message Request message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Request.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Request message from the specified reader or buffer.
             * @function decode
             * @memberof upload.UploadFile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {upload.UploadFile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.upload.UploadFile.Request();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.size = reader.int64();
                        break;
                    case 3:
                        message.type = reader.string();
                        break;
                    case 4:
                        message.lastModified = reader.int64();
                        break;
                    case 5:
                        message.hash = reader.string();
                        break;
                    case 6:
                        message.expirationTime = reader.int64();
                        break;
                    case 7:
                        message.visitCount = reader.int64();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Request message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof upload.UploadFile.Request
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {upload.UploadFile.Request} Request
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Request.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Request message.
             * @function verify
             * @memberof upload.UploadFile.Request
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Request.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.size != null && message.hasOwnProperty("size"))
                    if (!$util.isInteger(message.size) && !(message.size && $util.isInteger(message.size.low) && $util.isInteger(message.size.high)))
                        return "size: integer|Long expected";
                if (message.type != null && message.hasOwnProperty("type"))
                    if (!$util.isString(message.type))
                        return "type: string expected";
                if (message.lastModified != null && message.hasOwnProperty("lastModified"))
                    if (!$util.isInteger(message.lastModified) && !(message.lastModified && $util.isInteger(message.lastModified.low) && $util.isInteger(message.lastModified.high)))
                        return "lastModified: integer|Long expected";
                if (message.hash != null && message.hasOwnProperty("hash"))
                    if (!$util.isString(message.hash))
                        return "hash: string expected";
                if (message.expirationTime != null && message.hasOwnProperty("expirationTime"))
                    if (!$util.isInteger(message.expirationTime) && !(message.expirationTime && $util.isInteger(message.expirationTime.low) && $util.isInteger(message.expirationTime.high)))
                        return "expirationTime: integer|Long expected";
                if (message.visitCount != null && message.hasOwnProperty("visitCount"))
                    if (!$util.isInteger(message.visitCount) && !(message.visitCount && $util.isInteger(message.visitCount.low) && $util.isInteger(message.visitCount.high)))
                        return "visitCount: integer|Long expected";
                return null;
            };

            /**
             * Creates a Request message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof upload.UploadFile.Request
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {upload.UploadFile.Request} Request
             */
            Request.fromObject = function fromObject(object) {
                if (object instanceof $root.upload.UploadFile.Request)
                    return object;
                var message = new $root.upload.UploadFile.Request();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.size != null)
                    if ($util.Long)
                        (message.size = $util.Long.fromValue(object.size)).unsigned = false;
                    else if (typeof object.size === "string")
                        message.size = parseInt(object.size, 10);
                    else if (typeof object.size === "number")
                        message.size = object.size;
                    else if (typeof object.size === "object")
                        message.size = new $util.LongBits(object.size.low >>> 0, object.size.high >>> 0).toNumber();
                if (object.type != null)
                    message.type = String(object.type);
                if (object.lastModified != null)
                    if ($util.Long)
                        (message.lastModified = $util.Long.fromValue(object.lastModified)).unsigned = false;
                    else if (typeof object.lastModified === "string")
                        message.lastModified = parseInt(object.lastModified, 10);
                    else if (typeof object.lastModified === "number")
                        message.lastModified = object.lastModified;
                    else if (typeof object.lastModified === "object")
                        message.lastModified = new $util.LongBits(object.lastModified.low >>> 0, object.lastModified.high >>> 0).toNumber();
                if (object.hash != null)
                    message.hash = String(object.hash);
                if (object.expirationTime != null)
                    if ($util.Long)
                        (message.expirationTime = $util.Long.fromValue(object.expirationTime)).unsigned = false;
                    else if (typeof object.expirationTime === "string")
                        message.expirationTime = parseInt(object.expirationTime, 10);
                    else if (typeof object.expirationTime === "number")
                        message.expirationTime = object.expirationTime;
                    else if (typeof object.expirationTime === "object")
                        message.expirationTime = new $util.LongBits(object.expirationTime.low >>> 0, object.expirationTime.high >>> 0).toNumber();
                if (object.visitCount != null)
                    if ($util.Long)
                        (message.visitCount = $util.Long.fromValue(object.visitCount)).unsigned = false;
                    else if (typeof object.visitCount === "string")
                        message.visitCount = parseInt(object.visitCount, 10);
                    else if (typeof object.visitCount === "number")
                        message.visitCount = object.visitCount;
                    else if (typeof object.visitCount === "object")
                        message.visitCount = new $util.LongBits(object.visitCount.low >>> 0, object.visitCount.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Request message. Also converts values to other types if specified.
             * @function toObject
             * @memberof upload.UploadFile.Request
             * @static
             * @param {upload.UploadFile.Request} message Request
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Request.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.size = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.size = options.longs === String ? "0" : 0;
                    object.type = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.lastModified = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.lastModified = options.longs === String ? "0" : 0;
                    object.hash = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.expirationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.expirationTime = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.visitCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.visitCount = options.longs === String ? "0" : 0;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.size != null && message.hasOwnProperty("size"))
                    if (typeof message.size === "number")
                        object.size = options.longs === String ? String(message.size) : message.size;
                    else
                        object.size = options.longs === String ? $util.Long.prototype.toString.call(message.size) : options.longs === Number ? new $util.LongBits(message.size.low >>> 0, message.size.high >>> 0).toNumber() : message.size;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = message.type;
                if (message.lastModified != null && message.hasOwnProperty("lastModified"))
                    if (typeof message.lastModified === "number")
                        object.lastModified = options.longs === String ? String(message.lastModified) : message.lastModified;
                    else
                        object.lastModified = options.longs === String ? $util.Long.prototype.toString.call(message.lastModified) : options.longs === Number ? new $util.LongBits(message.lastModified.low >>> 0, message.lastModified.high >>> 0).toNumber() : message.lastModified;
                if (message.hash != null && message.hasOwnProperty("hash"))
                    object.hash = message.hash;
                if (message.expirationTime != null && message.hasOwnProperty("expirationTime"))
                    if (typeof message.expirationTime === "number")
                        object.expirationTime = options.longs === String ? String(message.expirationTime) : message.expirationTime;
                    else
                        object.expirationTime = options.longs === String ? $util.Long.prototype.toString.call(message.expirationTime) : options.longs === Number ? new $util.LongBits(message.expirationTime.low >>> 0, message.expirationTime.high >>> 0).toNumber() : message.expirationTime;
                if (message.visitCount != null && message.hasOwnProperty("visitCount"))
                    if (typeof message.visitCount === "number")
                        object.visitCount = options.longs === String ? String(message.visitCount) : message.visitCount;
                    else
                        object.visitCount = options.longs === String ? $util.Long.prototype.toString.call(message.visitCount) : options.longs === Number ? new $util.LongBits(message.visitCount.low >>> 0, message.visitCount.high >>> 0).toNumber() : message.visitCount;
                return object;
            };

            /**
             * Converts this Request to JSON.
             * @function toJSON
             * @memberof upload.UploadFile.Request
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Request.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Request;
        })();

        UploadFile.Response = (function() {

            /**
             * Properties of a Response.
             * @memberof upload.UploadFile
             * @interface IResponse
             * @property {string|null} [token] Response token
             * @property {number|Long|null} [uploadedTotalSize] Response uploadedTotalSize
             * @property {Array.<number|Long>|null} [uploadedOffset] Response uploadedOffset
             * @property {upload.UploadFile.Response.IUrls|null} [urls] Response urls
             * @property {number|Long|null} [chunkSize] Response chunkSize
             * @property {string|null} [apiUrl] Response apiUrl
             */

            /**
             * Constructs a new Response.
             * @memberof upload.UploadFile
             * @classdesc Represents a Response.
             * @implements IResponse
             * @constructor
             * @param {upload.UploadFile.IResponse=} [properties] Properties to set
             */
            function Response(properties) {
                this.uploadedOffset = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Response token.
             * @member {string} token
             * @memberof upload.UploadFile.Response
             * @instance
             */
            Response.prototype.token = "";

            /**
             * Response uploadedTotalSize.
             * @member {number|Long} uploadedTotalSize
             * @memberof upload.UploadFile.Response
             * @instance
             */
            Response.prototype.uploadedTotalSize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Response uploadedOffset.
             * @member {Array.<number|Long>} uploadedOffset
             * @memberof upload.UploadFile.Response
             * @instance
             */
            Response.prototype.uploadedOffset = $util.emptyArray;

            /**
             * Response urls.
             * @member {upload.UploadFile.Response.IUrls|null|undefined} urls
             * @memberof upload.UploadFile.Response
             * @instance
             */
            Response.prototype.urls = null;

            /**
             * Response chunkSize.
             * @member {number|Long} chunkSize
             * @memberof upload.UploadFile.Response
             * @instance
             */
            Response.prototype.chunkSize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Response apiUrl.
             * @member {string} apiUrl
             * @memberof upload.UploadFile.Response
             * @instance
             */
            Response.prototype.apiUrl = "";

            /**
             * Creates a new Response instance using the specified properties.
             * @function create
             * @memberof upload.UploadFile.Response
             * @static
             * @param {upload.UploadFile.IResponse=} [properties] Properties to set
             * @returns {upload.UploadFile.Response} Response instance
             */
            Response.create = function create(properties) {
                return new Response(properties);
            };

            /**
             * Encodes the specified Response message. Does not implicitly {@link upload.UploadFile.Response.verify|verify} messages.
             * @function encode
             * @memberof upload.UploadFile.Response
             * @static
             * @param {upload.UploadFile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
                if (message.uploadedTotalSize != null && Object.hasOwnProperty.call(message, "uploadedTotalSize"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int64(message.uploadedTotalSize);
                if (message.uploadedOffset != null && message.uploadedOffset.length) {
                    writer.uint32(/* id 3, wireType 2 =*/26).fork();
                    for (var i = 0; i < message.uploadedOffset.length; ++i)
                        writer.int64(message.uploadedOffset[i]);
                    writer.ldelim();
                }
                if (message.urls != null && Object.hasOwnProperty.call(message, "urls"))
                    $root.upload.UploadFile.Response.Urls.encode(message.urls, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.chunkSize != null && Object.hasOwnProperty.call(message, "chunkSize"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.chunkSize);
                if (message.apiUrl != null && Object.hasOwnProperty.call(message, "apiUrl"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.apiUrl);
                return writer;
            };

            /**
             * Encodes the specified Response message, length delimited. Does not implicitly {@link upload.UploadFile.Response.verify|verify} messages.
             * @function encodeDelimited
             * @memberof upload.UploadFile.Response
             * @static
             * @param {upload.UploadFile.IResponse} message Response message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Response.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Response message from the specified reader or buffer.
             * @function decode
             * @memberof upload.UploadFile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {upload.UploadFile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.upload.UploadFile.Response();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.token = reader.string();
                        break;
                    case 2:
                        message.uploadedTotalSize = reader.int64();
                        break;
                    case 3:
                        if (!(message.uploadedOffset && message.uploadedOffset.length))
                            message.uploadedOffset = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.uploadedOffset.push(reader.int64());
                        } else
                            message.uploadedOffset.push(reader.int64());
                        break;
                    case 4:
                        message.urls = $root.upload.UploadFile.Response.Urls.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.chunkSize = reader.int64();
                        break;
                    case 6:
                        message.apiUrl = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Response message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof upload.UploadFile.Response
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {upload.UploadFile.Response} Response
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Response.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Response message.
             * @function verify
             * @memberof upload.UploadFile.Response
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Response.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.token != null && message.hasOwnProperty("token"))
                    if (!$util.isString(message.token))
                        return "token: string expected";
                if (message.uploadedTotalSize != null && message.hasOwnProperty("uploadedTotalSize"))
                    if (!$util.isInteger(message.uploadedTotalSize) && !(message.uploadedTotalSize && $util.isInteger(message.uploadedTotalSize.low) && $util.isInteger(message.uploadedTotalSize.high)))
                        return "uploadedTotalSize: integer|Long expected";
                if (message.uploadedOffset != null && message.hasOwnProperty("uploadedOffset")) {
                    if (!Array.isArray(message.uploadedOffset))
                        return "uploadedOffset: array expected";
                    for (var i = 0; i < message.uploadedOffset.length; ++i)
                        if (!$util.isInteger(message.uploadedOffset[i]) && !(message.uploadedOffset[i] && $util.isInteger(message.uploadedOffset[i].low) && $util.isInteger(message.uploadedOffset[i].high)))
                            return "uploadedOffset: integer|Long[] expected";
                }
                if (message.urls != null && message.hasOwnProperty("urls")) {
                    var error = $root.upload.UploadFile.Response.Urls.verify(message.urls);
                    if (error)
                        return "urls." + error;
                }
                if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                    if (!$util.isInteger(message.chunkSize) && !(message.chunkSize && $util.isInteger(message.chunkSize.low) && $util.isInteger(message.chunkSize.high)))
                        return "chunkSize: integer|Long expected";
                if (message.apiUrl != null && message.hasOwnProperty("apiUrl"))
                    if (!$util.isString(message.apiUrl))
                        return "apiUrl: string expected";
                return null;
            };

            /**
             * Creates a Response message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof upload.UploadFile.Response
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {upload.UploadFile.Response} Response
             */
            Response.fromObject = function fromObject(object) {
                if (object instanceof $root.upload.UploadFile.Response)
                    return object;
                var message = new $root.upload.UploadFile.Response();
                if (object.token != null)
                    message.token = String(object.token);
                if (object.uploadedTotalSize != null)
                    if ($util.Long)
                        (message.uploadedTotalSize = $util.Long.fromValue(object.uploadedTotalSize)).unsigned = false;
                    else if (typeof object.uploadedTotalSize === "string")
                        message.uploadedTotalSize = parseInt(object.uploadedTotalSize, 10);
                    else if (typeof object.uploadedTotalSize === "number")
                        message.uploadedTotalSize = object.uploadedTotalSize;
                    else if (typeof object.uploadedTotalSize === "object")
                        message.uploadedTotalSize = new $util.LongBits(object.uploadedTotalSize.low >>> 0, object.uploadedTotalSize.high >>> 0).toNumber();
                if (object.uploadedOffset) {
                    if (!Array.isArray(object.uploadedOffset))
                        throw TypeError(".upload.UploadFile.Response.uploadedOffset: array expected");
                    message.uploadedOffset = [];
                    for (var i = 0; i < object.uploadedOffset.length; ++i)
                        if ($util.Long)
                            (message.uploadedOffset[i] = $util.Long.fromValue(object.uploadedOffset[i])).unsigned = false;
                        else if (typeof object.uploadedOffset[i] === "string")
                            message.uploadedOffset[i] = parseInt(object.uploadedOffset[i], 10);
                        else if (typeof object.uploadedOffset[i] === "number")
                            message.uploadedOffset[i] = object.uploadedOffset[i];
                        else if (typeof object.uploadedOffset[i] === "object")
                            message.uploadedOffset[i] = new $util.LongBits(object.uploadedOffset[i].low >>> 0, object.uploadedOffset[i].high >>> 0).toNumber();
                }
                if (object.urls != null) {
                    if (typeof object.urls !== "object")
                        throw TypeError(".upload.UploadFile.Response.urls: object expected");
                    message.urls = $root.upload.UploadFile.Response.Urls.fromObject(object.urls);
                }
                if (object.chunkSize != null)
                    if ($util.Long)
                        (message.chunkSize = $util.Long.fromValue(object.chunkSize)).unsigned = false;
                    else if (typeof object.chunkSize === "string")
                        message.chunkSize = parseInt(object.chunkSize, 10);
                    else if (typeof object.chunkSize === "number")
                        message.chunkSize = object.chunkSize;
                    else if (typeof object.chunkSize === "object")
                        message.chunkSize = new $util.LongBits(object.chunkSize.low >>> 0, object.chunkSize.high >>> 0).toNumber();
                if (object.apiUrl != null)
                    message.apiUrl = String(object.apiUrl);
                return message;
            };

            /**
             * Creates a plain object from a Response message. Also converts values to other types if specified.
             * @function toObject
             * @memberof upload.UploadFile.Response
             * @static
             * @param {upload.UploadFile.Response} message Response
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Response.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uploadedOffset = [];
                if (options.defaults) {
                    object.token = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.uploadedTotalSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.uploadedTotalSize = options.longs === String ? "0" : 0;
                    object.urls = null;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.chunkSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.chunkSize = options.longs === String ? "0" : 0;
                    object.apiUrl = "";
                }
                if (message.token != null && message.hasOwnProperty("token"))
                    object.token = message.token;
                if (message.uploadedTotalSize != null && message.hasOwnProperty("uploadedTotalSize"))
                    if (typeof message.uploadedTotalSize === "number")
                        object.uploadedTotalSize = options.longs === String ? String(message.uploadedTotalSize) : message.uploadedTotalSize;
                    else
                        object.uploadedTotalSize = options.longs === String ? $util.Long.prototype.toString.call(message.uploadedTotalSize) : options.longs === Number ? new $util.LongBits(message.uploadedTotalSize.low >>> 0, message.uploadedTotalSize.high >>> 0).toNumber() : message.uploadedTotalSize;
                if (message.uploadedOffset && message.uploadedOffset.length) {
                    object.uploadedOffset = [];
                    for (var j = 0; j < message.uploadedOffset.length; ++j)
                        if (typeof message.uploadedOffset[j] === "number")
                            object.uploadedOffset[j] = options.longs === String ? String(message.uploadedOffset[j]) : message.uploadedOffset[j];
                        else
                            object.uploadedOffset[j] = options.longs === String ? $util.Long.prototype.toString.call(message.uploadedOffset[j]) : options.longs === Number ? new $util.LongBits(message.uploadedOffset[j].low >>> 0, message.uploadedOffset[j].high >>> 0).toNumber() : message.uploadedOffset[j];
                }
                if (message.urls != null && message.hasOwnProperty("urls"))
                    object.urls = $root.upload.UploadFile.Response.Urls.toObject(message.urls, options);
                if (message.chunkSize != null && message.hasOwnProperty("chunkSize"))
                    if (typeof message.chunkSize === "number")
                        object.chunkSize = options.longs === String ? String(message.chunkSize) : message.chunkSize;
                    else
                        object.chunkSize = options.longs === String ? $util.Long.prototype.toString.call(message.chunkSize) : options.longs === Number ? new $util.LongBits(message.chunkSize.low >>> 0, message.chunkSize.high >>> 0).toNumber() : message.chunkSize;
                if (message.apiUrl != null && message.hasOwnProperty("apiUrl"))
                    object.apiUrl = message.apiUrl;
                return object;
            };

            /**
             * Converts this Response to JSON.
             * @function toJSON
             * @memberof upload.UploadFile.Response
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Response.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            Response.Urls = (function() {

                /**
                 * Properties of an Urls.
                 * @memberof upload.UploadFile.Response
                 * @interface IUrls
                 * @property {string|null} [encryptionUrl] Urls encryptionUrl
                 * @property {string|null} [url] Urls url
                 * @property {string|null} [domainUrl] Urls domainUrl
                 */

                /**
                 * Constructs a new Urls.
                 * @memberof upload.UploadFile.Response
                 * @classdesc Represents an Urls.
                 * @implements IUrls
                 * @constructor
                 * @param {upload.UploadFile.Response.IUrls=} [properties] Properties to set
                 */
                function Urls(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Urls encryptionUrl.
                 * @member {string} encryptionUrl
                 * @memberof upload.UploadFile.Response.Urls
                 * @instance
                 */
                Urls.prototype.encryptionUrl = "";

                /**
                 * Urls url.
                 * @member {string} url
                 * @memberof upload.UploadFile.Response.Urls
                 * @instance
                 */
                Urls.prototype.url = "";

                /**
                 * Urls domainUrl.
                 * @member {string} domainUrl
                 * @memberof upload.UploadFile.Response.Urls
                 * @instance
                 */
                Urls.prototype.domainUrl = "";

                /**
                 * Creates a new Urls instance using the specified properties.
                 * @function create
                 * @memberof upload.UploadFile.Response.Urls
                 * @static
                 * @param {upload.UploadFile.Response.IUrls=} [properties] Properties to set
                 * @returns {upload.UploadFile.Response.Urls} Urls instance
                 */
                Urls.create = function create(properties) {
                    return new Urls(properties);
                };

                /**
                 * Encodes the specified Urls message. Does not implicitly {@link upload.UploadFile.Response.Urls.verify|verify} messages.
                 * @function encode
                 * @memberof upload.UploadFile.Response.Urls
                 * @static
                 * @param {upload.UploadFile.Response.IUrls} message Urls message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Urls.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.encryptionUrl != null && Object.hasOwnProperty.call(message, "encryptionUrl"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.encryptionUrl);
                    if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.url);
                    if (message.domainUrl != null && Object.hasOwnProperty.call(message, "domainUrl"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.domainUrl);
                    return writer;
                };

                /**
                 * Encodes the specified Urls message, length delimited. Does not implicitly {@link upload.UploadFile.Response.Urls.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof upload.UploadFile.Response.Urls
                 * @static
                 * @param {upload.UploadFile.Response.IUrls} message Urls message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Urls.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Urls message from the specified reader or buffer.
                 * @function decode
                 * @memberof upload.UploadFile.Response.Urls
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {upload.UploadFile.Response.Urls} Urls
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Urls.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.upload.UploadFile.Response.Urls();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.encryptionUrl = reader.string();
                            break;
                        case 2:
                            message.url = reader.string();
                            break;
                        case 3:
                            message.domainUrl = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Urls message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof upload.UploadFile.Response.Urls
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {upload.UploadFile.Response.Urls} Urls
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Urls.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Urls message.
                 * @function verify
                 * @memberof upload.UploadFile.Response.Urls
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Urls.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.encryptionUrl != null && message.hasOwnProperty("encryptionUrl"))
                        if (!$util.isString(message.encryptionUrl))
                            return "encryptionUrl: string expected";
                    if (message.url != null && message.hasOwnProperty("url"))
                        if (!$util.isString(message.url))
                            return "url: string expected";
                    if (message.domainUrl != null && message.hasOwnProperty("domainUrl"))
                        if (!$util.isString(message.domainUrl))
                            return "domainUrl: string expected";
                    return null;
                };

                /**
                 * Creates an Urls message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof upload.UploadFile.Response.Urls
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {upload.UploadFile.Response.Urls} Urls
                 */
                Urls.fromObject = function fromObject(object) {
                    if (object instanceof $root.upload.UploadFile.Response.Urls)
                        return object;
                    var message = new $root.upload.UploadFile.Response.Urls();
                    if (object.encryptionUrl != null)
                        message.encryptionUrl = String(object.encryptionUrl);
                    if (object.url != null)
                        message.url = String(object.url);
                    if (object.domainUrl != null)
                        message.domainUrl = String(object.domainUrl);
                    return message;
                };

                /**
                 * Creates a plain object from an Urls message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof upload.UploadFile.Response.Urls
                 * @static
                 * @param {upload.UploadFile.Response.Urls} message Urls
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Urls.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.encryptionUrl = "";
                        object.url = "";
                        object.domainUrl = "";
                    }
                    if (message.encryptionUrl != null && message.hasOwnProperty("encryptionUrl"))
                        object.encryptionUrl = message.encryptionUrl;
                    if (message.url != null && message.hasOwnProperty("url"))
                        object.url = message.url;
                    if (message.domainUrl != null && message.hasOwnProperty("domainUrl"))
                        object.domainUrl = message.domainUrl;
                    return object;
                };

                /**
                 * Converts this Urls to JSON.
                 * @function toJSON
                 * @memberof upload.UploadFile.Response.Urls
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Urls.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Urls;
            })();

            return Response;
        })();

        return UploadFile;
    })();

    return upload;
})();

module.exports = $root;
